//#region Imports
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
//MUI
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/Error";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import InfoIcon from "@mui/icons-material/Info";
import PrintIcon from "@mui/icons-material/Print";
import { Formik, Form, Field } from "formik";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
  FormHelperText,
  Modal,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from '@mui/material';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import { FileUploadOutlined as FileUploadIcon } from "@mui/icons-material";
import Backdrop from "@mui/material/Backdrop";
import Checkbox from "@mui/material/Checkbox";
import AppLoader from '../../../components/AppLoader/AppLoader';
import InputAdornment from "@mui/material/InputAdornment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import ProcessingSummaryTableForCoa from "../../../components/processingSummaryTable/processingSummaryTableForCoa";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useCallback } from "react";
import mepcologo from "../../../images/mepcoLogo.png";
import pdfIcon from "../../../images/pdfIcon.png";
import MEPCOWaterMark from "../../../images/DiscosWater/mepcco-watermark.png";
import LESCOWaterMark from "../../../images/DiscosWater/lescowatermark.png";
import IESCOWaterMark from "../../../images/DiscosWater/iescowatermark.png";
import FESCOWaterMark from "../../../images/DiscosWater/fesco-watermark.png";
import GEPCOWaterMark from "../../../images/DiscosWater/gepco-watermark.png";
import HAZECOWaterMark from "../../../images/DiscosWater/hazeco-watermark.png";
import HESCOWaterMark from "../../../images/DiscosWater/hesco-watermark.png";
import TESCOWaterMark from "../../../images/DiscosWater/tesco-watermark.png";
import SEPCOWaterMark from "../../../images/DiscosWater/sepco-watermark.png";
import PESCOWaterMark from "../../../images/DiscosWater/pesco-watermark.png";
import QESCOWaterMark from "../../../images/DiscosWater/qesco-watermark.png";
import IESCODDLOGO from "../../../images/discologos/iesco logo.png";
import FESCODDLOGO from "../../../images/discologos/fesco.jpg";
import GEPCODDLOGO from "../../../images/discologos/gepco.jpg";
import HAZECODDLOGO from "../../../images/discologos/hazeco_logo-removebg-preview.png";
import HESCODDLOGO from "../../../images/discologos/hesco logo.png";
import LESCODDLOGO from "../../../images/discologos/lesco.jpg";
import MEPCODDLOGO from "../../../images/discologos/mepco1.jpg";
import PESCODDLOGO from "../../../images/discologos/pesco1.jpg";
import PITCDDLOGO from "../../../images/discologos/pitc11-removebg-preview.png";
import QESCODDLOGO from "../../../images/discologos/qesco.png";
import SEPCODDLOGO from "../../../images/discologos/sepco.jpg";
import TESCODDLOGO from "../../../images/discologos/tesco.jpg";
//components
// import StatusBar from '../../../components/statusbar/statusbar';
import Base64Image from "../../../components/Base64Image/Base64Image";
import ProcessingSummaryTable from "../../../components/processingSummaryTable/processingSummaryTable";
import tickicon from "../../../images/Accept.png";
import pencilIcon from "../../../images/pencil.png";
import crossIcon from "../../../images/remove.png";
import InfoImage from "../../../images/informationButton.png";
import {
  applicationName,
  companyName,
  companyShortName,
  convertDate,
  convertDateDDMMYY,
  convertDatewithTime,
  convertDatewithTimeWithoutSecond,
  dBillAPI,
  divisionName,
  documentValidation,
  downloadBill,
  filterOptions as filterOptionsCityDistrict,
  getPhase,
  handleFileUpload,
  isImage,
  isOneYearOld,
  isPdf,
  numberFormatting,
  printStamp,
  sodowo,
  subdivisionName,
  paymentDetails,
  discMeterDetails,
  rcoMeterProfile,
  calculateBoqCharges,
  formatBoqChargeAmount,
  numberFormattingForRCO,
} from "../../../services/Functions";
//scss
import "../../../style/common.scss";
import "../../../style/dnRejectModal.scss";
import "../../GeneralServices/Reconnection/ReconnectionWorkflowDialog.scss";
import {
  WORKFLOW_MOBILE_MEDIA,
  workflowDialogClassName,
  workflowDialogShellProps,
} from "../../../utils/workflowDialogShell";
import "./MeterChangeRequestWorkflowDialog.scss";
//Yup
import * as Yup from "yup";
import { yupSafeAddress, yupSafePersonName } from '../../../utils/sanitizeFormText';
//formik
import { useFormik } from "formik";
//urls
import { cfpBaseUrl } from "../../../network/urls";
// use scan detection
import useScanDetection from "use-scan-detection";
// authorization
import CheckPermissions from "../../../authorization/authorization";
// Services
import { openBase64Image } from "../../../services/OpenBase64Image";
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import JsBarcode from "jsbarcode";
import StepProgressBar from "../../../components/StepProgressBar/StepProgressBar";
import OpenBase64ImageInPopup from "../../../services/OpenBase64ImageInPopup";
import RcoActivityLogDialog, {
  RcoHistoryDoc,
  RcoHistoryField,
} from "../../../components/RcoActivityLogDialog/RcoActivityLogDialog";
import RcoActivityLogDetailDialog, {
  ACTIVITY_LOG_TIMELINE_TYPES,
} from "../../../components/activityLog/RcoActivityLogDetailDialog";
import { buildMcoActivityLogDetailRows } from "../../../utils/mcoActivityLogDetail";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { tableStyle, tableStyleOverDue } from "../../../style/common";
//pdfjs
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import autoTable from "jspdf-autotable";
import { useDispatch, useSelector } from "react-redux";
import ActionsCell from "../../../components/actionCell/ActionCell";
import ServiceDashboardTables from "../../../components/ServiceDashboardTables/ServiceDashboardTables";
import Error from "../../../components/error/error";
import { signOut } from "../../../features/authentication/authenticationSlice";
import { resetState as resetStateDueDate } from "../../../features/billingAndCollection/dueDateExtensionNormalSlice";
import { resetState as resetStateInstallmentsNormal } from "../../../features/billingAndCollection/installmentsNormalSlice";
import { resetState as resetStateInstallmentsOverdue } from "../../../features/billingAndCollection/installmentsOverdueSlice";
import { resetOverallPerformanceState } from "../../../features/dashboard/overallPerformance";
import { resetState as resetStateColNormal } from "../../../features/generalServices/colNormalSlice";
import { resetState as resetStateColOverdue } from "../../../features/generalServices/colOverdueSlice";
import { resetState as resetStateConNormal } from "../../../features/generalServices/coaNormalSlice";
import { resetState as resetStateConOverdue } from "../../../features/generalServices/coaOverdueSlice";
import { resetState as resetStateCotNormal } from "../../../features/generalServices/cotNormalSlice";
import { resetState as resetStateCotOverdue } from "../../../features/generalServices/cotOverdueSlice";
import {
  fetchPaginatedMeterChangeRequestNormal,
  filterDateFrom as filterDateFromNormal,
  filterDateTo as filterDateToNormal,
  filterObjectionStatus as filterObjectionStatusNormal,
  filterProgressId as filterProgressIdNormal,
  firstPage as firstPageNormal,
  lastPage as lastPageNormal,
  nextPage as nextPageNormal,
  previousPage as prePageNormal,
  resetDateFilter as resetDateFilterNormal,
  resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
  resetProgressIdFilter as resetProgressIdFilterNormal,
  resetState as resetStateRcNormal,
} from "../../../features/billingAndCollection/mcrNormalSlice";
import {
  fetchPaginatedMeterChangeRequestOverdue,
  filterDateFrom as filterDateFromOverdue,
  filterDateTo as filterDateToOverdue,
  filterObjectionStatus as filterObjectionStatusOverdue,
  filterProgressId as filterProgressIdOverdue,
  firstPage as firstPageOverdue,
  lastPage as lastPageOverdue,
  nextPage as nextPageOverdue,
  previousPage as prePageOverdue,
  resetDateFilter as resetDateFilterOverdue,
  resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
  resetProgressIdFilter as resetProgressIdFilterOverdue,
  resetState as resetStateRcOverdue,
} from "../../../features/billingAndCollection/mcrOverdueSlice";
import { resetFeederStatusState } from "../../../features/geoJson/feedersStatus";
import { resetGeoJsonState } from "../../../features/geoJson/geoJson";
import { removeStats } from "../../../features/stats/statsSlice";
import useFetchData from "../../../hooks/fetchData";
import { SearchIndividualApplication } from "../../../network/APIs/APIs";
import { documentExtensions, portalName } from "../../../utils/PortalName";
import { getInitialAdminOfficeCode, resolveDiscoCompanyCodeForBranding, resolveDiscoCodeForDocument, getDiscoUseOnlyWatermarkText } from "../../../utils/adminCompany";
import { addDnPaymentQrCodesToPdf, RCO_DN_QR_LAYOUT } from "../../../utils/generateDnPaymentQr";
import BatchWarningDialog from "../../../components/BatchWarningDialog/BatchWarningDialog";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../../images/pitc.png";
import {
  getFieldStaffDesignations,
  getWorkforceData,
} from "../../../network/APIs/APIs";
import { Token } from "@mui/icons-material";
//#endregion

const MeterChangeRequestTable = forwardRef((props, ref) => {
  //#region paginatedlogic
  const dispatch = useDispatch();
  const {
    currentPage: currentPageNormal,
    data: dataNormal,
    pageSize: pageSizeNormal,
    totalPages: totalPagesNormal,
    totalRecords: totalRecordsNormal,
    dateFrom: dateFromNormal,
    dateTo: dateToNormal,
    loadFrom: loadFromNormal,
    loadTo: loadToNormal,
    applicationProgressId: applicationProgressIdNormal,
    objectionStatus: objectionStatusNormal,
    error: rcNormalError,
    isLoading: isLoad,
  } = useSelector((state) => state.mcrNormalPaginated);
  const {
    currentPage: currentPageOverdue,
    data: dataOverdue,
    pageSize: pageSizeOverdue,
    totalPages: totalPagesOverdue,
    totalRecords: totalRecordsOverdue,
    dateFrom: dateFromOverdue,
    dateTo: dateToOverdue,
    loadFrom: loadFromOverdue,
    loadTo: loadToOverdue,
    applicationProgressId: applicationProgressIdOverdue,
    objectionStatus: objectionStatusOverdue,
    error: rcOverdueError,
    isLoading: isLoadd,
  } = useSelector((state) => state.mcrOverduePaginated);
  const {
    token,
    userId,
    hierarchy,
    roleId,
    roleName,
    permissions,
    roleTypeId,
    code,
    selectedAdminCompanyCode,
  } = useSelector((state) => state.auth);
  const isWorkflowMobile = useMediaQuery(WORKFLOW_MOBILE_MEDIA);
  let userCompany = resolveDiscoCompanyCodeForBranding(
    code,
    roleId,
    selectedAdminCompanyCode,
  );

  const getDocumentDiscoCode = (applicationId, fallbackCompanyCode = "") =>
    resolveDiscoCodeForDocument(
      applicationId,
      code,
      roleId,
      selectedAdminCompanyCode,
      fallbackCompanyCode,
    );
  const getWaterMarkLogo = (code) => {
    switch (code) {
      case "11":
        return LESCOWaterMark;
      case "12":
        return GEPCOWaterMark;
      case "13":
        return FESCOWaterMark;
      case "14":
        return IESCOWaterMark;
      case "15":
        return MEPCOWaterMark;
      case "26":
        return PESCOWaterMark;
      case "27":
        return HAZECOWaterMark;
      case "37":
        return HESCOWaterMark;
      case "38":
        return SEPCOWaterMark;
      case "48":
        return QESCOWaterMark;
      case "59":
        return TESCOWaterMark;
      default:
        return MEPCOWaterMark;
    }
  };

  const myHeaders = new Headers();
  myHeaders.append("Authorization", token);

  const RequestOptions = (method, myHeaders) => {
    return {
      method: method,
      headers: myHeaders,
      redirect: "follow",
    };
  };

  let requestOptions = RequestOptions("GET", myHeaders);
  const {
    data: cities,
    loading: citiesLoading,
    error: citiesError,
  } = useFetchData(
    cfpBaseUrl + "electricityNewConnection/citiesList",
    requestOptions,
  );

  // useEffect(() => {
  //   if ((rcNormalError && rcNormalError === "Failed to fetch") || (rcOverdueError && rcOverdueError === "Failed to fetch")) {
  //     alert("Network issue! NCAPIE")
  //     dispatch(resetStateRcNormal());
  //     dispatch(resetStateRcOverdue());
  //     dispatch(resetStateConNormal());
  //     dispatch(resetStateConOverdue());
  //     dispatch(resetStateColNormal());
  //     dispatch(resetStateColOverdue());
  //     dispatch(resetStateCotNormal());
  //     dispatch(resetStateCotOverdue());
  //     dispatch(resetStateDueDate());
  //     dispatch(resetStateInstallmentsNormal())
  //     dispatch(resetStateInstallmentsOverdue())
  //     dispatch(removeStats());
  //     dispatch(resetOverallPerformanceState());
  //     dispatch(resetFeederStatusState());
  //     dispatch(resetGeoJsonState());
  //     dispatch(signOut())
  //   }
  // }, [rcNormalError, rcOverdueError])

  const handleNextPageNormal = () => {
    dispatch(nextPageNormal());
  };

  const handleDateFromFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateFromNormal(value));
    }
  };

  const handleDateToFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateToNormal(value));
    }
  };

  const handleResetDateFilterNormal = () => {
    dispatch(resetDateFilterNormal());
  };

  const handleProgressIdFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true);
      dispatch(filterProgressIdNormal(value));
    }
  };

  const handleResetProgressIdFilterNormal = () => {
    dispatch(resetProgressIdFilterNormal());
  };

  const handleObjectionStatusFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true);
      dispatch(filterObjectionStatusNormal(value));
    }
  };

  const handleResetObjectionStatusFilterNormal = () => {
    dispatch(resetObjectionStatusFilterNormal());
  };

  const handlePreviousPageNormal = () => {
    dispatch(prePageNormal());
  };

  const handleFirstPageNormal = () => {
    dispatch(firstPageNormal());
  };

  const handleLastPageNormal = (page) => {
    dispatch(lastPageNormal(typeof page === 'number' ? page : totalPagesNormal));
  };
  function getTariffsForValue(value, tariffs) {
    return tariffs.filter((tariff) => {
      const from = parseInt(tariff.from, 10);
      const to = parseInt(tariff.to, 10);
      return value >= from && value <= to;
    });
  }

  // useEffect(() => {
  //    if (props.showTable && currentPath == "/reconnection-table") {
  //   setViewBackdrop(true);

  //     dispatch(
  //       fetchPaginatedMeterChangeRequestNormal({
  //         page: currentPageNormal,
  //         pageSize: pageSizeNormal,
  //         dateFrom: dateFromNormal,
  //         dateTo: dateToNormal,
  //         loadFrom: loadFromNormal,
  //         loadTo: loadToNormal,
  //         applicationProgressId: applicationProgressIdNormal,
  //         objectionStatus: objectionStatusNormal,
  //       })
  //     );
  //   }
  // }, []);

  //   useEffect(() => {
  //    if (props.showTable && currentPath == "/reconnection-table") {
  //   setViewBackdrop(true);

  //     dispatch(
  //       fetchPaginatedMeterChangeRequestOverdue({
  //         page: currentPageOverdue,
  //         pageSize: pageSizeOverdue,
  //         dateFrom: dateFromOverdue,
  //         dateTo: dateToOverdue,
  //         loadFrom: loadFromOverdue,
  //         loadTo: loadToOverdue,
  //         applicationProgressId: applicationProgressIdOverdue,
  //         objectionStatus: objectionStatusOverdue,
  //       })
  //     );
  //   }
  // }, []);

  useEffect(() => {
    if (dataNormal) {
      setReconnectionApplications(dataNormal);
      setViewBackdrop(false);
    }
  }, [dataNormal]);

  const handleNextPageOverdue = () => {
    dispatch(nextPageOverdue());
  };

  const handleDateFromFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateFromOverdue(value));
    }
  };

  const handleDateToFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterDateToOverdue(value));
    }
  };
  const handleResetDateFilterOverdue = () => {
    dispatch(resetDateFilterOverdue());
  };
  const handleProgressIdFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterProgressIdOverdue(value));
    }
  };

  const handleResetProgressIdFilterOverdue = () => {
    dispatch(resetProgressIdFilterOverdue());
  };

  const handleObjectionStatusFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true);
      dispatch(filterObjectionStatusOverdue(value));
    }
  };

  const handleResetObjectionStatusFilterOverdue = () => {
    dispatch(resetObjectionStatusFilterOverdue());
  };

  const handlePreviousPageOverdue = () => {
    dispatch(prePageOverdue());
  };

  const handleFirstPageOverdue = () => {
    dispatch(firstPageOverdue());
  };

  const handleLastPageOverdue = (page) => {
    dispatch(lastPageOverdue(typeof page === 'number' ? page : totalPagesOverdue));
  };

  useEffect(() => {
    if (dataOverdue) {
      setReconnectionApplicationsOverDue(dataOverdue);
      setViewBackdrop(false);
    }
  }, [dataOverdue]);

  // Close backdrop whenever Redux loading finishes (handles StrictMode double-effect / same-reference edge cases)
  useEffect(() => {
    if (!isLoad) {
      setViewBackdrop(false);
    }
  }, [isLoad]);

  useEffect(() => {
    if (!isLoadd) {
      setViewBackdrop(false);
    }
  }, [isLoadd]);

  // Fetch MCO Lookup Data (FS Observations & Meter Faults)
  useEffect(() => {
    const fetchMCOLookupData = async () => {
      try {
        const lookupHeaders = new Headers();
        lookupHeaders.append("Authorization", token);
        const lookupOptions = {
          method: "GET",
          headers: lookupHeaders,
          redirect: "follow",
        };
        const response = await fetch(
          cfpBaseUrl + "meterChangeOrder/getMCOLookupData",
          lookupOptions,
        );
        const result = await response.json();
        if (result?.status === "200" && result?.data) {
          setFsObservations(result.data.lookupFSObservation || []);
          setMeterFaults(result.data.lookupMeterFault || []);
        }
      } catch (error) { /* ignored */ }
    };
    if (token) {
      fetchMCOLookupData();
    }
  }, [token]);

  const referenceApi = async (dialogRowData) => {
    setViewBackdrop(true);
    try {
      const referenceNo = dialogRowData?.referenceNo;
      if (!referenceNo) {
        setViewBackdrop(false);
        return;
      }

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        searchById: referenceNo,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "ibs/getConsumerDetails",
        requestOptions,
      );
      const result = await response.json();

      if (result?.status === "200" && result?.data?.length > 0) {
        const consumerData = result.data[0];
        const arrearAmount = Number(consumerData.ARREAR || 0);

        if (arrearAmount > 0) {
          setPaymentStatus("Arrear exists");
          setArrearAmount(String(arrearAmount));
          setBillMonth(consumerData.BILL_MONTH || "");
        } else {
          setPaymentStatus("No arrear exists");
          setArrearAmount("");
          setBillMonth("");
        }
      } else {
        setPaymentStatus("No arrear exists");
        setArrearAmount("");
        setBillMonth("");
      }
    } catch (error) { /* ignored */ } finally {
      setViewBackdrop(false);
    }
  };

  const callReconnectionHistory = async (searchById, officeCode) => {
    if (!searchById) {
      setReconnectionHistoryRows([]);
      return;
    }

    setReconnectionHistoryLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        searchById: String(searchById),
        officeCode: String(officeCode),
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        "http://175.107.33.109:8038/ibs/getReconnectionHistory",
        requestOptions,
      );
      const result = await response.json();

      if (result?.status === "200" && Array.isArray(result?.data)) {
        setReconnectionHistoryRows(result.data);
      } else {
        setReconnectionHistoryRows([]);
      }
    } catch (error) {
      setReconnectionHistoryRows([]);
    } finally {
      setReconnectionHistoryLoading(false);
    }
  };

  const formatAmountOrNA = (value) => {
    if (value === null || value === undefined || value === "") return "N/A";
    const num = Math.round(Number(value) || 0);
    return numberFormatting(num) ?? String(num);
  };

  const formatNegativeAmountOrNA = (value) => {
    if (value === null || value === undefined || value === "") return "N/A";
    const num = Math.round(Math.abs(Number(value) || 0));
    if (num === 0) return "0";
    return `-${numberFormatting(num) ?? String(num)}`;
  };

  const hasLessTheCostValue = (value) =>
    Math.round(Math.abs(Number(value) || 0)) !== 0;

  //#endregion

  //#region initial values
  const initialValues = {
    iv_objection_Type: "",
    iv_objection_Descripton: "",

    //arrears fields
    iv_property_reference_no: "",

    //arears paid bill document field
    iv_arear_paid_bill_document: "",
    iv_arear_paid_bill_date: "",

    //applied load fields
    iv_applied_load: "",

    iv_generate_demand_notice: 0,
    iv_dn_for: 0,
    iv_no_of_default_meters: 1,

    //dn fields
    iv_distance: 1,
    iv_estimated_distance: 41,
    iv_sketch_diagram: "",
    iv_coverage_area: "3",
    iv_default_meters_ref_no_array: "",
    iv_tariff_to_allot: "",
    iv_surveyed_by: "",
    iv_survey_date: "",
    iv_batch: "",
    iv_reference_to_allot: "",
    iv_industry_factory_type: "",
    iv_bank_name: "",
    iv_connection_account_no: "",
    iv_grid_sharing_cost: 0,
    iv_feeder_rehab_charges: 0,
    iv_civil_work_charges: 0,
    iv_fixed_charges_of_metering: 0,
    iv_miscellaneous_charges: 0,
    iv_less_the_cost: 0,
    iv_mt_charges: 0,
    iv_labour_charges: 0,
    iv_design_wetting_fee: 0,
    iv_consultancy_charges: 0,
    iv_variation_charges: 0,
    iv_dismantlement_charges: 0,
    iv_earthing_charges: 0,

    // boq fields
    iv_fieldItemId: "",
    iv_fieldItemQty: "",
    iv_fieldItemRate: "",
    iv_fieldItemUnit: "",
    iv_fieldItemAmount: "",
    iv_items_array: "",

    // payment verification fields
    iv_payment_date: "",
    iv_receipt_image: "",
    iv_is_rco_fee_voucher_paid: "",
    iv_is_bill_paid: "",
    iv_bill_payment_date: "",

    // rco fee payment verification fields
    iv_rco_fee_payment_date: "",
    iv_rco_fee_receipt_image: "",

    iv_dn_receipt_image: "",
    iv_dn_fee_payment_date: null,

    //rco fields
    iv_fata_pata: "",
    iv_rural_urban: "U",
    iv_feeder_no: "",
    iv_sub_batch: "",
    iv_fgovt: "",
    iv_cantonment_board: "",
    iv_pgovt: "",
    iv_govt_dept_code: "",
    iv_local_bodies: "",
    iv_authorized_by_name: "",
    iv_date_of_authorization: "",
    iv_store_requisition_no: "",
    iv_store_requisition_date: "",
    iv_sanctioned_load: "",
    iv_seasonal_flag: 1,
    iv_no_of_acs: 0,
    iv_no_of_meters: 0,
    iv_no_of_meter_sets: 0,
    iv_no_of_sub_sets: 0,
    iv_no_ofsupply_points: 0,
    iv_transformer_code: "",
    iv_meter_id: "",
    iv_meter_serial_no: "",
    iv_location_code: "P",
    iv_meter_code1: "",
    iv_meter_code2: "",
    iv_manufacturer_code: "",
    iv_multiplying_factor: 1,
    iv_meter_range: 4,
    iv_meter_reading: "",
    iv_date_of_connection: "",
    iv_cp_78_item_no: "",
    iv_tie_up_non_tie_up: 1,
    iv_seal_on_meter: "",
    iv_seal_on_box: "",
    iv_security_slip_or_price_bond_no: "",
    iv_connection_installer_name: "",
    iv_meter_type: "",
    isReadingAccessible: "",
    isReferToMst: "",
    isMeterAvailable: "",
    isDefectiveCode: "",
    iv_faultType: "",
    iv_faultOtherReason: "",
    iv_meter_reading_off_peak_kwh: "",
    iv_meter_reading_peak_kwh: "",
    iv_meter_reading_off_peak_kvarh: "",
    iv_meter_reading_peak_kvarh: "",
    iv_ct: "",
    iv_ct_nom: "1",
    iv_ct_denom: "1",
    iv_pt: "",
    iv_pt_nom: "1",
    iv_pt_denom: "1",
    iv_mf: "",
    iv_mdi: "",
    iv_no_of_mdi_resets: "",

    // master data fields
    iv_govt_dept: 0,
    iv_ed_code: "",
    iv_standard_classification_code: "",
    iv_income_tax: 0,

    //basic info update fields
    iv_applicant_name: "",
    iv_applicant_cnic: "",
    iv_applicant_phone: "",
    iv_applicant_email: "",
    iv_address: "",
    iv_relative_name: "",
    iv_owner_name: "",
    iv_owner_cnic: "",
    iv_owner_phone: "",
    iv_owner_email: "",
    iv_city_district: "",
    iv_meter_installed: 0,
    iv_town_tehsil: "",
    iv_chak_street: "",
    // Urban
    iv_house: "",
    iv_street: "",
    iv_sector_block_phase_mohala: "",
    // Rural
    iv_chak_street: "",
    iv_village: "",

    iv_refer_to_subdivision: 0,
    iv_exempt_rco_fee: 0,
    iv_tariff_desc: "",
    installedMeterRefNos: [],

    iv_is_net_meter: "",
    iv_meter_category: "",
    iv_tariff_code: "",
    iv_total_kwh: "",
    iv_store_requisition_no: "",
    iv_store_requisition_date: "",
    iv_sanctioned_load: "",
    iv_seasonal_flag: 0,
    iv_meter_range: 4,
    iv_meter_code1: "",
    iv_meter_code2: "",
    iv_transformer_code: "",
    iv_transformer_refNo: "",
    iv_location_code: "P",
    iv_manufacturer_code: "",
    iv_meter_serial_no: "",
    iv_sim_number: "",
    iv_sim_ID: "",
    iv_meter_reading: "",
    iv_meter_reading_off_peak_kwh: "",
    iv_meter_reading_peak_kwh: "",
    iv_meter_reading_off_peak_kvarh: "",
    iv_meter_reading_peak_kvarh: "",
    iv_date_of_connection: "",
    iv_connection_installer_name: "",
    iv_installed_meter_image: "",
    iv_meter_typee: "",
    iv_ct_nom: "1",
    iv_ct_denom: "1",
    iv_pt_nom: "1",
    iv_pt_denom: "1",
    iv_mdi: "",
    iv_no_of_mdi_resets: "",
    iv_reading_info: {},
    iv_mandt_receipt_image: "",
    iv_mandt_payment_date: "",
    iv_mandt_report_no: "",
  };

  //#endregion

  //#region get item local storage
  const subDivisions = JSON.parse(window.localStorage.getItem("subDivisions"));
  //#endregion

  //#region states
  const [allTariffList, setAllTariffList] = useState();
  const [allMCOTariffList, setAllMCOTariffList] = useState([]);
  const [selectedTariffCode, setSelectedTariffCode] = useState("");
  const [selectedMCOTariffObj, setSelectedMCOTariffObj] = useState(null);
  const [readingInfoError, setReadingInfoError] = useState("");
  const [readingInfoDraft, setReadingInfoDraft] = useState({});
  const [allFeedersList, setAllFeedersList] = useState([]);
  const [allMaterialList, setAllMaterialList] = useState([]);
  const [standardClassificationCodes, setStandardClassificationCodes] =
    useState([]);
  const [sketchDiagram, setSketchDiagram] = useState();
  const [sketchDiagramThumbnail, setSketchDiagramThumbnail] = useState("");
  const [sketchDiagramError, setSketchDiagramError] = useState();
  const [meterImage, setMeterImage] = useState();
  const [meterImageThumbnail, setMeterImageThumbnail] = useState("");
  const [meterImageError, setMeterImageError] = useState("");
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [alreadyInstalledRefNos, setAlreadyInstalledRefNos] = useState([]);
  const [alreadyInstalledRefNosErrors, setAlreadyInstalledRefNosErrors] =
    useState([]);

  // State for Add Popup (move to component top)
  const [openAddPopup, setOpenAddPopup] = useState(false);
  const [addPopupField1, setAddPopupField1] = useState("");

  // Handler for Add Popup Submit
  const handleAddPopupSubmit = () => {
    // TODO: Implement your submit logic here
    setOpenAddPopup(false);
  };
  const [scoDetails, setScoDetails] = useState({
    scoId: "",
    applicationId: "",
    scoCreationDate: "",
    urbanRural: "",
    fataPata: "",
    refNo: "",
    feederNo: "",
    batch: "",
    subBatch: "",
    fGovt: "",
    cantonmentBoard: "",
    pGovt: "",
    localBodies: "",
    scoP1FilledBy: "",
    scoP1FillingDate: "",
    scoP1FillFlag: "",
    authorizedByName: "",
    dateOfAuthorization: "",
    scoP1ApprovedFlag: "",
    storeRequisitionNo: "",
    storeRequisitionDate: "",
    seasonalFlag: "",
    senctionLoad: "",
    noOfACs: "",
    noOfMeters: "",
    noOfMeterSets: "",
    noOfSubSets: "",
    noOfSupplyPoints: "",
    installedTransformerCapacity: "",
    meterId: "",
    meterNo: "",
    locationCode: "",
    meterCode: "",
    manufacturerCode: "",
    multiplyingFactor: "",
    meterRange: "",
    meterReading: "",
    dateOfConnection: "",
    cp78ItemNo: "",
    tieUpNonTieUp: "",
    sealOnMeter: "",
    sealOnBox: "",
    securitySlipOrPriceBondNo: "",
    connectionInstallerName: "",
    scoP2FilledBy: "",
    scoP2FillingDate: "",
    scoP2FillFlag: "",
    scoP2ApprovedBy: "",
    scoP2ApprovalDate: "",
    scoP2ApprovalFlag: "",
    installedMeterImage: "",
    meterType: null,
    threePhasePeak: null,
    threePhaseOffPeak: null,
    mdi: null,
    noOfMDIreset: null,
    cT: "",
    pT: "",
    threePhasePeakKVARH: "",
    threePhaseOffPeakKVARH: "",
    threePhasePeakKWH: "",
    threePhaseOffPeakKWH: "",
  });
  const [meterTypeValueForCheck, setMeterTypeValueForCheck] = useState("0");
  const [dnRejectModalOpen, setDnRejectModalOpen] = useState(false);
  const [arrearFlag, setArrearFlag] = useState(0);
  const [arrearsDetailsRefno, setArrearsDetailsRefno] = useState({
    arrearsAmount: "",
    meterStatus: "",
    tariffDesc: "",
    meterType: "",
    phase: "",
    consumerName: "",
    consumerNo: "",
    consumerAddress: "",
    consumerEmail: "",
  });
  const companies = [
    { code: "11", name: "LESCO", logo: LESCODDLOGO },
    { code: "12", name: "GEPCO", logo: GEPCODDLOGO },
    { code: "13", name: "FESCO", logo: FESCODDLOGO },
    { code: "14", name: "IESCO", logo: IESCODDLOGO },
    { code: "15", name: "MEPCO", logo: MEPCODDLOGO },
    { code: "26", name: "PESCO", logo: PESCODDLOGO },
    { code: "27", name: "HAZECO", logo: HAZECODDLOGO },
    { code: "37", name: "HESCO", logo: HESCODDLOGO },
    { code: "38", name: "SEPCO", logo: SEPCODDLOGO },
    { code: "48", name: "QESCO", logo: QESCODDLOGO },
    { code: "59", name: "TESCO", logo: TESCODDLOGO },
  ];

  // Selected officeCode state
  const [selectedOfficeCode, setSelectedOfficeCode] = useState(
    getInitialAdminOfficeCode(code, selectedAdminCompanyCode),
  );

  useEffect(() => {
    if (String(code) === "10" && selectedAdminCompanyCode) {
      setSelectedOfficeCode(String(selectedAdminCompanyCode));
    }
  }, [code, selectedAdminCompanyCode]);
  const [paidRCOFeeVoucherImg, setPaidRCOFeeVoucherImg] = useState(null);
  const [paidDNVoucherImg, setPaidDNVoucherImg] = useState(null);
  const [installedMeterImg, setInstalledMeterImg] = useState(null);
  const [batchError, setBatchError] = useState("");
  const [wrongBatchPopup, setWrongBatchPopup] = useState(false);
  const [phase, setPhase] = useState();
  const [tariff, setTariff] = useState();
  const [refNoAlreadyAllocatedError, setRefNoAlreadyAllocatedError] =
    useState("");
  const [viewDropBackForEfile, setViewDropBackForEfile] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [debouncedInputValue, setDebouncedInputValue] = useState(inputValue);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [reconnectionHistoryRows, setReconnectionHistoryRows] = useState([]);
  const [reconnectionHistoryLoading, setReconnectionHistoryLoading] =
    useState(false);
  const [openResponseModal, setOpenResponseModal] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseMessageError, setResponseMessageError] = useState("");
  const [responseType, setResponseType] = useState("");
  const [errormessageBoqEstimation, setErrormessageBoqEstimation] =
    useState("");
  const [arrearAmount, setArrearAmount] = useState("");
  const [billMonth, setBillMonth] = useState("");
  const [frontImg, setFrontImg] = useState(null);
  const [backImg, setBackImg] = useState(null);
  const [popUpfrontImg, setPopUpfrontImg] = useState(null);
  const [popUpBackImg, setPopUpBackImg] = useState(null);
  const [popUpEBillImg, setPopUpEBillImg] = useState(null);
  const [popUpEAnyOtherImg, setPopUpAnyOtherImg] = useState(null);
  const [meterImg, setMeterImg] = useState(null);
  const [mtReportImg, setMtReportImg] = useState(null);

  const [paidArrearImg, setPaidArrearImg] = useState(null);
  const [paidRCOFeeImg, setPaidRCOFeeImg] = useState(null);
  const [dnPaymentImg, setDnPaymentImg] = useState(null);
  const [reInstalledMeterImg, setReInstalledMeterImg] = useState(null);
   const [approvalDocImg, setApprovalDocImg] = useState(null);
  const [arrearPaidReceiptImageThumbnail, setArrearPaidReceiptImageThumbnail] =
    useState();
  const [installedMeterImgThumbnail, setInstalledMeterImgThumbnail] =
    useState();
  const [selectedStaffId, setSelectedStaffId] = useState("");
  const manufacturesList = [
    { code: 1, name: "General Electric" },
    { code: 10, name: "Climax" },
    { code: 11, name: "Ercorts" },
    { code: 12, name: "Schlumburger France" },
    { code: 13, name: "CHINA" },
    { code: 14, name: "TIP" },
    { code: 15, name: "RUSSIAN" },
    { code: 16, name: "BULGARIA" },
    { code: 17, name: "BRAZIL" },
    { code: 18, name: "GANZ" },
    { code: 19, name: "BELGIUM" },
    { code: 2, name: "Westinghouse" },
    { code: 20, name: "SWITZERLAND" },
    { code: 21, name: "KRIZIK" },
    { code: 22, name: "HITACHI" },
    { code: 23, name: "ISKARA" },
    { code: 24, name: "ELGMA(TOU)" },
    { code: 25, name: "USA(TOD)" },
    { code: 26, name: "SABEECO" },
    { code: 27, name: "MICRO TECH" },
    { code: 28, name: "ETHOPIA" },
    { code: 29, name: "LETHIANIA" },
    { code: 3, name: "Landis & Gyr" },
    { code: 30, name: "M.T.I Micro Tech" },
    { code: 31, name: "SBEEC" },
    { code: 32, name: "Hexing(China)" },
    { code: 33, name: "Creative Electronics" },
    { code: 34, name: "Elektromed" },
    { code: 35, name: "J n P" },
    { code: 36, name: "TRANSFAB" },
    { code: 37, name: "HAMEED" },
    { code: 38, name: "ELEMATIC" },
    { code: 39, name: "TRANSPAK" },
    { code: 4, name: "Aeg" },
    { code: 40, name: "NECOPE" },
    { code: 41, name: "TRANSFOPOWER" },
    { code: 42, name: "IRAN" },
    { code: 43, name: "ACE INDIGO" },
    { code: 44, name: "PAN POWER" },
    { code: 45, name: "AB AMPERRE" },
    { code: 46, name: "POWER TECH" },
    { code: 47, name: "J.F.INDUSTRIES" },
    { code: 48, name: "KBK" },
    { code: 49, name: "M / S HAMMAD" },
    { code: 5, name: "Siemens" },
    { code: 50, name: "M / S NATIONAL" },
    { code: 51, name: "M / S IMS" },
    { code: 52, name: "ACCURATE COMPANY" },
    { code: 53, name: "VERTEX STATIC" },
    { code: 54, name: "ELSTER" },
    { code: 55, name: "RECLAIMED" },
    { code: 56, name: "KAIFA" },
    { code: 57, name: "XJ" },
    { code: 58, name: "CHINT" },
    { code: 59, name: "PEL" },
    { code: 6, name: "GEC" },
    { code: 7, name: "Ferranti" },
    { code: 8, name: "Mitsubishi" },
    { code: 9, name: "Syed Bhais" },
  ];
  // Debounce the input value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedInputValue(inputValue);
    }, 300); // Adjust the debounce delay as needed

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    if (batchError) {
      setWrongBatchPopup(true);
    } else {
      setWrongBatchPopup(false);
    }
  }, [batchError]);

  useEffect(() => {
    if (props.showTable && currentPath == "/meter-change-request-table") {
      if (token) {
        dispatch(
          fetchPaginatedMeterChangeRequestNormal({
            page: currentPageNormal,
            pageSize: pageSizeNormal,
            dateFrom: dateFromNormal,
            dateTo: dateToNormal,
            loadFrom: loadFromNormal,
            loadTo: loadToNormal,
            applicationProgressId: applicationProgressIdNormal,
            objectionStatus: objectionStatusNormal,
            officeCode: selectedOfficeCode || code,
          }),
        );
      }
    }
  }, [
    currentPageNormal,
    pageSizeNormal,
    dateFromNormal,
    dateToNormal,
    loadFromNormal,
    loadToNormal,
    applicationProgressIdNormal,
    objectionStatusNormal,
    selectedOfficeCode,
  ]);

  useEffect(() => {
    if (props.showTable && currentPath == "/meter-change-request-table") {
      if (token) {
        dispatch(
          fetchPaginatedMeterChangeRequestOverdue({
            page: currentPageOverdue,
            pageSize: pageSizeOverdue,
            dateFrom: dateFromOverdue,
            dateTo: dateToOverdue,
            loadFrom: loadFromOverdue,
            loadTo: loadToOverdue,
            applicationProgressId: applicationProgressIdOverdue,
            objectionStatus: objectionStatusOverdue,
            officeCode: selectedOfficeCode || code,
          }),
        );
      }
    }
  }, [
    currentPageOverdue,
    pageSizeOverdue,
    dateFromOverdue,
    dateToOverdue,
    loadFromOverdue,
    loadToOverdue,
    applicationProgressIdOverdue,
    objectionStatusOverdue,
    selectedOfficeCode,
  ]);

  const [arrearsDetailsRefnoToDisplay, setArrearsDetailsRefnoToDisplay] =
    useState({
      refNo: "",
      arrearsAmount: "",
      meterStatus: "",
      tariffDesc: "",
      meterType: "",
      phase: "",
      consumerName: "",
      consumerNo: "",
      consumerAddress: "",
      consumerEmail: "",
      paidArearImage: "",
      paidArearDate: "",
    });

  const [isDemandNoteExpired, setIsDemandNoteExpired] = useState(null);
  const [isRcoFeeVoucherExpired, setIsRcoFeeVoucherExpired] = useState(null);
  const [installRefNo, setInstallRefNo] = useState([]);
  const [estimateDistance, setEstimateDistance] = useState("");
  const [meterAlreadyInstalled, setMeterAlreadyInstalled] = useState("");
  const [showBoq, setShowBoq] = React.useState(false);
  const [dnDetails, setDnDetails] = useState({
    demandNoticeNo: "",
    demandNoteExpiryCount: null,
    issueDate: "",
    applicationId: "",
    dueDate: "",
    roOfficeAddress: "",
    consumerAccountNo: "",
    batchNo: "",
    voltage: "",
    tariff: "",
    coverageAreaOfPremises: "",
    bankName: "",
    industryFactoryType: "",
    sketchImage: "",
    isDistance40: "",
    connectionAccountNo: "",
    dnPaymentFlag: "",
    paymentMethod: "",
    dnPaymentVerificationFlag: "",
    // meterRent: "",
    // serviceRent: "",
    sanctionLoad: "",
    surveyedBy: "",
    surveyedDate: "",
    filledBy: "",
    filledDate: "",
    filledFlag: null,
    approvedBy: "",
    approvedDate: "",
    approvedFlag: null,
    paymentDate: "",
    capitalCostAmount: "",
    securityDepositeAmount: "",
  });

  const [rcoFeeVoucherDetails, setRcoFeeVoucherDetails] = useState({
    applicationId: "",
    issueDate: null,
    dueDate: null,
    fixedChargesAmount: null,
    rcoFeeAmount: null,
  });
  const [disconnectedMeterDetails, setDisconnectedMeterDetails] = useState([]);
  const [
    disconnectedMeterDetsForROApproval,
    setDisconnectedMeterDetsForROApproval,
  ] = useState({});
  const [
    disconnectedMeterDetsImgForROApproval,
    setDisconnectedMeterDetsImgForROApproval,
  ] = useState();

  const [rcoDetails, setRcoDetails] = useState({
    rcoId: "",
    applicationId: "",
    rcoCreationDate: "",
    urbanRural: "",
    fataPata: "",
    refNo: "",
    feederNo: "",
    batch: "",
    subBatch: "",
    fGovt: "",
    cantonmentBoard: "",
    pGovt: "",
    localBodies: "",
    rcoP1FilledBy: "",
    rcoP1FillingDate: "",
    rcoP1FillFlag: "",
    authorizedByName: "",
    dateOfAuthorization: "",
    rcoP1ApprovedFlag: "",
    storeRequisitionNo: "",
    storeRequisitionDate: "",
    seasonalFlag: "",
    sanctionedLoad: "",
    noOfACs: "",
    noOfMeters: "",
    noOfMeterSets: "",
    noOfSubSets: "",
    noOfSupplyPoints: "",
    installedTransformerCapacity: "",
    meterId: "",
    meterNo: "",
    locationCode: "",
    meterCode: "",
    manufacturerCode: "",
    multiplyingFactor: "",
    meterRange: "",
    meterReading: "",
    dateOfReConnection: "",
    cp78ItemNo: "",
    tieUpNonTieUp: "",
    sealOnMeter: "",
    sealOnBox: "",
    securitySlipOrPriceBondNo: "",
    connectionInstallerName: "",
    rcoP2FilledBy: "",
    rcoP2FillingDate: "",
    rcoP2FillFlag: "",
    rcoP2ApprovedBy: "",
    rcoP2ApprovalDate: "",
    rcoP2ApprovalFlag: "",
    installedMeterImage: "",
    meterType: null,
    threePhasePeak: null,
    threePhaseOffPeak: null,
    mdi: null,
    noOfMDIreset: null,
    cT: "",
    pT: "",
    threePhasePeakKVARH: "",
    threePhaseOffPeakKVARH: "",
    threePhasePeakKWH: "",
    threePhaseOffPeakKWH: "",
  });

  const [masterDataFormDetails, setMasterDataFormDetails] = useState({
    applicationId: "",
    electricityDuty: "",
    governmentDepartment: "",
    standardClassificationCode: "",
    incomeTax: "",
    reason: "",
    authority: "",
    filledBy: "",
    filledByDate: "",
    filledByFlag: "",
    approvedBy: "",
    approvalDate: "",
    approvalFlag: "",
  });
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [voucherActionType, setVoucherActionType] = useState("");
  const [voucherActionTypeForDN, setVoucherActionTypeForDN] = useState(""); // approve | reject
  const [openVoucherActionModal, setOpenVoucherActionModal] = useState(false);
  const [openVoucherActionModalForDN, setOpenVoucherActionModalForDN] =
    useState(false);
  const [partialValue, setPartialValue] = useState("");
  const noArrears = "Bill status has been updated as paid in IBS.";
  const [flag_applicantCNICFront, setFlag_applicantCNICFront] = useState(null);
  const [flag_applicantCNICBack, setFlag_applicantCNICBack] = useState(null);
  const [
    flag_scannedCopyOfNearByElectricityBill,
    setFlag_scannedCopyOfNearByElectricityBill,
  ] = useState(null);
  const [flag_anyOtherDocument, setFlag_anyOtherDocument] = useState(null);
  const [
    scannedCopyOfNearByElectricityBillObjectionRemarks,
    setScannedCopyOfNearByElectricityBillObjectionRemarks,
  ] = useState("");
  const [
    anyOtherDocumentObjectionRemarks,
    setAnyOtherDocumentObjectionRemarks,
  ] = useState("");
  const [flag_paidBillImage, setFlag_paidBillImage] = useState(null);
  const [errormessageCostEstimation, setErrormessageCostEstimation] =
    useState("");
  const [paidBillImageObjectionRemarks, setPaidBillImageObjectionRemarks] =
    useState("");
  const [
    applicantCNICFrontObjectionRemarks,
    setApplicantCNICFrontObjectionRemarks,
  ] = useState("");
  const [
    applicantCNICBackObjectionRemarks,
    setApplicantCNICBackObjectionRemarks,
  ] = useState("");
  const [meterTypeValue, setMeterTypeValue] = useState("");
  const [areaTypeValue, setAreaType] = useState("");
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [urbanRuralValue, setUrbanRural] = useState("");
  const [distance, setDistance] = useState("1");
  const [reconnectionApplications, setReconnectionApplications] = useState([]);
  const [showCostEstimation, setShowCostEstimation] = React.useState(false);
  const [isReferedToFeildSurvey, setIsReferedToFeildSurvey] = useState(false);
  const [
    reconnectionApplicationsToDataGrid,
    setReconnectionApplicationsToDataGrid,
  ] = useState([]);
  const [reconnectionApplicationsOverDue, setReconnectionApplicationsOverDue] =
    useState([]);
  const [
    reconnectionApplicationsOverDueToDataGrid,
    setReconnectionApplicationsOverDueToDataGrid,
  ] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openMeterRemovedPopup, setOpenMeterRemovedPopup] =
    React.useState(false);
  const [openReadingInfoPopup, setOpenReadingInfoPopup] = React.useState(false);
  const [meterRemovedRowCount, setMeterRemovedRowCount] = React.useState(1);
  const [meterRemovedLoading, setMeterRemovedLoading] = React.useState(false);
  const [meterRemovedError, setMeterRemovedError] = React.useState("");
  const [storedMeterRemovedData, setStoredMeterRemovedData] =
    React.useState(null);
  const [meterRemovedSnapshotRows, setMeterRemovedSnapshotRows] =
    React.useState(null);
  const [meterRemovedTariffCd, setMeterRemovedTariffCd] = React.useState("");
  const [ibsMeterIdBySetNo, setIbsMeterIdBySetNo] = React.useState({});
  const [ibsMaxRemovedSetNo, setIbsMaxRemovedSetNo] = React.useState(0);
  const [removedMeterDetailError, setRemovedMeterDetailError] =
    React.useState("");
  const [mcoInstalledMeterData, setMcoInstalledMeterData] = React.useState([]);
  const [objectionPopUpOpen, setObjectionPopUpOpen] = React.useState(false);
  const [arrearsEntryPopUpOpen, setArrearsEntryPopUpOpen] =
    React.useState(false);

  const [copyOfApplicantCNICVerifyPopUp, setCopyOfApplicantCNICVerifyPopUp] =
    useState(false);
  const [nearByBillVerifyPopUp, setNearByBillVerifyPopUp] = useState(false);
  const [anyOtherDocumentVerifyPopUp, setAnyOtherDocumentVerifyPopUp] =
    useState(false);
  const [paidBillImagePopUp, setPaidBillImagePopUp] = useState(false);
  const [installedMeterImageVerifyPopUp, setInstalledMeterImageVerifyPopUp] =
    useState(false);
  const [workForceData, setWorkForceData] = useState([]);
  const [fieldStaffDesignations, setFieldStaffDesignations] = useState([]);
  const [paidDNImagePopUp, setPaidDNImagePopUp] = useState(false);

  const [dnPaymentVerifyAlert, setDnPaymentVerifyAlert] = React.useState(false);
  const [dnPaymentRejectAlert, setDnPaymentRejectAlert] = React.useState(false);
  const [rcoPart1ApproveAlert, setRcoPart1ApproveAlert] = React.useState(false);
  const [rcoPart2ApproveAlert, setRcoPart2ApproveAlert] = React.useState(false);
  const [rejectionRemovalAlert, setRejectionRemovalAlert] =
    React.useState(false);
  const [fieldRejectionRemovalAlert, setFieldRejectionRemovalAlert] =
    React.useState(false);
  const [dialogRowData, setDialogRowData] = React.useState({});
  const [itemsArray, setItemsArray] = useState([]);
  const [dnReceiptImage, setDnReceiptImage] = useState();
  const [dnReceiptImageThumbnail, setDnReceiptImageThumbnail] = useState();
  const [mandtReceiptImage, setMandtReceiptImage] = useState();
  const [mandtReceiptImageThumbnail, setMandtReceiptImageThumbnail] =
    useState();
  const [mandtReceiptImageError, setMandtReceiptImageError] = useState();
  const [dnReceiptImageError, setDnReceiptImageError] = useState();
  const [dnApproveStep, setDnApproveStep] = useState([]);
  const [dnDets, setDnDets] = useState([]);
  const [dnImage, setDnImage] = useState();
  const [rcoFeeReceiptImage, setRcoFeeReceiptImage] = useState();
  const [rcoFeeReceiptImageError, setRcoFeeReceiptImageError] = useState();
  const [rcoFeeReceiptImageThumbnail, setRcoFeeReceiptImageThumbnail] =
    useState();
  const [paidBillImage, setPaidBillImage] = useState();
  const [paidBillImageError, setPaidBillImageError] = useState();
  const [paidBillImageThumbnail, setPaidBillImageThumbnail] = useState();
  const [approvalDocument, setApprovalDocument] = useState("");
  const [approvalDocumentError, setApprovalDocumentError] = useState("");
  const [approvalDocumentThumbnail, setApprovalDocumentThumbnail] =
    useState("");
  const [dnNumber, setDnNumber] = useState();
  const [dnPaymentDate, setDnPaymentDate] = useState();
  const [bankName, setBankName] = useState();
  const [itemsAmount, setItemsAmount] = useState(null);
  const [storeCharges, setStoreCharges] = useState(null);
  const [installationCharges, setInstallationCharges] = useState(null);
  const [gridSharingCost, setGridSharingCost] = useState(0);
  const [feederRehabilitationCharges, setFeederRehabilitationCharges] =
    useState(0);
  const [civilWorkCharges, setCivilWorkCharges] = useState(0);
  const [fixedChargesOfMetering, setFixedChargesOfMetering] = useState(0);
  const [miscellaneousCharges, setMiscellaneousCharges] = useState(0);
  const [lessTheCost, setLessTheCost] = useState(0);
  const [totalCharges, setTotalCharges] = useState(0);
  const [grandTotalCharges, setGrandTotalCharges] = useState(0);
  const [standardClassificationCode, setStandardClassificationCode] = useState({
    XCLFM_CODE: "",
    XCLFM_DESC: "",
  });
  const [govtDeptCode, setGovtDeptCode] = useState({
    departmentCode: "",
    departmentName: "",
  });
  const [boqItems, setBoqItems] = useState([]);
  const [govtDeptCodes, setGovtDeptCodes] = useState([]);
  const [manufacturerCode, setManufcaturerCode] = useState({
    code: null,
    name: "",
  });
  const [eFileData, setEFileData] = useState([]);
  const [eFileCurrentStatus, setEFileCurrentStatus] = useState(null);
  const [activityLogDetailOpen, setActivityLogDetailOpen] = useState(false);
  const [sketchDiagramUploaded, setSketchDiagramUploaded] = useState();
  const { state } = useLocation();
  const foundId = state && typeof state === "object" ? state.foundId : undefined;
  const [foundInNc, setFoundInNc] = useState();
  const [gridFlag, setGridFlag] = useState(false);
  const [feederRehabFlag, setFeederRehabFlag] = useState(false);
  const [industryFlag, setIndustryFlag] = useState(true);
  const [arearPaidBillDocument, setArearPaidBillDocument] = useState("");
  const [arearPaidBillDocumentThumbnail, setArearPaidBillDocumentThumbnail] =
    useState("");
  const [arearPaidBillDocumentError, setArearPaidBillDocumentError] =
    useState("");
  const [installedMeterImage, setInstalledMeterImage] = useState("");
  const [installedMeterImageError, setInstalledMeterImageError] = useState("");
  const [installedMeterImageThumbnail, setInstalledMeterImageThumbnail] =
    useState("");
  const [meterInstallmentError, setMeterInstallmentError] = useState("");
  const [historyData, setHistoryData] = useState(null);
  const [openImgDialog, setOpenImgDialog] = React.useState(false);
  const [openImgDialogDN, setOpenImgDialogDN] = React.useState(false);
  const [ripeAge, setRipeAge] = useState(0);
  const [unripeAge, setUnripeAge] = useState(0);
  const [error, setError] = useState("");
  const [fieldSurveyError, setFieldSurveyError] = useState("");
  const [linemanAllocationSubPopUp, setLinemanAllocationSubPopUp] =
    useState(false);
  const [showUpdateBatchPopup, setShowUpdateBatchPopup] = useState(false);
  const [newConnectionPopup, setNewConnectionPopup] = useState(false);
  const [rcoPopUp, setRcoPopUp] = useState(false);
  const [cpPopUp, setCpPopUp] = useState(false);
  const [costEstimationForNC, setCostEstimationForNC] = React.useState({});
  const [shortListIndustrialTariff, setShortListIndustrialTariff] = useState(
    [],
  );

  const computeMeterRemovedAdvanceUnits = (
    masterReading,
    meterReading,
    multiplyFactor,
  ) => {
    if (!isValidMeterReadingInput(meterReading)) {
      return "";
    }
    const master = parseRemovedMeterReading(masterReading) ?? 0;
    const meter = parseRemovedMeterReading(meterReading) ?? 0;
    const factor = parseFloat(multiplyFactor) || 0;
    const advance = (meter - master) * factor;
    if (!Number.isFinite(advance)) return "";
    return String(Number(advance.toFixed(6)));
  };

  const isValidMeterReadingInput = (value) =>
    /^\d+(\.\d*)?$/.test(String(value ?? "").trim());

  const isMeterRemovedReadingProvided = (value) =>
    isValidMeterReadingInput(value);

  const hasRemovedMeterDisplayValue = (value) => {
    const text = String(value ?? "").trim();
    return text !== "" && text !== "-";
  };

  const isMeaningfulRemovedMeterRow = (row) => {
    if (!row) return false;

    const hasMeterType =
      row.meterType !== "" &&
      row.meterType !== null &&
      row.meterType !== undefined;

    const hasSerial = hasRemovedMeterDisplayValue(row.serialNo);
    const hasReading =
      isMeterRemovedReadingProvided(row.masterReading) ||
      isMeterRemovedReadingProvided(row.meterReading);
    const hasMultiplyFactor = hasRemovedMeterDisplayValue(row.multiplyFactor);

    return hasMeterType && (hasSerial || hasReading || hasMultiplyFactor);
  };

  const areRemovedMeterRowsPopulated = (sourceRows = []) =>
    Array.isArray(sourceRows) &&
    sourceRows.length > 0 &&
    sourceRows.some(isMeaningfulRemovedMeterRow);

  const getRemovedMeterApiValue = (value) => {
    if (value === null || value === undefined || value === "") return null;
    if (typeof value === "number" && Number.isFinite(value)) return value;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : value;
  };

  const parseRemovedMeterReading = (value) => {
    if (!isMeterRemovedReadingProvided(value)) return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const resolveRemovedMeterTypeSuffix = (meterType) => {
    const normalized = String(meterType ?? "")
      .trim()
      .toUpperCase();
    if (meterType === 1 || meterType === "1" || normalized === "KWH") {
      return "KWH";
    }
    if (meterType === 2 || meterType === "2" || normalized === "KVARH") {
      return "KVARH";
    }
    if (meterType === 3 || meterType === "3" || normalized === "MDI") {
      return "MDI";
    }
    return "";
  };

  const normalizeRemovedMeterRowForSubmit = (row) => {
    const meterReading = isMeterRemovedReadingProvided(row.meterReading)
      ? row.meterReading
      : isMeterRemovedReadingProvided(row.masterReading)
        ? row.masterReading
        : row.meterReading;

    return {
      ...row,
      meterReading,
      advanceUnits: computeMeterRemovedAdvanceUnits(
        row.masterReading,
        meterReading,
        row.multiplyFactor,
      ),
    };
  };

  const resolveRemovedMeterTransType = (meterType) => {
    const normalized = String(meterType ?? "")
      .trim()
      .toUpperCase();
    if (meterType === 1 || meterType === "1" || normalized === "KWH") return 1;
    if (meterType === 2 || meterType === "2" || normalized === "KVARH") return 2;
    if (meterType === 3 || meterType === "3" || normalized === "MDI") return 3;
    const parsed = Number(meterType);
    if (Number.isFinite(parsed) && parsed >= 1 && parsed <= 3) return parsed;
    return 1;
  };

  /** API installMeterId: KWH=1, KVARH=2, MDI=3 (per row meter type). */
  const resolveInstallMeterIdForApi = (meterType) =>
    resolveRemovedMeterTransType(meterType);

  const buildRemovedMeterProfileFromRows = (sourceRows = []) =>
    sourceRows.map((row) => ({
      removeSetNo: Number(row.setNo) || 1,
      transType: resolveRemovedMeterTransType(
        row.removeMeterId ?? row.meterId ?? row.meterType,
      ),
      removeMeterSerial: String(row.serialNo || "").trim(),
      removedMultiplyingFactor: parseFloat(row.multiplyFactor) || 0,
      removeMeterMasterReading:
        parseRemovedMeterReading(row.masterReading) ?? 0,
      removeMeterReading: parseRemovedMeterReading(row.meterReading) ?? 0,
      removedAdvanceUnits: parseFloat(row.advanceUnits) || 0,
      removeCons: String(row.advanceUnits ?? "").trim(),
      removeRoundComCode: String(row.roundingCompCode ?? "").trim(),
      removeMeterId:
        resolveRemovedMeterTransType(
          row.removeMeterId ?? row.meterId ?? row.meterType,
        ) || 0,
    }));

  const buildRemovedMeterPayloadFromRows = (sourceRows = []) => {
    const meterRemovedData = {};

    sourceRows.forEach((row) => {
      const setNo = row.setNo;
      const typeSuffix = resolveRemovedMeterTypeSuffix(row.meterType);

      if (!typeSuffix || !setNo) return;

      if (!meterRemovedData[`R_MULTIPLYING_FACTOR_${setNo}`]) {
        meterRemovedData[`R_MULTIPLYING_FACTOR_${setNo}`] =
          parseFloat(row.multiplyFactor) || 0;
      }
      if (!meterRemovedData.R_METER_SERIAL_NO) {
        meterRemovedData.R_METER_SERIAL_NO = row.serialNo || "";
      }

      meterRemovedData[`R_MASTER_READING_${typeSuffix}_${setNo}`] =
        parseRemovedMeterReading(row.masterReading);
      meterRemovedData[`R_METER_READING_${typeSuffix}_${setNo}`] =
        parseRemovedMeterReading(row.meterReading);

      const computedAdvanceUnits =
        ((parseRemovedMeterReading(row.meterReading) ?? 0) -
          (parseRemovedMeterReading(row.masterReading) ?? 0)) *
        (parseFloat(row.multiplyFactor) || 0);
      meterRemovedData[`R_ADVANCE_UNIT_${typeSuffix}_${setNo}`] =
        Number.isFinite(computedAdvanceUnits) ? computedAdvanceUnits : 0;
      meterRemovedData[`R_ROUNDING_COMP_CODE_${typeSuffix}_${setNo}`] =
        row.roundingCompCode ?? "";

      const rowMeterId = row.removeMeterId ?? row.meterId;
      if (rowMeterId !== null && rowMeterId !== undefined && rowMeterId !== "") {
        meterRemovedData[`R_METER_ID_${typeSuffix}_${setNo}`] = Number(rowMeterId);
      }
    });

    meterRemovedData.removedMeterProfile =
      buildRemovedMeterProfileFromRows(sourceRows);
    meterRemovedData.R_NO_KWH_METER = getMaxSetNoFromMeterRows(sourceRows);

    return meterRemovedData;
  };

  const getMaxSetNoFromIbsProfile = (profile = []) =>
    profile.reduce((maxSetNo, item) => {
      const setNo = Number(item?.SET_NO);
      return Number.isFinite(setNo) && setNo > maxSetNo ? setNo : maxSetNo;
    }, 0);

  const getMaxSetNoFromMeterRows = (rows = []) =>
    rows.reduce((maxSetNo, row) => {
      const setNo = Number(row?.setNo ?? row?.SET_NO ?? row?.removeSetNo);
      return Number.isFinite(setNo) && setNo > maxSetNo ? setNo : maxSetNo;
    }, 0);

  const resolveRNoKwhMeterForSubmit = (
    storedData,
    removedRows = [],
    maxSetNoFromIbs = 0,
  ) => {
    const ibsMax = Number(maxSetNoFromIbs);
    if (Number.isFinite(ibsMax) && ibsMax > 0) {
      return Math.floor(ibsMax);
    }

    const storedMax = Number(storedData?.R_NO_KWH_METER);
    if (Number.isFinite(storedMax) && storedMax > 0) {
      return Math.floor(storedMax);
    }

    const profileMax = getMaxSetNoFromMeterRows(
      storedData?.removedMeterProfile || [],
    );
    if (profileMax > 0) return profileMax;

    return getMaxSetNoFromMeterRows(removedRows);
  };

  /** Total kWh field value (iv_total_kwh) for I_NO_KWH_METER. */
  const resolveINoKwhMeterForSubmit = (totalKwhValue) => {
    const parsed = parseInt(String(totalKwhValue ?? "").trim(), 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
  };

  const NET_METER_TARIFF_CD = "12";

  const isNetMeterTariff = (tariffCd) =>
    String(tariffCd ?? "").trim() === NET_METER_TARIFF_CD;

  const getSetNoLabel = (
    setNo,
    tariffCd = meterRemovedTariffCd,
    tariffObj = selectedMCOTariffObj,
  ) => {
    const no = Number(setNo);
    if (!Number.isFinite(no) || no <= 0) return setNo ?? "";

    const showPeakOffPeak = isTruthyFlag(getTariffFlagRaw(tariffObj, "tod"));
    const peakLabel = no % 2 === 1 ? "Off Peak" : "Peak";

    if (isNetMeterTariff(tariffCd)) {
      if (no === 1 || no === 2) {
        return showPeakOffPeak ? `${peakLabel} Import` : "Import";
      }
      if (no === 3 || no === 4) {
        return showPeakOffPeak ? `${peakLabel} Export` : "Export";
      }
    }

    if (!showPeakOffPeak) return String(no);
    return peakLabel;
  };

  const getPeakOffPeakSetNoLabel = (
    setNo,
    tariffObj = selectedMCOTariffObj,
  ) => {
    const no = Number(setNo);
    if (!Number.isFinite(no) || no <= 0) return setNo ?? "";
    if (!isTruthyFlag(getTariffFlagRaw(tariffObj, "tod"))) return String(no);
    return no % 2 === 1 ? "Off Peak" : "Peak";
  };

  const ibsProfileIndicatesNetMeter = (profile = []) =>
    profile.some((item) => Number(item?.SET_NO) === 4);

  const buildIbsMeterIdMap = (profile = []) => {
    const meterIdMap = {};
    profile.forEach((item) => {
      const setNo = item?.SET_NO;
      const meterId = item?.METER_ID;
      if (setNo !== null && setNo !== undefined && meterId !== null && meterId !== undefined) {
        meterIdMap[Number(setNo)] = meterId;
      }
    });
    return meterIdMap;
  };

  const getInstallMeterIdForSet = (setNo) => {
    const no = Number(setNo);
    if (!Number.isFinite(no) || no <= 0) return undefined;

    if (ibsMeterIdBySetNo[no] !== undefined && ibsMeterIdBySetNo[no] !== null) {
      return ibsMeterIdBySetNo[no];
    }

    const removedRow = (meterRemovedSnapshotRows || []).find(
      (row) => Number(row?.setNo) === no,
    );
    return removedRow?.installMeterId ?? removedRow?.meterId ?? removedRow?.removeMeterId;
  };

  const removedRowsIndicateNetMeter = (sourceRows = []) =>
    sourceRows.some((row) => Number(row?.setNo) === 4);

  const tagRemovedRowsWithNetMeterFlag = (sourceRows = []) => {
    const isNetMeterProfile = removedRowsIndicateNetMeter(sourceRows);
    return sourceRows.map((row) => ({
      ...row,
      isNetMeterProfile,
    }));
  };

  const getMeterRemovedSetNoLabel = (row) => {
    const tariffObj =
      selectedMCOTariffObj ||
      findMCOTariffObj(
        dialogRowData?.tariffDesc,
        dialogRowData?.tariffCode ?? meterRemovedTariffCd,
      );

    if (row?.isNetMeterProfile) {
      return getSetNoLabel(row?.setNo, NET_METER_TARIFF_CD, tariffObj);
    }
    if (row?.isCp138ProfileRow) {
      return getPeakOffPeakSetNoLabel(row?.setNo, tariffObj);
    }
    return getSetNoLabel(
      row?.setNo,
      row?.tariffCd ?? meterRemovedTariffCd,
      tariffObj,
    );
  };

  const handleChange = (idx, field, value) => {
    setRows((prev) =>
      prev.map((r, i) => {
        if (i !== idx) return r;

        if (field === "meterReading") {
          const meterReading = value;
          const advanceUnits = computeMeterRemovedAdvanceUnits(
            r.masterReading,
            meterReading,
            r.multiplyFactor,
          );

          return { ...r, meterReading, advanceUnits };
        }

        return { ...r, [field]: value };
      }),
    );
  };

  const findMCOTariffObj = (
    selectedTariffName,
    tariffCodeHint = "",
    mcoTariffSource = allMCOTariffList,
    cfpTariffSource = allTariffList,
  ) => {
    const normalizeTariffCode = (code) => {
      if (code === null || code === undefined) return "";
      const strCode = String(code).trim();
      if (!strCode) return "";
      return strCode.padStart(2, "0");
    };

    const normalizeText = (value) =>
      String(value || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");

    const codeFromText = (value) =>
      normalizeTariffCode(String(value || "").match(/\((\d+)\)/)?.[1] || "");

    const getTariffCodeFromObject = (tariff) => {
      const rawCode =
        tariff?.Tariff_Code ??
        tariff?.tariffCode ??
        tariff?.tariffcode ??
        tariff?.code ??
        tariff?.tariff_code ??
        tariff?.TARIFF_CODE;

      return (
        normalizeTariffCode(rawCode) ||
        codeFromText(tariff?.Tariff_Name || tariff?.tariffName)
      );
    };

    const selectedTariff = (cfpTariffSource || []).find(
      (tariff) => tariff?.tariffName === selectedTariffName,
    );

    const codeFromName =
      typeof selectedTariffName === "string"
        ? selectedTariffName.match(/\((\d+)\)/)?.[1] || ""
        : "";

    const resolvedTariffCode = normalizeTariffCode(
      selectedTariff?.tariffCode || tariffCodeHint || codeFromName,
    );

    const normalizedSelectedName = normalizeText(selectedTariffName);

    return (
      (mcoTariffSource || []).find((tariff) => {
        const mcoCode = getTariffCodeFromObject(tariff);
        const mcoName = normalizeText(tariff?.Tariff_Name || tariff?.tariffName);
        return (
          (resolvedTariffCode && mcoCode && mcoCode === resolvedTariffCode) ||
          (mcoName && mcoName === normalizedSelectedName)
        );
      }) || null
    );
  };

  const handleTariffSelection = (
    selectedTariffName,
    tariffCodeHint = "",
    mcoTariffSource = allMCOTariffList,
  ) => {
    const normalizeTariffCode = (code) => {
      if (code === null || code === undefined) return "";
      const strCode = String(code).trim();
      if (!strCode) return "";
      return strCode.padStart(2, "0");
    };

    const selectedTariff = (allTariffList || []).find(
      (tariff) => tariff?.tariffName === selectedTariffName,
    );

    const codeFromName =
      typeof selectedTariffName === "string"
        ? selectedTariffName.match(/\((\d+)\)/)?.[1] || ""
        : "";

    const resolvedTariffCode = normalizeTariffCode(
      selectedTariff?.tariffCode || tariffCodeHint || codeFromName,
    );

    setSelectedTariffCode(resolvedTariffCode);
    setSelectedMCOTariffObj(
      findMCOTariffObj(
        selectedTariffName,
        tariffCodeHint,
        mcoTariffSource,
        allTariffList,
      ),
    );
  };

  const isTruthyFlag = (rawValue) => {
    const normalized = String(rawValue ?? "")
      .trim()
      .toUpperCase();
    return ["Y", "YES", "1", "TRUE", "T"].includes(normalized);
  };

  const toApiBooleanFlag = (rawValue) => {
    const normalized = String(rawValue ?? "")
      .trim()
      .toUpperCase();
    if (normalized === "Y") return true;
    if (normalized === "N") return false;
    return false;
  };

  const getTariffFlagRaw = (tariffObj, flagType) => {
    if (!tariffObj) return "";

    if (flagType === "mdi") {
      return (
        tariffObj?.mdiFlag ??
        tariffObj?.MDI_Flag ??
        tariffObj?.MDI_FLAG ??
        tariffObj?.MDIFlag ??
        tariffObj?.mdi_flag ??
        ""
      );
    }

    if (flagType === "tod") {
      return (
        tariffObj?.todFlag ??
        tariffObj?.TOD_Flag ??
        tariffObj?.TOD_FLAG ??
        tariffObj?.TODFlag ??
        tariffObj?.tod_flag ??
        ""
      );
    }

    return "";
  };

  const hasMdiTariff = (tariffObj) =>
    isTruthyFlag(getTariffFlagRaw(tariffObj, "mdi"));

  const hasTodTariff = (tariffObj) =>
    isTruthyFlag(getTariffFlagRaw(tariffObj, "tod"));

  const canSelectNetMeterYes = (tariffObj = selectedMCOTariffObj) =>
    Boolean(tariffObj) && hasTodTariff(tariffObj);

  const isNetMeterFieldLocked = (tariffObj = selectedMCOTariffObj) =>
    Boolean(tariffObj) && !hasTodTariff(tariffObj);

  const isInstalledNetMeterSelected = () =>
    scoPart2Formik?.values?.iv_is_net_meter === "1";

  const getExpectedTotalKwhForReading = (
    tariffObj = selectedMCOTariffObj,
    isNetMeter = scoPart2Formik?.values?.iv_is_net_meter,
  ) => {
    if (isNetMeterFieldLocked(tariffObj)) {
      return "1";
    }

    if (String(isNetMeter) === "1") {
      return "4";
    }

    return "2";
  };

  const isTotalKwhValidForReading = (
    totalKwh = scoPart2Formik?.values?.iv_total_kwh,
  ) => {
    const value = String(totalKwh ?? "").trim();
    if (!value) return false;

    return value === getExpectedTotalKwhForReading();
  };

  const resolveEffectiveTotalKwhForReading = (totalKwhMeters) => {
    const formikTotalKwh = scoPart2Formik?.values?.iv_total_kwh;
    const resolvedTotalKwh =
      totalKwhMeters !== undefined && totalKwhMeters !== null
        ? totalKwhMeters
        : formikTotalKwh;

    if (!isTotalKwhValidForReading(resolvedTotalKwh)) {
      return 0;
    }

    return parseInt(String(resolvedTotalKwh).trim(), 10) || 0;
  };

  const syncNetMeterFieldsWithTariff = (tariffObj = selectedMCOTariffObj) => {
    if (!tariffObj) return;

    if (!hasTodTariff(tariffObj)) {
      if (scoPart2Formik.values.iv_is_net_meter !== "0") {
        scoPart2Formik.setFieldValue("iv_is_net_meter", "0", false);
      }
      if (String(scoPart2Formik.values.iv_total_kwh || "").trim() !== "1") {
        scoPart2Formik.setFieldValue("iv_total_kwh", "1", false);
      }
      return;
    }

    const currentNetMeter = String(scoPart2Formik.values.iv_is_net_meter || "").trim();
    if (currentNetMeter !== "0" && currentNetMeter !== "1") {
      scoPart2Formik.setFieldValue("iv_is_net_meter", "0", false);
    }
  };

  const shouldCaptureMdiValues =
    phase !== "Single Phase" && phase !== "3 Phase" && hasMdiTariff(selectedMCOTariffObj);

  const getReadingMeterTypes = (tariffObj) => {
    const hasMdi = hasMdiTariff(tariffObj);

    // Per matrix: MDI=N => 1 row per set, MDI=Y => 3 rows per set.
    return hasMdi ? [1, 2, 3] : [1];
  };

  const buildReadingRows = (totalKwhMeters, tariffObj) => {
    const total = resolveEffectiveTotalKwhForReading(totalKwhMeters);

    if (total <= 0) return [];

    const isNetMeterSelected = isInstalledNetMeterSelected();
    const removedRowsForNetCheck = meterRemovedSnapshotRows?.length
      ? meterRemovedSnapshotRows
      : storedMeterRemovedData
        ? getRemovedMeterTableRows(storedMeterRemovedData)
        : [];
    const isNetMeterProfile =
      isNetMeterSelected ||
      removedRowsIndicateNetMeter(removedRowsForNetCheck) ||
      removedRowsForNetCheck.some((row) => row?.isNetMeterProfile);

    const meterTypes = getReadingMeterTypes(tariffObj);
    const rows = [];

    for (let setNo = 1; setNo <= total; setNo++) {
      meterTypes.forEach((meterType) => {
        const installMeterId = resolveInstallMeterIdForApi(meterType);
        rows.push({
          key: `${setNo}_${meterType}`,
          setNo,
          meterType,
          installMeterId,
          isNetMeterProfile,
          tariffCd: isNetMeterProfile
            ? NET_METER_TARIFF_CD
            : meterRemovedTariffCd,
        });
      });
    }

    return rows;
  };

  const getMeterLocationLabel = (locationCode) => {
    if (locationCode === "P") return "P";
    if (locationCode === "O") return "O";
    if (locationCode === "I") return "I";
    return "";
  };

  const getMeterManufacturerLabel = (manufacturerCodeValue) => {
    const matchedManufacturer = manufacturesList.find(
      (manufacturer) =>
        String(manufacturer.code) === String(manufacturerCodeValue || ""),
    );
    return matchedManufacturer ? String(matchedManufacturer.code) : "";
  };

  const resolveTariffCodeForApi = (tariffValue) => {
    if (tariffValue === null || tariffValue === undefined) return "";
    const str = String(tariffValue).trim();
    if (!str) return "";
    const fromParen = str.match(/\((\d+)\)/)?.[1];
    if (fromParen) return fromParen.padStart(2, "0");
    if (/^\d+$/.test(str)) return str.padStart(2, "0");
    return str;
  };

  const formatApiDateTime = (dateValue) => {
    if (!dateValue) return "";
    const parsed = new Date(dateValue);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toISOString().split("T")[0];
    }
    return String(dateValue).split("T")[0];
  };

  const getRemovedMeterRowsForSubmit = () => {
    if (meterRemovedSnapshotRows?.length > 0) {
      return meterRemovedSnapshotRows.map(normalizeRemovedMeterRowForSubmit);
    }
    if (storedMeterRemovedData?.removedMeterProfile?.length) {
      return normalizeStoredRemovedMeterRows(
        buildRemovedMeterRowsFromProfile(storedMeterRemovedData.removedMeterProfile),
      ).map(normalizeRemovedMeterRowForSubmit);
    }
    if (storedMeterRemovedData) {
      return normalizeStoredRemovedMeterRows(
        buildRemovedMeterRows(storedMeterRemovedData),
      ).map(normalizeRemovedMeterRowForSubmit);
    }
    return [];
  };

  const buildRemoveMeterInfoArray = (sourceRows = []) => {
    const applicationId = dialogRowData?.applicationId || "";
    const referenceNo = dialogRowData?.referenceNo || "";

    return sourceRows
      .filter((row) => row.setNo && resolveRemovedMeterTypeSuffix(row.meterType))
      .map((row, index) => {
        const removedMultiplyingFactor = parseFloat(row.multiplyFactor);
        const removedAdvanceUnits = parseFloat(row.advanceUnits);

        return {
          applicationId,
          referenceNo,
          transType: resolveRemovedMeterTransType(
            row.removeMeterId ?? row.meterType ?? row.meterId,
          ),
          removeMeterId:
            resolveRemovedMeterTransType(
              row.removeMeterId ?? row.meterId ?? row.METER_ID,
            ) || index + 1,
          removeSetNo: Number(row.setNo) || 1,
          removeMeterSerial: String(row.serialNo || "").trim(),
          removeMeterReading: parseRemovedMeterReading(row.meterReading) ?? 0,
          removeMeterMasterReading:
            parseRemovedMeterReading(row.masterReading) ?? 0,
          removedMultiplyingFactor: Number.isFinite(removedMultiplyingFactor)
            ? removedMultiplyingFactor
            : 0,
          removedAdvanceUnits: Number.isFinite(removedAdvanceUnits)
            ? removedAdvanceUnits
            : 0,
          removeCons: String(row.advanceUnits ?? "").trim(),
          removeRoundComCode: String(row.roundingCompCode || "").trim(),
        };
      });
  };

  const buildInstallMeterInfoArray = (readingRows, readingInfo, values) => {
    const applicationId = dialogRowData?.applicationId || "";
    const referenceNo = dialogRowData?.referenceNo || "";
    const feederCode = dialogRowData?.feederCode || "";
    const mdiResetNo = shouldCaptureMdiValues
      ? parseFloat(values.iv_no_of_mdi_resets) || 0
      : 0;
    const cumulativeMdi = shouldCaptureMdiValues
      ? parseFloat(values.iv_mdi) || 0
      : 0;
    const computedInstallMultiplyingFactor = parseFloat(
      calculateMF(
        values.iv_ct_nom,
        values.iv_ct_denom,
        values.iv_pt_nom,
        values.iv_pt_denom,
      ),
    );
    const installMultiplyingFactor = Number.isFinite(
      computedInstallMultiplyingFactor,
    )
      ? computedInstallMultiplyingFactor
      : 0;

    return readingRows.map((row, index) => {
      const rowData = readingInfo[row.key] || {};
      const setNo = Number(row.setNo) || 0;
      const meterType = Number(row.meterType) || 0;
      const isOffPeakSet = setNo % 2 === 1;
      const meterCode = isOffPeakSet
        ? rowData.meterCodeOffPeak || values.iv_meter_code1
        : rowData.meterCodePeak || values.iv_meter_code2 || values.iv_meter_code1;
      const meterRange = parseFloat(rowData.meterRange || values.iv_meter_range);
      const meterRead = parseFloat(rowData.meterReading);

      return {
        applicationId,
        referenceNo,
        installMeterId: resolveInstallMeterIdForApi(row.meterType),
        installSetNo: setNo,
        installMeterSerial: values.iv_meter_serial_no || "",
        installMeterMNFG:
          getMeterManufacturerLabel(values.iv_manufacturer_code) ||
          values.iv_manufacturer_code ||
          "",
        installLocationCode: values.iv_location_code
          ? String(values.iv_location_code).trim()
          : "",
        installMeterCode: meterCode || "",
        installMeterRange: Number.isFinite(meterRange) ? meterRange : 0,
        installMultiplyingFactor,
        installMeterReading: Number.isFinite(meterRead) ? meterRead : 0,
        installMDIResetNo: meterType === 3 ? mdiResetNo : 0,
        installCummulativeMDI: meterType === 3 ? cumulativeMdi : 0,
        installMeterFeederCode: feederCode,
      };
    });
  };

  const getReadingRowBaseData = (row) => {
    const isNormalMeter =
      Number(dialogRowData?.meterType ?? scoPart2Formik.values.iv_meter_typee) ===
      0;

    return {
      setNoLabel: getMeterRemovedSetNoLabel(row),
      meterTypeLabel:
        Number(row.meterType) === 1
          ? "KWH"
          : Number(row.meterType) === 2
            ? "KVARH"
            : Number(row.meterType) === 3
              ? "MDI"
              : "",
      meterSerialNo: scoPart2Formik.values.iv_meter_serial_no || "",
      meterManufacturer: getMeterManufacturerLabel(
        scoPart2Formik.values.iv_manufacturer_code,
      ),
      meterRange: String(scoPart2Formik.values.iv_meter_range || ""),
      meterLocation: getMeterLocationLabel(scoPart2Formik.values.iv_location_code),
      meterCode: scoPart2Formik.values.iv_meter_code1 || "",
      meterCodeOffPeak: scoPart2Formik.values.iv_meter_code1 || "",
      meterCodePeak: scoPart2Formik.values.iv_meter_code2 || scoPart2Formik.values.iv_meter_code1 || "",
      multiplyFactor: String(
        calculateMF(
          scoPart2Formik.values.iv_ct_nom,
          scoPart2Formik.values.iv_ct_denom,
          scoPart2Formik.values.iv_pt_nom,
          scoPart2Formik.values.iv_pt_denom,
        ) || "",
      ),
    };
  };

  const handleReadingInfoChange = (rowKey, fieldName, value) => {
    setReadingInfoError("");
    const [setNoPart, meterTypePart] = String(rowKey || "").split("_");
    // Only update the local draft while editing the popup. Commit to Formik on Save.
    setReadingInfoDraft((prev) => ({
      ...prev,
      [rowKey]: value,
    }));
  };

  const METER_READING_DECIMAL_PLACES = 3;

  const sanitizeDecimalInput = (
    rawValue,
    maxFractionDigits = METER_READING_DECIMAL_PLACES,
  ) => {
    let value = String(rawValue ?? "").replace(/[^\d.]/g, "");

    // Decimal point is only valid after at least one digit (e.g. "0.", "123.5")
    while (value.startsWith(".")) {
      value = value.slice(1);
    }

    const firstDot = value.indexOf(".");

    if (firstDot !== -1) {
      const intPart = value.slice(0, firstDot);
      if (!intPart) return "";
      const fractionPart = value
        .slice(firstDot + 1)
        .replace(/\./g, "")
        .slice(0, maxFractionDigits);
      value = `${intPart}.${fractionPart}`;
    }

    return value;
  };

  const restrictToNumericInput = (event) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "Tab",
      "Escape",
      "Enter",
      "ArrowLeft",
      "ArrowRight",
      "Home",
      "End",
    ];
    const isShortcut =
      (event.ctrlKey || event.metaKey) &&
      ["a", "c", "v", "x"].includes(String(event.key || "").toLowerCase());

    if (allowedKeys.includes(event.key) || isShortcut) {
      return;
    }

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  };

  const restrictToDecimalInput = (event) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "Tab",
      "Escape",
      "Enter",
      "ArrowLeft",
      "ArrowRight",
      "Home",
      "End",
      ".",
      "Decimal",
    ];
    const isShortcut =
      (event.ctrlKey || event.metaKey) &&
      ["a", "c", "v", "x"].includes(String(event.key || "").toLowerCase());

    if (allowedKeys.includes(event.key) || isShortcut) {
      return;
    }

    if (event.key === "." || event.key === "Decimal") {
      const currentValue = String(event.currentTarget?.value ?? "");
      const selectionStart = event.currentTarget?.selectionStart ?? currentValue.length;
      const textBeforeCursor = currentValue.slice(0, selectionStart);

      if (!/\d/.test(textBeforeCursor) || currentValue.includes(".")) {
        event.preventDefault();
      }
      return;
    }

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  };

  const isReadingInfoComplete = (useDraft = false) => {
    const readingRows = buildReadingRows(
      scoPart2Formik?.values?.iv_total_kwh,
      selectedMCOTariffObj,
    );

    if (readingRows.length === 0) {
      return false;
    }

    return !readingRows.some((row) => {
      if (useDraft && openReadingInfoPopup) {
        const draftVal =
          readingInfoDraft &&
          Object.prototype.hasOwnProperty.call(readingInfoDraft, row.key)
            ? String(readingInfoDraft[row.key] || "").trim()
            : "";
        return !isValidMeterReadingInput(draftVal);
      }

      const rowData = scoPart2Formik?.values?.iv_reading_info?.[row.key] || {};
      const meterReading = String(rowData.meterReading || "").trim();
      return !isValidMeterReadingInput(meterReading);
    });
  };

  const validateReadingInfoRows = () => {
    const readingRows = buildReadingRows(
      scoPart2Formik?.values?.iv_total_kwh,
      selectedMCOTariffObj,
    );

    if (readingRows.length === 0) {
      setReadingInfoError(
        isTotalKwhValidForReading()
          ? "Reading information rows are required."
          : "Please enter a valid Total kWh (2 for standard meter, 4 for Net Meter) before adding readings.",
      );
      return false;
    }

    if (!isReadingInfoComplete(openReadingInfoPopup)) {
      setReadingInfoError("Please fill Meter Reading for all rows.");
      return false;
    }

    setReadingInfoError("");
    return true;
  };

  // Wrapper that runs pre-submit checks before Formik submit
  const handleMeterInstallSubmit = async () => {
    // Check Removed Meter Details
    const hasRemovedMeterError = !storedMeterRemovedData;
    if (hasRemovedMeterError) {
      setRemovedMeterDetailError(
        "Please fill Removed Meter Detail before submitting.",
      );
    } else {
      setRemovedMeterDetailError("");
    }

    // Check Reading Information
    const isReadingInfoValid = validateReadingInfoRows();

    // Keep legacy single-phase field in sync with Reading Information table.
    const firstReadingValue = String(
      scoPart2Formik.values?.iv_reading_info?.["1_1"]?.meterReading || "",
    ).trim();
    const currentMeterReading = String(
      scoPart2Formik.values?.iv_meter_reading || "",
    ).trim();

    if (!currentMeterReading && firstReadingValue) {
      await scoPart2Formik.setFieldValue(
        "iv_meter_reading",
        firstReadingValue,
        false,
      );
    }

    const errors = await scoPart2Formik.validateForm();
    const hasFormikErrors = Object.keys(errors).length > 0;
    if (Object.keys(errors).length > 0) {
      const touchedFields = Object.keys(scoPart2Formik.values || {}).reduce(
        (acc, key) => ({ ...acc, [key]: true }),
        {},
      );
      scoPart2Formik.setTouched(touchedFields, true);
    }

    if (hasRemovedMeterError || !isReadingInfoValid || hasFormikErrors) {
      return;
    }

    scoPart2Formik.handleSubmit();
  };

  const handleSubmit = () => {
    const normalizedRows = rows.map(normalizeRemovedMeterRowForSubmit);

    // Validate all rows - Meter Reading and Rounding Comp Code are required
    const invalidRows = normalizedRows.filter((row) => {
      return (
        !isMeterRemovedReadingProvided(row.meterReading) ||
        !row.roundingCompCode ||
        row.roundingCompCode.toString().trim() === ""
      );
    });

    if (invalidRows.length > 0) {
      setMeterRemovedError(
        "Please fill all required fields (Meter Reading, Rounding Comp Code) for all rows.",
      );
      return;
    }
    // Validate Meter Reading is not less than Master Reading
    const invalidMeterReadingRows = normalizedRows.filter((row) => {
      const meterReading = parseRemovedMeterReading(row.meterReading) ?? 0;
      const masterReading = parseRemovedMeterReading(row.masterReading) ?? 0;
      return meterReading < masterReading;
    });

    if (invalidMeterReadingRows.length > 0) {
      setMeterRemovedError(
        "Meter Reading should be equal to or greater than Master Reading.",
      );
      return;
    }

    setMeterRemovedError("");

    const meterRemovedData = buildRemovedMeterPayloadFromRows(normalizedRows);

    // Store the meter removed data in state for use in main form submit
    setStoredMeterRemovedData(meterRemovedData);
    setIbsMaxRemovedSetNo(
      getMaxSetNoFromMeterRows(normalizedRows) ||
        meterRemovedData.R_NO_KWH_METER ||
        0,
    );
    setMeterRemovedSnapshotRows(cloneMeterRemovedRows(normalizedRows));
    setRemovedMeterDetailError("");

    // Close the popup (keep submitted values in rows for edit reopen)
    setOpenMeterRemovedPopup(false);
  };
  const govtDeptCodesFromlocalStorage = JSON.parse(
    localStorage.getItem("govtDeptCodes"),
  );
  const getClassificationCodesFromlocalStorage = JSON.parse(
    localStorage.getItem("govtClassFeCodes"),
  );
  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };
  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const tableColumnsProcessingSummary = [
    {
      header: "Step Name",
      accessorKey: "stepName",
    },
    {
      header: "Processed By",
      accessorKey: "processedBy",
    },
    {
      header: "Date",
      accessorKey: "date",
    },
    {
      header: "Remarks",
      accessorKey: "remarks",
    },
  ];

  const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState(
    [],
  );

  // Sub Popup states
  const [documentsVerifiedSubPopUp, setDocumentsVerifiedSubPopUp] =
    useState(false);
  const [applicationSubittedPopUp, setApplicationSubmittedPopUp] =
    useState(false);
     const [approvalRejectionSubPopUp, setApprovalRejectionSubPopUp] =
    useState(false);
  const [arrearVerifiedSubPopUp, setArrearVerifiedSubPopUp] = useState(false);
  const [rcoFeeVoucherApprovalSubPopUp, setRcoFeeVoucherApprovalSubPopUp] =
    useState(false);
  const [rcoFeeVoucherSubmissionSubPopUp, setRcoFeeVoucherSubmissionSubPopUp] =
    useState(false);
  const [
    rcoFeeVoucherVerificationSubPopUp,
    setRcoFeeVoucherVerificationSubPopUp,
  ] = useState(false);
  const [meterInstalationSubPopUp, setMeterInstalationSubPopUp] =
    useState(false);
  const [dnApprovalSubPopUp, setDnApprovalSubPopUp] = useState(false);
  const [dnSubmissionSubPopUp, setDnSubmissionSubPopUp] = useState(false);
  const [dnVerificationSubPopUp, setDnVerificationSubPopUp] = useState(false);
  const [mtSubmissionSubPopUp, setMtSubmissionSubPopUp] = useState(false);

  const [fieldSurveySubPopUp, setFieldSurveySubPopUp] = useState(false);
  const [forwardToROSubPopUp, setForwardToROSubPopUp] = useState(false);
  const [readyForBillingSubPopUp, setreadyForBillingSubPopUp] = useState(false);
  const [fieldSurveyedSubPopUp, setFieldSurveyedSubPopUp] = useState(false);
  const [referenceNoAllocatedSubPopUp, setReferenceNoAllocatedSubPopUp] =
    useState(false);
  const [dnPaymentSubmittedSubPopUp, setDnPaymentSubmittedSubPopUp] =
    useState(false);
  const [dnPaymentVerifiedSubPopUp, setDnPaymentVerifiedSubPopUp] =
    useState(false);
  const [
    serviceConnectionOrderedSubPopUp,
    setServiceConnectionOrderedSubPopUp,
  ] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [approvalRejectDialogOpen, setApprovalRejectDialogOpen] =
    useState(false);
  const [approvalRejectRemarks, setApprovalRejectRemarks] = useState("");
  const [approvalRejectRemarksError, setApprovalRejectRemarksError] =
    useState("");
  const [meterInstalledSubPopUp, setMeterInstalledSubPopUp] = useState(false);

  const [fieldSurveyData, setFieldSurveyData] = useState({
    status: "",
    applicationId: "",
    isLTLWI40Flag: null,
    estDistanceInMeter: null,
    sketchDiagram: "",
    areaMarla: "",
    noOfMeterInstalled: null,
    surveyedBy: "",
    surveyDate: "",
    installedMeterRefNos: [
      {
        installedMeterRefNo: "",
      },
    ],
  });

  const [paidDnImageDetails, setPaidDnImageDetails] = useState({
    id: null,
    applicationId: "",
    demandNoticeNo: "",
    paidDNImage: "",
    uploadedBy: "",
    uploadedAt: "",
    paymentDate: "",
    painDNImageVerification: null,
  });

  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDnExpiryPopup, setShowDnExpiryPopup] = useState(false);
  const [showRcoExpiryPopup, setShowRcoExpiryPopup] = useState(false);
  const [fsObservations, setFsObservations] = useState([]);
  const [meterFaults, setMeterFaults] = useState([]);

  //#endregion

  //#region constants / variables
  const navigate = useNavigate();

  const fieldObjections = [
    "No Issue",
    "Unelectrified area / No network.",
    "Premises / Property is disputed or sub-judice.",
    "Load at site exceeds than applied.",
    "Connection type at site is changed.",
    "Transformer overloaded",
    "Site is shifted.",
    "Arrears exist against other connected meter.",
  ];

  const areaMarla = ["3", "5", "7", "10", "20"];

  let batchArray = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
  ];

  let batchArrayGeneral = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
  ];

  let batchArrayGeneralString =
    "01, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23";

  let batchArrayIndustrial = [
    "24",
    "25",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
  ];

  let batchArrayIndustrialString = "24, 25, 27, 28, 29, 30, 31, 32, 33";

  let subBatchArray = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
  ];

  const tenantStatus = ["tenant", "Tenant"];

  let RCOStatusBarArrayWithArrearsVerificationAndReferedToFieldVerification = [
    {
      title1: "DOCUMENT",
      title2: "SUBMISSION",
    },
    {
      title1: "DOCUMENT",
      title2: "VERIFICATION",
    },
    {
      title1: "APPROVAL",
      title2: "/ REJECTION",
    },

    {
      title1: "ARREAR",
      title2: "VERIFICATION",
    },
    {
      title1: "FIELD SURVEY",
      title2: "& COST EST.",
    },
    {
      title1: "M&T",
      title2: "REPORT",
    },
    {
      title1: "DN",
      title2: "APPROVAL",
    },
    {
      title1: "DN",
      title2: "SUBMISSION",
    },
    {
      title1: "DN PAYMENT",
      title2: "VERIFICATION",
    },
    {
      title1: "METER",
      title2: "INSTALLATION",
    },

    {
      title1: "FORWARD",
      title2: "TO RO",
    },
    {
      title1: "READY FOR",
      title2: "BILLING",
    },
  ];

  const [rcoStatusBarArray, setRcoStatusBarArray] = useState(
    RCOStatusBarArrayWithArrearsVerificationAndReferedToFieldVerification,
  );

  const tblColumns = [
    {
      field: "applicationId",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Application No.",
      align: "center",
      headerStyle: { ...tableStyle.headerStyle, width: "3000px" },
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "creationDate",
      type: "date",
      sortable: false,
      filterable: true,
      headerName: "Date",
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "applicantName",
      headerName: "Applicant Name",
      sortable: false,
      filterable: false,
      type: "text",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "sanctionedLoad",
      headerName: "Load (kW)",
      sortable: false,
      filterable: false,
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "tariff",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Tariff",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: "12px" },
    },
    {
      field: "applicationProgressId",
      type: "singleSelect",
      sortable: false,
      filterable: true,
      valueOptions: [
        "Documents Uploading",
        "Documents Verification",
        "Approval / Rejection",
        "Arrear Verification",
        "Field Survey",
        "M&T Report",
        "DN Approval",
        "DN Submission",
        "DN Payment Verification",
        "Meter Installation",
        "Forward To RO",
        "Ready for Billing",
        "Completed",
      ],
      headerName: "Description",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: "12px" },
    },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: {
        ...tableStyle.rowCellStyle,
        fontSize: "15px",
        overflow: "visible",
      },
      field: "downloads",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <ActionsCell data={params} serviceKind="mco" />;
      },
    },
  ];

  const tblColumnsOverDue = [
    {
      field: "applicationId",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Application No.",
      align: "center",
      headerStyle: { ...tableStyleOverDue.headerStyle, width: "3000px" },
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, marginLeft: "5px" },
    },
    {
      field: "creationDate",
      type: "date",
      headerName: "Date",
      sortable: false,
      filterable: true,
      align: "center",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "applicantName",
      headerName: "Applicant Name",
      sortable: false,
      filterable: false,
      type: "text",
      align: "left",
      disableColumnMenu: true,
      sortable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "sanctionedLoad",
      headerName: "Load (kW)",
      sortable: false,
      filterable: false,
      align: "center",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
    },
    {
      field: "tariff",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Tariff",
      align: "left",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: "12px" },
    },
    {
      field: "applicationProgressId",
      type: "singleSelect",
      sortable: false,
      filterable: true,
      valueOptions: [
        "Documents Uploading",
        "Documents Verification",
        "Approval / Rejection",
        "Arrear Verification",
        "Field Survey",
        "M&T Report",
        "DN Approval",
        "DN Submission",
        "DN Payment Verification",
        "Meter Installation",
        "Forward To RO",
        "Ready for Billing",
        "Completed",
      ],
      headerName: "Description",
      align: "left",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: "12px" },
    },
    {
      field: "exceededDuration",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Days",
      align: "center",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: {
        ...tableStyleOverDue.rowCellStyle,
        color: "red",
        minWidth: "20px",
      },
    },
    {
      headerName: "Docs.",
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      flex: 1,
      filterable: false,
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: {
        ...tableStyleOverDue.rowCellStyle,
        fontSize: "15px",
        overflow: "visible",
      },
      field: "downloads",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <ActionsCell data={params} serviceKind="mco" theme="overdue" />;
      },
    },
  ];

  const pdfjsLib = window.pdfjsLib;
  pdfjsLib.GlobalWorkerOptions.workerSrc =
    "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.mjs";

  const pdfToImage = async (base64) => {
    const pdfData = atob(base64.replace("data:application/pdf;base64,", ""));
    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const page = await pdf.getPage(1);

    const viewport = page.getViewport({ scale: 1.5 });
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    await page.render({ canvasContext: context, viewport }).promise;
    return canvas.toDataURL("image/png");
  };

  useEffect(() => {
    if (
      dialogRowData?.applicationProgressId === 2 &&
      dialogRowData?.objectionStatus === 1
    ) {
      referenceApi(dialogRowData);
    }
  }, [dialogRowData?.applicationProgressId, dialogRowData?.objectionStatus]);

  useEffect(() => {
    const convert = async () => {
      if (
        dialogRowData.applicantCNICFront?.startsWith("data:application/pdf")
      ) {
        const img = await pdfToImage(dialogRowData.applicantCNICFront);
        setFrontImg(img);
      } else {
        setFrontImg(dialogRowData.applicantCNICFront);
      }

      if (dialogRowData.applicantCNICBack?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(dialogRowData.applicantCNICBack);
        setBackImg(img);
      } else {
        setBackImg(dialogRowData.applicantCNICBack);
      }
    };

    convert();
  }, [dialogRowData.applicantCNICFront, dialogRowData.applicantCNICBack]);

  useEffect(() => {
    const convert = async () => {
      if (
        rcoFeeVoucherDetails.rcoFeePaidImage?.startsWith("data:application/pdf")
      ) {
        const img = await pdfToImage(rcoFeeVoucherDetails.rcoFeePaidImage);
        setPaidRCOFeeVoucherImg(img);
      } else {
        setPaidRCOFeeVoucherImg(rcoFeeVoucherDetails.rcoFeePaidImage);
      }
    };

    convert();
  }, [rcoFeeVoucherDetails.rcoFeePaidImage]);

  useEffect(() => {
    const convert = async () => {
      if (dnApproveStep.paidDNImage?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(dnApproveStep.paidDNImage);
        setPaidDNVoucherImg(img);
      } else {
        setPaidDNVoucherImg(dnApproveStep.paidDNImage);
      }
    };

    convert();
  }, [dnApproveStep.paidDNImage]);

  useEffect(() => {
    const convert = async () => {
      if (
        disconnectedMeterDetsImgForROApproval?.startsWith(
          "data:application/pdf",
        )
      ) {
        const img = await pdfToImage(disconnectedMeterDetsImgForROApproval);
        setInstalledMeterImg(img);
      } else {
        setInstalledMeterImg(disconnectedMeterDetsImgForROApproval);
      }
    };

    convert();
  }, [disconnectedMeterDetsImgForROApproval]);

  useEffect(() => {
    if (!historyData?.paidBillImage) {
      setPaidArrearImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.paidBillImage;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setPaidArrearImg(img);
        } else {
          // Image base64 (jpg/png)
          setPaidArrearImg(file);
        }
      } catch (error) {
        setPaidArrearImg(null);
      }
    };

    convert();
  }, [historyData?.paidBillImage]);

  useEffect(() => {
    if (!historyData?.rcoFeePaidImage) {
      setPaidRCOFeeImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.rcoFeePaidImage;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setPaidRCOFeeImg(img);
        } else {
          // Image base64 (jpg/png)
          setPaidRCOFeeImg(file);
        }
      } catch (error) {
        setPaidRCOFeeImg(null);
      }
    };

    convert();
  }, [historyData?.rcoFeePaidImage]);

  useEffect(() => {
    if (!historyData?.installedMeterImage) {
      setReInstalledMeterImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.installedMeterImage;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setReInstalledMeterImg(img);
        } else {
          // Image base64 (jpg/png)
          setReInstalledMeterImg(file);
        }
      } catch (error) {
        setReInstalledMeterImg(null);
      }
    };

    convert();
  }, [historyData?.installedMeterImage]);

  useEffect(() => {
    if (!historyData?.applicantCNICFront) {
      setPopUpfrontImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.applicantCNICFront;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setPopUpfrontImg(img);
        } else {
          // Image base64 (jpg/png)
          setPopUpfrontImg(file);
        }
      } catch (error) {
        setPopUpfrontImg(null);
      }
    };

    convert();
  }, [historyData?.applicantCNICFront]);

  useEffect(() => {
    if (!historyData?.applicantCNICBack) {
      setPopUpBackImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.applicantCNICBack;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setPopUpBackImg(img);
        } else {
          // Image base64 (jpg/png)
          setPopUpBackImg(file);
        }
      } catch (error) {
        setPopUpBackImg(null);
      }
    };

    convert();
  }, [historyData?.applicantCNICBack]);

  useEffect(() => {
    if (!historyData?.electricityBillImage) {
      setPopUpEBillImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.electricityBillImage;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setPopUpEBillImg(img);
        } else {
          // Image base64 (jpg/png)
          setPopUpEBillImg(file);
        }
      } catch (error) {
        setPopUpEBillImg(null);
      }
    };

    convert();
  }, [historyData?.electricityBillImage]);

  useEffect(() => {
    if (!historyData?.anyOtherDocument) {
      setPopUpAnyOtherImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.anyOtherDocument;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setPopUpAnyOtherImg(img);
        } else {
          // Image base64 (jpg/png)
          setPopUpAnyOtherImg(file);
        }
      } catch (error) {
        setPopUpAnyOtherImg(null);
      }
    };

    convert();
  }, [historyData?.anyOtherDocument]);

  useEffect(() => {
    if (!historyData?.meterImage) {
      setMeterImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.meterImage;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setMeterImg(img);
        } else {
          // Image base64 (jpg/png)
          setMeterImg(file);
        }
      } catch (error) {
        setMeterImg(null);
      }
    };

    convert();
  }, [historyData?.meterImage]);

  useEffect(() => {
    if (!historyData?.["m&TReportImage"]) {
      setMtReportImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData?.["m&TReportImage"];

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setMtReportImg(img);
        } else {
          setMtReportImg(file);
        }
      } catch (error) {
        setMtReportImg(null);
      }
    };

    convert();
  }, [historyData?.["m&TReportImage"]]);

  useEffect(() => {
    if (!historyData?.paidDNImage) {
      setDnPaymentImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.paidDNImage;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setDnPaymentImg(img);
        } else {
          // Image base64 (jpg/png)
          setDnPaymentImg(file);
        }
      } catch (error) {
        setDnPaymentImg(null);
      }
    };

    convert();
  }, [historyData?.paidDNImage]);

  useEffect(() => {
    if (!historyData?.approvalDocument) {
      setApprovalDocImg(null);
      return;
    }

    const convert = async () => {
      try {
        const file = historyData.approvalDocument;

        if (file.startsWith("data:application/pdf")) {
          const img = await pdfToImage(file);
          setApprovalDocImg(img);
        } else {
          // Image base64 (jpg/png)
          setApprovalDocImg(file);
        }
      } catch (error) {
        setApprovalDocImg(null);
      }
    };

    convert();
  }, [historyData?.approvalDocument]);
  //#endregion

  //#region api function

  const callTariffList = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: myHeaders,
    };

    await fetch(
      cfpBaseUrl + "customerFaciliationPortal/getTariffsDetail",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        setAllTariffList(result.data);
      })
      .catch(() => {});
  };

  const callMCOTariffDetails = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "meterChangeOrder/GetTariffsDetails",
        requestOptions,
      );
      const result = await response.json();
      const latestTariffs = result?.data || [];
      setAllMCOTariffList(latestTariffs);
      return latestTariffs;
    } catch (error) {
      setAllMCOTariffList([]);
      return [];
    }
  };

  const callFeederList = async (feederCode, regCode, gridCode, sDivCode) => {
    var formdata = new FormData();

    formdata.append("feederCode", feederCode);
    formdata.append("rgnCode", regCode);
    formdata.append("gridCode", gridCode);
    formdata.append("sDivCode", sDivCode);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "demandNotice/getFeeders", requestOptions)
      .then((response) => response.json())
      .then((result) => setAllFeedersList(result.data))
      .catch(() => {});
  };

  const callArrearsVerification = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      let progId = null;
      let objStat = null;
      let remrks = "";

      // if (arrearFlag == 1) {
      //   progId = dialogRowData.applicationProgressId
      //   objStat = 1
      //   remrks = 'Bill status is unpaid in IBS.'
      // } else {
      progId = dialogRowData.applicationProgressId + 1;
      objStat = 0;
      remrks = "Bill status is paid in IBS.";
      // }

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: progId,
        objectionStatus: objStat,
        lastModifiedBy: userId,
        remarks: remrks,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/verifyRCOArrears", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          handleClose();
        })
        .catch(() => {});
    } catch (e) { /* ignored */ }
  };
  const callMaterials = async (applicationId) => {
  try {
    setViewBackdrop(true); // show loader

    const normalizedApplicationId = String(applicationId || "");
    if (normalizedApplicationId.length < 8) {
      setAllMaterialList([]);
      return [];
    }

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      subDivisionCode: normalizedApplicationId.slice(3, 8),
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const response = await fetch(
      "https://eopsapi.pitc.com.pk/enc/getMaterialDetails",
      requestOptions
    );

    const result = await response.json();
    setAllMaterialList(Array.isArray(result?.data) ? result.data : []);

    return Array.isArray(result?.data) ? result.data : [];
  } catch (e) {
    return [];
  } finally {
    setViewBackdrop(false); // always hide loader
  }
};

  const handlePrepareEstimate = async () => {
    await callMaterials(dialogRowData?.applicationId);
    onPressAddPrepare();
  };

  const handleEditEstimate = async () => {
    await callMaterials(dialogRowData?.applicationId);
    setShowBoq(true);
  };
  const callingUpdateDocumentStatusAPI = async () => {
    setViewBackdrop(true);

    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      let progId = null;
      let objStat = null;
      let remrks = "";
      let remarksDetail = "";

      if (
        flag_applicantCNICFront === -1 ||
        flag_applicantCNICBack === -1 ||
        flag_scannedCopyOfNearByElectricityBill === -1 ||
        flag_anyOtherDocument === -1
      ) {
        progId = 1;
        objStat = 1;
        remrks = "Documents Rejected.";
        remarksDetail = `Documents Objection in : ${
          flag_applicantCNICFront === -1 ? "CNIC Front, " : ""
        }${flag_applicantCNICBack === -1 ? "CNIC Back, " : ""}${
          flag_scannedCopyOfNearByElectricityBill === -1
            ? "Electricity Bill, "
            : ""
        }${flag_anyOtherDocument === -1 ? "Other Document" : ""}`;
      } else if (
        flag_applicantCNICFront === 1 &&
        flag_applicantCNICBack === 1 &&
        (flag_scannedCopyOfNearByElectricityBill === 1 ||
          flag_scannedCopyOfNearByElectricityBill === null) &&
        (flag_anyOtherDocument === 1 || flag_anyOtherDocument === null)
      ) {
        progId = 2;
        objStat = 0;
        remrks = "Documents Verified.";
        remarksDetail = "CNIC Front Verified. CNIC Back Verified.";
      }

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: progId,
        objectionStatus: objStat,
        remarks: remrks,
        remarksDetail: remarksDetail,
        applicantCNICFrontFlag: flag_applicantCNICFront,
        applicantCNICBackFlag: flag_applicantCNICBack,
        electricityBillImageFlag: flag_scannedCopyOfNearByElectricityBill,
        anyOtherDocumentFlag: flag_anyOtherDocument,
        applicantCNICFrontRemarks: applicantCNICFrontObjectionRemarks,
        applicantCNICBackRemarks: applicantCNICBackObjectionRemarks,
        electricityBillImageRemarks:
          scannedCopyOfNearByElectricityBillObjectionRemarks,
        anyOtherDocumentRemarks: anyOtherDocumentObjectionRemarks,
      });

      const response = await fetch(
        cfpBaseUrl + "meterChangeOrder/verifyMCODocuments",
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
        },
      );

      const result = await response.json();

      if (result?.status === "200" || result?.status === 200) {
      handleClose();
        setSnackbar({
          open: true,
          message: result?.message || remrks,
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: result?.message || "Something went wrong",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Server error. Please try again.",
        severity: "error",
      });
    } finally {
      setViewBackdrop(false); // 🔹 loader OFF (always)
    }
  };

  const callChangeProgressIdAPI = async (
    applicationProgressId,
    status,
    remarks,
    remarksDetails = "-",
    id = dialogRowData.applicationId,
  ) => {
    var formdata = new FormData();

    formdata.append("applicationId", id);
    formdata.append("applicationProgressId", applicationProgressId);
    formdata.append("remarks", remarks);
    formdata.append("remarksDetails", remarksDetails);
    formdata.append("lastModifiedBy", userId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "comman/changeProgressId", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          handleClose();
        } else {
        }
      })
      .catch(() => {});

    // setOpen(false);
  };

  const callApproveOrRejectApplication = async (
    applicationProgressId,
    objectionStatus,
    remarks,
    remarksDetail,
  ) => {
    if (!dialogRowData?.applicationId) return;

    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId,
        objectionStatus,
        remarks,
        remarksDetail,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        `${cfpBaseUrl}meterChangeOrder/approveOrRejectApplication`,
        requestOptions,
      );
      const result = await response.json();

      if (result?.status === "200" || result?.status === 200) {
        setSnackbar({
          open: true,
          message: result?.message || "Approved successfully",
          severity: "success",
        });
        handleClose();
      } else {
        setSnackbar({
          open: true,
          message: result?.message || "Something went wrong",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Server error. Please try again.",
        severity: "error",
      });
    }
  };

  const handleApprovalRejectionApprove = () => {
    setApprovalRejectRemarksError("");
    callApproveOrRejectApplication(
      3,
      0,
      "Application approved.",
      "Application approved.",
    );
  };

  const openApprovalRejectionRejectDialog = () => {
    setApprovalRejectRemarks("");
    setApprovalRejectRemarksError("");
    setApprovalRejectDialogOpen(true);
  };

  const closeApprovalRejectionRejectDialog = () => {
    setApprovalRejectDialogOpen(false);
    setApprovalRejectRemarksError("");
  };

  const handleApprovalRejectionReject = () => {
    const remarks = (approvalRejectRemarks || "").trim();
    if (!remarks) {
      setApprovalRejectRemarksError("Remarks are required for rejection.");
      return;
    }

    setApprovalRejectDialogOpen(false);
    setApprovalRejectRemarksError("");
    callApproveOrRejectApplication(2, 1, "Application rejected.", remarks);
  };

  const callChangeObjectionStatus = async (
    objectionStatus,
    remarks,
    remarksDetails = "-",
  ) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      applicationProgressId: 5,
      objectionStatus: 0,
      remarks: remarks,
      remarksDetail: remarksDetails,
      submittedThrough: portalName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    await fetch(cfpBaseUrl + "rco/removeRCOFieldSurveyObjecton", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          handleClose();
        } else {
        }
      })
      .catch(() => {});

    setRejectionRemovalAlert(false);
    setObjectionPopUpOpen(false);
    setFieldRejectionRemovalAlert(false);
  };

  const callResetObjectionStatus = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      cfpBaseUrl + "electricityNewConnection/resetObjectionStatus",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          // setDialogRowData(lclStrdNewConApp[index])
        } else {
        }
      })
      .catch(() => {});
  };

  const callRCOFeeVerificationAPI = async (
    applicationId,
    progressId,
    remarks,
  ) => {
    if (applicationId) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      const raw = JSON.stringify({
        applicationId: applicationId,
        applicationProgressId: progressId,
        objectionStatus: 0,
        lastModifiedBy: userId,
        remarks: remarks,
        rcoFeePaymentVerificationFlag: 1,
        paidBillImageFlag: 1,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/verifyOrObjectRCOPayment", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "200") {
            handleClose();
          }
        })
        .catch(() => {});
    }
  };

  const callRCOApprovePart1API = async (rcoId) => {
    var formdata = new FormData();
    formdata.append("rcoId", rcoId);
    formdata.append("authorizedByName", userId);
    formdata.append("authorizedByDesignation", roleName);
    formdata.append("rcoP1ApprovedFlag", 1);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "rco/rcoP1Approval", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callChangeProgressIdAPI(
            5,
            "Demand Notice Created",
            "Demand Notice Created",
          );
        } else {
        }
      })
      .catch(() => {});
  };

  const callRCOApprovePart2API = async () => {
    const raw = JSON.stringify({
      applicationId: dialogRowData.applicationId,
      applicationProgressId: dialogRowData.applicationProgressId + 1,
      objectionStatus: 0,
      lastModifiedBy: userId,
      remarks: "Meter Installation Verified",
    });

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      body: raw,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "rco/approveRCOMeterInfo", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callApproveRCOForBilling(
            dialogRowData.applicationId,
            13,
            "RCO Approved for Billing",
          );
        } else {
        }
      })
      .catch(() => {});
  };

 const callApproveRCOForBilling = async (
  applicationId,
  applicationProgressId,
  objectionStatus,
  remarks,
  remarksDetails,
  approvalDocumentData = "",
) => {
  if (!applicationId) return;

  setViewBackdrop(true); 

  try {
    const response = await fetch(
      `${cfpBaseUrl}meterChangeOrder/forwardToRO`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          applicationId,
          applicationProgressId,
          objectionStatus,
          remarks,
          remarksDetail: remarksDetails,
          approvalDocument: approvalDocumentData,
        }),
      }
    );

    const result = await response.json();

    if (result?.status === "200" || result?.status === 200) {
      setSnackbar({
        open: true,
        message: result?.message || "Approved successfully",
        severity: "success",
      });
    } else {
      setSnackbar({
        open: true,
        message: result?.message || "Something went wrong",
        severity: "error",
      });
    }
  } catch (error) {
    setSnackbar({
      open: true,
      message: "Server error. Please try again.",
      severity: "error",
    });
  } finally {
    setViewBackdrop(false); 
  }
};

  const handleForwardToROApprove = () => {
    if (dialogRowData?.isReferToMT === true && !approvalDocumentThumbnail) {
      setApprovalDocumentError("Upload approval document before approving.");
      return;
    }

    callApproveRCOForBilling(
      dialogRowData.applicationId,
      dialogRowData.applicationProgressId + 1,
      0,
      "MCO Meter Profile verified",
      "MCO Meter Profile verified Successfully.",
      approvalDocumentThumbnail,
    );
  };

 const callPostedToIBSForBilling = async (
  applicationId,
  applicationProgressId,
  objectionStatus,
  remarks,
  remarksDetails,
) => {
  if (!applicationId) return;

  setViewBackdrop(true); 

  try {
    const response = await fetch(
      `${cfpBaseUrl}meterChangeOrder/processReadyForBilling`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          applicationId,
          applicationProgressId,
          objectionStatus,
          remarks,
          remarksDetail: remarksDetails,
        }),
      }
    );

    const result = await response.json();

    if (result?.status === "200" || result?.status === 200) {
      setSnackbar({
        open: true,
        message: result?.message || "Approved successfully",
        severity: "success",
      });
    } else {
      setSnackbar({
        open: true,
        message: result?.message || "Something went wrong",
        severity: "error",
      });
    }
  } catch (error) {
    setSnackbar({
      open: true,
      message: "Server error. Please try again.",
      severity: "error",
    });
  } finally {
    setViewBackdrop(false); 
  }
};

  const callGetRCOAPI = async (applicationId, phase) => {
    try {
      let rcoDets = "";
      if (applicationId) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: applicationId,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "rco/GetRCOMeterInfo", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              setRcoDetails(result.data[0]);
              if (result.data[0].rcoP2FillFlag === 1) {
                rcoPart2Formik.values.iv_store_requisition_no =
                  result.data[0].storeRequisitionNo;
                rcoPart2Formik.values.iv_store_requisition_date =
                  result.data[0].storeRequisitionDate.slice(0, 10);
                rcoPart2Formik.values.iv_seasonal_flag =
                  result.data[0].seasonalFlag;
                rcoPart2Formik.values.iv_no_of_acs = result.data[0].noOfACs;
                rcoPart2Formik.values.iv_no_of_meters =
                  result.data[0].noOfMeters;
                rcoPart2Formik.values.iv_no_of_meter_sets =
                  result.data[0].noOfMeterSets;
                rcoPart2Formik.values.iv_no_of_sub_sets =
                  result.data[0].noOfSubSets;
                rcoPart2Formik.values.iv_no_ofsupply_points =
                  result.data[0].noOfSupplyPoints;
                rcoPart2Formik.values.iv_transformer_code =
                  result.data[0].installedTransformerCapacity;
                rcoPart2Formik.values.iv_meter_id = result.data[0].meterId;
                rcoPart2Formik.values.iv_meter_serial_no =
                  result.data[0].meterNo;
                rcoPart2Formik.values.iv_location_code = result.data[0]
                  .locationCode
                  ? result.data[0].locationCode
                  : "P";
                rcoPart2Formik.values.iv_meter_code1 =
                  result.data[0].meterCode1;
                rcoPart2Formik.values.iv_meter_code2 =
                  result.data[0].meterCode2;
                rcoPart2Formik.values.iv_manufacturer_code =
                  result.data[0].manufacturerCode;
                let mC = manufacturesList.find(
                  (item) => item.code == result.data[0].manufacturerCode,
                );
                setManufcaturerCode(mC);
                rcoPart2Formik.values.iv_multiplying_factor =
                  result.data[0].multiplyingFactor;
                rcoPart2Formik.values.iv_meter_range =
                  result.data[0].meterRange;
                rcoPart2Formik.values.iv_meter_reading =
                  result.data[0].meterReading;
                rcoPart2Formik.values.iv_date_of_connection = new Date(
                  result.data[0].dateOfReConnection,
                );
                rcoPart2Formik.values.iv_cp_78_item_no =
                  result.data[0].cp78ItemNo;
                rcoPart2Formik.values.iv_tie_up_non_tie_up =
                  result.data[0].tieUpNonTieUp;
                rcoPart2Formik.values.iv_seal_on_meter =
                  result.data[0].sealOnMeter;
                rcoPart2Formik.values.iv_seal_on_box = result.data[0].sealOnBox;
                rcoPart2Formik.values.iv_security_slip_or_price_bond_no =
                  result.data[0].securitySlipOrPriceBondNo;
                rcoPart2Formik.values.iv_connection_installer_name =
                  result.data[0].connectionInstallerName;
                rcoPart2Formik.values.iv_installed_meter_image =
                  result.data[0].installedMeterImage;
                rcoPart2Formik.values.iv_meter_type = result.data[0].meterType;
                if (phase == "3 Phase") {
                  rcoPart2Formik.values.iv_meter_reading_peak_kwh =
                    result.data[0].threePhasePeak;
                  rcoPart2Formik.values.iv_meter_reading_off_peak_kwh =
                    result.data[0].threePhaseOffPeak;
                } else {
                  rcoPart2Formik.values.iv_meter_reading_peak_kwh =
                    result.data[0].threePhasePeakKWH;
                  rcoPart2Formik.values.iv_meter_reading_off_peak_kwh =
                    result.data[0].threePhaseOffPeakKWH;
                }
                rcoPart2Formik.values.iv_mdi = result.data[0].mdi;
                rcoPart2Formik.values.iv_no_of_mdi_resets =
                  result.data[0].noOfMDIreset;
                rcoPart2Formik.values.iv_ct = result.data[0].cT;
                rcoPart2Formik.values.iv_pt = result.data[0].pT;
                rcoPart2Formik.values.iv_ct_nom = result.data[0].cTN;
                rcoPart2Formik.values.iv_pt_nom = result.data[0].pTN;
                rcoPart2Formik.values.iv_ct_denom = result.data[0].cTD;
                rcoPart2Formik.values.iv_pt_denom = result.data[0].pTD;
                rcoPart2Formik.values.iv_meter_reading_peak_kvarh =
                  result.data[0].threePhasePeakKVARH;
                rcoPart2Formik.values.iv_meter_reading_off_peak_kvarh =
                  result.data[0].threePhaseOffPeakKVARH;
                setInstalledMeterImageThumbnail(
                  result.data[0].installedMeterImage,
                );
              } else {
              }
              rcoDets = result.data[0];
            } else {
            }
          })
          .catch(() => {});
      }
      return rcoDets;
    } catch (e) { /* ignored */ }
  };

  const callGetCP136API = async (applicationId) => {
    try {
      var formdata = new FormData();
      formdata.append("applicationId", applicationId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "cpForm136/cpForm136Details", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setMasterDataFormDetails(result.data[0]);
            if (result.data[0].filledByFlag === 1) {
              masterDataFormik.values.iv_govt_dept =
                result.data[0].governmentDepartment;
              masterDataFormik.values.iv_ed_code =
                result.data[0].electricityDuty;
              masterDataFormik.values.iv_standard_classification_code =
                result.data[0].standardClassificationCode;
              let sc = standardClassificationCodes.find(
                (item) =>
                  item.XCLFM_CODE === result.data[0].standardClassificationCode,
              );
              setStandardClassificationCode(sc);
              masterDataFormik.values.iv_income_tax = result.data[0].incomeTax;
            }
          }
        })
        .catch(() => {});
    } catch (e) { /* ignored */ }
  };

  const callApproveCP136API = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    formdata.append("approvedBy", userId);
    formdata.append("approvedByDesignation", roleName);
    formdata.append("approvalFlag", 1);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "cpForm136/cpForm136Approval", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callChangeProgressIdAPI(
            10,
            "Application Completed",
            "Application Completed",
          );
        } else {
        }
      })
      .catch((error) => {
      });
  };

  const callEfileAPI = async (applicationId, application) => {
    try {
      setViewDropBackForEfile(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({ applicationId });

      const response = await fetch(
        `${cfpBaseUrl}meterChangeOrder/getBasicMCOHistory`,
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
        },
      );

      const result = await response.json();

      if (result.status === "200" && result.data) {
        let applicationHistory = result.data.history || [];
        let applicationCurrentState = result.data.currentStatus?.[0] || {};

        // sort DESC
        const sortedApplicationHistory = [...applicationHistory].sort(
          (a, b) => {
            return (
              new Date(b.lastModificationDate || 0) -
              new Date(a.lastModificationDate || 0)
            );
          },
        );

        setEFileData(sortedApplicationHistory);
        setEFileCurrentStatus({
          ...applicationCurrentState,
          applicationProgressId:
            application?.applicationProgressId ??
            applicationCurrentState.applicationProgressId,
        });

        const dataforTable = sortedApplicationHistory.map((item, index) => {
          const isEarliest = index === sortedApplicationHistory.length - 1;

          return {
            stepName: item.mcoProgStatusName,
            processedBy:
              item.lastModifiedBy || applicationCurrentState.createdBy,
            date: item.lastModificationDate
              ? convertDate(item.lastModificationDate)
              : convertDate(applicationCurrentState.creationDate),
            remarks: isEarliest
              ? "Application Submitted."
              : item.remarks || "-",
            applicationProgressId: item.applicationProgressId,
            _raw: item,
          };
        });

        // keep for UI
        setTableDataProcessingSummary(dataforTable);

        // ✅ IMPORTANT: RETURN DATA
        return dataforTable;
      }

      return [];
    } catch (error) {
      return [];
    } finally {
      setViewDropBackForEfile(false);
    }
  };

  const callApproveFieldAPI = async (applicationId) => {
    var formdata = new FormData();

    formdata.append("approvedBy", userId);
    formdata.append("approvedByDesignation", roleName);
    formdata.append("approvedFlag", 1);
    formdata.append("applicationNo", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "PUT",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "demandNotice/approveFeildVerification",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callRCOApprovePart1API(rcoDetails.rcoId);
        } else {
        }
      })
      .catch((error) => {
      });
  };

  const callAsyncDnDetailsAPI = async (applicationId) => {
    try {
      let dnDets = {};
      let boqItems = [];
      let dnExpiryFlag = 0;

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "meterChangeOrder/getMCODemandNoteData",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setIsDemandNoteExpired(result.data[0].demandNoteExpiryFlag);
            dnDets = result.data[0];
            boqItems = result.BoQitems ? result.BoQitems : [];
            dnExpiryFlag = result.data[0].demandNoteExpiryFlag;
            setDnDetails(result.data[0]);
          }
        })
        .catch(() => {});
      return { dnDets, boqItems, dnExpiryFlag };
    } catch (e) {
      return { dnDets: {}, boqItems: [] };
    }
  };

  const callAsyncGetRCOAPI = async (applicationId) => {
    try {
      let rcoDets = {};
      if (applicationId) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: applicationId,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "rco/GetRCOMeterInfo", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              rcoDets = result.data[0];
              setRcoDetails(result.data[0]);
            }
          })
          .catch(() => {});
        return rcoDets;
      }
    } catch (e) { /* ignored */ }
  };

  const callAsyncGetCP136API = async (applicationId) => {
    try {
      let cpDets = {};
      var formdata = new FormData();
      formdata.append("applicationId", applicationId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "cpForm136/cpForm136Details", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            cpDets = result.data[0];
          }
        })
        .catch(() => {});

      return cpDets;
    } catch (e) { /* ignored */ }
  };

  const callAsyncGetDocumentsAPI = async (applicationId) => {
    try {
      let appDocs = {};
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "meterChangeOrder/getMCODocuments",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            appDocs = result.data[0];
          }
        })
        .catch(() => {});

      return appDocs;
    } catch (e) { /* ignored */ }
  };

  const callAsyncGetPaidDnImageAPI = async (applicationId) => {
    try {
      let dnImage = "";
      var formdata = new FormData();

      formdata.append("applicationNo", applicationId);
      formdata.append("demandNoticeNo", "");

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "demandNotice/getPaidDNImage", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setPaidDnImageDetails(result.data[0]);
            dnImage = result.data[0].paidDNImage;
          }
        })
        .catch(() => {});
      return dnImage;
    } catch (e) { /* ignored */ }
  };

  const callAsyncFieldSurveyInformation = async (applicationId) => {
    if (applicationId) {
      var formdata = new FormData();
      formdata.append("applicationId", applicationId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "demandNotice/getFieldSurvey", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            fieldFormik.values.iv_distance = result.isLTLWI40Flag;
            fieldFormik.values.iv_estimated_distance =
              result.estDistanceInMeter;
            setSketchDiagramThumbnail(result.sketchDiagram);
            fieldFormik.values.iv_coverage_area = result.areaMarla;
            fieldFormik.values.iv_no_of_default_meters =
              result.noOfMeterInstalled;
            let existingReferenceNumbers = result.installedMeterRefNos;
            existingReferenceNumbers.map((item) => (item.actualFlag = null));
            setAlreadyInstalledRefNos(existingReferenceNumbers);
            setFieldSurveyData(result);
          }
        })
        .catch(() => {});
    }
  };

  const deleteFieldSurvey = async (
    applicationId = dialogRowData.applicationId,
  ) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "demandNotice/deleteFeildSurveyAndDNData",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callDeleteRCOAPI(applicationId);
          callAsyncResetDocsFlags(applicationId);
          callChangeProgressIdAPI(
            1,
            "Reference Number Allocation Objection",
            formik.values.iv_objection_Type,
            formik.values.iv_objection_Type,
          );
          setDnDetails(!dnDetails.filledFlag);
        } else {
          setError(result.message);
        }
      });
  };

  const callDeleteRCOAPI = async (applicationId) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "rco/deleteRCO", requestOptions)
      .then((response) => response.json())
      .then((result) => {})
      .catch(() => {});
  };

  const updateRco1Flag = async (
    applicationId = dialogRowData.applicationId,
    rcoId = rcoDetails.rcoId,
  ) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    formdata.append("rcoId", rcoId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "rco/updateRCOPart1Flag", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callChangeProgressIdAPI(
            7,
            "RCO. Part1 Rejected",
            "RCO. Part1 Rejected",
          );
          setRcoDetails(rcoDetails.rcoP1FillFlag === null);
        } else {
          setError(result.message);
        }
      });
  };

  const updateCpFlag = async (applicationId = dialogRowData.applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "cpForm136/updateCP136Flag", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          callChangeProgressIdAPI(9, "CP 136 Rejected", "CP 136 Rejection");
          setMasterDataFormDetails(masterDataFormDetails.filledByFlag === null);
        } else {
          setError(result.message);
        }
      });
  };

  const callAsyncResetDocsFlags = async (
    applicationId = dialogRowData.applicationId,
  ) => {
    var formdata = new FormData();
    formdata.append("applicationNo", applicationId);
    formdata.append("ownerNOCFlag", "");
    formdata.append("paidBillImageFlag", "");
    formdata.append("applicantCNICFrontFlag", "");
    formdata.append("applicantCNICBackFlag", "");
    formdata.append("scannedCopyOfNearByElectricityBillFlag", "");
    formdata.append("anyOtherDocumentFlag", "");
    formdata.append("copyOfOwnerCNICFrontFlag", "");
    formdata.append("copyOfOwnerCNICBackFlag", "");
    formdata.append("resolutionFormDescFlag", "");
    formdata.append("certMemoDescFlag", "");
    formdata.append("certFormDescFlag", "");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "electricityNewConnection/updateDocumentFlag",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          // setReconnectionApplications(allApplications)
        } else {
        }
      })
      .catch(() => {});
  };

  const callDemandNoteRenewalAPI = async (
    applicationId = dialogRowData.applicationId,
  ) => {
    try {
      setViewBackdrop(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: applicationId,
        remarks: "DN Renewed.",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "meterChangeOrder/renewMCOExpiredDN",
        requestOptions,
      );

      const result = await response.json();

      if (result?.status === "200") {
        setSnackbar({
          open: true,
          message: result?.message || "Demand Note Renewed Successfully",
          severity: "success",
        });
        handleClose();
      } else {
        setSnackbar({
          open: true,
          message: result?.message || "Something went wrong",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Something went wrong. Please try again.",
        severity: "error",
      });
    } finally {
      setViewBackdrop(false);
    }
  };

  const callAsyncGetMCOMTReportData = async (
    applicationId = dialogRowData.applicationId,
  ) => {
    let mtVoucherDetails = {
      mtVoucherDets: {},
    };
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      const raw = JSON.stringify({
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "meterChangeOrder/getMTReportData",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "200") {
            mtVoucherDetails.mtVoucherDets = result.data;
          }
        })
        .catch(() => {});
    } catch (e) { /* ignored */ }
    return mtVoucherDetails;
  };
  //#endregion

  //#region functions

  const updateDocFlag = (documentName, value, remarks) => {
    switch (documentName) {
      case "copyOfApplicantCNIC":
        setFlag_applicantCNICFront(value);
        setFlag_applicantCNICBack(value);
        setApplicantCNICFrontObjectionRemarks(remarks);
        setApplicantCNICBackObjectionRemarks(remarks);
        setCopyOfApplicantCNICVerifyPopUp(false);
        break;
      case "paidBillImage":
        setFlag_paidBillImage(value);
        setPaidBillImageObjectionRemarks(remarks);
        setPaidBillImagePopUp(false);
        break;
      case "scannedCopyOfNearByElectricityBill":
        setFlag_scannedCopyOfNearByElectricityBill(value);
        setScannedCopyOfNearByElectricityBillObjectionRemarks(remarks);
        setNearByBillVerifyPopUp(false);
        break;
      case "anyOtherDocument":
        setFlag_anyOtherDocument(value);
        setAnyOtherDocumentObjectionRemarks(remarks);
        setAnyOtherDocumentVerifyPopUp(false);
        break;
      default:
        break;
    }
  };

  useScanDetection({
    onComplete: async (code) => {
      if (code) {
        code = code.replace(/Shift/g, "");
        const regex = /^[A-Z]{2}-\d{14,15}$/;
        if (regex.test(code)) {
          await handleRowClick(code);
        } else {
        }
      }
    },
    minLength: 4, // EAN13
    // Do not treat normal typing inside form controls as scanner input.
    ignoreIfFocusOn: ["input", "textarea", "select"],
  });

  const SketchDiagram = (event) => {
    fieldFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        const newFileName = "sketchDiagram." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        setSketchDiagram(renamedFile);
        const reader = new FileReader();

        reader.onload = (e) => {
          // Set the thumbnail image as the data URL
          setSketchDiagramThumbnail(e.target.result);
        };

        reader.readAsDataURL(file);
      } else if (documentValidate === 2) {
      } else {
      }
    }
  };

  const MeterImageUpload = (event) => {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        setMeterImageError("");
        const newFileName = "meterImage." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        setMeterImage(renamedFile);
        const reader = new FileReader();
        reader.onload = (e) => {
          setMeterImageThumbnail(e.target.result);
        };
        reader.readAsDataURL(file);
      } else if (documentValidate === 2) {
        setMeterImageError(
          "File size exceeds " + maxSize / 1024 / 1024 + "MB limit.",
        );
      } else {
        setMeterImageError(
          "Invalid file type. Only JPG, PNG, and PDF are allowed.",
        );
      }
    }
  };

  const handleClose = async () => {
    setApprovalRejectDialogOpen(false);
    setApprovalRejectRemarks("");
    setApprovalRejectRemarksError("");
    setReconnectionHistoryRows([]);
    setReconnectionHistoryLoading(false);
    //applied load field
    arrearPaymentReceiptFormik.values.iv_arrear_paid_bill_document = null;
    arrearPaymentReceiptFormik.values.iv_arrear_payment_date = "";
    arrearPaymentReceiptFormik.values.iv_remarks_detail = "";
    rcoFeeReceiptFormik.values.iv_rco_fee_payment_date = "";
    rcoFeeReceiptFormik.values.iv_rco_fee_receipt_image = null;
    arrearPaymentObjectionReceiptFormik.values.iv_obj_arrear_paid_bill_document =
      null;
    dnReceiptFormik.values.iv_dn_receipt_image = null;
    dnReceiptFormik.values.iv_dn_fee_payment_date = null;
    arrearPaymentObjectionReceiptFormik.values.iv__obj_arrear_payment_date = "";
    arrearPaymentObjectionReceiptFormik.values.iv_obj_remarks_detail = "";
    setRcoFeeReceiptImageThumbnail("");
    setRcoFeeReceiptImage("");
    setPaymentStatus("");
    setBillMonth("");
    setDnReceiptImage("");
    setDnReceiptImageThumbnail("");
    setDnReceiptImageError("");
    setArrearAmount("");
    setBoqItems([]);
    setMandtReceiptImage("");
    setMandtReceiptImageThumbnail("");
    setErrormessageBoqEstimation("");
    setErrormessageCostEstimation("");
    setRcoFeeReceiptImageError("");
    meterInstallationFormik.resetForm();
    scoPart2Formik.resetForm();

    meterInstallationFormik.values.iv_installed_meter_date = "";
    meterInstallationFormik.values.iv_installed_meter_img = null;

    appliedLoadFormik.resetForm();
    appliedLoadFormik.values.iv_applied_load = "";
    //field verification fields
    fieldItemFormik.resetForm();
    fieldFormik.resetForm();
    fieldFormik.values.iv_coverage_area = "";
    fieldFormik.values.iv_sanctioned_load = "";
    fieldFormik.values.iv_batch = "";
    fieldFormik.values.iv_reference_to_allot = "";
    setArrearFlag(0);
    setArearPaidBillDocument("");
    setArearPaidBillDocumentThumbnail("");
    arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
    arearBillDocumentFormik.values.iv_arear_paid_bill_date = "";
    formik.resetForm();
    setAlreadyInstalledRefNos([]);
    setGridFlag(false);
    setFeederRehabFlag(false);
    setFeederRehabFlag(false);
    refNoAllocationFormik.resetForm();
    fieldFormik.values.iv_grid_sharing_cost = 0;
    fieldFormik.values.iv_feeder_rehab_charges = 0;
    fieldFormik.values.iv_tariff_to_allot = "";
    fieldFormik.values.iv_survey_date = "";
    fieldFormik.values.iv_surveyed_by = "";
    mandtReceiptFormik.resetForm();
    mandtReceiptFormik.values.iv_mandt_receipt_image = null;
    mandtReceiptFormik.values.iv_mandt_fee_payment_date = null;
    mandtReceiptFormik.values.iv_mandt_report_no = "";
    dnPymentReceiptFormik.resetForm();
    setDnReceiptImage("");
    setPaymentStatus("");
    setArrearAmount("");
    setBillMonth("");
    setDnReceiptImageThumbnail("");
    refNoAllocationFormik.resetForm();
    refNoAllocationFormik.values.iv_feeder_no = "";
    refNoAllocationFormik.values.iv_cantonment_board = "";
    refNoAllocationFormik.values.iv_fgovt = "";
    refNoAllocationFormik.values.iv_pgovt = "";
    refNoAllocationFormik.values.iv_govt_dept_code = "";
    refNoAllocationFormik.values.iv_local_bodies = "";
    refNoAllocationFormik.values.iv_batch = "";
    refNoAllocationFormik.values.iv_sub_batch = "";
    rcoPart2Formik.resetForm();
    rcoPart2Formik.values.iv_store_requisition_no = "";
    rcoPart2Formik.values.iv_store_requisition_date = "";
    rcoPart2Formik.values.iv_sanctioned_load = "";
    rcoPart2Formik.values.iv_no_of_meters = 0;
    rcoPart2Formik.values.iv_no_of_acs = 0;
    rcoPart2Formik.values.iv_no_of_meter_sets = 0;
    rcoPart2Formik.values.iv_no_of_sub_sets = 0;
    rcoPart2Formik.values.iv_no_ofsupply_points = 0;
    rcoPart2Formik.values.iv_transformer_code = "";
    rcoPart2Formik.values.iv_seasonal_flag = 0;
    rcoPart2Formik.values.iv_meter_id = "";
    rcoPart2Formik.values.iv_meter_serial_no = "";
    rcoPart2Formik.values.iv_location_code = "P";
    rcoPart2Formik.values.iv_meter_code1 = "";
    rcoPart2Formik.values.iv_meter_code2 = "";
    rcoPart2Formik.values.iv_manufacturer_code = "";
    rcoPart2Formik.values.iv_multiplying_factor = 1;
    rcoPart2Formik.values.iv_meter_range = 4;
    rcoPart2Formik.values.iv_meter_reading = "";
    rcoPart2Formik.values.iv_seal_on_meter = "";
    rcoPart2Formik.values.iv_seal_on_box = "";
    rcoPart2Formik.values.iv_ct_nom = "1";
    rcoPart2Formik.values.iv_ct_denom = "1";
    rcoPart2Formik.values.iv_pt_nom = "1";
    rcoPart2Formik.values.iv_pt_denom = "1";
    rcoPart2Formik.values.iv_seal_on_box = "";
    rcoPart2Formik.values.iv_connection_installer_name = "";
    rcoPart2Formik.values.iv_date_of_connection = "";
    rcoPart2Formik.values.iv_cp_78_item_no = "";
    rcoPart2Formik.values.iv_security_slip_or_price_bond_no = "";
    rcoPart2Formik.values.iv_tie_up_non_tie_up = 0;
    rcoPart2Formik.values.iv_meter_reading = "";
    rcoPart2Formik.values.iv_meter_reading_off_peak_kwh = "";
    rcoPart2Formik.values.iv_meter_reading_peak_kwh = "";
    rcoPart2Formik.values.iv_meter_reading_off_peak_kvarh = "";
    rcoPart2Formik.values.iv_meter_reading_peak_kvarh = "";
    scoPart2Formik.values.iv_meter_code2 = "";
    scoPart2Formik.values.iv_meter_code1 = "";
    setManufcaturerCode({ code: null, name: "" });
    setInstalledMeterImage("");
    setInstalledMeterImageThumbnail("");
    setApprovalDocument("");
    setApprovalDocumentThumbnail("");
    setApprovalDocumentError("");
    masterDataFormik.resetForm();
    masterDataFormik.values.iv_govt_dept = 0;
    masterDataFormik.values.iv_income_tax = 0;
    masterDataFormik.values.iv_standard_classification_code = "";
    setStandardClassificationCode({ XCLFM_CODE: "", XCLFM_DESC: "" });
    setGovtDeptCode({ departmentCode: null, departmentName: "" });
    setStoreCharges();
    setItemsAmount();
    setSketchDiagram();
    setSketchDiagramUploaded();
    setSketchDiagramThumbnail();
    setMeterImage();
    setMeterImageThumbnail("");
    setMeterImageError("");
    setInstallationCharges();
    setError("");
    setArrearsDetailsRefno({
      arrearsAmount: "",
      meterStatus: "",
      tariffDesc: "",
      meterType: "",
      phase: "",
      consumerName: "",
      consumerNo: "",
      consumerAddress: "",
      consumerEmail: "",
    });
    setArrearsDetailsRefnoToDisplay({
      refNo: "",
      arrearsAmount: "",
      meterStatus: "",
      tariffDesc: "",
      meterType: "",
      phase: "",
      consumerName: "",
      consumerNo: "",
      consumerAddress: "",
      consumerEmail: "",
      paidArearImage: "",
      paidArearDate: "",
    });
    setDnDetails({
      demandNoticeNo: "",
      issueDate: "",
      applicationId: "",
      dueDate: "",
      roOfficeAddress: "",
      consumerAccountNo: "",
      batchNo: "",
      voltage: "",
      tariff: "",
      coverageAreaOfPremises: "",
      bankName: "",
      industryFactoryType: "",
      sketchImage: "",
      isDistance40: "",
      connectionAccountNo: "",
      dnPaymentFlag: "",
      paymentMethod: "",
      dnPaymentVerificationFlag: "",
      // meterRent: "",
      // serviceRent: "",
      sanctionLoad: "",
      surveyedBy: "",
      surveyedDate: "",
      filledBy: "",
      filledDate: "",
      filledFlag: "",
      approvedBy: "",
      approvedDate: "",
      approvedFlag: "",
      amountOfGridSharing: "",
      amountOfFeederRehab: "",
      paymentDate: "",
      capitalCostAmount: "",
      securityDepositeAmount: "",
    });
    setRcoDetails({
      rcoId: "",
      applicationId: "",
      rcoCreationDate: "",
      urbanRural: "",
      refNo: "",
      fataPata: "",
      feederNo: "",
      batch: "",
      subBatch: "",
      fGovt: "",
      cantonmentBoard: "",
      pGovt: "",
      localBodies: "",
      rcoP1FilledBy: "",
      rcoP1FillingDate: "",
      rcoP1FillFlag: "",
      authorizedByName: "",
      dateOfAuthorization: "",
      rcoP1ApprovedFlag: "",
      storeRequisitionNo: "",
      storeRequisitionDate: "",
      seasonalFlag: "",
      sanctionedLoad: "",
      noOfACs: "",
      noOfMeters: "",
      noOfMeterSets: "",
      noOfSubSets: "",
      noOfSupplyPoints: "",
      installedTransformerCapacity: "",
      meterId: "",
      meterNo: "",
      locationCode: "",
      meterCode: "",
      manufacturerCode: "",
      multiplyingFactor: "",
      meterRange: "",
      meterReading: "",
      dateOfReConnection: "",
      cp78ItemNo: "",
      tieUpNonTieUp: "",
      sealOnMeter: "",
      sealOnBox: "",
      securitySlipOrPriceBondNo: "",
      connectionInstallerName: "",
      rcoP2FilledBy: "",
      rcoP2FillingDate: "",
      rcoP2FillFlag: "",
      rcoP2ApprovedBy: "",
      rcoP2ApprovalDate: "",
      rcoP2ApprovalFlag: "",
      installedMeterImage: "",
    });
    setDialogRowData((prevObject) => ({
      ...prevObject,
      applicantCNICFront: "",
      applicantCNICBack: "",
      paidBillImage: "",
      scannedCopyOfNearByElectricityBill: "",
      anyOtherDocument: "",
      copyOfOwnerCNICFront: "",
      copyOfOwnerCNICBack: "",
      ownerNOC: "",
      resolutionFormDesc: "",
      certFormDesc: "",
      certMemoDesc: "",
    }));
    setTotalCharges(0);
    setItemsArray([]);
    setFlag_applicantCNICFront(null);
    setFlag_applicantCNICBack(null);
    setFlag_scannedCopyOfNearByElectricityBill(null);
    setFlag_anyOtherDocument(null);
    setFlag_paidBillImage(null);
    setApplicantCNICFrontObjectionRemarks("");
    setApplicantCNICBackObjectionRemarks("");
    setPaidBillImageObjectionRemarks("");
    setScannedCopyOfNearByElectricityBillObjectionRemarks("");
    setAnyOtherDocumentObjectionRemarks("");
    setBankName();
    setFoundInNc();
    setStoredMeterRemovedData(null);
    setMeterRemovedSnapshotRows(null);
    setMeterRemovedTariffCd("");
    setOpenMeterRemovedPopup(false);
    setOpenReadingInfoPopup(false);
    setReadingInfoDraft({});
    setReadingInfoError("");
    setMeterRemovedError("");
    setMeterRemovedLoading(false);
    setIbsMeterIdBySetNo({});
    setIbsMaxRemovedSetNo(0);
    applyMeterRemovedRows([
      {
        setNo: 1,
        meterType: "",
        serialNo: "",
        multiplyFactor: "",
        masterReading: "",
        meterReading: "",
        advanceUnits: "",
        roundingCompCode: "",
      },
    ]);
    setOpen(false);
    setEFileData([]);
    setTableDataProcessingSummary([]);
    dispatch(
      fetchPaginatedMeterChangeRequestNormal({
        page: currentPageNormal,
        pageSize: pageSizeNormal,
        dateFrom: dateFromNormal,
        dateTo: dateToNormal,
        loadFrom: loadFromNormal,
        loadTo: loadToNormal,
        applicationProgressId: applicationProgressIdNormal,
        objectionStatus: objectionStatusNormal,
        officeCode: selectedOfficeCode || code,
      }),
    );
    dispatch(
      fetchPaginatedMeterChangeRequestOverdue({
        page: currentPageOverdue,
        pageSize: pageSizeOverdue,
        dateFrom: dateFromOverdue,
        dateTo: dateToOverdue,
        loadFrom: loadFromOverdue,
        loadTo: loadToOverdue,
        applicationProgressId: applicationProgressIdOverdue,
        objectionStatus: objectionStatusOverdue,
        officeCode: selectedOfficeCode || code,
      }),
    );
  };

  const showArrearsEntryPopup = () => {
    setArrearsEntryPopUpOpen(true);
  };

  const showObjectionPopup = () => {
    setObjectionPopUpOpen(true);
  };

  const hideObjectionPopup = () => {
    formik.handleReset();
    setObjectionPopUpOpen(false);
  };

  const hideCopyOfApplicantCNICVerifyAlert = (x) => {
    setCopyOfApplicantCNICVerifyPopUp(x);
  };

  const hideInstalledMeterImageVerifyAlert = (x) => {
    setInstalledMeterImageVerifyPopUp(x);
  };

  const hidePropertyDocVerifyAlert = (x) => {
    setPaidBillImagePopUp(x);
  };

  const hideNearByBillVerifyAlert = (x) => {
    setNearByBillVerifyPopUp(x);
  };

  const hideAnyOtherDocumentVerifyAlert = (x) => {
    setAnyOtherDocumentVerifyPopUp(x);
  };

  const hidePaidDnImagePopUp = (x) => {
    setPaidDNImagePopUp(x);
  };

  const hideDnPaymentVerifyAlert = () => {
    setDnPaymentVerifyAlert(false);
  };

  const hideDnPaymentRejectAlert = () => {
    setDnPaymentRejectAlert(false);
  };

  const hideRCOPart1ApproveAlert = () => {
    setRcoPart1ApproveAlert(false);
  };

  const hideRCOPart2ApproveAlert = () => {
    setRcoPart2ApproveAlert(false);
  };

  const showRejectionRemovalAlert = () => {
    setRejectionRemovalAlert(true);
  };

  const showFieldRejectionRemovalAlert = () => {
    setFieldRejectionRemovalAlert(true);
  };

  const hideRejectionRemovalAlert = () => {
    setRejectionRemovalAlert(false);
  };

  const hideFieldRejectionRemovalAlert = () => {
    setFieldRejectionRemovalAlert(false);
  };

  const hideArrearsEntryAlert = () => {
    setArrearsEntryPopUpOpen(false);
  };

  const getClassName = (x) => {
    if (x === "Pending") {
      return "pending-button";
    } else if (x === "In Process") {
      return "inprocess-button";
    } else if (x === "Approved") {
      return "approved-button";
    } else if (x === "Completed") {
      return "completed-button";
    } else if (x === "Objection") {
      return "objection-button";
    }
  };

  const filterRCApp = async (applicationId) => {
    const myArray = reconnectionApplications;
    let allApplications = myArray.concat(reconnectionApplicationsOverDue);
    let itemFound = allApplications.find(
      (item) => item.applicationId === applicationId,
    );
    if (itemFound === undefined) {
      itemFound = await SearchIndividualApplication(token, applicationId, "2");
    }

    return itemFound;
  };

  const apiToDataGridConversionNormal = async () => {
    try {
      const tempArray = [];
      if (reconnectionApplications) {
        reconnectionApplications.forEach((item) => {
          let dataGridObject = {};
          if (item.applicationId && item.applicationId.startsWith("MC")) {
            if (
              !item.objectionStatus ||
              item.objectionStatus == 0 ||
              item.objectionStatus == 2
            ) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType ?? 5,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.consumerName,
                applicantCNIC: item.consumerCNIC,
                sanctionedLoad: item.sanctionedLoad,
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus,
                ),
                applicationProgressId: progFunc(item.applicationProgressId),
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                tariff:
                  allTariffList && getTariff(item.tariffCode, allTariffList),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                isDiscAboveAYear: item.isDiscAboveAYear,
                isMCOWithCost: item.isMCOWithCost,
                isMeterAvailable: item.isMeterAvailable,
                downloadEFile: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadCP138PDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadCP138PDF(application, scoDetails);
                },
                downloadNOCPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadNOCPDF(application);
                },
              };
            } else if (item.objectionStatus === 1) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType ?? 5,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.consumerName,
                applicantCNIC: item.consumerCNIC,
                sanctionedLoad: item.sanctionedLoad,
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus,
                ),
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                tariff:
                  allTariffList && getTariff(item.tariffCode, allTariffList),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                applicationProgressId: item.remarks,
                isMCOWithCost: item.isMCOWithCost,
                isMeterAvailable: item.isMeterAvailable,
                downloadEFile: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadCP138PDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadCP138PDF(application, scoDetails);
                },
                downloadNOCPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadNOCPDF(application);
                },
              };
            }
            tempArray.push(dataGridObject);
          }
        });
      } else {
        const dataGridObject = {
          applicationId: " ",
          connectionType: "",
          applicantName: " ",
          applicantCNIC: " ",
          applicationStatusId: statusFunc(" "),
        };
        tempArray.push(dataGridObject);
      }

      setReconnectionApplicationsToDataGrid(tempArray);
      setViewBackdrop(false);
    } catch (e) { /* ignored */ }
  };

  const apiToDataGridConversionOverdue = async () => {
    try {
      const tempArray = [];
      if (reconnectionApplicationsOverDue) {
        reconnectionApplicationsOverDue.forEach((item) => {
          let dataGridObject = {};
          if (item.applicationId && item.applicationId.startsWith("MC")) {
            if (
              !item.objectionStatus ||
              item.objectionStatus == 0 ||
              item.objectionStatus == 2
            ) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType ?? 5,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.consumerName,
                applicantCNIC: item.consumerCNIC,
                sanctionedLoad: item.sanctionedLoad,
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus,
                ),
                applicationProgressId: progFunc(item.applicationProgressId),
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                tariff:
                  allTariffList && getTariff(item.tariffCode, allTariffList),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                isDiscAboveAYear: item.isDiscAboveAYear,
                isMCOWithCost: item.isMCOWithCost,
                isMeterAvailable: item.isMeterAvailable,
                downloadEFile: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadCP138PDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadCP138PDF(application, scoDetails);
                },
                downloadNOCPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadNOCPDF(application);
                },
              };
            } else if (item.objectionStatus === 1) {
              dataGridObject = {
                applicationId: item.applicationId,
                applicationType: item.applicationType ?? 5,
                creationDate: convertDateDDMMYY(item.creationDate),
                lastModificationDate: convertDate(item.lastModificationDate),
                connectionType: item.connectionType,
                applicantName: item.consumerName,
                applicantCNIC: item.consumerCNIC,
                sanctionedLoad: item.sanctionedLoad,
                applicationStatusId: statusFunc(
                  item.applicationProgressId,
                  item.objectionStatus,
                ),
                applicationProgressNumber: item.applicationProgressId,
                inTime: item.inTime,
                tariff:
                  allTariffList && getTariff(item.tariffCode, allTariffList),
                exceededDuration: item.exceededDuration,
                releventApplicationFlage: item.releventApplicationFlage,
                applicationProgressId: item.remarks,
                isMCOWithCost: item.isMCOWithCost,
                isMeterAvailable: item.isMeterAvailable,
                downloadEFile: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadEFile(application);
                },
                downloadDNPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadDNPDF(application);
                },
                downloadCP138PDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadCP138PDF(application, scoDetails);
                },
                downloadNOCPDF: async () => {
                  let application = await filterRCApp(item.applicationId);
                  await downloadNOCPDF(application);
                },
              };
            }
            tempArray.push(dataGridObject);
          }
        });
      } else {
        const dataGridObject = {
          applicationId: " ",
          connectionType: "",
          applicantName: " ",
          applicantCNIC: " ",
          applicationStatusId: statusFunc(" "),
        };
        tempArray.push(dataGridObject);
      }

      setReconnectionApplicationsOverDueToDataGrid(tempArray);
      setViewBackdrop(false);
    } catch (e) { /* ignored */ }
  };

  const updateDocumentStatus = () => {
    if (
      flag_applicantCNICFront !== null &&
      flag_applicantCNICBack !== null &&
      flag_scannedCopyOfNearByElectricityBill !== null &&
      (!dialogRowData.anyOtherDocument || flag_anyOtherDocument !== null)
    ) {
      callingUpdateDocumentStatusAPI();
    } else {
      setSnackbar({
        open: true,
        message: "Check all the attached documents before submitting!",
        severity: "error",
      });
    }
  };

  const statusFunc = (x, objection) => {
    if (objection === 0 || objection === 2) {
      if (x === 0) {
        return "Pending";
      } else if (x > 0 && x < 5) {
        return "In Process";
      } else if (x >= 5 && x < 10) {
        return "Approved";
      } else {
        return "Completed";
      }
    } else {
      return "Objection";
    }
  };

  const progFunc = (x) => {
    if (x === 0) {
      return "Documents Uploading";
    } else if (x === 1) {
      return "Documents Verification";
    } else if (x === 2) {
      return "Approval / Rejection";
    }  else if (x === 3) {
      return "Arrear Verification";
    } else if (x === 4) {
      return "Field Survey";
    } else if (x === 5) {
      return "M&T Report";
    } else if (x === 6) {
      return "DN Approval";
    } else if (x === 7) {
      return "DN Submission";
    } else if (x === 8) {
      return "DN Payment Verification";
    } else if (x === 9) {
      return "Meter Installation";
    } else if (x === 10) {
      return "Forward To RO";
    } else if (x === 11) {
      return "Ready for Billing";
    } else if (x === 12) {
      return "Completed";
    }
  };

  const stepName = (x) => {
    if (x === 0) {
      return "Application Submitted";
    } else if (x === 1) {
      return "Documents Submitted";
    } else if (x === 2) {
      return "Documents Verified";
    } else if (x === 3) {
      return "Approval / Rejection";
    }else if (x === 4) {
      return "Arrear Verification";
    } else if (x === 5) {
      return "Field Survey";
    } else if (x === 6) {
      return "M&T Report";
    } else if (x === 7) {
      return "DN Approval";
    } else if (x === 8) {
      return "DN Submission";
    } else if (x === 9) {
      return "DN payment Verification";
    } else if (x === 10) {
      return "Meter Installation";
    } else if (x === 11) {
      return "Forward To RO";
    } else if (x === 12) {
      return "Ready For Billing";
    }
  };

  const getWFData = async () => {
    setViewBackdrop(true);
    let wfData = await getWorkforceData(
      token,
      hierarchy == 52 ? code : "15171",
    );
    setWorkForceData(wfData);
    setViewBackdrop(false);
  };

  const callGetSCOAPI = async (applicationId) => {
    try {
      let mcoDets = "";

      if (!applicationId) return mcoDets;

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({ applicationId });

      const response = await fetch(
        cfpBaseUrl + "meterChangeOrder/getCP138Data",
        {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        },
      );

      const result = await response.json();

      if (result.status === "200") {
        const payload = result.data || {};
        const installation = payload.mcoMeterInstallation?.[0] || {};
        const removedMeterProfile = payload.removedMeterProfile || [];
        const installedMeterProfile = payload.installedMeterProfile || [];

        const mergedDetails = {
          ...installation,
          removedMeterProfile,
          installedMeterProfile,
        };

        setScoDetails(mergedDetails);
        setMcoInstalledMeterData(payload.mcoMeterInstallation || []);

        mcoDets = mergedDetails;
      }

      return mcoDets;
    } catch (e) {
      return "";
    }
  };

  const handleRowClick = async (applicationId, event) => {
    setViewBackdrop(true);
    let demandNoticeDetails = "";
    let dnPayDate = "";
    let rcoDets = "";
    if (applicationId) {
      const item = await filterRCApp(applicationId);
      if (item) {
        const connectionType = item.connectionCategory;
        const sanctionedLoad = item.sanctionedLoad;
        const consumerRefNo = item.referenceNo;
        const isReferedToFeildSurvey = item.isReferedToFeildSurvey;
        let phase = getPhase(item.sanctionedLoad);
        setPhase(phase);
        setDialogRowData(item);
        setApplicantCNICFrontObjectionRemarks(item.applicantCNICFrontRemarks);
        setApplicantCNICBackObjectionRemarks(item.applicantCNICBackRemarks);
        setFlag_applicantCNICFront(item.applicantCNICFrontFlag);
        setFlag_applicantCNICBack(item.applicantCNICBackFlag);
        setFlag_scannedCopyOfNearByElectricityBill(
          item.electricityBillImageFlag,
        );
        setFlag_anyOtherDocument(item.anyOtherDocumentFlag);
        setScannedCopyOfNearByElectricityBillObjectionRemarks(
          item.electricityBillImageRemarks,
        );
        setAnyOtherDocumentObjectionRemarks(item.anyOtherDocumentRemarks);
        // await callEfileAPI(applicationId, item);

        if ((item.applicationProgressId === 1 || item.applicationProgressId === 2) && item.customerId) {
          await callReconnectionHistory(
            item.customerId,
            code?.slice(0, 2) || selectedOfficeCode || "10",
          );
        } else {
          setReconnectionHistoryRows([]);
          setReconnectionHistoryLoading(false);
        }

        if (item.applicationProgressId === 1) {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");
          const raw = JSON.stringify({
            applicationId: item.applicationId,
          });
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };
          await fetch(
            cfpBaseUrl + "meterChangeOrder/getMCODocuments",
            requestOptions,
          )
            .then((response) => response.json())
            .then((result) => {
              setDialogRowData((prevObject) => ({
                ...prevObject,
                paidBillImage: result.data[0].paidBillImage,
                applicantCNICFront: result.data[0].applicantCNICFront,
                applicantCNICBack: result.data[0].applicantCNICBack,
                scannedCopyOfNearByElectricityBill:
                  result.data[0].electricityBillImage,
                anyOtherDocument: result.data[0].anyOtherDocument,
              }));
            })
            .catch(() => {});
        }
        if (item.applicationProgressId === 4) {
          await getWFData();
          let fieldStaffDesignations = await getFieldStaffDesignations(token);
          setFieldStaffDesignations(fieldStaffDesignations);

          let subDivisionObject = subDivisions.find(
            (objs) => objs.subDivisionCode === item.subDivisionCode,
          );
          if (subDivisionObject) {
            setBankName(subDivisionObject.subDivBankName);
          }
          fieldFormik.setFieldValue(
            "iv_meter_type",
            item?.meterPhaseType == null || item?.meterPhaseType === ""
              ? ""
              : String(item.meterPhaseType),
          );
        }
        if (
          item.applicationProgressId === 6 ||
          item.applicationProgressId === 7 ||
          item.applicationProgressId === 8
        ) {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: item.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          await fetch(
            cfpBaseUrl + "meterChangeOrder/getMCODemandNoteData",
            requestOptions,
          )
            .then((response) => response.json())
            .then((result) => {
              if (result.status === "200") {
                setDnImage(result.data[0].paidDNImage);
                setDnApproveStep(result.data[0]);
                setDnDets(result.data[0]);
              }
            })
            .catch(() => {});
        }

        if (item.applicationProgressId === 9) {
          const latestMcoTariffs = await callMCOTariffDetails();

        if (scoPart2Formik.values.iv_total_kwh == "1") {
            scoPart2Formik.values.iv_meter_code1 = "000002";
          } else if (Number(scoPart2Formik.values.iv_total_kwh) >= 2) {
            scoPart2Formik.values.iv_meter_code1 = "050502";
            scoPart2Formik.values.iv_meter_code2 = "050602";
          }

          if (phase == "MDI (LT)(CT)" || phase == "MDI (HT)(CT/PT)") {
            scoPart2Formik.values.iv_ct_nom = "100";
            scoPart2Formik.values.iv_ct_denom = "5";
          } else {
            scoPart2Formik.values.iv_ct_nom = "1";
            scoPart2Formik.values.iv_ct_denom = "1";
          }

          if (phase == "MDI (HT)(CT/PT)") {
            scoPart2Formik.values.iv_pt_nom = "11000";
            scoPart2Formik.values.iv_pt_denom = "110";
          }

          scoPart2Formik.setFieldValue("iv_connection_installer_name", userId);
          scoPart2Formik.setFieldValue("iv_tariff_code", item.tariffDesc);
          handleTariffSelection(
            item.tariffDesc,
            item?.tariffCode,
            latestMcoTariffs,
          );
          scoPart2Formik.setFieldValue(
            "iv_meter_typee",
            item?.meterType == null || item?.meterType === ""
              ? ""
              : String(item.meterType),
          );
        }

        if (item.applicationProgressId >= 10) {
          await callGetSCOAPI(item.applicationId);
        }
        setViewBackdrop(false);
        setOpen(true);
      }
    }
  };

  useEffect(() => {
    if (dialogRowData && allTariffList) {
      const connectionType = dialogRowData?.connectionType?.toLowerCase() || "";

      const matchedTariffs = allTariffList.filter(
        (tariff) =>
          tariff?.consumerType &&
          tariff.consumerType.toLowerCase() === connectionType,
      );

      const shortlistedTariffs = getTariffsForValue(
        parseInt(dialogRowData?.appliedLoad || 0),
        matchedTariffs,
      );

      setShortListIndustrialTariff(shortlistedTariffs);
    } else {
      setShortListIndustrialTariff([]);
    }
  }, [
    dialogRowData?.connectionType,
    dialogRowData?.appliedLoad,
    allTariffList,
  ]);

  useEffect(() => {
    const callStandardClassificaitionCodesAPI = async () => {
      try {
        var formdata = new FormData();

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "demandNotice/getClassificationCodes",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              setStandardClassificationCodes(result.data);
            }
          })
          .catch(() => {});
      } catch (e) { /* ignored */ }
    };

    callStandardClassificaitionCodesAPI();
  }, []);

  useEffect(() => {
    const callGovtDeptCodesAPI = async () => {
      try {
        var formdata = new FormData();

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "sco/getGovtDepartList", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              setGovtDeptCodes(result.data);
            }
          })
          .catch(() => {});
      } catch (e) { /* ignored */ }
    };
    callGovtDeptCodesAPI();
  }, []);

  const getDocumentBackGroundColor = (flagValue) => {
    switch (flagValue) {
      case null:
        return "white";
      case -1:
        return "#FFCAC9";
      case "-1":
        return "#FFCAC9";
      case 0:
        return "#F3F6FB";
      case 1:
        return "#D6F6D5";
      case "1":
        return "#D6F6D5";
      default:
        return "white";
    }
  };

  // const DnReceiptImage = (event) => {
  //   dnPymentReceiptFormik.handleChange(event);
  //   if (event.target.files.length > 0) {
  //     let file = event.target.files[0];
  //     let fileName = file.name;
  //     let fileNameArray = fileName.split(".");
  //     let extension = fileNameArray[fileNameArray.length - 1];
  //     const maxSize = 2 * 1024 * 1024; // 2MB in bytes
  //     const documentValidate = documentValidation(file, maxSize);
  //     if (documentValidate === 1) {
  //       const newFileName = "dnReceiptImage." + extension;
  //       const renamedFile = new File([file], newFileName, { type: file.type });
  //       setDnReceiptImage(renamedFile);
  //       const reader = new FileReader();
  //       reader.readAsDataURL(file);
  //       reader.onload = () => {
  //         // Set the thumbnail image as the data URL
  //         const base64Image = reader.result;
  //         setDnReceiptImageThumbnail(base64Image);
  //       };
  //     } else if (documentValidate === 2) {
  //     }
  //   }
  // };

  const RcoFeeReceiptImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "rcoFeeReceiptImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        rcoFeeReceiptFormik.handleChange,
        setRcoFeeReceiptImage,
        setRcoFeeReceiptImageError,
        setRcoFeeReceiptImageThumbnail,
        newFileName,
      );
    }
  };

  const DnReceiptImage = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const newFileName = "dnReceiptImage." + file.name.split(".").pop();

      const uploaded = handleFileUpload(
        event,
        dnReceiptFormik.handleChange,
        setDnReceiptImage,
        setDnReceiptImageError,
        setDnReceiptImageThumbnail,
        newFileName,
      );

      if (uploaded === true) {
        dnReceiptFormik.setFieldValue("iv_dn_receipt_image", file);
        dnReceiptFormik.setFieldTouched("iv_dn_receipt_image", true);
      } else {
        dnReceiptFormik.setFieldValue("iv_dn_receipt_image", null);
        dnReceiptFormik.setFieldTouched("iv_dn_receipt_image", true);
      }
    }
  };

  const handleDnReceiptSubmit = () => {
    if (!dnReceiptImageThumbnail?.trim()) {
      setDnReceiptImageError(
        (prev) => prev || "Upload paid DN receipt image.",
      );
      dnReceiptFormik.setFieldTouched("iv_dn_fee_payment_date", true, false);
      dnReceiptFormik.validateForm();
      return;
    }

    dnReceiptFormik.handleSubmit();
  };

  const MAndTReceiptImage = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const newFileName = "mandtReceiptImage." + file.name.split(".").pop();

      const uploaded = handleFileUpload(
        event,
        mandtReceiptFormik.handleChange,
        setMandtReceiptImage,
        setMandtReceiptImageError,
        setMandtReceiptImageThumbnail,
        newFileName,
      );

      if (uploaded === true) {
        mandtReceiptFormik.setFieldValue("iv_mandt_receipt_image", file);
        mandtReceiptFormik.setFieldTouched("iv_mandt_receipt_image", true);
      } else {
        mandtReceiptFormik.setFieldValue("iv_mandt_receipt_image", null);
        mandtReceiptFormik.setFieldTouched("iv_mandt_receipt_image", false);
        setMandtReceiptImage("");
        setMandtReceiptImageThumbnail("");
      }
    }
  };

  const handleMandtReceiptSubmit = async () => {
    mandtReceiptFormik.setFieldTouched("iv_mandt_report_no", true, false);
    mandtReceiptFormik.setFieldTouched("iv_mandt_payment_date", true, false);
    mandtReceiptFormik.setFieldTouched("iv_mandt_receipt_image", true, false);

    const hasThumbnail = Boolean(mandtReceiptImageThumbnail?.trim());
    if (!hasThumbnail && !mandtReceiptImageError) {
      setMandtReceiptImageError("Upload M&T report image.");
    }

    const errors = await mandtReceiptFormik.validateForm();
    if (Object.keys(errors).length > 0 || !hasThumbnail) {
      return;
    }

    mandtReceiptFormik.handleSubmit();
  };

  const PaidBillImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "paidBillImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        rcoFeeReceiptFormik.handleChange,
        setPaidBillImage,
        setPaidBillImageError,
        setPaidBillImageThumbnail,
        newFileName,
      );
    }
  };

  const ApprovalDocumentImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "approvalDocument." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        () => {},
        setApprovalDocument,
        setApprovalDocumentError,
        setApprovalDocumentThumbnail,
        newFileName,
      );
    }
  };

  const deleteItem = (indexToDelete) => {
    const updatedItems = itemsArray.filter((_, i) => i !== indexToDelete);

    const { totalAmountofItems, store_charges, installation_charges } =
      calculateCharges(updatedItems, dialogRowData?.applicationId);
    const total_charges =
      totalAmountofItems + store_charges + installation_charges;

    setItemsAmount(totalAmountofItems);
    setStoreCharges(store_charges);
    setInstallationCharges(installation_charges);
    setTotalCharges(total_charges);
    setItemsArray(updatedItems);

    fieldItemFormik.setFieldValue("iv_items_array", updatedItems);
  };

  const updateItemQtyByDelta = (indexToUpdate, delta) => {
    if (dnDetails && dnDetails.filledFlag === 1) return;
    if (indexToUpdate < 0 || indexToUpdate >= itemsArray.length) return;

    const currentQty = Number(itemsArray[indexToUpdate]?.qty) || 0;
    const nextQty = Math.max(1, currentQty + delta);

    const updatedItems = itemsArray.map((item, i) =>
      i === indexToUpdate
        ? {
            ...item,
            qty: nextQty,
            amount: calculateItemAmount(nextQty, item?.rate),
          }
        : item,
    );

    const { totalAmountofItems, store_charges, installation_charges } =
      calculateCharges(updatedItems, dialogRowData?.applicationId);
    const total_charges =
      totalAmountofItems + store_charges + installation_charges;

    setItemsAmount(totalAmountofItems);
    setStoreCharges(store_charges);
    setInstallationCharges(installation_charges);
    setTotalCharges(total_charges);
    setItemsArray(updatedItems);
    fieldItemFormik.setFieldValue("iv_items_array", updatedItems);
  };

  const getMeterType = (code) => {
    switch (code) {
      case 0:
        return "Normal";
      case "0":
        return "Normal";
      case 1:
        return "Smart";
      case "1":
        return "Smart";
      default:
        return "-";
    }
  };

  const FataPata = (event) => {
    refNoAllocationFormik.handleChange(event);
    refNoAllocationFormik.values.iv_fata_pata = event.target.value;
  };

  const RuralUrban = (event) => {
    refNoAllocationFormik.handleChange(event);
    refNoAllocationFormik.values.iv_rural_urban = event.target.value;
  };

  const SeasonalNonSeasonal = (event) => {
    rcoPart2Formik.handleChange(event);
    rcoPart2Formik.values.iv_seasonal_flag = event.target.value;
  };

  const GovtDept = (event) => {
    masterDataFormik.handleChange(event);
    masterDataFormik.values.iv_govt_dept = event.target.value;
    masterDataFormik.values.iv_ed_code = "";
  };

  const MeterType = (event) => {
    rcoPart2Formik.handleChange(event);
    rcoPart2Formik.values.iv_meter_type = event.target.value;
  };

  const IncomeTax = (event) => {
    masterDataFormik.handleChange(event);
    masterDataFormik.values.iv_income_tax = event.target.value;
  };

  const MeterLine = (event) => {
    fieldFormik.handleChange(event);
    fieldFormik.values.iv_distance = event.target.value;
    setDistance(event.target.value);
    if (event.target.value == "0") {
      setGridFlag(false);
      setFeederRehabFlag(false);
    }
    // if (event.target.value == "1") {
    //   setCivilWorkCharges(0)
    //   setFixedChargesOfMetering(0)
    //   setMiscellaneousCharges(0)
    //   setInstallationCharges('')
    //   setItemsAmount('')
    //   setStoreCharges(0)
    //   setLessTheCost(0)
    //   setGridSharingCost(0)
    //   setFeederRehabilitationCharges('')
    //   SetTotalEstimatedAmnt('')
    //   setBoqItems([])
    //   setItemsArray([])
    //   setGrandTotalCharges(0)

    // } else {
    //   setCivilWorkCharges("")
    //   setItemsArray([])
    //   setFixedChargesOfMetering('')
    //   setMiscellaneousCharges('')
    //   setInstallationCharges('')
    //   setItemsAmount('')
    //   setStoreCharges('')
    //   setLessTheCost('')
    //   setGridSharingCost("")
    //   setFeederRehabilitationCharges('')
    //   SetTotalEstimatedAmnt('')
    //   setBoqItems([])
    //   setGrandTotalCharges('')
    // }
    setCivilWorkCharges(0);
    setFixedChargesOfMetering(0);
    setMiscellaneousCharges(0);
    setInstallationCharges("");
    setItemsAmount("");
    setStoreCharges(0);
    setLessTheCost(0);
    setGridSharingCost(0);
    setFeederRehabilitationCharges("");
    setBoqItems([]);
    setItemsArray([]);
    setGrandTotalCharges(0);
  };

  const ReferToSubdivision = (event) => {
    referToFieldFormik.handleChange(event);
    referToFieldFormik.values.iv_refer_to_subdivision = event.target.value;
  };

  const ExemptRCOFee = (event) => {
    referToFieldFormik.handleChange(event);
    referToFieldFormik.values.iv_exempt_rco_fee = event.target.value;
    if (event.target.value == 1) {
      referToFieldFormik.values.iv_refer_to_subdivision = 0;
    }
  };

  const eFileIcon = () => {
    return <img src={eFileIcon} alt="Efile Icon" height="20" width="25" />;
  };

  const resolveScoDetailsForCP138 = async (applicationId, scoDetails) => {
    let resolvedScoDetails = scoDetails;
    const hasScoData =
      resolvedScoDetails &&
      (resolvedScoDetails.removedMeterProfile?.length > 0 ||
        resolvedScoDetails.installedMeterProfile?.length > 0 ||
        resolvedScoDetails.R_NO_KWH_METER != null ||
        resolvedScoDetails.I_NO_KWH_METER != null ||
        resolvedScoDetails.R_METER_SERIAL_NO ||
        resolvedScoDetails.I_METER_SERIAL_NO);
    if (!hasScoData) {
      resolvedScoDetails = await callGetSCOAPI(applicationId);
    }
    return resolvedScoDetails;
  };

  const addCP138WatermarkAndPageNumbers = (doc, DiscoCode) => {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.addImage(
        getWaterMarkLogo(DiscoCode),
        "PNG",
        0,
        0,
        pageWidth,
        pageHeight,
      );
      doc.setFontSize(8);
      doc.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 10, {
        align: "center",
      });
    }
  };

  const buildCP138PDFDoc = async (
    application,
    scoDetails,
    { includeFooter = true, targetDoc = null, startOnNewPage = false } = {},
  ) => {
    const applicationId = application.applicationId;
    const DiscoCode = getDocumentDiscoCode(
      application.applicationId,
      application.companyCode,
    );
    const resolvedScoDetails = await resolveScoDetailsForCP138(
      applicationId,
      scoDetails,
    );
      const doc = targetDoc ?? new jsPDF({ compressPdf: true });
      if (startOnNewPage) {
        doc.addPage();
      }
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      let height = 10;
      const padding = 10;
      const leftMargin = 50;

      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, applicationId);
      const barcodeDataURL = barcodeCanvas.toDataURL("image/png");

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;

      doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20);
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      // ── Print By / On stamp (top-right, diagonal) ────────────────────
      const printDate = new Date().toLocaleDateString("en-GB");
      (() => {
        const sc = document.createElement("canvas");
        sc.width = 500;
        sc.height = 300;
        const ctx = sc.getContext("2d");
        const cx = sc.width / 2,
          cy = sc.height / 2;

        // rotate ~-12 deg around centre
        ctx.translate(cx, cy);
        ctx.rotate((-12 * Math.PI) / 180);
        ctx.translate(-cx, -cy);

        // stamp box centred with generous padding from canvas edges
        const bx = 40,
          by = 60,
          bw = sc.width - 80,
          bh = 170;

        // outer border rounded rect
        const rr = (x, y, w, h, r, lineW, color) => {
          ctx.beginPath();
          ctx.moveTo(x + r, y);
          ctx.lineTo(x + w - r, y);
          ctx.quadraticCurveTo(x + w, y, x + w, y + r);
          ctx.lineTo(x + w, y + h - r);
          ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
          ctx.lineTo(x + r, y + h);
          ctx.quadraticCurveTo(x, y + h, x, y + h - r);
          ctx.lineTo(x, y + r);
          ctx.quadraticCurveTo(x, y, x + r, y);
          ctx.closePath();
          ctx.strokeStyle = color;
          ctx.lineWidth = lineW;
          ctx.stroke();
        };
        rr(bx, by, bw, bh, 16, 5, "#555555");
        rr(bx + 6, by + 6, bw - 12, bh - 12, 11, 2, "#555555");

        // top banner fill
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(bx + 6 + 11, by + 6);
        ctx.lineTo(bx + 6 + bw - 12 - 11, by + 6);
        ctx.quadraticCurveTo(
          bx + 6 + bw - 12,
          by + 6,
          bx + 6 + bw - 12,
          by + 6 + 11,
        );
        ctx.lineTo(bx + 6 + bw - 12, by + 6 + 44);
        ctx.lineTo(bx + 6, by + 6 + 44);
        ctx.lineTo(bx + 6, by + 6 + 11);
        ctx.quadraticCurveTo(bx + 6, by + 6, bx + 6 + 11, by + 6);
        ctx.closePath();
        ctx.fillStyle = "#555555";
        ctx.fill();
        ctx.restore();

        // banner text
        ctx.fillStyle = "#fff";
        ctx.font = "bold 26px Georgia";
        ctx.textAlign = "center";
        ctx.fillText("PRINTED", cx, by + 39);

        // divider
        ctx.strokeStyle = "#555555";
        ctx.lineWidth = 1.5;
        ctx.beginPath();
        ctx.moveTo(bx + 20, by + 56);
        ctx.lineTo(bx + bw - 20, by + 56);
        ctx.stroke();

        // body rows — large text
        ctx.textAlign = "left";
        ctx.fillStyle = "#555555";
        const labelX = bx + 22;
        const valueX = bx + 110;

        ctx.font = "bold 22px Arial";
        ctx.fillText("By :", labelX, by + 96);
        ctx.font = "bold 26px Arial";
        ctx.fillText(userId ?? "-", valueX, by + 96);

        ctx.font = "bold 22px Arial";
        ctx.fillText("On :", labelX, by + 140);
        ctx.font = "bold 26px Arial";
        ctx.fillText(printDate, valueX, by + 140);

        doc.addImage(
          sc.toDataURL("image/png"),
          "PNG",
          pageWidth - 70,
          2,
          64,
          30,
        );
      })();

      height += 15;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      height += 8;
      doc.setFontSize(18);
      doc.text("E-Document", pageWidth / 2, height, { align: "center" });

      height += 12;
      doc.setFontSize(11);
      doc.setFont("helvetica", "normal");

      const row = (label1, value1, label2, value2) => {
        doc.text(String(label1 ?? "-"), padding, height);
        doc.text(String(value1 ?? "-"), padding + leftMargin, height);
        doc.text(String(label2 ?? "-"), padding + leftMargin * 2, height);
        doc.text(String(value2 ?? "-"), padding + leftMargin * 3, height);
        height += 9;
      };

      row(
        "Applicant Name:",
        application.consumerName,
        "Applicant CNIC:",
        application.consumerCNIC,
      );
      row(
        "Father's Name:",
        application.consumerFatherName || "-",
        "Sanct. Load(kW):",
        application.sanctionedLoad != null
          ? String(application.sanctionedLoad)
          : "-",
      );
      row(
        "Connection Type:",
        application.connectionCategory,
        "Meter Type:",
        application.meterType === 0
          ? "Normal"
          : application.meterType === 1
            ? "Smart"
            : "-",
      );
      row(
        "Tariff:",
        application.tariffDesc,
        "Subdivision:",
        subdivisionName(application.subDivisionCode, subDivisions),
      );
      row(
        "Consumer ID:",
        application.customerId,
        "Ref. No.:",
        application.referenceNo,
      );

      const cp138FeederCode =
        resolvedScoDetails?.installedMeterProfile?.[0]?.installMeterFeederCode ??
        resolvedScoDetails?.I_FEEDER_CODE;

      row(
        "Transformer Ref. No.:",
        resolvedScoDetails?.transformerRefNo,
        "Feeder Code:",
        cp138FeederCode,
      );

      if (application.meterType === 1) {
        row(
          "SIM ID:",
          resolvedScoDetails?.simId,
          "SIM No:",
          resolvedScoDetails?.simNo,
        );
      }
      {
        const addressValue = String(application.consumerAddress ?? "-");
        const addressMaxWidth = leftMargin - 6;
        const addressLines = doc.splitTextToSize(addressValue, addressMaxWidth);
        const rowStartHeight = height;

        doc.text("Address:", padding, rowStartHeight);
        addressLines.forEach((line, index) => {
          doc.text(line, padding + leftMargin, rowStartHeight + index * 9);
        });
        doc.text("Phone No.:", padding + leftMargin * 2, rowStartHeight);
        doc.text(
          String(application.applicantMobileNo ?? "-"),
          padding + leftMargin * 3,
          rowStartHeight,
        );

        height = rowStartHeight + Math.max(addressLines.length, 1) * 9;
      }
      // doc.text(
      //   application.consumerAddress ?? "-",
      //   padding + leftMargin,
      //   height,
      // );

      height += 8;

      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);
      doc.line(10, height, pageWidth - 10, height);

      height += 10;

      // ── Meter Removed Table ───────────────────────────────────────────
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text("Meter Removed", pageWidth / 2, height, { align: "center" });
      height += 6;

      const removedTableColumns = [
        "Set No",
        "Meter Type",
        "Serial No",
        "Multiply Factor",
        "Master Reading",
        "Meter Reading",
        "Advance Units",
        "Rounding Comp Code",
      ];

      const removedRows = getRemovedMeterTableRows(resolvedScoDetails).map((row) => [
        (getMeterRemovedSetNoLabel(row)),
        getRemovedMeterTypeDisplayLabel(row),
        row.serialNo,
        row.multiplyFactor,
        row.masterReading,
        row.meterReading,
        row.advanceUnits,
        row.roundingCompCode,
      ]);

      autoTable(doc, {
        startY: height,
        head: [removedTableColumns],
        body:
          removedRows.length > 0
            ? removedRows
            : [
                [
                  {
                    content: "No removed meter data found",
                    colSpan: removedTableColumns.length,
                    styles: {
                      halign: "center",
                      fontStyle: "bold",
                      textColor: [150, 0, 0],
                    },
                  },
                ],
              ],
        theme: "grid",
        styles: {
          fontSize: 7.5,
          halign: "center",
          valign: "middle",
          cellPadding: 1.5,
          overflow: "linebreak",
        },
        headStyles: {
          fillColor: [0, 106, 209],
          textColor: 255,
          fontStyle: "bold",
        },
        margin: { left: 8, right: 8 },
      });

      // ── Meter Installed Table ─────────────────────────────────────────
      height = doc.lastAutoTable.finalY + 10;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.text("Meter Installed", pageWidth / 2, height, { align: "center" });
      height += 6;

      const installedTableColumns = [
        "Set No",
        "Meter Type",
        "Meter Number",
        "Meter Location",
        "Meter Mfg.",
        "Meter Code",
        "MF",
        "Range",
        "Reading",
        "Feeder Code",
        "MDI Reset",
        "MDI Cum",
      ];

      const installedRows = getInstalledMeterTableRows(resolvedScoDetails).map(
        (row) => [
           (getMeterRemovedSetNoLabel(row)),
          getInstalledMeterTypeDisplayLabel(row),
          row.meterNumber,
          row.meterLocation,
          row.meterManufacturing,
          row.meterCode,
          row.multiplyFactor,
          row.meterRange,
          row.meterReading,
          row.feederCode,
          row.mdiResetNo,
          row.mdiCumRead,
        ],
      );

      autoTable(doc, {
        startY: height,
        head: [installedTableColumns],
        body:
          installedRows.length > 0
            ? installedRows
            : [
                [
                  {
                    content: "No installed meter data found",
                    colSpan: installedTableColumns.length,
                    styles: {
                      halign: "center",
                      fontStyle: "bold",
                      textColor: [150, 0, 0],
                    },
                  },
                ],
              ],
        theme: "grid",
        styles: {
          fontSize: 7.5,
          halign: "center",
          valign: "middle",
          cellPadding: 1.5,
          overflow: "linebreak",
        },
        headStyles: {
          fillColor: [0, 106, 209],
          textColor: 255,
          fontStyle: "bold",
        },
        margin: { left: 8, right: 8 },
      });

      if (includeFooter) {
        addCP138WatermarkAndPageNumbers(doc, DiscoCode);
      }

      return doc;
  };

  const downloadCP138PDF = async (application, scoDetails) => {
    setViewBackdrop(true);

    try {
      const applicationId = application.applicationId;
      const doc = await buildCP138PDFDoc(application, scoDetails, {
        includeFooter: true,
      });
      const pdfBlob = doc.output("blob");
      const fileName = `${applicationId}-CP138.pdf`;
      const pdfURL = URL.createObjectURL(pdfBlob);

      window.open(pdfURL + "#" + fileName, fileName);
    } catch (err) { /* ignored */ } finally {
      setViewBackdrop(false);
    }
  };

  const ArearPaidBillDocument = (event) => {
    arearBillDocumentFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name;
      let fileNameArray = fileName.split(".");
      let extension = fileNameArray[fileNameArray.length - 1];
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize);
      if (documentValidate === 1) {
        const newFileName = "paidBillArear." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const image = new Image();
        image.src = URL.createObjectURL(renamedFile);

        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0);
          const waterMarkText = getDiscoUseOnlyWatermarkText(
            getDocumentDiscoCode(
              dialogRowData?.applicationId,
              dialogRowData?.companyCode,
            ),
          );
          ctx.font = "24px Arial";
          ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
          ctx.fillText(waterMarkText, 10, canvas.height - 10);
          const watermarkedBase64 = canvas.toDataURL();
          setArearPaidBillDocument(renamedFile);
          setArearPaidBillDocumentThumbnail(watermarkedBase64);
        };
      } else if (documentValidate === 2) {
      } else {
      }
    }
  };

  const InstalledMeterImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "installedMeterImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        rcoPart2Formik.handleChange,
        setInstalledMeterImage,
        setInstalledMeterImageError,
        setInstalledMeterImageThumbnail,
        newFileName,
      );
    }
  };

  const handleInputChange = async (e, index) => {
    const { name, value } = e.target;

    const updatedDataArray = [...alreadyInstalledRefNos];

    let itemToUpdate = updatedDataArray[index];

    if (!itemToUpdate) {
      itemToUpdate = {
        refNo: "",
        actualFlag: null,
      };
    }

    if (value.length === 14) {
      if (value == dialogRowData.referenceNo) {
        let updatedErrorsArray = alreadyInstalledRefNosErrors;
        updatedErrorsArray[index] =
          `Reference no should be different than the one in RCO application.`;
        setAlreadyInstalledRefNosErrors(alreadyInstalledRefNosErrors);
        itemToUpdate.actualFlag = false;
        itemToUpdate.arrearsAmount = "";
        itemToUpdate.netBillAmount = "";
        itemToUpdate.billingMonth = "";
      } else {
        let apiResponse = await dBillAPI(token, value);
        if (apiResponse.status) {
          if (parseInt(apiResponse.basicInfo.arrear) > 0) {
            itemToUpdate.actualFlag = true;
            itemToUpdate.arrearsAmount = apiResponse.basicInfo.arrear;
            itemToUpdate.netBillAmount = apiResponse.basicInfo.netBill;
            itemToUpdate.billingMonth =
              apiResponse.basicInfo.billMonth.split("T")[0];
            let updatedErrorsArray = alreadyInstalledRefNosErrors;
            updatedErrorsArray[index] = ``;
            setAlreadyInstalledRefNosErrors(alreadyInstalledRefNosErrors);
          } else {
            let updatedErrorsArray = alreadyInstalledRefNosErrors;
            updatedErrorsArray[index] =
              `No arrears exist against entered reference no.`;
            setAlreadyInstalledRefNosErrors(alreadyInstalledRefNosErrors);
            itemToUpdate.actualFlag = false;
            itemToUpdate.arrearsAmount = "";
            itemToUpdate.netBillAmount = "";
            itemToUpdate.billingMonth = "";
          }
        } else {
          let updatedErrorsArray = alreadyInstalledRefNosErrors;
          updatedErrorsArray[index] = `RefNo. doesn't exists!`;
          setAlreadyInstalledRefNosErrors(alreadyInstalledRefNosErrors);
          itemToUpdate.actualFlag = false;
          itemToUpdate.arrearsAmount = "";
          itemToUpdate.netBillAmount = "";
          itemToUpdate.billingMonth = "";
        }
      }
    } else {
      let updatedErrorsArray = alreadyInstalledRefNosErrors;
      updatedErrorsArray[index] = ``;
      setAlreadyInstalledRefNosErrors(alreadyInstalledRefNosErrors);
      itemToUpdate.actualFlag = false;
      itemToUpdate.arrearsAmount = "";
      itemToUpdate.netBillAmount = "";
      itemToUpdate.billingMonth = "";
    }

    const updatedItem = {
      ...updatedDataArray[index],
      refNo: value,
      actualFlag: itemToUpdate.actualFlag,
    };
    updatedDataArray[index] = updatedItem;
    fieldFormik.values.iv_default_meters_ref_no_array = updatedDataArray;
    setAlreadyInstalledRefNos(updatedDataArray);
  };

  const openDetailsPopUp = async (stepName) => {
    setViewBackdrop(true);

    if (stepName.applicationProgressId != undefined) {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        historyId: stepName.historyId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "meterChangeOrder/getDetailByHistoryId",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            setViewBackdrop(false);
            setHistoryData(result.data[0]);
            let histDet = result.data[0];
            if (
              histDet.applicationProgressId == 1 &&
              histDet.objectionStatus == 1
            ) {
              setDocumentsVerifiedSubPopUp(true);
            }
            if (
              histDet.historyProgressId == 0 &&
              histDet.objectionStatus == 0
            ) {
              setDocumentsVerifiedSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 2 &&
              histDet.objectionStatus == 0
            ) {
              setDocumentsVerifiedSubPopUp(true);
            }
             if (
              histDet.applicationProgressId == 3 &&
              (histDet.objectionStatus == 0 )
            ) {
              setApprovalRejectionSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 2 &&
              (histDet.objectionStatus == 1 )
            ) {
              setApprovalRejectionSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 4 &&
              histDet.objectionStatus == 0
            ) {
              setArrearVerifiedSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 4 &&
              histDet.objectionStatus == 1
            ) {
              setRcoFeeVoucherSubmissionSubPopUp(true);
            }
            if (
              histDet.applicationProgressId == 3 &&
              histDet.objectionStatus == 1
            ) {
              setArrearVerifiedSubPopUp(true);
            }
            if (
              (histDet.applicationProgressId == 5 &&
                histDet.objectionStatus == 0 &&
                histDet.historyProgressId == 4) ||
              (histDet.applicationProgressId == 6 &&
                histDet.objectionStatus == 0 &&
                histDet.historyProgressId == 4) ||
              (histDet.applicationProgressId == 9 &&
                histDet.historyProgressId == 4)
            ) {
              setRcoFeeVoucherSubmissionSubPopUp(true);
            }

            // if (
            //   histDet.applicationProgressId == 5 &&
            //   histDet.objectionStatus == 0
            // ) {
            //   setFieldSurveySubPopUp(true);
            // }

            // if (
            //   histDet.applicationProgressId == 5 &&
            //   histDet.objectionStatus == 1
            // ) {
            //   setFieldSurveySubPopUp(true);
            // }

            // if (
            //   histDet.applicationProgressId == 6 &&
            //   histDet.objectionStatus == 0
            // ) {
            //   setFieldSurveySubPopUp(true);
            // }
            // if (
            //   histDet.applicationProgressId == 7 &&
            //   histDet.objectionStatus == 0
            // ) {
            //   setDnApprovalSubPopUp(true);
            // }

            // if (
            //   histDet.applicationProgressId == 7 &&
            //   histDet.objectionStatus == 1
            // ) {
            //   setDnSubmissionSubPopUp(true);
            // }

            if (
              (histDet.applicationProgressId == 9 ||
                histDet.applicationProgressId == 6) &&
              histDet.historyProgressId == 5 &&
              histDet["isReferToMT"] === true &&
              histDet.objectionStatus == 0
            ) {
              setMtSubmissionSubPopUp(true);
              setRcoFeeVoucherSubmissionSubPopUp(false);
            }
            if (
              histDet.historyProgressId == 6 &&
              histDet.objectionStatus == 0
            ) {
              setDnApprovalSubPopUp(true);
              setArrearVerifiedSubPopUp(false);
            }
            if (
              histDet.historyProgressId == 6 &&
              histDet.objectionStatus == 1
            ) {
              setDnSubmissionSubPopUp(true);
            }
            if (
              histDet.historyProgressId == 7 &&
              histDet.objectionStatus == 0
            ) {
              setDnSubmissionSubPopUp(true);
            }
            if (
              (histDet.historyProgressId == 8 &&
              histDet.objectionStatus == 0) || (histDet.historyProgressId == 8 &&
              histDet.objectionStatus == 1)
            ) {
              setDnVerificationSubPopUp(true);
            }
            if (
              histDet.historyProgressId == 9 &&
              histDet.objectionStatus == 0
            ) {
              setMeterInstalationSubPopUp(true);
            }

            if (
              histDet.historyProgressId == 10 &&
              histDet.objectionStatus == 0
            ) {
              setForwardToROSubPopUp(true);
            }
            if (
              histDet.historyProgressId == 11 &&
              histDet.objectionStatus == 0
            ) {
              setreadyForBillingSubPopUp(true);
            }

            // if (
            //   histDet.applicationProgressId == 9 &&
            //   histDet.objectionStatus == 0
            // ) {
            //   setRcoFeeVoucherVerificationSubPopUp(true);
            // }

            // if (
            //   histDet.applicationProgressId == 10 &&
            //   histDet.objectionStatus == 0
            // ) {
            //   setMeterInstalationSubPopUp(true);
            // }
            // if (
            //   histDet.applicationProgressId == 11 &&
            //   histDet.objectionStatus == 0
            // ) {
            //   setForwardToROSubPopUp(true);
            // }
            // if (
            //   histDet.applicationProgressId == 12 &&
            //   histDet.objectionStatus == 0
            // ) {
            //   setreadyForBillingSubPopUp(true);
            // }
          }
        })
        .catch(() => {});
    }
  };

  const getTariff = (tariffCode, tariffs) => {
    if (tariffs) {
      let tariff = tariffs.find((item) => item.tariffCode == tariffCode);
      return tariff.tariffName;
    } else {
      return "Tariff Name";
    }
  };

  const handleCloses = () => {
    setNewConnectionPopup(false);
  };

  const rcoHandleClose = () => {
    setRcoPopUp(false);
  };

  const cpHandleClose = () => {
    setCpPopUp(false);
  };

  const errorCloses = () => {
    setError("");
    setFieldSurveyError("");
  };

  const filterOptions = (options, { inputValue }, fields = []) => {
    const trimmedInputValue = inputValue.trim().toLowerCase();
    const inputLength = trimmedInputValue.length;
    let count = 0;

    return inputLength === 0
      ? options
      : options.filter((option) => {
          // Dynamically concatenate the specified fields
          const optionLabel = fields
            .map((field) => option[field])
            .join("")
            .toLowerCase();

          const containsInput = optionLabel.includes(trimmedInputValue);
          const match = containsInput && count < 5; // Limit the number of options shown
          if (match) {
            count += 1;
          }
          return match;
        });
  };

  const normalizeItemRate = (rate) => Math.round(Number(rate) || 0);

  const getBoqItemRate = (rate) => Number(rate) || 0;

  const calculateItemAmount = (qty, rate) =>
    Math.round(Number(qty) * getBoqItemRate(rate));

  const calculateCharges = (arrayOfItems, applicationId = "") => {
    const isMC13 = String(applicationId).startsWith("MC-13");
    return calculateBoqCharges(arrayOfItems, isMC13);
  };

  const normalizeDnAmounts = (dnDets = {}) => {
    const roundOff = (value) => Math.round(parseFloat(value) || 0);

    return {
      ...dnDets,
      capitalCostAmount: roundOff(dnDets.capitalCostAmount),
      securityDepositeAmount: roundOff(dnDets.securityDepositeAmount),
      estimatedSecurityAmount: roundOff(dnDets.estimatedSecurityAmount),
      amountOfGridSharing: roundOff(dnDets.amountOfGridSharing),
      amountOfFeederRehab: roundOff(dnDets.amountOfFeederRehab),
      previousSecurity: roundOff(dnDets.previousSecurity),
      civilWorkCharges: roundOff(dnDets.civilWorkCharges),
      fixedChargesOfMetering: roundOff(dnDets.fixedChargesOfMetering),
      miscellaneousCharges: roundOff(dnDets.miscellaneousCharges),
      lessTheCost: roundOff(dnDets.lessTheCost),
    };
  };

  const handleFieldSurveySubmit = () => {
    fieldFormik.handleSubmit();
  };

  //#endregion

  //#region printing functions

  const downloadDNPDF = async (application) => {
    setViewBackdrop(true);
    const applicationId = application.applicationId;
    // Capture before SearchIndividualApplication may replace `application`.
    const mcoDialogReferenceNo = String(
      application?.referenceNo || dialogRowData?.referenceNo || "",
    ).trim();
    let DiscoCode = getDocumentDiscoCode(
      application.applicationId,
      application.companyCode,
    );
    if (!application.subDivisionCode) {
      try {
        application = await SearchIndividualApplication(
          token,
          application.applicationId,
          "2",
        );
      } catch (e) { /* ignored */ }
    }
    try {
      let dnDets;
      let boqItems;
      let dnExpiryFlag;
      await callAsyncDnDetailsAPI(applicationId).then((response) => {
        dnDets = normalizeDnAmounts(response.dnDets);
        boqItems = response.boqItems;
        dnExpiryFlag = response.dnExpiryFlag;
      });
      if (dnExpiryFlag === "1") {
        setDialogRowData(application);
        setShowDnExpiryPopup(true);
      } else {
        //#region text
        // let application = reconnectionApplications.find(item => item.applicationId === applicationId)
        let officeCode = application.subDivisionCode.toString();
        let officeName = subdivisionName(parseInt(officeCode), subDivisions);
        let authorizedByName = dnDets.approvedBy ? dnDets.approvedBy : "---";
        let authorizedByDesignation = dnDets.approvedByDesignation
          ? dnDets.approvedByDesignation
          : "Role";
        let dateToPrint = dnDets.approvedDate
          ? numberFormatting(new Date(dnDets.approvedDate))
          : "---";
        let stampData = printStamp(
          officeCode,
          officeName,
          authorizedByName,
          authorizedByDesignation,
          dateToPrint,
        );

        const fontSize = 8;
        const doc = new jsPDF({ compressPdf: true });
        if (dnDets.approvedBy) {
          doc.addImage(stampData, "PNG", 20, 200, 55, 40); // Add image to PDF (x, y, width, height)
          doc.addImage(stampData, "PNG", 140, 265, 55, 40); // Add image to PDF (x, y, width, height)
        }

        //#region Line 1
        var padding = 10;
        var line2Height = 10;
        var lineHeightIncreament = 5;
        doc.setFontSize(fontSize);
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          companyName(applicationId.slice(3, 5)).concat(
            application.sanctionedLoad < 15
              ? "(" +
                  applicationId.slice(3, 8) +
                  "-" +
                  subdivisionName(
                    parseInt(application.subDivisionCode),
                    subDivisions,
                  ) +
                  ")"
              : "(" +
                  applicationId.slice(3, 7) +
                  "-" +
                  divisionName(
                    parseInt(application.divisionCode),
                    subDivisions,
                  ) +
                  ")",
          ),
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 2
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(Department of Electricity)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 3
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 12;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo;
        var text3 = "Application Id: ";
        var text4 = applicationId;
        var text5 = "Apply Date: ";
        var text6 = convertDate(application.creationDate);

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 4
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 3.35;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Application Type: ";
        var text4 = "Meter Change Order (MCO)";
        var text5 = "Required Tariff: ";
        var text6 = dnDets.tariff ? dnDets.tariff : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );

        //#endregion

        //#region Line 5
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "New Alloated Reference No.: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = "Consumer Mobile No.: ";
        var text4 = application.applicantMobileNo
          ? application.applicantMobileNo
          : "-";
        var text5 = "Connection type: ";
        var text6 = application.connectionCategory
          ? application.connectionCategory
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

       //#region Line 6
var line2Height = line2Height + lineHeightIncreament;
var text1 =
  "(under which the funds are to be deposited in the bank with the concerned officer of the department)";

doc.setFontSize(6);

// Center text1 on the page
var pageWidth = doc.internal.pageSize.getWidth();
var text1Width = doc.getTextWidth(text1);
var centeredX = (pageWidth - text1Width) / 2;

doc.text(text1, centeredX, line2Height);

//#endregion

        //#region Line 7
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22.25;
        var text1 = `Department's approved Bank name: `;
        var text2 = dnDets.bankName ? dnDets.bankName : "-";
        var text3 = "Required Load (kW): ";
        var text4 = application.sanctionedLoad
          ? application.sanctionedLoad.toString()
          : "|";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 8
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22;
        var text1 = `Department's Revenue Officer: `;
        var text2 = divisionName(
          parseInt(application.divisionCode),
          subDivisions,
        );
        var text3 = "";
        var text4 = "";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 10
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "DEMAND NOTICE",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 11
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "(Notification of Approval Application and Demand Under Guarantee)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 12
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          `Applicant's part`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 13
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var text1 = `Mr. / Mrs.`;
        var relationType = application.applicantRelationType;
        var relationTypeText =
          relationType == 1 || relationType == "S/O"
            ? "S/O"
            : relationType == 2 || relationType == "D/O"
              ? "D/O"
              : relationType == 3 || relationType == "W/O"
                ? "W/O"
                : relationType == 4 || relationType == "C/O"
                  ? "C/O"
                  : "";
        var relativePart = application.applicantRelativeName
          ? ` ${relationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.consumerName
          ? application.consumerName
              .concat(relativePart)
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        //#endregion

        //#region Line 14
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `You are hereby informed by demand notice that your application for obtaining electricity connection whose particulars are mentioned above has been approved by the authorized officer on the following conditions apart from the prevailing general conditions of electricity of the department.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 15
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `1. You should deposit the following amounts in the approved bank of the department or with the concerned officer of the department itself within [word1] days from the date of issue of this notice and inform my office with the receipt number and date of your payment.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[word1]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 16
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `A. Expenditure service connection as per approved estimate ______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`;
        var text2 = dnDets.serviceConnectionAmount
          ? numberFormatting(dnDets.serviceConnectionAmount)
          : "";
        var lines = doc.splitTextToSize(text1, maxWidth);
        doc.setFont("helvetica", "bold");
        doc.text(text2, 90, line2Height);
        doc.setFont("helvetica", "normal");
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[serviceConnectionAmount]",
            dnDets.serviceConnectionAmount
              ? numberFormatting(dnDets.serviceConnectionAmount)
              : "",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }

        //#endregion

        //#region Line 17
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `B. Arrears due to non-payment of previous electricity bills etc. _____ PKR. (this amount is to be deposited in the bank after receiving the final bill from the revenue officer).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 18
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 19
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. You shall, within [noOfDays] days from the date of issue of this notice, obtain a test report from a Government approved wiring contractor in proof of the soundness and quality of the internal wiring of your building and the completion of the installation of your electrical appliances and send send to my office for further departmental inspection and testing and get receipt (Blank Test Report is on Form CP-7).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfDays]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 20
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `3. Since you have not provided your purchased meter to the department for measuring the supply of electricity, you will be charged a monthly meter rental fee of [amount] PKR.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 21
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `4. Demand notices for release of security deposit sent separately Process of connection will start after deposit of both demand notice amounts separate.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 22
        doc.text(
          `(Irrelevant should be cut down)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 23
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfMonth = "1";
        var text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for obtaining electricity will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        // //#region Line 24
        // doc.setFontSize(fontSize);
        // var text1 = `Regards`;
        // var spaceLeft = 100;
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        // //#region Line 25
        // doc.setFontSize(fontSize);
        // var line2Height = line2Height + lineHeightIncreament;
        // var text1 =
        //   application.sanctionedLoad < 15
        //     ? "Sub-Division Office " +
        //       applicationId.slice(3, 8) +
        //       "-" +
        //       subdivisionName(
        //         parseInt(application.subDivisionCode),
        //         subDivisions,
        //       ) +
        //       " SDO " +
        //       companyShortName(DiscoCode)
        //     : "Division Office " +
        //       applicationId.slice(3, 7) +
        //       " - " +
        //       divisionName(parseInt(application.divisionCode), subDivisions) +
        //       " XEN MEPCO";
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        //#region Line 26
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var text1 = "Signature Bank Officer: ";
        var text2 =
          application.sanctionedLoad < 15
            ? "Line Superintendent Office" +
              "(" +
              applicationId.slice(3, 8) +
              " - " +
              subdivisionName(
                parseInt(application.subDivisionCode),
                subDivisions,
              ) +
              ") SDO " +
              companyShortName(DiscoCode)
            : "Line Superintendent Office" +
              "(" +
              applicationId.slice(3, 7) +
              " - " +
              divisionName(parseInt(application.divisionCode), subDivisions) +
              ") XEN MEPCO";
        doc.text(text1, padding, line2Height);
        // doc.text(text2, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 27
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 28
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          "For Bank Use Only",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 29
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 30
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var spaceLeft = 50;

        var text1 = `1. Applicant's Name and Complete address `;
        var bankRelationType = application.applicantRelationType;
        var bankRelationTypeText =
          bankRelationType == 1 || bankRelationType == "S/O"
            ? "S/O"
            : bankRelationType == 2 || bankRelationType == "D/O"
              ? "D/O"
              : bankRelationType == 3 || bankRelationType == "W/O"
                ? "W/O"
                : bankRelationType == 4 || bankRelationType == "C/O"
                  ? "C/O"
                  : "";
        var bankRelativePart = application.applicantRelativeName
          ? ` ${bankRelationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.consumerName
          ? application.consumerName
              .concat(bankRelativePart)
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
          line2Height,
        );
        //#endregion

        //#region Line 31
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "2. Application Id: ";
        var text2 = application.applicationId ? application.applicationId : "-";
        var text3 = "Date: ";
        var text4 = application.creationDate
          ? convertDate(application.creationDate)
          : "-";
        var text5 = "Service Connection:";
        var serviceConnectionAmount = Number(
          String(
            dnDets?.serviceConnectionAmount ?? dnDets?.capitalCostAmount ?? 0,
          ).replace(/,/g, ""),
        );
        var text6 = numberFormatting(serviceConnectionAmount);
        var leftSpace = 40;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        var serviceLabelX = 130;
        var serviceValueX = serviceLabelX + doc.getTextWidth(text5) + 2;
        doc.text(text5, serviceLabelX, line2Height);
        doc.text(text6, serviceValueX, line2Height);
        doc.setFont("helvetica", "normal");
        doc.line(
          serviceValueX,
          line2Height + 1,
          serviceValueX + doc.getTextWidth(text6) + 4,
          line2Height + 1,
        );

        //#endregion

        //#region Line 32
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "3. Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Date: ";
        var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 35;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        
        //#endregion

        //#region Line 33
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "4. Account No. for acquisition connection: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 10;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        
        //#endregion

        // Meter Change DN QR (same approach as RCO — right side, no row shift)
        // QR RefNo from application/dialogRow (e.g. 09131420411212), not getMCODemandNoteData.
        {
          const capitalForQr =
            parseFloat(
              dnDets.serviceConnectionAmount ?? dnDets.capitalCostAmount,
            ) || 0;
          const mcoQrRefNo = String(
            mcoDialogReferenceNo ||
              application?.referenceNo ||
              dialogRowData?.referenceNo ||
              "",
          ).trim();
          await addDnPaymentQrCodesToPdf(doc, {
            dnDets: {
              ...dnDets,
              capitalCostAmount: capitalForQr,
              ...(mcoQrRefNo
                ? {
                    connectionAccountNo: mcoQrRefNo,
                    consumerAccountNo: mcoQrRefNo,
                    refNo: mcoQrRefNo,
                  }
                : {}),
            },
            applicationId,
            token,
            securityAmount: 0,
            capitalCost: capitalForQr,
            discoCode: DiscoCode,
            layout: {
              ...RCO_DN_QR_LAYOUT,
              skipNcDefaults: true,
              skipSecurity: true,
              imageY: line2Height + 2,
            },
          });
        }

        //#region Line 34
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "5. Approved bank name and address:";
        var text2 = dnDets.bankName ? dnDets.bankName : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 35 — Signature Bank Officer removed (Meter Change DN; QR uses space)
        var line2Height = line2Height + lineHeightIncreament;
        //#endregion

        //#region Line 36
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 10;
        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        //#endregion

        // Room under bank QR before Applicant's Response (stamps fixed)
        line2Height = line2Height + 12;

        //#region Line 37
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 38
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          `Applicant's Response`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 39
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `1. I/We have submitted the amount of service connection of [serviceConnectionAmount] only in the department's approved bank [bankName] by receipt no. _______________________________________ on date _______________________________.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[serviceConnectionAmount]",
            numberFormatting(dnDets.serviceConnectionAmount),
          );
          lineText = lineText.replace(
            "[securityCost]",
            numberFormatting(dnDets.securityDepositeAmount),
          );
          lineText = lineText.replace(
            "[bankName]",
            dnDets.bankName ? dnDets.bankName : "-",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 40
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. Since I/We did not provide funds to buy meter to the department, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 41
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 42
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          `For Computer Center Use`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 43
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          `(Demand Notice Data)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 44
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var padding = 10;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Application Id: ";
        var text4 = applicationId ? applicationId : "-";
        var text5 = "Application Form No.: ";
        var text6 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 45
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var padding = 10;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Amount to be paid: ";
        var serviceConnectionAmount = Number(
          String(
            dnDets?.serviceConnectionAmount ?? dnDets?.capitalCostAmount ?? 0,
          ).replace(/,/g, ""),
        );
        var text4 = numberFormatting(serviceConnectionAmount);
        var text5 = " ";
        var text6 = " ";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        //#endregion

        //#region Line 46
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament / 2;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = application.sanctionedLoad < 15 ? " " : " ";
        var leftSpace = 110;
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        //#endregion

        //#region Line 47
        doc.setFontSize(6);
        lineHeightIncreament = 2;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
        var text1 =
          "NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
        var lineSpace = 6.6;
        var lines = doc.splitTextToSize(text1, maxWidth);
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        const totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          doc.addImage(
            getWaterMarkLogo(DiscoCode),
            "PNG",
            0,
            0,
            doc.internal.pageSize.getWidth(),
            doc.internal.pageSize.getHeight(),
          );
        }

        const pdfBlob = doc.output("blob");
        const pdfDataUrl = URL.createObjectURL(pdfBlob);
        const masterDataFileName = applicationId + "- Demand Note.pdf";

        // Open the PDF in a new tab with filename
        window.open(pdfDataUrl + '#' + masterDataFileName, masterDataFileName);

        //#endregion
      }
    } catch (e) { /* ignored */ }
    setViewBackdrop(false);
  };

   const downloadNOCPDF = async (application, dnDets) => {
      setViewBackdrop(true);
      const applicationId = application.applicationId;
  
      if (!application.subDivisionCode) {
        try {
          application = await SearchIndividualApplication(
            token,
            application.applicationId,
            "2"
          );
        } catch (e) { /* ignored */ }
      }

      const DiscoCode = getDocumentDiscoCode(
        application.applicationId,
        application.companyCode,
      );
  
      try {
        let boqItems;
        let dnExpiryFlag;
  
        // Fetch demand notice details
        await callAsyncDnDetailsAPI(applicationId).then((response) => {
          dnDets = response.dnDets;
          boqItems = response.boqItems;
          dnExpiryFlag = response.dnExpiryFlag;
        });
  
        const baseFont = 9;
        const doc = new jsPDF({ compressPdf: true });
  
        // Layout variables
        let padding = 10;
        let line2Height = 10;
        let lineHeightIncreament = 5;
        let lines = [];
  
        // Header
        doc.setFontSize(baseFont + 1);
        doc.setFont(undefined, "normal");
        doc.text(
          companyName(applicationId.slice(3, 5)).concat(
            " (" +
            applicationId.slice(3, 8) +
            "-" +
            subdivisionName(parseInt(applicationId.slice(3, 8)), subDivisions) +
            ")"
          ),
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          { align: "center" }
        );
  
        // Row 1 - No, Dated
        line2Height += lineHeightIncreament + 5;
        const textPairs2 = [
          ["No.: ", applicationId],
          [
            "Dated: ",
            new Date()
              .toLocaleDateString("en-GB", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })
              .replace(/ /g, "-"),
          ],
        ];
  
        const colWidth = (doc.internal.pageSize.getWidth() - padding * 2) / 2; // equal spacing
        let xPos = padding;
        textPairs2.forEach(([label, value], index) => {
          doc.setFontSize(baseFont);
          doc.setFont(undefined, "normal");
          const labelY = line2Height;
          doc.text(label, xPos, labelY);
          const labelWidth = doc.getTextWidth(label);
          const valueX = xPos + labelWidth + 3;
          doc.text(value, valueX, labelY);
          const valueWidth = doc.getTextWidth(value);
          // underline value
          doc.line(valueX, labelY + 1.5, valueX + valueWidth, labelY + 1.5);
          // move to next column
          xPos += colWidth;
        });
  
        // Row 2 - Name & Address
        line2Height += lineHeightIncreament + 2;
        const textPairsNameAddress = [
          ["Name: ", application.consumerName || "-"],
          ["Address: ", application.consumerAddress || "-"],
        ];
  
        xPos = padding;
        textPairsNameAddress.forEach(([label, value]) => {
          doc.setFontSize(baseFont);
          doc.setFont(undefined, "normal");
          const labelY = line2Height;
          doc.text(label, xPos, labelY);
          const labelWidth = doc.getTextWidth(label);
          const valueX = xPos + labelWidth + 3;
          doc.text(value, valueX, labelY);
          const valueWidth = doc.getTextWidth(value);
          doc.line(valueX, labelY + 1.5, valueX + valueWidth, labelY + 1.5);
          xPos += colWidth;
        });
  
        // Row 3 - Phone & S/O D/O
        line2Height += lineHeightIncreament + 2;
        const textPairsPhoneSO = [
          ["S/O, W/O, D/O: ", application.consumerFatherName || "-"],
          ["Phone: ", application.applicantMobileNo || "-"],
        ];
  
        xPos = padding;
        textPairsPhoneSO.forEach(([label, value]) => {
          doc.setFontSize(baseFont);
          doc.setFont(undefined, "normal");
          const labelY = line2Height;
          doc.text(label, xPos, labelY);
          const labelWidth = doc.getTextWidth(label);
          const valueX = xPos + labelWidth + 3;
          doc.text(value, valueX, labelY);
          const valueWidth = doc.getTextWidth(value);
          doc.line(valueX, labelY + 1.5, valueX + valueWidth, labelY + 1.5);
          xPos += colWidth;
        });
  
        // Add Top Margin Before Title
        line2Height += lineHeightIncreament + 10;
  
        // Title
        doc.setFontSize(12);
        doc.setFont(undefined, "normal");
        const titleText =
          "NOC FOR PURCHASE OF 01 NO. SINGLE PHASE AMI SMART ENERGY METER PRIVATELY TO THE CONSUMER FROM THE APPROVED MANUFACTURERS";
        const splitTitle = doc.splitTextToSize(titleText, 180);
        const pageWidth = doc.internal.pageSize.getWidth();
        splitTitle.forEach((line, i) => {
          doc.text(line, pageWidth / 2, line2Height + i * 6, { align: "center" });
        });
        line2Height += splitTitle.length * 6;
  
        // Paragraph
        line2Height += lineHeightIncreament + 2;
        doc.setFontSize(baseFont);
        doc.setFont(undefined, "normal");
        const maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        const newParagraph =
          "MEPCO BOD in its 237th meeting held on 06.10.2025, circulated vide Company Secretary MEPCO Memo No.14212 dated 06.10.2025 has allowed the consumers for private purchase of Single Phase AMI Smart Energy Meters from the approved meter manufacturers having valid prototype approval of Chief Engineer (S&S) NTDC, as time gap arrangement and till further order.";
        lines = doc.splitTextToSize(newParagraph, maxWidth);
        for (let i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height += lineHeightIncreament;
        }
  
        // Meter Manufacturers List
        line2Height += lineHeightIncreament;
  
        // First 9 static manufacturers
        const meterManufacturers = [
          "1. M/s PEL 14-KM Ferozepur Road, Lahore.",
          "2. M/s Microtech Industries (Pvt.) Ltd., Plot # 2, St # 2, Attari Industrial Estate 18-Km Ferozepur Road, Lahore.",
          "3. M/s Creative Electronics (Pvt.) Ltd., 160-151/S, QIE Kot Lakhpat, Lahore.",
          "4. M/s Accurate (Pvt.) Ltd., 104-J, M.A Johar Town Lahore.",
          "5. M/s KBK Electronics Engg & Control (Pvt.) Ltd., 1st Floor Sanam Building 37-Ferozpur Road, Lahore.",
          "6. M/s Transfopower Industries Pvt. Ltd., 2-Km Katar Bund Road, Off. Multan Road, Thokar Niaz Baig, Lahore.",
          "7. M/s Intelligent Metering System (Pvt.) Ltd., 62, Block-C Model Town, Lahore.",
          "8. M/s Vertex Electronics (Pvt.) Ltd., 506-Sundar Industrial Estate, Lahore.",
          "9. M/s AM Associates Pvt. Ltd., 69/3 FCC Gulberg IV Canal Bank Road, Lahore.",
        ];
  
        // Print static manufacturers
              doc.setFont(undefined, "normal");
              meterManufacturers.forEach((item) => {
                lines = doc.splitTextToSize(item, maxWidth);
                lines.forEach((l) => {
                  doc.text(l, padding, line2Height);
                  line2Height += lineHeightIncreament;
                });
              });
        
              line2Height += lineHeightIncreament;
        
              // Line 2: Objection statement
              doc.setFont(undefined, "normal");
              const objectionLine =
                "This office has no objection for purchase of 01 No. Single Phase AMI Smart Energy Meter from above approved meter manufacturers at your own level.";
              lines = doc.splitTextToSize(objectionLine, maxWidth);
              lines.forEach((l) => {
                doc.text(l, padding, line2Height);
                line2Height += lineHeightIncreament;
              });
        
              // Line 3: Handover statement
              doc.setFont(undefined, "normal");
              const handoverLine =
                "After purchasing of said meter, it will be handed over to Divisional AMI Cell for further process.";
              lines = doc.splitTextToSize(handoverLine, maxWidth);
              lines.forEach((l) => {
                doc.text(l, padding, line2Height);
                line2Height += lineHeightIncreament;
              });
        
              // Sub Divisional Officer Section
              line2Height += lineHeightIncreament;
              const xPosition = padding + 110;
              doc.setFontSize(10);
              doc.setFont(undefined, "normal");
              doc.text("Sub Divisional Officer", xPosition, line2Height);
        
              line2Height += lineHeightIncreament;
              doc.setFontSize(9.5);
              doc.setFont(undefined, "normal");
              doc.text(
                `MEPCO Sub Division ${subdivisionName(
                  parseInt(applicationId.slice(3, 8)),
                  subDivisions
                )}`,
                xPosition,
                line2Height
              );
        
              // C.C. Section
              line2Height += lineHeightIncreament * 2;
              doc.setFontSize(baseFont);
              doc.setFont(undefined, "normal");
              doc.text("C.C.", padding, line2Height);
        
              line2Height += lineHeightIncreament;
              doc.setFontSize(baseFont - 0.5);
              doc.setFont(undefined, "normal");
              doc.text(
                `1. XEN (OP) MEPCO Division ${subdivisionName(
                  parseInt(applicationId.slice(3, 8)),
                  subDivisions
                )} (Attention: Divisional AMI Cell).`,
                padding,
                line2Height
              );
              line2Height += lineHeightIncreament;
              doc.text("2. Master File.", padding, line2Height);
        
              // Note at Bottom
              // doc.setFontSize(8);
              // doc.setFont(undefined, 'normal');
              // lineHeightIncreament = 2;
              // const text1 =
              //   'NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/applicant. In case any document is found false at later stages, the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and company reserved its rights to take legal action against owner/applicant.';
              // lines = doc.splitTextToSize(text1, maxWidth);
              // const pageHeight = doc.internal.pageSize.getHeight();
              // const bottomMargin = 10;
              // const noteHeight = lines.length * lineHeightIncreament;
              // line2Height = pageHeight - bottomMargin - noteHeight;
              // for (let i = 0; i < lines.length; i++) {
              //   doc.text(lines[i], padding, line2Height);
              //   line2Height += lineHeightIncreament;
              // }
        
              // Watermark
              const totalPages = doc.internal.getNumberOfPages();
              for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
                doc.addImage(
                  getWaterMarkLogo(DiscoCode),
                  "PNG",
                  0,
                  0,
                  doc.internal.pageSize.getWidth(),
                  doc.internal.pageSize.getHeight()
                );
              }
        
              // Open PDF in new tab
              const nocPdfBlob = doc.output("blob");
              const nocFileName = application.applicationId + "- NOC.pdf";
              const nocPdfURL = URL.createObjectURL(nocPdfBlob);
              window.open(nocPdfURL + '#' + nocFileName, nocFileName);
            } catch (e) { /* ignored */ }
        
            setViewBackdrop(false);
          };

     const downloadMasterData = async (application) => {
        setViewBackdrop(true);
        const applicationId = application.applicationId;
        let DiscoCode = getDocumentDiscoCode(
      application.applicationId,
      application.companyCode,
    );
        if (!application.subDivisionCode) {
          try {
            application = await SearchIndividualApplication(
              token,
              application.applicationId,
              "1",
            );
          } catch (e) { /* ignored */ }
        }
    
        try {
          let dnDets, boqItems, rcoDets, masterDataFormDets;
    
          await callAsyncDnDetailsAPI(applicationId).then((response) => {
            dnDets = response.dnDets;
            boqItems = response.boqItems;
          });
    
          await callAsyncGetRCOAPI(applicationId).then((response) => {
            rcoDets = response;
          });
    
          await callAsyncGetCP136API(applicationId).then((response) => {
            masterDataFormDets = response;
          });
    
          //#region text
          const doc = new jsPDF({ compressPdf: true });
          doc.setFontSize(10);
          doc.text(
            "MASTER DATA ADDITION / CHANGE FORM",
            doc.internal.pageSize.getWidth() / 2,
            10,
            {
              align: "center",
            },
          );
          doc.text(
            application.connectionType != "Domestic" &&
              application.connectionType != "Commercial"
              ? "(For MDI Consumer Only)"
              : "(For General Consumer Only)",
            doc.internal.pageSize.getWidth() / 2,
            15,
            {
              align: "center",
            },
          );
          doc.setFontSize(8);
          doc.text(
            "Name & Address of Consumer",
            doc.internal.pageSize.getWidth() / 2,
            100,
            {
              align: "center",
            },
          );
          doc.setFontSize(8);
          doc.text("Meter Information", doc.internal.pageSize.getWidth() / 2, 140, {
            align: "center",
          });
          if (phase != "Single Phase" && phase != "3 Phase") {
            doc.text(
              "Reading Information",
              doc.internal.pageSize.getWidth() / 2,
              180,
              {
                align: "center",
              },
            );
          }
          doc.setFontSize(8);
          doc.text("Reason: Reconnection", 20, 240, {});
          //#endregion
    
          // Set default properties for the table
          const tableProps1 = {
            margin: { top: 20, right: 20, bottom: 20, left: 20 },
            cellHeight: 10,
            headerColor: "#000",
            rowColors: ["#EEE", "#FFF"],
            lineWidth: 0.1,
            lineColor: "#000", // Solid black border color
            headStyles: {
              fillColor: "#FFF",
              textColor: "#000",
              lineWidth: 0.1,
              halign: "center",
              valign: "middle",
              fontSize: 7,
            },
            styles: {
              fontSize: 7,
              fontStyle: "normal",
            },
          };
    
          // const header = [[{ colSpan: 3, content: 'Reference Number' }, { rowSpan: 2, content: 'Sub Batch' }, { rowSpan: 2, content: 'Tariff Code' }, { colSpan: 2, content: 'Application Registration' }, { colSpan: 2, content: 'Security Deposit' }]];
    
          const header1 = [
            [
              { colSpan: 3, content: ["Reference Number"] },
              { colSpan: 1, rowSpan: 2, content: ["Sub Batch"] },
              { rowSpan: 2, content: ["Tariff Code"] },
              { colSpan: 2, content: "Application Registration" },
              { colSpan: 2, content: "Security Deposit" },
            ],
          ];
    
          const data1 = [
            [
              "Batch #",
              "Sub Div.",
              "Account Number",
              "",
              "",
              "Number",
              "Date",
              "Amount",
              "Date",
            ],
            [
              dnDets.batchNo ? dnDets.batchNo : "-",
              application.subDivisionCode
                ? application.subDivisionCode.toString()
                : "-",
              dnDets.consumerAccountNo ? dnDets.consumerAccountNo.toString() : "-",
              rcoDets.subBatch ? rcoDets.subBatch.toString() : "-",
              dnDets.tariff ? dnDets.tariff.toString().slice(0, 7) : "-",
              dnDets.tariff
                ? dnDets.tariff
                    .toString()
                    .slice(0, 1)
                    .concat(application.applicationId.slice(4))
                : "-",
              application.creationDate
                ? convertDate(application.creationDate)
                : "-",
              dnDets.securityDepositeAmount
                ? numberFormatting(dnDets.securityDepositeAmount)
                : "-",
              dnDets.issueDate ? convertDate(dnDets.issueDate) : "-",
            ],
          ];
    
          doc.autoTable({
            startY: 20,
            head: header1,
            body: data1,
            theme: "grid",
            ...tableProps1,
          });
    
          // Set default properties for the table
          const tableProps2 = {
            margin: { top: 20, right: 20, bottom: 20, left: 20 },
            cellHeight: 10,
            headerColor: "#000",
            rowColors: ["#EEE", "#FFF"],
            lineWidth: 0.1,
            lineColor: "#000", // Solid black border color
            headStyles: {
              fillColor: "#FFF",
              textColor: "#000",
              lineWidth: 0.1,
              halign: "center",
              valign: "middle",
              fontSize: 7,
            },
            styles: {
              fontSize: 7,
              fontStyle: "normal",
            },
          };
    
          const header2 = [
            [
              { rowSpan: 2, content: ["Date of Connection"] },
              { rowSpan: 2, content: ["Sanctioned Load"] },
              { colSpan: 8, content: ["Codes"] },
            ],
          ];
    
          const data2 = [
            [
              "",
              "",
              "R/U",
              "F/P",
              "Seasonal",
              "Transformer Code",
              "Electricity Duty",
              "Government Department",
              "Standard Classification",
              "Income Tax",
            ],
            [
              rcoDets.dateOfReConnection,
              rcoDets.sanctionedLoad,
              rcoDets.urbanRural,
              rcoDets.fataPata,
              rcoDets.seasonalFlag,
              rcoDets.installedTransformerCapacity,
              masterDataFormDets.electricityDuty,
              masterDataFormDets.governmentDepartment,
              masterDataFormDets.standardClassificationCode,
              masterDataFormDets.incomeTax,
            ],
          ];
    
          doc.autoTable({
            startY: 50,
            head: header2,
            body: data2,
            theme: "grid",
            ...tableProps2,
          });
    
          // Set default properties for the tables
          const tableProps3 = {
            margin: { top: 20, right: 20, bottom: 20, left: 20 },
            cellWidth: 30,
            cellHeight: 10,
            headerColor: "#000",
            rowColors: ["#EEE", "#FFF"],
            lineWidth: 0.1,
            lineColor: "#000", // Solid black border color
            headStyles: {
              fillColor: "#FFF",
              textColor: "#000",
              lineWidth: 0.1,
              halign: "center",
              valign: "middle",
              fontSize: 7,
            },
            styles: {
              fontSize: 7,
              fontStyle: "normal",
            },
          };
    
          const header3 = [["National Identity Card No."]];
          const data3 = [[application.applicantCNIC]];
    
          doc.autoTable({
            head: header3,
            startY: 80,
            body: data3,
            theme: "grid",
            tableWidth: 80,
            ...tableProps3,
          });
    
          // Set default properties for the tables
          const tableProps4 = {
            margin: { top: 20, right: 20, bottom: 20, left: 140 },
            align: "right",
            cellWidth: 30,
            cellHeight: 10,
            headerColor: "#000",
            rowColors: ["#EEE", "#FFF"],
            lineWidth: 0.1,
            lineColor: "#000", // Solid black border color
            headStyles: {
              fillColor: "#FFF",
              textColor: "#000",
              lineWidth: 0.1,
              halign: "center",
              valign: "middle",
              fontSize: 7,
            },
            styles: {
              fontSize: 7,
              fontStyle: "normal",
            },
          };
    
          const header4 = [["Store Requisition No.", "Date"]];
          const data4 = [
            [rcoDets.storeRequisitionNo, convertDate(rcoDets.rcoCreationDate)],
          ];
    
          doc.autoTable({
            head: header4,
            startY: 80,
            body: data4,
            theme: "grid",
            tableWidth: 50,
            ...tableProps4,
          });
    
          // Set default properties for the table
          const tableProps5 = {
            margin: { top: 20, right: 20, bottom: 20, left: 20 },
            cellHeight: 10,
            cellWidth: 5,
            headerColor: "#000",
            rowColors: ["#EEE", "#FFF"],
            lineWidth: 0.1,
            lineColor: "#000", // Solid black border color
            headStyles: {
              fillColor: "#FFF",
              textColor: "#000",
              lineWidth: 0.1,
              halign: "center",
              valign: "middle",
              fontSize: 7,
            },
            styles: {
              fontSize: 7,
              fontStyle: "normal",
            },
          };
    
          const header5 = [
            ["Name", { colSpan: 3, content: [application.applicantName] }],
          ];
    
          const data5 = [
            ["Address", { colSpan: 3, content: [application.premisesAddress] }],
            [
              "Cell No.",
              application.applicantMobile,
              "Email Address",
              application.applicantEmail,
            ],
            [
              sodowo(application.applicantRelationType),
              application.applicantRelativeName
                ? application.applicantRelativeName
                : "-",
              "NTN",
              application.NTN ? application.NTN : "-",
            ],
          ];
    
          doc.autoTable({
            startY: 105,
            head: header5,
            body: data5,
            theme: "grid",
            ...tableProps5,
          });
    
          if (phase === "Single Phase") {
            // Set default properties for the table
            const tableProps6 = {
              margin: { top: 20, right: 20, bottom: 20, left: 20 },
              cellHeight: 10,
              cellWidth: [5, 10, 10, 10, 10, 10, 10],
              headerColor: "#000",
              rowColors: ["#EEE", "#FFF"],
              lineWidth: 0.1,
              lineColor: "#000", // Solid black border color
              headStyles: {
                fillColor: "#FFF",
                textColor: "#000",
                lineWidth: 0.1,
                halign: "center",
                valign: "middle",
                fontSize: 7,
              },
              styles: {
                fontSize: 7,
                fontStyle: "normal",
              },
            };
            const header6 = [
              [
                "Feeder Code",
                "Meter Number",
                "Location Code",
                "Manufacturer Code",
                "Meter Code",
                "Meter Range",
                "Initial Meter Reading",
              ],
            ];
    
            const data6 = [
              [
                rcoDets.feederNo,
                rcoDets.meterNo,
                rcoDets.locationCode ? rcoDets.locationCode : "-",
                rcoDets.meterNo.slice(0, 2),
                rcoDets.meterCode1 ? rcoDets.meterCode1 : "-",
                rcoDets.meterRange ? rcoDets.meterRange : "-",
                rcoDets.meterReading,
              ],
            ];
    
            doc.autoTable({
              startY: 145,
              head: header6,
              body: data6,
              theme: "grid",
              ...tableProps6,
            });
          } else if (phase === "3 Phase") {
            // Set default properties for the table
            const tableProps6 = {
              margin: { top: 20, right: 20, bottom: 20, left: 20 },
              cellHeight: 10,
              cellWidth: [5, 10, 10, 10, 10, 10, 10],
              headerColor: "#000",
              rowColors: ["#EEE", "#FFF"],
              lineWidth: 0.1,
              lineColor: "#000", // Solid black border color
              headStyles: {
                fillColor: "#FFF",
                textColor: "#000",
                lineWidth: 0.1,
                halign: "center",
                valign: "middle",
                fontSize: 7,
              },
              styles: {
                fontSize: 7,
                fontStyle: "normal",
              },
            };
            const header6 = [
              [
                { rowSpan: 2, content: ["Feeder Code"] },
                { rowSpan: 2, content: ["MSN"] },
                { rowSpan: 2, content: ["Location Code"] },
                { rowSpan: 2, content: ["Manufacturer Code"] },
                { colSpan: 2, content: ["Meter Code"] },
                { rowSpan: 2, content: ["Meter Range"] },
                { colSpan: 2, content: ["Initial Meter Reading (kWh)"] },
              ],
            ];
    
            const data6 = [
              ["", "", "", "", "Peak", "Off Peak", "", "Peak", "Off Peak"],
              [
                rcoDets.feederNo,
                rcoDets.meterNo,
                rcoDets.locationCode ? rcoDets.locationCode : "-",
                rcoDets.meterNo.slice(0, 2),
                rcoDets.meterCode1 ? rcoDets.meterCode1 : "-",
                rcoDets.meterCode2 ? rcoDets.meterCode2 : "-",
                rcoDets.meterRange ? rcoDets.meterRange : "-",
                rcoDets.threePhasePeak,
                rcoDets.threePhaseOffPeak,
              ],
            ];
    
            doc.autoTable({
              startY: 145,
              head: header6,
              body: data6,
              theme: "grid",
              ...tableProps6,
            });
          } else {
            const tableProps6 = {
              margin: { top: 20, right: 20, bottom: 20, left: 20 },
              cellHeight: 10,
              cellWidth: [5, 10, 10, 10, 10, 10, 10],
              headerColor: "#000",
              rowColors: ["#EEE", "#FFF"],
              lineWidth: 0.1,
              lineColor: "#000", // Solid black border color
              headStyles: {
                fillColor: "#FFF",
                textColor: "#000",
                lineWidth: 0.1,
                halign: "center",
                valign: "middle",
                fontSize: 7,
              },
              styles: {
                fontSize: 7,
                fontStyle: "normal",
              },
            };
    
            const header6 = [
              [
                { rowSpan: 2, content: ["Feeder Code"] },
                { rowSpan: 2, content: ["MSN"] },
                { rowSpan: 2, content: ["Location Code"] },
                { rowSpan: 2, content: ["Manufacturer Code"] },
                { colSpan: 2, content: ["Meter Code"] },
                { rowSpan: 2, content: ["Meter Range"] },
              ],
            ];
    
            const data6 = [
              ["", "", "", "", "Peak", "Off Peak", ""],
              [
                rcoDets.feederNo,
                rcoDets.meterNo,
                rcoDets.locationCode ? rcoDets.locationCode : "-",
                rcoDets.meterNo.slice(0, 2),
                rcoDets.meterCode1 ? rcoDets.meterCode1 : "-",
                rcoDets.meterCode2 ? rcoDets.meterCode2 : "-",
                rcoDets.meterRange ? rcoDets.meterRange : "-",
              ],
            ];
    
            doc.autoTable({
              startY: 145,
              head: header6,
              body: data6,
              theme: "grid",
              ...tableProps6,
            });
    
            const tableProps7 = {
              margin: { top: 20, right: 20, bottom: 20, left: 20 },
              cellHeight: 10,
              cellWidth: [5, 10, 10, 10, 10, 10, 10],
              headerColor: "#000",
              rowColors: ["#EEE", "#FFF"],
              lineWidth: 0.1,
              lineColor: "#000", // Solid black border color
              headStyles: {
                fillColor: "#FFF",
                textColor: "#000",
                lineWidth: 0.1,
                halign: "center",
                valign: "middle",
                fontSize: 7,
              },
              styles: {
                fontSize: 7,
                fontStyle: "normal",
              },
            };
    
            const header7 = [
              [
                { colSpan: 2, content: ["kWh"] },
                { colSpan: 2, content: ["kVARh"] },
                { rowSpan: 2, content: ["MDI"] },
                { rowSpan: 2, content: ["No. of MDI Resets"] },
                { rowSpan: 2, content: ["Multiplying Factor"] },
              ],
            ];
    
            const data7 = [
              ["Peak", "Off Peak", "Peak", "Off Peak", "", "", ""],
              [
                rcoDets.threePhasePeakKWH,
                rcoDets.threePhaseOffPeakKWH,
                rcoDets.threePhasePeakKVARH,
                rcoDets.threePhaseOffPeakKVARH,
                rcoDets.mdi,
                rcoDets.noOfMDIreset,
                rcoDets.multiplyingFactor
                  ? rcoDets.multiplyingFactor.toString()
                  : "-",
              ],
            ];
    
            doc.autoTable({
              startY: 185,
              head: header7,
              body: data7,
              theme: "grid",
              ...tableProps7,
            });
          }
    
          const totalPages = doc.internal.getNumberOfPages();
    
          for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.addImage(
              getWaterMarkLogo(DiscoCode),
              "PNG",
              0,
              0,
              doc.internal.pageSize.getWidth(),
              doc.internal.pageSize.getHeight(),
            );
          }
          const pdfBlob = doc.output("blob");
          const pdfDataUrl = URL.createObjectURL(pdfBlob);
          const cp136FileName = applicationId + "- Master Data.pdf";
    
          // Open the PDF in a new tab with filename
          window.open(pdfDataUrl + '#' + cp136FileName, cp136FileName);
        } catch (e) { /* ignored */ }
        setViewBackdrop(false);
      };

  const getAmountText = (amount) => {
    if (amount == null || amount === "" || amount === undefined) return "0";
    const num = parseFloat(amount);
    return isNaN(num) ? "0" : numberFormatting(num);
  };

  const formatAmount = (value) => {
    const num = Number(value) || 0; // convert safely
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const downloadEFile = async (application) => {
    setViewBackdrop(true);
    try {
      let applicationId = application.applicationId;
      const mcoDialogReferenceNo = String(
        application?.referenceNo || dialogRowData?.referenceNo || "",
      ).trim();
      let DiscoCode = getDocumentDiscoCode(
      application.applicationId,
      application.companyCode,
    );

      let mtVoucherDets;

      // ⬇⬇ GET DOCUMENTS FROM YOUR NEW API
      const applicationDocs = await callAsyncGetDocumentsAPI(applicationId);

      if (!applicationDocs) {
        return;
      }

      // ⬇⬇ CALL E-FILE API TO GET eFileData
      const eFileTableData = await callEfileAPI(applicationId, application);

      let paidDemandNoteImage = "";
      let dnDets = null;
      let boqItems = [];

      // Fetch BOQ items for progressId >= 4 (after field survey)
      if (application.applicationProgressId >= 5) {
        try {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);
          myHeaders.append("Content-Type", "application/json");

          const raw = JSON.stringify({
            applicationId: application.applicationId,
          });

          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          const response = await fetch(
            cfpBaseUrl + "meterChangeOrder/getMCODemandNoteData",
            requestOptions,
          );

          const result = await response.json();

          if (
            result.status === "200" &&
            result.data &&
            result.data.length > 0
          ) {
            dnDets = normalizeDnAmounts(result.data[0]);
            paidDemandNoteImage = dnDets.paidDNImage || "";
          }

          boqItems = result.BoQitems || [];
        } catch (error) { /* ignored */ }
      } else {
      }

      if (
        application.applicationProgressId >= 6 &&
        application.isReferToMT === true
      ) {
        await callAsyncGetMCOMTReportData(applicationId).then((response) => {
          mtVoucherDets = response.mtVoucherDets[0];
        });
      }

      // Read all document URLs safely
      const copyOfApplicantCNICFront = applicationDocs.applicantCNICFront || "";
      const copyOfApplicantCNICBack = applicationDocs.applicantCNICBack || "";
      const copyElectricityBillDoc = applicationDocs.electricityBillImage || "";
      const copyOfAnyOtherDoc = applicationDocs.anyOtherDocument || "";
      const copyOfmtImg = mtVoucherDets?.["m&TReportImage"] || "";

      let CNICFrontImg = "";
      let CNICBackImg = "";
      let ElectricityImg = "";
      let AnyOtherImg = "";
      let mtReportImg = "";
      let paidDNImg = "";
      let dnPaidImg = "";
      if (copyOfApplicantCNICFront?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(copyOfApplicantCNICFront);
        CNICFrontImg = img;
      } else {
        CNICFrontImg = copyOfApplicantCNICFront;
      }

      if (copyOfApplicantCNICBack?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(copyOfApplicantCNICBack);
        CNICBackImg = img;
      } else {
        CNICBackImg = copyOfApplicantCNICBack;
      }

      if (copyElectricityBillDoc?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(copyElectricityBillDoc);
        ElectricityImg = img;
      } else {
        ElectricityImg = copyElectricityBillDoc;
      }

      if (copyOfAnyOtherDoc?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(copyOfAnyOtherDoc);
        AnyOtherImg = img;
      } else {
        AnyOtherImg = copyOfAnyOtherDoc;
      }

      if (copyOfmtImg?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(copyOfmtImg);
        mtReportImg = img;
      } else {
        mtReportImg = copyOfmtImg;
      }

      if (paidDemandNoteImage?.startsWith("data:application/pdf")) {
        const img = await pdfToImage(paidDemandNoteImage);
        paidDNImg = img;
      } else {
        paidDNImg = paidDemandNoteImage;
      }

      const doc = new jsPDF({ compressPdf: true });

      // Helper function to add page header
      const addPageHeader = (doc, DiscoCode, applicationId, documentTitle) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const padding = 10;
        const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
        const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
        const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
        const logoX = (pageWidth - logoWidth) / 2;

        let height = 10;

        doc.addImage(
          getLogo(DiscoCode),
          "PNG",
          logoX,
          5,
          logoWidth,
          logoHeight,
        );

        height += 15;
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
          align: "center",
        });

        height += 10;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(12);
        doc.text("Application Id: ", padding, height);
        doc.text(
          applicationId,
          padding + doc.getTextWidth("Application Id: "),
          height,
        );

        const applicationName = application.consumerName || application.applicantName || "-";
        const applicationLoad = application.sanctionedLoad != null ? String(application.sanctionedLoad) : "-";
        const applicationTariff = application.tariff || application.tariffDesc || tariff || "-";

        doc.text("Name: ", pageWidth / 2, height);
        doc.text(
          applicationName,
          pageWidth / 2 + doc.getTextWidth("Name: "),
          height,
        );

        height += 10;
        const secondRowY = height;
        doc.text("Load: ", padding, secondRowY);
        doc.text(
          applicationLoad,
          padding + doc.getTextWidth("Load: "),
          secondRowY,
        );
        doc.text("Tariff: ", pageWidth / 2, secondRowY);
        doc.text(
          applicationTariff,
          pageWidth / 2 + doc.getTextWidth("Tariff: "),
          secondRowY,
        );

        height += 10;
        const rectWidth = 195;
        const rectHeight = 10;
        const rectX = (pageWidth - rectWidth) / 2;

        doc.setFillColor(199, 199, 199);
        doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
        doc.setFont("helvetica", "bold");
        doc.text(documentTitle, pageWidth / 2, height, { align: "center" });

        return height + 3.5;
      };

      // Helper function to add document image/PDF with fixed dimensions
      const addDocumentContent = async (doc, documentData, startHeight) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;

        doc.rect(rectX, startHeight, rectWidth, rectHeight);

        const fileType = documentData.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = documentData.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = documentData.slice(17, 19);
        }

        const cardWidth = 190;
        const cardHeight = 228;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + 3;

        if (extension.startsWith("jp")) {
          doc.addImage(documentData, "jpeg", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pn")) {
          doc.addImage(documentData, "png", xPos, yPos, cardWidth, cardHeight);
        }
      };

      // Helper function to add CNIC images with fixed size to fit in border
      const addCNICImage = (
        doc,
        cnicData,
        startHeight,
        containerHeight = 234,
      ) => {
        const pageWidth = doc.internal.pageSize.getWidth();

        const cardWidth = 150;
        const cardHeight = 95;
        const xPos = (pageWidth - cardWidth) / 2;
        const yPos = startHeight + (containerHeight - cardHeight) / 2;

        const fileType = cnicData.slice(0, 6);
        let extension = "";

        if (fileType === "data:i") {
          extension = cnicData.slice(11, 15);
        } else if (fileType === "data:a") {
          extension = cnicData.slice(17, 19);
        }

        if (extension.startsWith("jp")) {
          doc.addImage(cnicData, "jpeg", xPos, yPos, cardWidth, cardHeight);
        } else if (extension.startsWith("pn")) {
          doc.addImage(cnicData, "png", xPos, yPos, cardWidth, cardHeight);
        }

        return yPos + cardHeight;
      };

      // FIRST PAGE - Application Summary
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Generate the barcode
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, applicationId);
      const barcodeDataURL = barcodeCanvas.toDataURL("image/png");

      const smallLogoCodes = ["12", "13", "11", "16", "26", "27", "48", "59"];
      const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
      const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
      const logoX = (pageWidth - logoWidth) / 2;

      doc.addImage(barcodeDataURL, "PNG", pageWidth - 50, 5, 40, 20);
      doc.addImage(getLogo(DiscoCode), "PNG", logoX, 5, logoWidth, logoHeight);

      let height = 25;
      const padding = 10;
      const leftMargin = 50;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
        align: "center",
      });

      height += 8;
      doc.setFontSize(18);
      doc.text("E-Document", pageWidth / 2, height, { align: "center" });

      height += 8;
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      height += 8;

      doc.text("Document Type: ", padding, height);
      doc.text("Meter Change Order", padding + leftMargin, height);
      doc.text("Tracking Id:", padding + leftMargin + leftMargin, height);
      doc.text(
        applicationId,
        padding + leftMargin + leftMargin + leftMargin,
        height,
      );

      height += 6;
      doc.text("Application Status: ", padding, height);
      doc.text(
        statusFunc(
          application.applicationProgressId,
          application.objectionStatus,
        ),
        padding + leftMargin,
        height,
      );
      doc.text("Application Date:", padding + leftMargin + leftMargin, height);
      doc.text(
        application.creationDate ? convertDate(application.creationDate) : "-",
        padding + leftMargin + leftMargin + leftMargin,
        height,
      );

      height += 6;
      doc.text("Sub-Division: ", padding, height);
      doc.text(
        application.subDivisionCode
          ? subdivisionName(parseInt(application.subDivisionCode), subDivisions)
          : "-",
        padding + leftMargin,
        height,
      );
      doc.text("Connection Type:", padding + leftMargin + leftMargin, height);
      doc.text(
        application.connectionCategory ? application.connectionCategory : "-",
        padding + leftMargin + leftMargin + leftMargin,
        height,
      );

      height += 6;

      doc.text("Phase / Load: ", padding, height);

      doc.text(
        application.sanctionedLoad ? String(application.sanctionedLoad) : "-",
        padding + leftMargin,
        height,
      );
      doc.text("Connection Date:", padding + leftMargin + leftMargin, height);
      doc.text("-", padding + leftMargin + leftMargin + leftMargin, height);

      height += 20;
      let rectWidth = 195;
      let rectHeight = 10;
      let rectX = (pageWidth - rectWidth) / 2;

      doc.setFillColor(200, 200, 200);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Applicant Particulars", pageWidth / 2, height, {
        align: "center",
      });

      height += 6;
      rectHeight = 30;
      const applicantAddress = application.consumerAddress
        ? application.consumerAddress
        : "-";
      const addressLines = doc.splitTextToSize(applicantAddress, 120);
      const wrappedAddressLines =
        addressLines.length > 2 ? addressLines.slice(0, 2) : addressLines;
      rectHeight += (wrappedAddressLines.length - 1) * 6;
      doc.rect(rectX, height - 2.5, rectWidth, rectHeight);

      doc.setFont("helvetica", "normal");
      height += 8;
      const extraPadding = 5;

      doc.text("Applicant Name:", padding + extraPadding, height);
      doc.text(
        application.consumerName ? application.consumerName : "-",
        padding + 70,
        height,
      );

      height += 6;
      doc.text("CNIC:", padding + extraPadding, height);
      doc.text(
        application.consumerCNIC ? application.consumerCNIC : "-",
        padding + 70,
        height,
      );

      height += 6;
      doc.text("Present Address:", padding + extraPadding, height);
      doc.text(wrappedAddressLines, padding + 70, height);

      height += 6 * wrappedAddressLines.length;
      doc.text("Phone No.:", padding + extraPadding, height);
      doc.text(
        application.applicantMobileNo ? application.applicantMobileNo : "-",
        padding + 70,
        height,
      );

      // Add spacing before Application Summary section
      height += 15;
      rectHeight = 10;

      doc.setFillColor(199, 199, 199);
      doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
      doc.setFont("helvetica", "bold");
      doc.text("Application Summary", pageWidth / 2, height, {
        align: "center",
      });

      doc.setFontSize(12);
      height += 3.5;

      const summaryTableProps = {
        margin: { left: rectX, right: rectX },
        startY: height,
        tableWidth: rectWidth,
        styles: {
          fontSize: 11,
          fontStyle: "normal",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          minCellHeight: 10,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontSize: 11,
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          lineWidth: 0,
        },
        alternateRowStyles: {
          fillColor: [235, 235, 235],
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 15 },
          1: { halign: "center", cellWidth: 40 },
          2: { halign: "center", cellWidth: 35 },
          3: { halign: "center", cellWidth: 30 },
          4: { halign: "center", cellWidth: 65 },
        },
        theme: "plain",
        tableLineWidth: 0.5,
        tableLineColor: [0, 0, 0],
      };

      const summaryData = [];

      // Check if eFileResult exists and has data
      if (eFileTableData && eFileTableData.length > 0) {
        // Keep same ordering as activity log (already sorted by latest date first)
        const sortedData = [...eFileTableData];

        let srNumber = sortedData.length;

        for (let i = 0; i < sortedData.length; i++) {
          const row = sortedData[i];

          const remarksToShow = row.remarks || "";

          summaryData.push([
            srNumber.toString(),
            row.stepName || "",
            row.processedBy || "",
            convertDatewithTimeWithoutSecond(row.date).slice(0, 11),
            remarksToShow,
          ]);

          srNumber--;
        }
      }
      // Draw the table
      doc.autoTable({
        head: [["Sr.", "Step", "Processed By", "Date", "Remarks"]],
        body: summaryData,
        ...summaryTableProps,
      });

      // ADD OTHER DOCUMENTS ON NEW PAGES
      if (CNICFrontImg !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Front",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(doc, CNICFrontImg, contentHeight, rectHeight);
      }

      if (CNICBackImg !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Applicant CNIC - Back",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(doc, CNICBackImg, contentHeight, rectHeight);
      }

      if (ElectricityImg !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Electricity Bill",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(doc, ElectricityImg, contentHeight, rectHeight);
      }

      if (AnyOtherImg !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Any Other Img",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(doc, AnyOtherImg, contentHeight, rectHeight);
      }

      if (
        mtReportImg !== "" &&
        application.applicationProgressId >= 6 &&
        application.isReferToMT === true
      ) {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "M&T Image",
        );

        const rectWidth = 195;
        const rectHeight = 234;
        const rectX = (pageWidth - rectWidth) / 2;
        doc.rect(rectX, contentHeight, rectWidth, rectHeight);

        await addCNICImage(doc, mtReportImg, contentHeight, rectHeight);
      }

      if (
        dnDets &&
        dnDets.approvedFlag == 1 &&
        application.applicationProgressId >= 7
      ) {
        doc.addPage();
        var line2Height = 10;
        var lineHeightIncreament = 5;
        // let application = reconnectionApplications.find(item => item.applicationId === applicationId)
        let officeCode = application.subDivisionCode.toString();
        let officeName = subdivisionName(parseInt(officeCode), subDivisions);
        let authorizedByName = dnDets.approvedBy ? dnDets.approvedBy : "---";
        let authorizedByDesignation = dnDets.approvedByDesignation
          ? dnDets.approvedByDesignation
          : "Role";
        let dateToPrint = dnDets.approvedDate
          ? numberFormatting(new Date(dnDets.approvedDate))
          : "---";
        let stampData = printStamp(
          officeCode,
          officeName,
          authorizedByName,
          authorizedByDesignation,
          dateToPrint,
        );

        const fontSize = 8;
        if (dnDets.approvedBy) {
          doc.addImage(stampData, "PNG", 20, 200, 55, 40); // Add image to PDF (x, y, width, height)
          doc.addImage(stampData, "PNG", 140, 265, 55, 40); // Add image to PDF (x, y, width, height)
        }

        //#region Line 1
        doc.setFontSize(fontSize);
        doc.setFont("helvetica", "normal");
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          companyName(applicationId.slice(3, 5)).concat(
            application.sanctionedLoad < 15
              ? "(" +
                  applicationId.slice(3, 8) +
                  "-" +
                  subdivisionName(
                    parseInt(application.subDivisionCode),
                    subDivisions,
                  ) +
                  ")"
              : "(" +
                  applicationId.slice(3, 7) +
                  "-" +
                  divisionName(
                    parseInt(application.divisionCode),
                    subDivisions,
                  ) +
                  ")",
          ),
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 2
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(Department of Electricity)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 3
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 12;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo;
        var text3 = "Application Id: ";
        var text4 = applicationId;
        var text5 = "Apply Date: ";
        var text6 = convertDate(application.creationDate);

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 4
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 3.35;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Application Type: ";
        var text4 = application.applicationType
          ? applicationName(application.applicationType)
          : "-";
        var text5 = "Required Tariff: ";
        var text6 = dnDets.tariff ? dnDets.tariff : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );

        //#endregion

        //#region Line 5
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "New Alloated Reference No.: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = "Consumer Mobile No.: ";
        var text4 = application.applicantMobileNo
          ? application.applicantMobileNo
          : "-";
        var text5 = "Connection type: ";
        var text6 = application.connectionCategory
          ? application.connectionCategory
          : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

       //#region Line 6
var line2Height = line2Height + lineHeightIncreament;
var text1 =
  "(under which the funds are to be deposited in the bank with the concerned officer of the department)";

doc.setFontSize(6);

// Center text1 on the page
// var pageWidth = doc.internal.pageSize.getWidth();
var text1Width = doc.getTextWidth(text1);
var centeredX = (pageWidth - text1Width) / 2;

doc.text(text1, centeredX, line2Height);

//#endregion

        //#region Line 7
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22.25;
        var text1 = `Department's approved Bank name: `;
        var text2 = dnDets.bankName ? dnDets.bankName : "-";
        var text3 = "Required Load (kW): ";
        var text4 = application.sanctionedLoad
          ? application.sanctionedLoad.toString()
          : "|";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 8
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 22;
        var text1 = `Department's Revenue Officer: `;
        var text2 = divisionName(
          parseInt(application.divisionCode),
          subDivisions,
        );
        var text3 = "";
        var text4 = "";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion


        //#region Line 10
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "DEMAND NOTICE",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 11
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          "(Notification of Approval Application and Demand Under Guarantee)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 12
        var line2Height = line2Height + lineHeightIncreament;

        doc.text(
          `Applicant's part`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 13
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var text1 = `Mr. / Mrs.`;
        var relationType = application.applicantRelationType;
        var relationTypeText =
          relationType == 1 || relationType == "S/O"
            ? "S/O"
            : relationType == 2 || relationType == "D/O"
              ? "D/O"
              : relationType == 3 || relationType == "W/O"
                ? "W/O"
                : relationType == 4 || relationType == "C/O"
                  ? "C/O"
                  : "";
        var relativePart = application.applicantRelativeName
          ? ` ${relationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.consumerName
          ? application.consumerName
              .concat(relativePart)
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        //#endregion

        //#region Line 16
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `A. Expenditure service connection as per approved estimate ______________ PKR. (this amount is to be deposited with the concerned officer of the department). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`;
        var text2 = dnDets.serviceConnectionAmount
          ? numberFormatting(dnDets.serviceConnectionAmount)
          : "";
        var text3 = dnDets.securityDepositeAmount
          ? numberFormatting(dnDets.securityDepositeAmount)
          : "";
        var lines = doc.splitTextToSize(text1, maxWidth);
        doc.setFont("helvetica", "bold");
        doc.text(text2, 90, line2Height);
        doc.text(text3, 130, line2Height);
        doc.setFont("helvetica", "normal");
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[capitalCost]",
            dnDets.capitalCostAmount
              ? numberFormatting(dnDets.capitalCostAmount)
              : "",
          );
          lineText = lineText.replace(
            "[securityCost]",
            dnDets.securityDepositeAmount
              ? numberFormatting(dnDets.securityDepositeAmount)
              : "",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }

        //#endregion

        //#region Line 17
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `B. Arrears due to non-payment of previous electricity bills etc. _____ PKR. (this amount is to be deposited in the bank after receiving the final bill from the revenue officer).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 18
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 19
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. You shall, within [noOfDays] days from the date of issue of this notice, obtain a test report from a Government approved wiring contractor in proof of the soundness and quality of the internal wiring of your building and the completion of the installation of your electrical appliances and send send to my office for further departmental inspection and testing and get receipt (Blank Test Report is on Form CP-7).`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfDays]", noOfDays);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 20
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `3. Since you have not provided your purchased meter to the department for measuring the supply of electricity, you will be charged a monthly meter rental fee of [amount] PKR.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 21
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var amount = "_____";
        var text1 = `4. Demand notices for release of security deposit sent separately Process of connection will start after deposit of both demand notice amounts separate.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[amount]", amount);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 22
        doc.text(
          `(Irrelevant should be cut down)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 23
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfMonth = "1";
        var text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for obtaining electricity will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

           doc.setTextColor(220, 0, 0);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(24);
        doc.text(
          "NOT VALID FOR BANKS",
          doc.internal.pageSize.getWidth() / 2,
          145,
          {
            align: "center",
            angle: 320,
          },
        );
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(fontSize);
        doc.setFont("helvetica", "normal");

        // //#region Line 24
        // doc.setFontSize(fontSize);
        // var text1 = `Regards`;
        // var spaceLeft = 100;
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        // //#region Line 25
        // doc.setFontSize(fontSize);
        // var line2Height = line2Height + lineHeightIncreament;
        // var text1 =
        //   application.sanctionedLoad < 15
        //     ? "Sub-Division Office " +
        //       applicationId.slice(3, 8) +
        //       "-" +
        //       subdivisionName(
        //         parseInt(application.subDivisionCode),
        //         subDivisions,
        //       ) +
        //       " SDO " +
        //       companyShortName(DiscoCode)
        //     : "Division Office " +
        //       applicationId.slice(3, 7) +
        //       " - " +
        //       divisionName(parseInt(application.divisionCode), subDivisions) +
        //       " XEN MEPCO";
        // doc.text(text1, padding + spaceLeft, line2Height);
        // //#endregion

        //#region Line 26
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var text1 = "Signature Bank Officer: ";
        var text2 =
          application.sanctionedLoad < 15
            ? "Line Superintendent Office" +
              "(" +
              applicationId.slice(3, 8) +
              " - " +
              subdivisionName(
                parseInt(application.subDivisionCode),
                subDivisions,
              ) +
              ") SDO " +
              companyShortName(DiscoCode)
            : "Line Superintendent Office" +
              "(" +
              applicationId.slice(3, 7) +
              " - " +
              divisionName(parseInt(application.divisionCode), subDivisions) +
              ") XEN MEPCO";
        doc.text(text1, padding, line2Height);
        // doc.text(text2, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 27
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 28
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          "For Bank Use Only",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 29
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)",
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 30
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 16;
        var spaceLeft = 50;

        var text1 = `1. Applicant's Name and Complete address `;
        var bankRelationType = application.applicantRelationType;
        var bankRelationTypeText =
          bankRelationType == 1 || bankRelationType == "S/O"
            ? "S/O"
            : bankRelationType == 2 || bankRelationType == "D/O"
              ? "D/O"
              : bankRelationType == 3 || bankRelationType == "W/O"
                ? "W/O"
                : bankRelationType == 4 || bankRelationType == "C/O"
                  ? "C/O"
                  : "";
        var bankRelativePart = application.applicantRelativeName
          ? ` ${bankRelationTypeText} ${application.applicantRelativeName}`
          : "";
        var text2 = application.consumerName
          ? application.consumerName
              .concat(bankRelativePart)
              .concat(" | ")
              .concat(application.consumerAddress)
          : "|";
        var text3 = ``;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.setFontSize(6);
        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2 + spaceLeft),
          line2Height,
        );
        //#endregion

        //#region Line 31
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "2. Application Id: ";
        var text2 = application.applicationId ? application.applicationId : "-";
        var text3 = "Date: ";
        var text4 = application.creationDate
          ? convertDate(application.creationDate)
          : "-";
        var text5 = "Service Connection:";
        var serviceConnectionAmount = Number(
          String(
            dnDets?.serviceConnectionAmount ?? dnDets?.capitalCostAmount ?? 0,
          ).replace(/,/g, ""),
        );
        var text6 = numberFormatting(serviceConnectionAmount);
        var leftSpace = 40;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        var serviceLabelX = 130;
        var serviceValueX = serviceLabelX + doc.getTextWidth(text5) + 2;
        doc.text(text5, serviceLabelX, line2Height);
        doc.text(text6, serviceValueX, line2Height);
        doc.setFont("helvetica", "normal");
        doc.line(
          serviceValueX,
          line2Height + 1,
          serviceValueX + doc.getTextWidth(text6) + 4,
          line2Height + 1,
        );
        //#endregion

        //#region Line 32
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "3. Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Date: ";
        var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 35;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        
        //#endregion

        //#region Line 33
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "4. Account No. for acquisition connection: ";
        var text2 = dnDets.connectionAccountNo
          ? dnDets.connectionAccountNo
          : "-";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 10;

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        // doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
        // doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
        // doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            leftSpace +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        
        //#endregion

        // Meter Change DN QR (same approach as RCO — right side, no row shift)
        // QR RefNo from application/dialogRow (e.g. 09131420411212), not getMCODemandNoteData.
        {
          const capitalForQr =
            parseFloat(
              dnDets.serviceConnectionAmount ?? dnDets.capitalCostAmount,
            ) || 0;
          const mcoQrRefNo = String(
            mcoDialogReferenceNo ||
              application?.referenceNo ||
              dialogRowData?.referenceNo ||
              "",
          ).trim();
          await addDnPaymentQrCodesToPdf(doc, {
            dnDets: {
              ...dnDets,
              capitalCostAmount: capitalForQr,
              ...(mcoQrRefNo
                ? {
                    connectionAccountNo: mcoQrRefNo,
                    consumerAccountNo: mcoQrRefNo,
                    refNo: mcoQrRefNo,
                  }
                : {}),
            },
            applicationId,
            token,
            securityAmount: 0,
            capitalCost: capitalForQr,
            discoCode: DiscoCode,
            layout: {
              ...RCO_DN_QR_LAYOUT,
              skipNcDefaults: true,
              skipSecurity: true,
              imageY: line2Height + 2,
            },
          });
        }

        //#region Line 34
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = "5. Approved bank name and address:";
        var text2 = dnDets.bankName ? dnDets.bankName : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );
        //#endregion

        //#region Line 35 — Signature Bank Officer removed (Meter Change DN; QR uses space)
        var line2Height = line2Height + lineHeightIncreament;
        //#endregion

        //#region Line 36
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = " ";
        var leftSpace = 10;
        doc.setFontSize(6);
        doc.text(text1, padding, line2Height);
        //#endregion

        // Room under bank QR before Applicant's Response (stamps fixed)
        line2Height = line2Height + 12;

        //#region Line 37
        doc.setFontSize(fontSize);
        var line2Height = line2Height + lineHeightIncreament;
        spaceLeft = 10;
        var text1 =
          "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------";
        doc.text(text1, padding + spaceLeft, line2Height);
        //#endregion

        //#region Line 38
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          "DUE Date: " + convertDate(dnDets.dueDate),
          padding,
          line2Height,
          {},
        );
        doc.text(
          `Applicant's Response`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 39
        lineHeightIncreament = 4;
        var line2Height = line2Height + lineHeightIncreament;
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var text1 = `1. I/We have submitted the amount of service connection of [serviceConnectionAmount] only in the department's approved bank [bankName] by receipt no. _______________________________________ on date _______________________________.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          var lineText = lines[i].replace(
            "[serviceConnectionAmount]",
            numberFormatting(dnDets.serviceConnectionAmount),
          );
          lineText = lineText.replace(
            "[securityCost]",
            numberFormatting(dnDets.securityDepositeAmount),
          );
          lineText = lineText.replace(
            "[bankName]",
            dnDets.bankName ? dnDets.bankName : "-",
          );
          doc.text(lineText, padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 40
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `2. Since I/We did not provide funds to buy meter to the department, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 41
        doc.setFontSize(fontSize);
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 2;
        var noOfDays = "30";
        var text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period.`;
        var lines = doc.splitTextToSize(text1, maxWidth);
        // Iterate through each line and add it to the PDF
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
        }
        //#endregion

        //#region Line 42
        lineHeightIncreament = 5;
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          `For Computer Center Use`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 43
        var line2Height = line2Height + lineHeightIncreament;
        doc.text(
          `(Demand Notice Data)`,
          doc.internal.pageSize.getWidth() / 2,
          line2Height,
          {
            align: "center",
          },
        );
        //#endregion

        //#region Line 44
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Serial No.: ";
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";
        var text3 = "Application Id: ";
        var text4 = applicationId ? applicationId : "-";
        var text5 = "Application Form No.: ";
        var text6 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : "-";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text5,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height,
        );
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 4 +
            doc.getTextWidth(text6) +
            lineSpace * 2,
          line2Height + 1,
        );
        //#endregion

        //#region Line 45
        var line2Height = line2Height + lineHeightIncreament;
        var lineHeightIncreament = 5;
        var lineSpace = 7.5;
        var text1 = "Demand Notice Issuance Date: ";
        var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : "-";
        var text3 = "Amount to be paid: ";
        var serviceConnectionAmount = Number(
          String(
            dnDets?.serviceConnectionAmount ?? dnDets?.capitalCostAmount ?? 0,
          ).replace(/,/g, ""),
        );
        var text4 = numberFormatting(serviceConnectionAmount);
        var text5 = " ";
        var text6 = " ";

        doc.text(text1, padding, line2Height);
        doc.text(
          text2,
          doc.getTextWidth(text1) + padding + lineSpace,
          line2Height,
        );
        doc.line(
          doc.getTextWidth(text1) + padding,
          line2Height + 1,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height + 1,
        );

        doc.text(
          text3,
          doc.getTextWidth(text1) +
            padding +
            (doc.getTextWidth(text2) + lineSpace * 2),
          line2Height,
        );
        doc.setFont("helvetica", "bold");
        doc.text(
          text4,
          doc.getTextWidth(text2) +
            doc.getTextWidth(text1) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 3,
          line2Height,
        );
        doc.setFont("helvetica", "normal");
        doc.line(
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2,
          line2Height + 1,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            padding +
            lineSpace * 2 +
            (doc.getTextWidth(text4) + lineSpace * 2),
          line2Height + 1,
        );

        //#endregion

        //#region Line 46
        doc.setFontSize(fontSize);
        var line2Height =
          line2Height + lineHeightIncreament + lineHeightIncreament / 2;
        var lineSpace = 6.6;
        var text1 = " ";
        var text2 = " ";
        var text3 = " ";
        var text4 = " ";
        var text5 = " ";
        var text6 = application.sanctionedLoad < 15 ? " " : " ";
        var leftSpace = 110;
        doc.text(
          text6,
          doc.getTextWidth(text1) +
            doc.getTextWidth(text2) +
            doc.getTextWidth(text3) +
            doc.getTextWidth(text4) +
            doc.getTextWidth(text5) +
            padding +
            lineSpace * 5 +
            +leftSpace,
          line2Height,
        );
        //#endregion

        //#region Line 47
        doc.setFontSize(6);
        lineHeightIncreament = 2;
        var maxWidth = doc.internal.pageSize.getWidth() - padding * 8;
        var text1 =
          "NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. ";
        var lineSpace = 6.6;
        var lines = doc.splitTextToSize(text1, maxWidth);
        for (var i = 0; i < lines.length; i++) {
          doc.text(lines[i], padding, line2Height);
          line2Height = line2Height + lineHeightIncreament;
        }
      }

      if (application.applicationProgressId >= 8 && paidDNImg !== "") {
        doc.addPage();
        let contentHeight = addPageHeader(
          doc,
          DiscoCode,
          applicationId,
          "Paid Demand Note",
        );
        await addDocumentContent(doc, paidDNImg, contentHeight);
      }
      // ⬇⬇ ADD DEMAND NOTE CONTENT ONLY IF CONDITIONS ARE MET

      if (application.applicationProgressId >= 5 && boqItems.length >= 1) {
        doc.addPage();
        height = 10;
        if (boqItems.length >= 1) {
          const smallLogoCodes = [
            "12",
            "13",
            "11",
            "16",
            "26",
            "27",
            "48",
            "59",
          ];

          const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
          const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;

          const logoX = (pageWidth - logoWidth) / 2;
          doc.addImage(
            getLogo(DiscoCode),
            "PNG",
            logoX,
            5,
            logoWidth,
            logoHeight,
          );

          var increment = 15;
          height += increment;
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
            align: "center",
          });

          increment = 10;
          height += increment;
          doc.text("Application Id: ", padding, height);
          doc.text(
            applicationId,
            padding + doc.getTextWidth("Application Id: "),
            height,
          );
          doc.text("Name: ", pageWidth / 2, height);
          doc.text(
            application.consumerName || "-",
            pageWidth / 2 + doc.getTextWidth("Name: "),
            height,
          );
          height += increment;
          doc.text("Load: ", padding, height);
          doc.text(
            application.sanctionedLoad != null ? String(application.sanctionedLoad) : "-",
            padding + doc.getTextWidth("Load: "),
            height,
          );
          doc.text("Tariff: ", pageWidth / 2, height);
          doc.text(
            application.tariffDesc || "-",
            pageWidth / 2 + doc.getTextWidth("Tariff: "),
            height,
          );
          height += increment;

          // Draw header rectangle
          doc.setFillColor(199, 199, 199);
          doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
          doc.setFont("helvetica", "bold");
          doc.text("Items List", pageWidth / 2, height, { align: "center" });

          height += 3.5;
          const itemsBoxTop = height;
          const pageHeight = doc.internal.pageSize.getHeight();
          const itemsBoxBottom = pageHeight - 12;
          rectHeight = itemsBoxBottom - itemsBoxTop;
          doc.rect(rectX, itemsBoxTop, rectWidth, rectHeight);

          // Table setup
          const boqTableProps = {
            margin: { top: 0, right: 20, bottom: 20, left: 20 },
            cellHeight: 10,
            headerColor: "#000",
            rowColors: ["#EEE", "#FFF"],
            lineWidth: 1,
            lineColor: "#000",
            headStyles: {
              fillColor: "#FFF",
              textColor: "#000",
              fontSize: 11,
              fontStyle: "bold",
              halign: "left",
              valign: "middle",
            },
            styles: {
              fontSize: 11,
              fontStyle: "normal",
              lineWidth: 0,
              lineColor: [0, 0, 0],
              fillColor: [255, 255, 255],
              textColor: [0, 0, 0],
            },
            alternateRowStyles: { fillColor: [235, 235, 235] },
          };

          const boqHeaders = [["Sr.", "Item Name", "Unit", "Qty", "Amount"]];
          const boqData = [];
          let itemsTotal = 0;
          const materialsList = await callMaterials(applicationId, token);
          for (let i = 0; i < boqItems.length; i++) {
            const rowData = boqItems[i];

            // Match BOQ item with material list using item_Code
            const item = materialsList.find(
              (mat) => String(mat.item_Code) === String(rowData.itemCode),
            );
            if (!item) {
              continue; // skip this row
            }

            const serialNo = i + 1;
            const itemName = item.item_Name;
            const unit = item.item_Unit;
            const qtyValue = Number(rowData.qty) || 0;
            const itemRateValue =
              Number(rowData.itemAmount) || Number(item.item_Amount) || 0;
            const qty = numberFormatting(qtyValue);
            const amount = numberFormatting(itemRateValue);
            itemsTotal += itemRateValue;

            const row = [serialNo.toString(), itemName, unit, qty, amount];
            boqData.push(row);
          }

          // Generate PDF table
          doc.autoTable({
            startY: itemsBoxTop + 1,
            head: boqHeaders,
            body: boqData,
            theme: "grid",
            margin: { left: rectX + 1, right: rectX + 1 },
            tableWidth: rectWidth - 2,
            ...boqTableProps,
          });

          // Add page for Service Cost Estimate
          doc.addPage();
          height = 10;
          doc.addImage(
            getLogo(DiscoCode),
            "PNG",
            logoX,
            5,
            logoWidth,
            logoHeight,
          );

          increment = 15;
          height += increment;
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(getCompanies(DiscoCode), pageWidth / 2, height, {
            align: "center",
          });

          increment = 10;
          height += increment;
          doc.setFontSize(12);
          const detailLeftX = padding;
          const detailRightX = pageWidth - 95;
          const detailValueGap = 3;
          doc.setFont("helvetica", "bold");
          doc.text("Application Id: ", detailLeftX, height);
          doc.setFont("helvetica", "bold");
          doc.text(
            applicationId,
            detailLeftX + doc.getTextWidth("Application Id: ") + detailValueGap,
            height,
          );
          doc.setFont("helvetica", "bold");
          doc.text("Name: ", detailRightX, height);
          doc.setFont("helvetica", "bold");
          doc.text(
            application.consumerName || "-",
            detailRightX + doc.getTextWidth("Name: ") + detailValueGap,
            height,
          );
          height += increment;
          doc.text("Load: ", detailLeftX, height);
          doc.text(
            application.sanctionedLoad != null ? String(application.sanctionedLoad) : "-",
            detailLeftX + doc.getTextWidth("Load: ") + detailValueGap,
            height,
          );
          doc.text("Tariff: ", detailRightX, height);
          doc.text(
            application.tariffDesc || "-",
            detailRightX + doc.getTextWidth("Tariff: ") + detailValueGap,
            height,
          );
          height += increment;
          doc.setFontSize(12);

          // Header for Service Cost Estimate
          rectWidth = 195;
          rectHeight = 10;
          rectX = (pageWidth - rectWidth) / 2;
          doc.setFillColor(199, 199, 199);
          doc.rect(rectX, height - 6.5, rectWidth, rectHeight, "DF");
          doc.setFont("helvetica", "bold");
          doc.text("Service Cost Estimate", pageWidth / 2, height, {
            align: "center",
          });

          increment = 12;
          height += increment;

          // First, safely convert all input values
          const itemsTotalValue = Number(itemsTotal) || 0;
          const isMC13 = String(applicationId).startsWith("MC-13");
          const roundAmount = (value) => Math.round(Number(value) || 0);
          const roundedItemsTotal = roundAmount(itemsTotalValue);
          const roundedStoreCharges = isMC13
            ? 0
            : Math.floor((roundedItemsTotal * 12 + 50) / 100);
          const roundedInstallationCharges = Math.floor(
            ((roundedItemsTotal + roundedStoreCharges) * 8 + 50) / 100,
          );
          const roundedCivilWork = roundAmount(dnDets?.civilWorkCharges);
          const roundedMetering = roundAmount(dnDets?.fixedChargesOfMetering);
          const roundedMiscCharges = roundAmount(dnDets?.miscellaneousCharges);
          const roundedGridSharing = roundAmount(dnDets?.amountOfGridSharing);
          const roundedFeederRehab = roundAmount(dnDets?.amountOfFeederRehab);
          const roundedMtCharges = roundAmount(dnDets?.mtCharges);
          const roundedLabourCharges = roundAmount(dnDets?.labourCharges);
          const roundedDesignWettingFee = roundAmount(dnDets?.designVetteingFee);
          const roundedConsultancyCharges = roundAmount(dnDets?.consultancyCharges);
          const roundedVariationCharges = roundAmount(dnDets?.variationsCharges);
          const roundedDismantlementCharges = roundAmount(dnDets?.dismentalmentCharges);
          const roundedEarthingCharges = roundAmount(dnDets?.earthingCharges);
          const roundedLessTheCost = roundAmount(dnDets?.lessTheCost);

          const roundedSecurityDeposit = roundAmount(
            dnDets?.securityDepositeAmount ?? dnDets?.securityDepositAmount,
          );

          const subTotalA = roundedItemsTotal + roundedStoreCharges;
          const subTotalB =
            roundedInstallationCharges + roundedGridSharing + roundedFeederRehab;
          const subTotalC =
            roundedCivilWork +
            roundedMiscCharges +
            roundedMtCharges +
            roundedLabourCharges;
          const subTotalD =
            roundedMetering +
            roundedDesignWettingFee +
            roundedConsultancyCharges +
            roundedVariationCharges +
            roundedDismantlementCharges +
            roundedEarthingCharges;

          const grossTotal = subTotalA + subTotalB + subTotalC + subTotalD;
          const netTotal = grossTotal - roundedLessTheCost;
          const grandTotalPayable = netTotal + roundedSecurityDeposit;
          const roundedGrossTotal = roundAmount(grossTotal);
          const roundedNetTotal = roundAmount(netTotal);
          const roundedGrandTotalPayable = roundAmount(grandTotalPayable);

          const leftX = 10;
          const rightX = pageWidth - 10;
          const labelX = leftX + 3;
          const valueX = rightX - 3;
          const rowGap = 7;
          const sectionGap = 0.8;

          const drawSeparator = () => {
            doc.setDrawColor(180, 180, 180);
            doc.setLineWidth(0.15);
            doc.line(leftX, height - 2.6, rightX, height - 2.6);
          };

          const drawSectionHeader = (title) => {
            doc.setFillColor(232, 232, 232);
            doc.rect(leftX, height - 4.8, rightX - leftX, 7.2, "F");
            doc.setFont("helvetica", "bold");
            doc.setTextColor(24, 51, 87);
            doc.text(title, labelX, height + 0.3);
            doc.setTextColor(0, 0, 0);
            height += rowGap;
          };

          const drawRow = (label, amount) => {
            const rowLabelX = labelX + 10;
            const rowValueText = `${formatAmount(amount)} /-`;
            doc.setFont("helvetica", "normal");
            doc.text(label, rowLabelX, height);
            doc.text(rowValueText, valueX, height, {
              align: "right",
            });

            const lineStartX = rowLabelX + doc.getTextWidth(label) + 3;
            const lineEndX = valueX - doc.getTextWidth(rowValueText) - 3;
            if (lineEndX > lineStartX) {
              doc.setDrawColor(185, 185, 185);
              doc.setLineWidth(0.12);
              doc.setLineDashPattern([1, 1], 0);
              doc.line(lineStartX, height - 1, lineEndX, height - 1);
              doc.setLineDashPattern([], 0);
            }

            height += rowGap;
          };

          const drawSubtotal = (label, amount) => {
            drawSeparator();
            height += 2.2;
            doc.setFont("helvetica", "bold");
            doc.text(label, labelX + 10, height);
            doc.text(`${formatAmount(amount)} /-`, valueX, height, {
              align: "right",
            });
            height += rowGap;
            height += sectionGap;
          };

          drawSectionHeader("A. Material & Store Cost");
          drawRow("Items Total Amount", roundedItemsTotal);
          drawRow(`Store Charges (${isMC13 ? "0%" : "12%"})`, roundedStoreCharges);
          drawSubtotal("Subtotal (A)", subTotalA);

          drawSectionHeader("B. Installation & Technical Cost");
          drawRow("Installation Charges (8%)", roundedInstallationCharges);
          drawRow("Grid Sharing Cost", roundedGridSharing);
          drawRow("Feeder Rehab Charges", roundedFeederRehab);
          drawSubtotal("Subtotal (B)", subTotalB);

          drawSectionHeader("C. Civil & Miscellaneous");
          drawRow("Civil Work Charges", roundedCivilWork);
          drawRow("Misc. Charges", roundedMiscCharges);
          drawRow("MNT Charges", roundedMtCharges);
          drawRow("Labour Charges", roundedLabourCharges);
          drawSubtotal("Subtotal (C)", subTotalC);

          drawSectionHeader("D. Other Charges");
          drawRow("Fixed Charges Of Metering", roundedMetering);
          drawRow("Design Vetting Fee", roundedDesignWettingFee);
          drawRow("Consultancy Charges", roundedConsultancyCharges);
          drawRow("Variation Charges", roundedVariationCharges);
          drawRow("Dismantlement Charges", roundedDismantlementCharges);
          drawRow("Earthing Charges", roundedEarthingCharges);
          drawSubtotal("Subtotal (D)", subTotalD);

          drawSeparator();
          height += 2.2;
          doc.setFont("helvetica", "bold");
          doc.text("Gross Total (A+B+C+D)", labelX, height);
          doc.text(`${formatAmount(roundedGrossTotal)} /-`, valueX, height, {
            align: "right",
          });
          height += rowGap;

          doc.setFont("helvetica", "bold");
          doc.setTextColor(170, 0, 0);
          height += 1.5;
          doc.text("Less:", labelX, height);
          doc.setTextColor(0, 0, 0);
          doc.text("Cost Adjustment", labelX + 13, height);
          doc.text(`-${formatAmount(roundedLessTheCost)} /-`, valueX, height, {
            align: "right",
          });
          height += rowGap;

          drawSeparator();
          height += 2.2;
          doc.setFont("helvetica", "bold");
          doc.text("Net Total", labelX, height);
          doc.text(`${formatAmount(roundedNetTotal)} /-`, valueX, height, {
            align: "right",
          });
          height += rowGap;

          drawSeparator();
          height += 2.2;
          doc.setFont("helvetica", "bold");
          doc.text("Security Deposit", labelX, height);
          doc.text(`${formatAmount(roundedSecurityDeposit)} /-`, valueX, height, {
            align: "right",
          });
          height += rowGap;

          doc.setFillColor(224, 233, 224);
          doc.rect(leftX, height - 5, rightX - leftX, 9, "F");
          doc.setFont("helvetica", "bold");
          doc.setTextColor(0, 90, 40);
          doc.text("GRAND TOTAL PAYABLE", labelX, height + 0.9);
          doc.text(`${formatAmount(roundedGrandTotalPayable)} /-`, valueX, height + 0.9, {
            align: "right",
          });
          doc.setTextColor(0, 0, 0);
        }
      }

      // === END OF RCO VOUCHER ADDITION ===

      if (Number(application.applicationProgressId) === 12) {
        try {
          await buildCP138PDFDoc(application, scoDetails, {
            targetDoc: doc,
            startOnNewPage: true,
            includeFooter: false,
          });
        } catch (cp138Error) { /* ignored */ }
      }

      // Add watermark and page numbers
      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(
          getWaterMarkLogo(DiscoCode),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight(),
        );
      }

      doc.setFontSize(8);
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        const pageNumberY = doc.internal.pageSize.getHeight() - 10;
        doc.text(
          "Page " + i + " of " + totalPages,
          doc.internal.pageSize.getWidth() / 2,
          pageNumberY,
          { align: "center" },
        );
      }

      const pdfBlob = doc.output("blob");
      const fileName = `${applicationId}-E-File.pdf`;
      const pdfURL = URL.createObjectURL(pdfBlob);

      window.open(pdfURL + '#' + fileName, fileName);

      setEFileData([]);
    } catch (e) { /* ignored */ } finally {
      setViewBackdrop(false);
    }
  };

  const handleEditIconClick = () => {
    editBasicInfoFormik.values.iv_applicant_name = dialogRowData.consumerName;
    editBasicInfoFormik.values.iv_applicant_cnic = dialogRowData.consumerCNIC;
    editBasicInfoFormik.values.iv_applicant_phone =
      dialogRowData.applicantMobileNo;
    editBasicInfoFormik.values.iv_applicant_email =
      dialogRowData.applicantEmail;
    editBasicInfoFormik.values.iv_relative_name =
      dialogRowData.applicantRelativeName;
    editBasicInfoFormik.values.iv_owner_name = dialogRowData.ownerName;
    editBasicInfoFormik.values.iv_owner_cnic = dialogRowData.ownerCNIC;
    editBasicInfoFormik.values.iv_owner_phone = dialogRowData.ownerMobile;
    editBasicInfoFormik.values.iv_owner_email = dialogRowData.ownerEmail;
    editBasicInfoFormik.values.iv_house = dialogRowData.houseNo;
    editBasicInfoFormik.values.iv_street = dialogRowData.streetNo;
    editBasicInfoFormik.values.iv_sector_block_phase_mohala =
      dialogRowData.sectorBlockPhaseMohalah;
    editBasicInfoFormik.values.iv_town_tehsil = dialogRowData.townTehsil;
    editBasicInfoFormik.values.iv_city_district = dialogRowData.cityDistrict;
    editBasicInfoFormik.values.iv_chak_street = dialogRowData.chakStreet;
    editBasicInfoFormik.values.iv_village = dialogRowData.village;
    setShowEditPopup(true);
  };

  //#endregion

  //#region formiks
  const appliedLoadFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_applied_load: Yup.number()
        .min(
          dialogRowData.sanctionedLoad,
          "New load can not be less than previous load.",
        )
        .max(1000, "Applied load can not be more than 1000kW.")
        .required("Enter applied load."),
    }),
    onSubmit: async (values, { resetForm }) => {
      var formdata = new FormData();
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("appliedLoad", appliedLoadFormik.values.iv_applied_load);
      formdata.append("lastModifiedBy", userId);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "electricityNewConnection/updateAppliedLoad",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            let nCApplications = reconnectionApplications;
            setReconnectionApplications(nCApplications);
            callChangeObjectionStatus(2, "Field Objection Removed");
          } else {
          }
        })
        .catch((error) => {
        });
    },
  });

  const referToFieldFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_refer_to_subdivision: Yup.mixed().required("Select the option."),
      iv_exempt_rco_fee: Yup.mixed().required("Select the option."),
      iv_exampt_rco_remarks: Yup.string().when("iv_exempt_rco_fee", {
        is: (iv_exempt_rco_fee) => iv_exempt_rco_fee == 1,
        then: Yup.string().required("Enter remarks for rco fee examption."),
        otherwise: Yup.string().optional(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      let progId = null;
      let remarks = "";

      if (values.iv_exempt_rco_fee == 1) {
        progId = 10;
        remarks = "Meter will be installed with RCO fee.";
      } else {
        if (values.iv_refer_to_subdivision == 1) {
          progId = 4;
          remarks = "Refered to Sub division";
        } else {
          progId = 8;
          remarks = "RCO Fee Voucher created.";
        }
      }

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: progId,
        objectionStatus: 0,
        lastModifiedBy: userId,
        remarks: remarks,
        isReferedToFeildSurvey: values.iv_refer_to_subdivision,
        exemptRcoFee: values.iv_exempt_rco_fee,
        exemptRcoRemarks: values.iv_exempt_rco_fee,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/refereToFeildSurvey", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == 200) {
            resetForm();
            handleClose();
          } else {
            setError(result.message);
          }
        })
        .catch(() => {});
    },
  });

  const refNoAllocationFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_grid_sharing_cost: Yup.mixed().when("gridFlag", {
        is: (gridFlag) => gridFlag === true,
        then: Yup.number()
          .typeError("Enter value in numbers.")
          .required("Enter grid sharing cost.")
          .min(1, "Cost cannot be less than 1"),
        otherwise: Yup.mixed()
          .test(
            "is-valid",
            "Enter value in numbers or enter '0'.",
            (value) => value === "0" || !isNaN(Number(value)),
          )
          .optional('Enter value in numbers or enter "0".'),
      }),
      iv_feeder_rehab_charges: Yup.mixed().when("feederRehabFlag", {
        is: (feederRehabFlag) => feederRehabFlag === true,
        then: Yup.number()
          .typeError("Enter value in numbers.")
          .required("Enter feeder rehab cost.")
          .min(1, "Cost cannot be less than 1"),
        otherwise: Yup.mixed()
          .test(
            "is-valid",
            "Enter value in numbers or enter '0'.",
            (value) => value === "0" || !isNaN(Number(value)),
          )
          .optional('Enter value in numbers or enter "0".'),
      }),
      iv_civil_work_charges: Yup.number(
        `Enter value in numbers or enter '0'.`,
      ).optional(),
      iv_fixed_charges_of_metering: Yup.number(
        `Enter value in numbers or enter '0'.`,
      ).optional(),
      iv_miscellaneous_charges: Yup.number(
        `Enter value in numbers or enter '0'.`,
      ).optional(),
      iv_less_the_cost: Yup.number(
        `Enter value in numbers or enter '0'.`,
      ).optional(),
      iv_feeder_no: Yup.mixed().required("Select feeder!"),
      iv_sub_batch: Yup.mixed().required("Select sub batch."),
      iv_batch: Yup.mixed().required("Select batch."),
      iv_reference_to_allot: Yup.string()
        .required("Enter reference no. to allot.")
        .min(7, `Reference no. can't be < 12 digits.`)
        .max(7, `Reference no. can't > 12 digits.`)
        .matches(/^[0-9]+$/, "Enter reference no. as 01234567891234"),
      iv_industry_factory_type: Yup.string().when("connectionType", {
        is: () =>
          (dialogRowData.connectionCategory === "Industrial" &&
            industryFlag === true) ||
          (dialogRowData.connectionCategory === "industrial" &&
            industryFlag === true),
        then: Yup.string().required("Please enter industry / factory type."),
        otherwise: Yup.string().optional(),
      }),
      iv_items_array: Yup.mixed().optional(),
      iv_fata_pata: Yup.mixed().optional("Select FATA / PATA!"),
      iv_rural_urban: Yup.mixed().required("Select Urban / Rural!"),
      iv_fgovt: Yup.string().optional(
        "Select Federal Govt / Autonomous and Local Bodies under Prov. Govt",
      ),
      iv_cantonment_board: Yup.string().optional("Select Cantonment Board"),
      iv_pgovt: Yup.string().optional(
        "Select Provincial Govt / Autonomous and Local Bodies under Prov. Govt",
      ),
      iv_govt_dept_code: Yup.string().when(["iv_pgovt", "iv_fgovt"], {
        is: (iv_pgovt, iv_fgovt) => Boolean(iv_pgovt || iv_fgovt),
        then: Yup.string().required("Select Govt. Department Code."),
        otherwise: Yup.string().optional(),
      }),
      iv_local_bodies: Yup.string().optional("Select Local Bodies"),
    }),
    onSubmit: async (values, { resetForm }) => {
      //#region If Distance < 40
      if (fieldFormik.values.iv_distance === 1) {
        var formdata = new FormData();
        formdata.append("applicationId", dialogRowData.applicationId);
        formdata.append("consumerAccountNo", values.iv_reference_to_allot);
        formdata.append("batchNo", values.iv_batch);
        formdata.append("feederNo", values.iv_feeder_no);
        formdata.append("subBatch", values.iv_sub_batch);
        formdata.append("tariff", tariff);
        formdata.append("bankName", bankName);
        formdata.append("industryFactoryType", values.iv_industry_factory_type);
        formdata.append(
          "connectionAccountNo",
          values.iv_batch
            .concat(partialValue)
            .concat(values.iv_reference_to_allot),
        );
        formdata.append("meterRent", 0); // Removed by Shafiq Sb
        formdata.append("serviceRent", 0); // Removed by Shafiq Sb
        formdata.append("sanctionLoad", dialogRowData.sanctionedLoad);
        formdata.append("filledBy", userId);
        formdata.append("filledFlag", 1);
        formdata.append("amountOfGridSharing", values.iv_grid_sharing_cost);
        formdata.append("amountOfFeederRehab", values.iv_feeder_rehab_charges);
        formdata.append("civilWorkCharges", civilWorkCharges);
        formdata.append("fixedChargesOfMetering", fixedChargesOfMetering);
        formdata.append("miscellaneousCharges", miscellaneousCharges);
        formdata.append("lessTheCost", lessTheCost);
        formdata.append("urbanRural", values.iv_rural_urban);
        formdata.append("fataPata", values.iv_fata_pata);
        formdata.append("fGovt", values.iv_fgovt);
        formdata.append("cantonmentBoard", values.iv_cantonment_board);
        formdata.append("pGovt", values.iv_pgovt);
        formdata.append("localBodies", values.iv_local_bodies);
        formdata.append(
          "governmentDepartmentCode",
          values.iv_govt_dept_code && values.iv_govt_dept_code != NaN
            ? values.iv_govt_dept_code
            : "",
        );

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "demandNotice/refNosAllocation",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              if (!dnDetails.filledFlag) {
                //In case of filling
                resetForm();
                setGridFlag(false);
                setFeederRehabFlag(false);
                setBankName();
              } else if (
                dnDetails &&
                dnDetails.filledFlag &&
                dnDetails.filledFlag === 1
              ) {
                //In case of approval
                if (dialogRowData.objectionStatus === 2) {
                  callResetObjectionStatus(dialogRowData.applicationId);
                }
                setNewConnectionPopup(true);
                callApproveFieldAPI(dialogRowData.applicationId);
                setGridFlag(false);
                setFeederRehabFlag(false);
                resetForm();
                setBankName();
              }
            }
            handleClose();
          })
          .catch(() => {});
      }
      //#endregion

      //#region If Distance > 40
      else if (fieldFormik.values.iv_distance == 0) {
        let arrayOfItems = [];
        itemsArray.forEach((item) => {
          let itemObject = {};
          itemObject.itemCode = item.itemCode;
          itemObject.Id = item.Id.toString();
          itemObject.qty = item.qty;
          arrayOfItems.push(itemObject);
        });

        var formdata = new FormData();

        formdata.append("applicationId", dialogRowData.applicationId);
        formdata.append("consumerAccountNo", values.iv_reference_to_allot);
        formdata.append("batchNo", values.iv_batch);
        formdata.append("tariff", tariff);
        formdata.append("feederNo", values.iv_feeder_no);
        formdata.append("subBatch", values.iv_sub_batch);
        formdata.append("bankName", bankName);
        formdata.append("industryFactoryType", values.iv_industry_factory_type);
        formdata.append(
          "connectionAccountNo",
          values.iv_batch
            .concat(partialValue)
            .concat(values.iv_reference_to_allot),
        );
        formdata.append("meterRent", 0); // Removed by Shafiq Sb
        formdata.append("serviceRent", 0); // Removed by Shafiq Sb
        formdata.append("sanctionLoad", dialogRowData.sanctionedLoad);
        formdata.append("filledBy", userId);
        formdata.append("filledFlag", 1);
        formdata.append("amountOfGridSharing", values.iv_grid_sharing_cost);
        formdata.append("amountOfFeederRehab", values.iv_feeder_rehab_charges);
        formdata.append("civilWorkCharges", civilWorkCharges);
        formdata.append("fixedChargesOfMetering", fixedChargesOfMetering);
        formdata.append("miscellaneousCharges", miscellaneousCharges);
        formdata.append("lessTheCost", lessTheCost);
        formdata.append("urbanRural", values.iv_rural_urban);
        formdata.append("fataPata", values.iv_fata_pata);
        formdata.append("fGovt", values.iv_fgovt);
        formdata.append("cantonmentBoard", values.iv_cantonment_board);
        formdata.append("pGovt", values.iv_pgovt);
        formdata.append("localBodies", values.iv_local_bodies);
        formdata.append(
          "governmentDepartmentCode",
          values.iv_govt_dept_code && values.iv_govt_dept_code != NaN
            ? values.iv_govt_dept_code
            : "",
        );

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        let requestOptions = {
          method: "POST",
          body: formdata,
          headers: myHeaders,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "demandNotice/refNosAllocation",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              // rcoPart1Formik.handleSubmit();
              if (!dnDetails.filledFlag) {
                //In case of filling
                //#region Boq InsertAPI
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Authorization", token);
                var raw = JSON.stringify({
                  applicationId: dialogRowData.applicationId,
                  array: arrayOfItems,
                });
                var requestOptions = {
                  method: "POST",
                  headers: myHeaders,
                  body: raw,
                  redirect: "follow",
                };

                fetch(cfpBaseUrl + "demandNotice/insertBOQ", requestOptions)
                  .then((response) => response.json())
                  .then((result) => {
                    if (result.status === "200") {
                      setItemsArray([]);
                      setItemsAmount();
                      setStoreCharges();
                      setInstallationCharges();
                      setGridFlag(false);
                      setFeederRehabFlag(false);
                      resetForm();
                      setBankName();
                      setTotalCharges(0);
                    } else {
                    }
                  })
                  .catch((error) => {
                  });
                //#endregion
              } else if (
                dnDetails &&
                dnDetails.filledFlag &&
                dnDetails.filledFlag === 1
              ) {
                //In case of approval
                if (arrayOfItems.length) {
                  //#region Boq UpdateAPI
                  let myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");
                  myHeaders.append("Authorization", token);
                  let raw = JSON.stringify({
                    applicationId: dialogRowData.applicationId,
                    array: arrayOfItems,
                  });

                  let requestOptions = {
                    method: "PUT",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                  };

                  fetch(cfpBaseUrl + "demandNotice/updateBoq", requestOptions)
                    .then((response) => response.json())
                    .then((result) => {
                      if (result.status === "200") {
                        setItemsArray([]);
                        setItemsAmount();
                        setStoreCharges();
                        setInstallationCharges();
                        setGridFlag(false);
                        setFeederRehabFlag(false);
                        resetForm();
                        setBankName();
                        setTotalCharges(0);
                        callApproveFieldAPI(dialogRowData.applicationId);
                      } else {
                      }
                    })
                    .catch((error) => {
                    });
                  //#endregion
                } else {
                  //#region net meter
                  setItemsArray([]);
                  setItemsAmount();
                  setStoreCharges();
                  setInstallationCharges();
                  setGridFlag(false);
                  setFeederRehabFlag(false);
                  resetForm();
                  setBankName();
                  setTotalCharges(0);
                  callApproveFieldAPI(dialogRowData.applicationId);
                }
              }
            } else {
            }
          })
          .catch((error) => {
          });
      }
      //#endregion
    },
  });

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_objection_Type: Yup.string().required("Enter reason for rejection."),
      // iv_objection_Descripton: Yup.string().optional("Enter reason for rejection."),
    }),
    onSubmit: async (values, { resetForm }) => {
      callChangeObjectionStatus(
        1,
        values.iv_objection_Type,
        values.iv_objection_Type,
      );
      resetForm();
    },
  });

  const dnPymentReceiptFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_payment_date: Yup.date()
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),
      iv_receipt_image: Yup.mixed().required(
        "Upload paid demand notice receipt image.",
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      var formdata = new FormData();

      formdata.append("applicationNo", dialogRowData.applicationId);
      formdata.append("demandNoticeNo", dnDetails.demandNoticeNo);
      formdata.append("uploadedBy", userId);
      formdata.append("paidDNImage", dnReceiptImageThumbnail);
      formdata.append("paymentMethod", "1");
      formdata.append("paymentDate", values.iv_payment_date);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "demandNotice/insertPaidDNImage", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callChangeProgressIdAPI(
              6,
              "Demand Notice Paid",
              "Demand Notice Paid",
            );
            resetForm();
            setDnReceiptImage();
            setDnReceiptImageThumbnail();
            setRcoPopUp(true);
          }
        })
        .catch(() => {});
    },
  });

  const mandtReceiptFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_mandt_payment_date: Yup.date()
        .max(new Date(), "M&T report date must be in the past!")
        .required("M&T report date is required!"),

      iv_mandt_receipt_image: Yup.mixed().required("Upload M&T report image."),

      iv_mandt_report_no: Yup.string()
        .matches(/^[0-9]{3,}$/, "Enter at least 3 digits.")
        .required("Please enter a valid number."),
    }),

    onSubmit: async (values, { resetForm }) => {
      if (
        !values.iv_mandt_report_no?.trim() ||
        !values.iv_mandt_payment_date ||
        !mandtReceiptImageThumbnail?.trim()
      ) {
        return;
      }

      try {
        setViewBackdrop(true); // ✅ show loader

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId:
            dialogRowData.isMCOWithCost === true &&
            dialogRowData.isMeterAvailable === true
              ? 6
              : 9,
          objectionStatus: 0,
          remarks: "M&T report submitted.",
          remarksDetail: "M&T report submitted Successfully.",
          mTReportNo: values.iv_mandt_report_no,
          mTReportDate: values.iv_mandt_payment_date,
          mTReportImage: mandtReceiptImageThumbnail,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "meterChangeOrder/processMCOMAndTReport",
          requestOptions,
        );

        const result = await response.json();

        if (result?.status === "200") {
          setSnackbar({
            open: true,
            message: result?.message || "Submitted successfully",
            severity: "success",
          });

          resetForm();
          setMandtReceiptImage(null);
          setMandtReceiptImageThumbnail(null);
          setMandtReceiptImageError(null);
          handleClose();
        } else {
          setSnackbar({
            open: true,
            message: result?.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {
        setSnackbar({
          open: true,
          message: "Something went wrong. Please try again.",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false); // ✅ always close loader
      }
    },
  });

  const rcoFeeReceiptFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_rco_fee_payment_date: Yup.date()
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),
      iv_rco_fee_receipt_image: Yup.mixed().required(
        "Upload paid RCO fee receipt image.",
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: 4,
          objectionStatus: 0,
          remarks: "RCO fee voucher uploaded.",
          remarksDetail: "RCO fee voucher uploaded Successfully.",
          submittedThrough: portalName,
          rcoFeePaidImage: rcoFeeReceiptImageThumbnail,
          rcoFeePaymentDate: values.iv_rco_fee_payment_date,
          lastModifiedBy: "",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "rco/uploadPaidRCOFeeVoucher",
          requestOptions,
        );

        const result = await response.json();

        if (result?.status === "200") {
          setSnackbar({
            open: true,
            message: result?.message || "Approved successfully",
            severity: "success",
          });

          resetForm();
          setRcoFeeReceiptImage();
          setRcoFeeReceiptImageThumbnail();
          setRcoFeeReceiptImageError();
          handleClose();
        } else {
          setSnackbar({
            open: true,
            message: result?.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {

        setSnackbar({
          open: true,
          message: "Server error. Please try again.",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false);
      }
    },
  });

  const dnReceiptFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_dn_fee_payment_date: Yup.date()
        .nullable()
        .typeError("Invalid payment date")
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),
      iv_dn_receipt_image: Yup.mixed().required(
        "Upload paid DN receipt image.",
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (!dnReceiptImageThumbnail?.trim()) {
        setDnReceiptImageError(
          (prev) => prev || "Upload paid DN receipt image.",
        );
        return;
      }

      try {
        setViewBackdrop(true);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: 8,
          objectionStatus: 0,
          remarks: "DN uploaded.",
          remarksDetail: "DN uploaded.",
          submittedThrough: portalName,
          paymentDate: values.iv_dn_fee_payment_date,
          paidDNImage: dnReceiptImageThumbnail,
          lastModifiedBy: "",
          uploadedBy: "",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "meterChangeOrder/uploadMCOPaidDemandNote",
          requestOptions,
        );

        const result = await response.json();

        if (result?.status === "200") {
          setSnackbar({
            open: true,
            message: result?.message || "Approved successfully",
            severity: "success",
          });

          resetForm();
          setDnReceiptImage(null);
          setDnReceiptImageThumbnail(null);
          setDnReceiptImageError(null);
          handleClose();
        } else {
          setSnackbar({
            open: true,
            message: result?.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {

        setSnackbar({
          open: true,
          message: "Server error. Please try again.",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false);
      }
    },
  });

  const fieldItemFormik = useFormik({
    initialValues: {
      iv_fieldItemId: "",
      iv_fieldItemQty: "",
      iv_fieldItemRate: "",
      iv_fieldItemUnit: "",
      iv_fieldItemAmount: "",
      iv_items_array: itemsArray,
    },
    validationSchema: Yup.object().shape({
      iv_fieldItemId: Yup.mixed().required("Select the item from list."),
      iv_fieldItemQty: Yup.number()
        .typeError("Enter qty.")
        .integer("Qty must be a whole number.")
        .moreThan(0, "Qty must be greater than 0.")
        .required("Enter qty."),
      iv_fieldItemRate: Yup.string().optional(),
      iv_fieldItemUnit: Yup.string().optional(),
      iv_fieldItemAmount: Yup.string().optional(),
    }),

    onSubmit: (values, { resetForm }) => {
      let itemToBeAdded = {};
      let arrayOfItems = [...itemsArray];

      const qty = parseInt(values.iv_fieldItemQty, 10);
      const rate = Number(values.iv_fieldItemRate);

      if (!Number.isInteger(qty) || qty <= 0) return;
      if (isNaN(rate) || rate < 0) return;

      itemToBeAdded.item_Code = values.iv_fieldItemId;

      // ✅ Case-insensitive match (handles both Item_Code / item_Code)
      let alreadyPresent = arrayOfItems.find(
        (item) =>
          String(item.item_Code).trim().toLowerCase() ===
          String(itemToBeAdded.item_Code).trim().toLowerCase(),
      );

      if (alreadyPresent) {
        const index = arrayOfItems.findIndex(
          (item) =>
            String(item.item_Code).trim().toLowerCase() ===
            String(itemToBeAdded.item_Code).trim().toLowerCase(),
        );
        const nextQty = arrayOfItems[index].qty + qty;
        const nextRate = getBoqItemRate(arrayOfItems[index].rate);
        arrayOfItems = arrayOfItems.map((item, i) =>
          i === index
            ? {
                ...item,
                qty: nextQty,
                rate: nextRate,
                amount: calculateItemAmount(nextQty, nextRate),
              }
            : item,
        );
      } else {
        // ✅ Handle both cases from backend
        let it = allMaterialList.find(
          (item) =>
            String(item.item_Code || item.Item_Code)
              .trim()
              .toLowerCase() ===
            String(itemToBeAdded.item_Code).trim().toLowerCase(),
        );

        if (it) {
          itemToBeAdded.item_Code = it.item_Code || it.Item_Code;
          itemToBeAdded.Id = itemToBeAdded.item_Code;
          itemToBeAdded.item_Name = it.item_Name || it.Item_Name;
          itemToBeAdded.unit = it.item_Unit || it.Item_Unit;
          itemToBeAdded.rate = getBoqItemRate(
            it.item_Amount || it.Item_Amount,
          );
        } else return;

        itemToBeAdded.qty = qty;
        itemToBeAdded.amount = calculateItemAmount(qty, itemToBeAdded.rate);
        arrayOfItems = [...arrayOfItems, itemToBeAdded];
      }

      const { totalAmountofItems, store_charges, installation_charges } =
        calculateCharges(arrayOfItems, dialogRowData?.applicationId);

      const total_charges =
        totalAmountofItems + store_charges + installation_charges;

      setItemsAmount(totalAmountofItems);
      setStoreCharges(store_charges);
      setInstallationCharges(installation_charges);
      setTotalCharges(total_charges);
      setItemsArray(arrayOfItems);

      resetForm();
    },
  });

  const rcoPart1Formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_fata_pata: Yup.mixed().optional("Select FATA / PATA!"),
      iv_rural_urban: Yup.mixed().required("Select Urban / Rural!"),
      iv_fgovt: Yup.string().optional(
        "Select Federal Govt / Autonomous and Local Bodies under Prov. Govt",
      ),
      iv_cantonment_board: Yup.string().optional("Select Cantonment Board"),
      iv_pgovt: Yup.string().optional(
        "Select Provincial Govt / Autonomous and Local Bodies under Prov. Govt",
      ),
      iv_govt_dept_code: Yup.string().when(["iv_pgovt", "iv_fgovt"], {
        is: (iv_pgovt, iv_fgovt) => Boolean(iv_pgovt || iv_fgovt),
        then: Yup.string().required("Select Govt. Department Code."),
        otherwise: Yup.string().optional(),
      }),
      iv_local_bodies: Yup.string().optional("Select Local Bodies"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      let formdata = new FormData();
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("rcoId", rcoDetails.rcoId);
      formdata.append("urbanRural", values.iv_rural_urban);
      formdata.append("fataPata", values.iv_fata_pata);
      formdata.append("feederNo", refNoAllocationFormik.values.iv_feeder_no);
      formdata.append("batch", refNoAllocationFormik.values.iv_batch);
      formdata.append("subBatch", refNoAllocationFormik.values.iv_sub_batch);
      formdata.append("fGovt", values.iv_fgovt);
      formdata.append("cantonmentBoard", values.iv_cantonment_board);
      formdata.append("pGovt", values.iv_pgovt);
      formdata.append("localBodies", values.iv_local_bodies);
      formdata.append("rcoP1FilledBy", userId);
      formdata.append(
        "consumerAccountNo",
        refNoAllocationFormik.values.iv_reference_to_allot,
      );
      formdata.append("rcoP1FillFlag", 1);
      formdata.append(
        "governmentDepartmentCode",
        values.iv_govt_dept_code && values.iv_govt_dept_code != NaN
          ? values.iv_govt_dept_code
          : "",
      );

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/rcoDataInsertP1", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            if (
              rcoDetails.rcoP1FillFlag === null ||
              rcoDetails.rcoP1FillFlag === 0 ||
              rcoDetails.rcoP1FillFlag === ""
            ) {
              resetForm();
              handleClose();
            } else {
              // resetForm()
              // callRCOApprovePart1API(rcoDetails.rcoId)
              // callChangeProgressIdAPI(8, "RCO Issued", "RCO Issued")
              // setOpen(false)
            }
          } else {
          }
        })
        .catch(() => {});
      setViewBackdrop(false);
    },
  });

  const rcoPart2Formik = useFormik({
    initialValues,
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema: Yup.object().shape({
      iv_store_requisition_no: Yup.string().when("dialogRowData", {
        is: () => isOneYearOld(dialogRowData.disconnectionDate),
        then: Yup.string()
          .required("Enter store requisition no.")
          .min(6, "SRN should be 6 digits.")
          .max(6, "SRN should be 6 digits.")
          .matches(
            /^[1-9][0-9]{5}$/,
            "SRN should be a 6-digit number and cannot start with 0.",
          ),
        otherwise: Yup.string().optional(),
      }),
      iv_store_requisition_date: Yup.date().when("dialogRowData", {
        is: () => isOneYearOld(dialogRowData.disconnectionDate),
        then: Yup.date()
          .max(new Date(), "Requisition date must be in the past.")
          .required("Enter requisition date."),
        otherwise: Yup.date().optional(),
      }),
      iv_sanctioned_load: Yup.number()
        .when([], {
          is: () => dialogRowData.connectionCategory === "Domestic",
          then: Yup.number()
            .min(3, "Load can't be less than 3.")
            .max(1000, "Residential Maximum Load 1000kW.")
            .optional("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionCategory === "Commercial",
          then: Yup.number()
            .min(3, "Load can't be less than 3.")
            .max(5000, "Commercial Maximum Load 5000kW.")
            .optional("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionCategory === "Industrial",
          then: Yup.number()
            .min(3, "Load can't be less than 3.")
            .optional("Enter sanctioned load."),
        })
        .when([], {
          is: () => dialogRowData.connectionCategory === "Agriculture",
          then: Yup.number()
            .min(3, "Load can't be less than 3.")
            .max(5000, "Applied load cannot be more than 5000kW.")
            .optional("Enter sanctioned load."),
        })
        .when([], {
          is: () =>
            [
              "Tubewell",
              "Temporary",
              "GeneralServices",
              "Electrification",
              "StreetLight",
              "CorporateCompany",
            ].includes(dialogRowData.connectionCategory),
          then: Yup.number()
            .min(3, "Load can't be less than 3.")
            .max(5000, "Applied load cannot be more than 5000kW.")
            .optional("Enter sanctioned load."),
        })
        .optional("Enter sanctioned load."),
      iv_seasonal_flag: Yup.mixed().when("phase", {
        is: () => phase != "Single Phase" || phase != "3 Phase",
        then: Yup.mixed().required("Select seasonal / non seasonal value."),
        otherwise: Yup.mixed().optional(),
      }),
      iv_meter_range: Yup.number("Range should be a number.")
  .min(4, "Range can't be less than 4.")
  .max(8, "Range can't be greater than 8.")
  .required("Enter meter range."),
      iv_meter_code1: Yup.string().when("iv_total_kwh", {
        is: "1",
        then: Yup.string()
          .oneOf(["000002"], "For Total kWh 1, meter code must be 000002.")
          .required("Enter meter code."),
        otherwise: Yup.string().when("iv_total_kwh", {
          is: (value) => Number(value) >= 2,
          then: Yup.string()
            .oneOf(
              ["050502"],
              "For Total kWh 2 or greater, meter code must be 050502.",
            )
            .required("Enter meter code."),
          otherwise: Yup.string()
            .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.")
            .test(
              "valid-start",
              "The first two digits must be 00, 01, 02, 03, 04, or 05.",
              (value) => {
                if (!value) return false;
                const firstTwoDigits = parseInt(value.substring(0, 2), 10);
                return [0, 1, 2, 3, 4, 5].includes(firstTwoDigits);
              },
            )
            .test(
              "validate-3rd-digit",
              "The 3rd digit must be 0, 1, 2.",
              (value) => {
                if (!value) return false;
                const thirdDigit = parseInt(value.substring(2, 3), 10);
                return [0, 1, 2].includes(thirdDigit);
              },
            )
            .test(
              "validate-4th-digit",
              "The 4th digit must be 1, 2, 6, 7.",
              (value) => {
                if (!value) return false;
                const fourthDigit = parseInt(value.substring(3, 4), 10);
                return [1, 2, 6, 7].includes(fourthDigit);
              },
            )
            .test(
              "last-digits",
              "The last 2 digits must be 00, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13.",
              (value) => {
                if (!value) return false;
                const lastDigits = parseInt(value.substring(4), 10);
                return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(
                  lastDigits,
                );
              },
            )
            .required("Enter meter code."),
        }),
      }),
      iv_meter_code2: Yup.string().when("iv_total_kwh", {
        is: (value) => Number(value) >= 2,
        then: Yup.string()
          .oneOf(
            ["050602"],
            "For Total kWh 2 or greater, meter code must be 050602.",
          )
          .required("Enter meter code."),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_transformer_code: Yup.string().optional(),
      iv_location_code: Yup.mixed().required("Select location."),
      iv_manufacturer_code: Yup.string().required("Select Manufacturer."),
      iv_meter_serial_no: Yup.string()
        .required("Enter meter number.")
        .min(7, "Meter no. should be 7 digits.")
        .max(15, "Meter no. should be 15 digits.")
        .matches(/^[0-9]+$/, "Meter no. should be number only."),
      // iv_meter_reading: Yup.string().when("phase", {
      //   is: () => phase === "Single Phase",
      //   then: Yup.string()
      //     .max(9, "Meter reading can not be more than 999999999.")
      //     .min(1, "Meter reading can not be less than 1.")
      //     .required("Enter meter reading.")
      //     .matches(/^[0-9]+$/, "Enter meter reading in numbers."),
      //   otherwise: Yup.string().optional(),
      // }),
      // iv_meter_reading_peak_kwh: Yup.string().when("phase", {
      //   is: () => phase != "Single Phase",
      //   then: Yup.string()
      //     .required("Enter peak reading.")
      //     .test(
      //       "is-decimal",
      //       "Enter peak reading in numbers with up to 3 decimal places.",
      //       (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
      //     ),
      //   otherwise: Yup.string().optional(),
      // }),
      // iv_meter_reading_off_peak_kwh: Yup.string().when("phase", {
      //   is: () => phase != "Single Phase",
      //   then: Yup.string()
      //     .required("Enter off peak reading.")
      //     .test(
      //       "is-decimal",
      //       "Enter off peak reading in numbers with up to 3 decimal places.",
      //       (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
      //     ),
      //   otherwise: Yup.string().optional(),
      // }),
      // iv_meter_reading_peak_kvarh: Yup.string().when("phase", {
      //   is: () => phase != "Single Phase" && phase != "3 Phase",
      //   then: Yup.string()
      //     .required("Enter peak reading.")
      //     .test(
      //       "is-decimal",
      //       "Enter peak reading in numbers with up to 3 decimal places.",
      //       (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
      //     ),
      //   otherwise: Yup.string().optional(),
      // }),
      // iv_meter_reading_off_peak_kvarh: Yup.string().when("phase", {
      //   is: () => phase != "Single Phase" && phase != "3 Phase",
      //   then: Yup.string()
      //     .required("Enter peak reading.")
      //     .test(
      //       "is-decimal",
      //       "Enter off peak reading in numbers with up to 3 decimal places.",
      //       (value) => /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
      //     ),
      //   otherwise: Yup.string().optional(),
      // }),
      iv_date_of_connection: Yup.date()
        .max(new Date(), "Connection date must be in the past.")
        .required("Enter connection date."),
      iv_connection_installer_name: Yup.string()
        .required("Enter installed by name.")
        .max(30, "Name should be less than 30 characters."),
      iv_installed_meter_image: Yup.string().optional("Upload meter image."),
      iv_meter_type: Yup.mixed().required("Select meter type!"),
      iv_ct_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Nom in whole numbers greater than 0.",
          )
          .test(
            "is-positive",
            "CT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "ct-standard-values",
            "The CT Nom must be 100, 200, 300, 400, 600, 800, 1000.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const ctNom = parseInt(value, 10);
              return [100, 200, 300, 400, 600, 800, 1000].includes(ctNom);
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_ct_denom: Yup.string().when("phase", {
        is: (phase) => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Denom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Denom in whole numbers greater than 0.",
          )
          .test(
            "is-positive",
            "CT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "is-less-than-nom",
            "CT Denom must be less than CT Nom.",
            function (value) {
              const { iv_ct_nom } = this.parent; // Access sibling field
              if (!iv_ct_nom || !value) return true; // Skip validation if either value is missing
              return (
                (iv_ct_nom == 1 && value == 1) ||
                parseInt(value, 10) < parseInt(iv_ct_nom, 10)
              );
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Nom in natural numbers greater than 0.",
          )
          .test(
            "is-positive",
            "PT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "is-less-than-nom",
            "PT Denom must be less than PT Nom.",
            function (value) {
              const { iv_pt_nom } = this.parent; // Access sibling field
              if (!iv_pt_nom || !value) return true; // Skip validation if either value is missing
              return parseInt(value, 10) >= parseInt(iv_pt_nom, 10);
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_denom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Denom in natural numbers greater than 0.",
          )
          .test(
            "is-positive",
            "PT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_mdi: Yup.string().when("phase", {
        is: () => shouldCaptureMdiValues,
        then: Yup.string()
          .required("Enter MDI cumulative reading.")
          .matches(
            /^[1-9]\d*$/,
            "Enter MDI cumulative reading in numbers greater than 0.",
          )
          .test(
            "is-positive",
            "MDI cumulative reading must be greater than 0.",
            (value) => parseFloat(value) > 0,
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_no_of_mdi_resets: Yup.string().when("phase", {
        is: () => shouldCaptureMdiValues,
        then: Yup.string()
          .max(5, "No. of MDI reset can not be more than 99999.")
          .min(1, "No. of MDI reset can not be less than 1.")
          .required("Enter No. of MDI reset.")
          .matches(/^[0-9]+$/, "Enter No. of MDI reset in numbers."),
        otherwise: Yup.string().optional().nullable(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: dialogRowData.applicationProgressId,
        objectionStatus: dialogRowData.objectionStatus,
        lastModifiedBy: userId,
        remarks: "Meter Installed",
        urbanRural: "",
        fataPata: "",
        feederNo: "",
        batch: "",
        subBatch: "",
        fGovt: "",
        governmentDepartmentCode: "",
        cantonmentBoard: "",
        pGovt: "",
        localBodies: "",
        authorizedByName: "",
        authorizedByDesignation: "",
        dateOfAuthorization: "2024-01-01T00:00:00",
        storeRequisitionNo: values.iv_store_requisition_no,
        storeRequisitionDate: values.iv_store_requisition_date
          ? values.iv_store_requisition_date
          : null,
        seasonalFlag: 0,
        sanctionedLoad: 0.0,
        noOfACs: "",
        noOfMeters: "",
        noOfMeterSets: "",
        noOfSubSets: "",
        noOfSupplyPoints: "",
        installedTransformerCapacity: values.iv_transformer_code,
        meterId: values.iv_meter_id,
        meterNo: values.iv_meter_serial_no,
        locationCode: values.iv_location_code,
        meterCode1: values.iv_meter_code1,
        meterCode2: values.iv_meter_code2,
        manufacturerCode: values.iv_manufacturer_code,
        multiplyingFactor: calculateMF(
          values.iv_ct_nom,
          values.iv_ct_denom,
          values.iv_pt_nom,
          values.iv_pt_denom,
        ),
        meterRange: values.iv_meter_range,
        meterReading: phase === "Single Phase" ? values.iv_meter_reading : "",
        dateOfReConnection: values.iv_date_of_connection,
        cp78ItemNo: "",
        tieUpNonTieUp: "",
        sealOnMeter: "",
        sealOnBox: "",
        securitySlipOrPriceBondNo: "",
        connectionInstallerName: values.iv_connection_installer_name,
        rcoP2FilledBy: userId,
        rcoP2FillingDate: "",
        rcoP2FillFlag: 1,
        installedMeterImage: installedMeterImageThumbnail,
        meterType: values.iv_meter_type,
        threePhasePeak:
          phase === "3 Phase" ? values.iv_meter_reading_peak_kwh : "",
        threePhaseOffPeak:
          phase === "3 Phase" ? values.iv_meter_reading_off_peak_kwh : "",
        mdi: shouldCaptureMdiValues ? values.iv_mdi : "",
        noOfMdiReset:
          shouldCaptureMdiValues
            ? values.iv_no_of_mdi_resets
            : "",
        ct:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_ct_nom / values.iv_ct_denom
            : "",
        ctD:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_ct_denom
            : "",
        ctN:
          phase != "Single Phase" && phase != "3 Phase" ? values.iv_ct_nom : "",
        pt:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_pt_nom / values.iv_pt_denom
            : "",
        ptD:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_pt_denom
            : "",
        ptN:
          phase != "Single Phase" && phase != "3 Phase" ? values.iv_pt_nom : "",
        threePhasePeakKvarh:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_peak_kvarh
            : "",
        threePhaseOffPeakKvarh:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_off_peak_kwh
            : "",
        threePhasePeakKwh:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_peak_kwh
            : "",
        threePhaseOffPeakKwh:
          phase != "Single Phase" && phase != "3 Phase"
            ? values.iv_meter_reading_off_peak_kwh
            : "",
      });

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: "POST",
        body: raw,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "rco/submitRCOMeterInfo", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            // if (rcoDetails.rcoP2FillFlag === null || rcoDetails.rcoP2FillFlag === 0) {
            //   resetForm()
            //   handleClose()
            // }
            // else {
            resetForm();
            callRCOApprovePart2API(rcoDetails.rcoId);
            setRcoPopUp(true);
            // }
          } else {
          }
        })
        .catch(() => {});
    },
  });

  const masterDataFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_govt_dept: Yup.mixed().required("Select Govt Dept."),
      iv_ed_code: Yup.mixed().required("Select Electricity Duty code."),
      iv_standard_classification_code: Yup.mixed().required(
        "Select Std. classification code.",
      ),
      iv_income_tax: Yup.mixed().required("Select Income tax value."),
    }),

    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: 12,
          objectionStatus: 0,
          remarks: "Completed",
          remarksDetail: "Completed",
          governmentDepartmentCode: values.iv_govt_dept,
          EDCode: values.iv_ed_code,
          stdClassCode: values.iv_standard_classification_code,
          incomeTax: values.iv_income_tax,
        });

        const response = await fetch(
          cfpBaseUrl + "rco/processReadyForBilling",
          {
            method: "POST",
            headers: myHeaders,
            body: raw,
          },
        );

        const result = await response.json();

        if (result?.status === 200 || result?.status === "200") {
          setSnackbar({
            open: true,
            message: result?.message || "Approved successfully",
            severity: "success",
          });

          resetForm();
        } else {
          setSnackbar({
            open: true,
            message: result?.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {
        setSnackbar({
          open: true,
          message: "Server error. Please try again.",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false); // ✅ HIDE loader (ALWAYS)
      }
    },
  });

  const arearBillDocumentFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_arear_paid_bill_document: Yup.mixed().required(
        "Upload arrears paid bill document!",
      ),
      iv_arear_paid_bill_date: Yup.string().required(
        "Enter date on which arrears are paid!",
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      var raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        paidBillDate: values.iv_arear_paid_bill_date,
        paidBillImage: arearPaidBillDocumentThumbnail,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "comman/updateENCArearPaidBillImage",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            callChangeObjectionStatus(
              0,
              "Arrears Objection Removed",
              "Arrears Paid by consumer",
            );
            callChangeProgressIdAPI(
              3,
              "Arrears Verified.",
              "Arrears Verified.",
              "",
              dialogRowData.applicationId,
            );
            resetForm();
            handleClose();
          } else {
          }
        })
        .catch(() => {});
    },
  });

  const editBasicInfoFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_applicant_name: yupSafePersonName(Yup.string().required("Enter applicant name.")),
      iv_applicant_cnic: Yup.string().required("Enter applicant CNIC."),
      iv_applicant_phone: Yup.string().required("Enter applicant phone no."),
      iv_applicant_email: Yup.string().optional("Enter applicant email."),
      iv_address: yupSafeAddress(Yup.string().optional("Enter applicant address.")),
      iv_relative_name: yupSafePersonName(Yup.string().required("Enter relative name.")),
      iv_owner_name: Yup.string().when("dialogRowData", {
        is: () => dialogRowData.applicantStatus === "Tenant",
        then: yupSafePersonName(Yup.string().required("Enter owner name.")),
        otherwise: Yup.string().optional(),
      }),
      iv_owner_cnic: Yup.string().when("dialogRowData", {
        is: () => dialogRowData.applicantStatus === "Tenant",
        then: Yup.string().required("Enter owner CNIC."),
        otherwise: Yup.string().optional(),
      }),
      iv_owner_phone: Yup.string().when("dialogRowData", {
        is: () => dialogRowData.applicantStatus === "Tenant",
        then: Yup.string().required("Enter owner phone no."),
        otherwise: Yup.string().optional(),
      }),
      iv_owner_email: Yup.string().when("dialogRowData", {
        is: () => dialogRowData.applicantStatus === "Tenant",
        then: Yup.string().optional("Enter owner email."),
        otherwise: Yup.string().optional(),
      }),
      iv_city_district: Yup.string()
        .required("Please select a city.")
        .oneOf(cities ? cities : [], "Please select a valid option"),
      // Urban
      iv_house: Yup.string().when("iv_area_type", {
        is: () => dialogRowData.areaType === "Urban",
        then: Yup.string()
          .matches(
            /^[a-zA-Z0-9\s]*$/,
            "House must be alphanumeric characters only.",
          )
          .max(50, "House must be less than 50 character")
          .required("Enter house."),
        otherwise: Yup.string(),
      }),
      iv_street: Yup.string().when("iv_area_type", {
        is: () => dialogRowData.areaType === "Urban",
        then: Yup.string()
          .matches(
            /^[a-zA-Z0-9\s]*$/,
            "Street must be alphanumeric characters only.",
          )
          .max(50, "Street must be less than 50 character")
          .required("Enter street."),
        otherwise: Yup.string(),
      }),
      iv_sector_block_phase_mohala: Yup.string().when("iv_area_type", {
        is: () => dialogRowData.areaType === "Urban",
        then: Yup.string()
          .max(50, "Sector/Block must be less than 50 character")
          .required("Please enter sector/block."),
        otherwise: Yup.string(),
      }),
      iv_town_tehsil: Yup.string()
        .max(50, "Town / Tehsil must be less than 50 character")
        .required("Please enter town."),
      // Rural
      iv_chak_street: Yup.string().when("iv_area_type", {
        is: () => dialogRowData.areaType === "Rural",
        then: Yup.string()
          .max(50, "Chak / Street must be less than 50 character")
          .required("Please enter chak / street."),
        otherwise: Yup.string(),
      }),
      iv_village: Yup.string().when("iv_area_type", {
        is: () => dialogRowData.areaType === "Rural",
        then: Yup.string()
          .max(50, "Village must be less than 50 character")
          .required("Please enter village."),
        otherwise: Yup.string(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const formdata = new FormData();
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("applicantName", values.iv_applicant_name);
      formdata.append("applicantCNIC", values.iv_applicant_cnic);
      formdata.append("applicantEmail", values.iv_applicant_email);
      formdata.append("applicantMobile", values.iv_applicant_phone);
      formdata.append(
        "applicantRelationType",
        dialogRowData.applicantRelationType,
      );
      formdata.append("applicantRelativeName", values.iv_relative_name);
      if (
        dialogRowData.applicantStatus === "Owner" ||
        dialogRowData.applicantStatus === "owner"
      ) {
        formdata.append("ownerName", values.iv_applicant_name);
        formdata.append("ownerCNIC", values.iv_applicant_cnic);
        formdata.append("ownerMobile", values.iv_applicant_phone);
        formdata.append("ownerEmail", values.iv_applicant_email);
      } else if (
        dialogRowData.applicantStatus === "Tenant" ||
        dialogRowData.applicantStatus === "tenant"
      ) {
        formdata.append("ownerName", values.iv_owner_name);
        formdata.append("ownerCNIC", values.iv_owner_cnic);
        formdata.append("ownerMobile", values.iv_owner_phone);
        formdata.append("ownerEmail", values.iv_owner_email);
      }
      formdata.append("houseNo", values.iv_house);
      formdata.append("streetNo", values.iv_street);
      formdata.append(
        "sectorBlockPhaseMohalah",
        values.iv_sector_block_phase_mohala,
      );
      formdata.append("chakStreet", values.iv_chak_street);
      formdata.append("village", values.iv_village);
      formdata.append("townTehsil", values.iv_town_tehsil);
      formdata.append("cityDistrict", values.iv_city_district);
      if (
        dialogRowData.areaType === "Urban" ||
        dialogRowData.areaType === "urban"
      ) {
        formdata.append(
          "premisesAddress",
          values.iv_house.concat(
            " " +
              values.iv_street +
              " ," +
              values.iv_sector_block_phase_mohala +
              " ," +
              values.iv_town_tehsil +
              " ," +
              values.iv_city_district,
          ),
        );
      }
      if (
        dialogRowData.areaType === "Rural" ||
        dialogRowData.areaType === "rural"
      ) {
        formdata.append(
          "premisesAddress",
          values.iv_chak_street.concat(
            " " +
              values.iv_village +
              " ," +
              values.iv_town_tehsil +
              " ," +
              values.iv_city_district,
          ),
        );
      }
      formdata.append("lastModifiedBy", userId);
      formdata.append("remarks", "Applicant Info Updated.");
      formdata.append("remarksDetail", "");

      const requestOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl +
          "electricityNewConnection/updateNewConnectionApplicantInfo",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            resetForm();
            setShowEditPopup(false);
            handleClose();
          }
        })
        .catch(() => {});
      setViewBackdrop(false);
    },
  });
  //#endregion

  //#region useEffects

  useEffect(() => {
    callTariffList();
    callMaterials();
  }, []);

  // useEffect(() => {
  //   if (dialogRowData) {
  //     if (!dialogRowData.isNetBillPaid && (!dialogRowData.isReferedToFeildSurvey || !isReferedToFeildSurvey)) {
  //       setRcoStatusBarArray(RCOStatusBarArrayWithArrearsVerificationAndWithOutReferedToFieldVerification)
  //     } else if (dialogRowData.isNetBillPaid && (!dialogRowData.isReferedToFeildSurvey || !isReferedToFeildSurvey)) {
  //       setRcoStatusBarArray(RCOStatusBarArrayWithOutArrearsVerificationAndWithOutReferedToFieldVerification)
  //     } else if (dialogRowData.isNetBillPaid && (dialogRowData.isReferedToFeildSurvey || isReferedToFeildSurvey)) {
  //       setRcoStatusBarArray(RCOStatusBarArrayWithOutArrearsVerificationAndWithOutReferedToFieldVerification)
  //     }
  //   }
  // }, [isReferedToFeildSurvey, dialogRowData])

  useEffect(() => {
    if (reconnectionApplications && allTariffList) {
      apiToDataGridConversionNormal();
    }
  }, [allTariffList, reconnectionApplications]);

  useEffect(() => {
    if (reconnectionApplicationsOverDue && allTariffList) {
      apiToDataGridConversionOverdue();
    }
  }, [allTariffList, reconnectionApplicationsOverDue]);

  useEffect(() => {
    if (
      dialogRowData?.connectionCategory &&
      refNoAllocationFormik.values.iv_batch
    ) {
      if (
        dialogRowData.connectionCategory == "Domestic" ||
        dialogRowData.connectionCategory == "Commercial"
      ) {
        if (
          batchArrayIndustrial.includes(refNoAllocationFormik.values.iv_batch)
        ) {
          setBatchError(
            dialogRowData.connectionCategory +
              " connection should have batch in " +
              batchArrayGeneralString,
          );
        } else {
          setBatchError(null);
        }
      } else {
        if (batchArrayGeneral.includes(refNoAllocationFormik.values.iv_batch)) {
          setBatchError(
            dialogRowData.connectionCategory +
              " connection should have batch in " +
              batchArrayIndustrialString,
          );
        } else {
          setBatchError(null);
        }
      }
    }
  }, [
    dialogRowData?.connectionCategory,
    refNoAllocationFormik.values.iv_batch,
  ]);

  // useEffect(() => {
  //   if (referenceNumberToAllot) {
  //     if (referenceNumberToAllot.length === 7) {
  //       refNoAllocationFormik.values.iv_reference_to_allot = partialValue + referenceNumberToAllot
  //     }
  //     else {
  //       refNoAllocationFormik.values.iv_reference_to_allot = partialValue
  //     }
  //   }
  // }, [referenceNumberToAllot])

  useEffect(() => {
    const checkRefNo = async () => {
      if (
        refNoAllocationFormik.values.iv_batch &&
        refNoAllocationFormik.values.iv_reference_to_allot
      ) {
        let refNo = refNoAllocationFormik.values.iv_batch
          .concat(partialValue)
          .concat(refNoAllocationFormik.values.iv_reference_to_allot);
        if (refNo.length === 14) {
          setViewBackdrop(true);
          let apiResponse = await dBillAPI(token, refNo);
          if (apiResponse.status) {
            setRefNoAlreadyAllocatedError("Reference No. already allocated!");
          } else {
            setRefNoAlreadyAllocatedError("");
          }
          setViewBackdrop(false);
        }
      }
    };
    checkRefNo();
  }, [
    refNoAllocationFormik.values.iv_batch,
    refNoAllocationFormik.values.iv_reference_to_allot,
  ]);

  useEffect(() => {
    if (dialogRowData?.subDivisionCode) {
      setPartialValue(dialogRowData.subDivisionCode);
    }
  }, [dialogRowData?.subDivisionCode]);

  useEffect(() => {
    const { iv_fieldItemId } = fieldItemFormik.values;

    if (iv_fieldItemId && allMaterialList?.length > 0) {
      const item = allMaterialList.find(
        (it) =>
          String(it.item_Code || it.Item_Code)
            .trim()
            .toLowerCase() === String(iv_fieldItemId).trim().toLowerCase(),
      );

      if (item) {
        fieldItemFormik.setFieldValue(
          "iv_fieldItemRate",
          normalizeItemRate(item.item_Amount || item.Item_Amount || 0),
        );
        fieldItemFormik.setFieldValue(
          "iv_fieldItemUnit",
          item.item_Unit || item.Item_Unit || "",
        );
      } else {
        fieldItemFormik.setFieldValue("iv_fieldItemRate", "");
        fieldItemFormik.setFieldValue("iv_fieldItemUnit", "");
      }
    }
  }, [fieldItemFormik.values.iv_fieldItemId, allMaterialList]);

  useEffect(() => {
    if (foundId && foundId !== "") {
      setFoundInNc(foundId);
    }
  }, [foundId]);

  useLayoutEffect(() => {
    if (foundInNc) {
      handleRowClick(foundInNc);
    }
  }, [foundInNc]);

  //#endregion

  useImperativeHandle(ref, () => ({
    handleRowClick,
  }));

  const calculateMF = (ctNom, ctDenom, ptNom, ptDenom) => {
    let mf = (ctNom / ctDenom) * (ptNom / ptDenom);
    return mf;
  };

  const [uploadedImages, setUploadedImages] = useState([]);
  const [thumbnails, setThumbnails] = useState([]); // Base64 previews
  const [errors, setErrors] = useState([]); // Validation errors

  const handleImageUpload = async (event, index) => {
    await handleFileUpload(
      event,
      () => {}, // No additional handleChange logic required
      (renamedFile) => {
        const updatedImages = [...uploadedImages];
        updatedImages[index] = renamedFile;
        setUploadedImages(updatedImages);
      },
      (error) => {
        const updatedErrors = [...errors];
        updatedErrors[index] = error;
        setErrors(updatedErrors);
      },
      (thumbnail) => {
        const updatedThumbnails = [...thumbnails];
        updatedThumbnails[index] = thumbnail;
        setThumbnails(updatedThumbnails);
      },
      `image_${index + 1}.${event.target.files[0]?.name.split(".").pop()}`,
    );
  };

  const handleRemoveImage = (index) => {
    const updatedImages = [...uploadedImages];
    const updatedThumbnails = [...thumbnails];
    const updatedErrors = [...errors];

    updatedImages[index] = null;
    updatedThumbnails[index] = null;
    updatedErrors[index] = "";

    setUploadedImages(updatedImages);
    setThumbnails(updatedThumbnails);
    setErrors(updatedErrors);
  };

  const location = useLocation();
  const currentPath = location.pathname;

  const tblColumnsArrears = [
    {
      field: "refNo",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Reference No.",
      align: "center",
      headerStyle: { ...tableStyle.headerStyle, width: "3000px" },
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "arrearsAmount",
      type: "text",
      sortable: false,
      filterable: false,
      headerName: "Arrears",
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "netBillAmount",
      headerName: "Net Bill",
      sortable: false,
      filterable: false,
      type: "text",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "billingMonth",
      type: "text",
      headerName: "Bill Month",
      sortable: false,
      filterable: false,
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
  ];

  const arrearPaymentReceiptFormik = useFormik({
    initialValues: {
      iv_arrear_paid_bill_document: "",
      iv_arrear_payment_date: "",
      iv_remarks_detail: "",
    },

    validationSchema: Yup.object().shape({
      iv_arrear_paid_bill_document: Yup.mixed().required(
        "Upload Paid Bill receipt image.",
      ),
      iv_arrear_payment_date: Yup.date()
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),

      iv_remarks_detail: Yup.string()
        .trim()
        .min(10, "Remarks must be at least 10 characters")
        .required("Remarks details are required!"),
    }),

    onSubmit: (values) => {
      callArrearVerificationAPI(
        dialogRowData.applicationId,
        dialogRowData.applicationProgressId + 1,
        0,
        "Arrear Verified.",
        values.iv_remarks_detail,
        arrearAmount,
        values.iv_arrear_payment_date,
        billMonth,
        arearPaidBillDocumentThumbnail,
      );
    },
  });

  const arrearPaymentObjectionReceiptFormik = useFormik({
    initialValues: {
      iv_obj_arrear_paid_bill_document: "",
      iv__obj_arrear_payment_date: "",
      iv_obj_remarks_detail: "",
    },

    validationSchema: Yup.object().shape({
      iv_obj_arrear_paid_bill_document: Yup.mixed().required(
        "Upload Paid Bill receipt image.",
      ),
      iv__obj_arrear_payment_date: Yup.date()
        .max(new Date(), "Payment date must be in the past!")
        .required("Payment date is required!"),

      iv_obj_remarks_detail: Yup.string()
        .trim()
        .min(10, "Remarks must be at least 10 characters")
        .required("Remarks details are required!"),
    }),

    onSubmit: (values) => {
      callArrearVerificationAPI(
        dialogRowData.applicationId,
        dialogRowData.applicationProgressId + 1,
        0,
        "Arrear Verified.",
        values.iv_obj_remarks_detail,
        arrearAmount,
        values.iv__obj_arrear_payment_date,
        billMonth,
        arearPaidBillDocumentThumbnail,
      );
    },
  });

  const meterInstallationFormik = useFormik({
    initialValues: {
      iv_installed_meter_img: "",
      iv_installed_meter_date: "",
    },

    validationSchema: Yup.object().shape({
      iv_installed_meter_img: Yup.mixed()
        .required("Meter image is required.")
        .test("file-present", "Meter image is required.", (value) => !!value),
      iv_installed_meter_date: Yup.date()
        .max(new Date(), "Installation date must be in the past!")
        .required("Installation date is required!"),
    }),

    onSubmit: async (values) => {
      try {
        setViewBackdrop(true);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          objectionStatus: 0,
          applicationProgressId: 10,
          remarks: "RCO Meter Installed.",
          remarksDetail: "RCO Meter Installed.",
          submittedThrough: portalName,
          storeRequisitionNo: null,
          storeRequisitionDate: null,
          meterReinstalledAt: values.iv_installed_meter_date,
          reinstalledMeterImage: installedMeterImgThumbnail,
          meterProfile: disconnectedMeterDetails,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "rco/processRCOMeterProfileWithinAYear",
          requestOptions,
        );

        const result = await response.json();

        if (result.status == 200) {
          setSnackbar({
            open: true,
            message: result.message,
            severity: "success",
          });
        } else {
          setSnackbar({
            open: true,
            message: result.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {
        setSnackbar({
          open: true,
          message: "Failed to submit data",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false); // Hide loader
      }
    },
  });

  const callArrearVerificationAPI = async (
    applicationId,
    applicationProgresId,
    objectionStatuss,
    remarks,
    remarksDetails,
    arrearsAmount,
    arrearsPaymentDate,
    arrearsMonth,
    paidBillImage,
  ) => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: applicationId,
      applicationProgressId: applicationProgresId,
      objectionStatus: objectionStatuss,
      remarks: remarks,
      remarksDetail: remarksDetails,
      arrearsAmount: arrearsAmount,
      arrearsPaymentDate: arrearsPaymentDate,
      arrearsMonth: arrearsMonth,
      paidBillImage: arrearsAmount > 0 ? paidBillImage : "",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "meterChangeOrder/processMCOArrearsVerification",
        requestOptions,
      );

      const result = await response.json();

      if (result.status === "200") {
        handleClose();
        setSnackbar({
          open: true,
          message: result.message,
          severity: "success",
        });
        setPaymentStatus("");
        setBillMonth("");
        setArrearAmount("");
      } else {
        handleClose();
        setSnackbar({
          open: true,
          message: result.message,
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Something went wrong! Please try again.",
        severity: "error",
      });
      setOpenResponseModal(true);
    } finally {
      setViewBackdrop(false);
    }
  };

  const processRCOFeeVoucher = async (type, remarksDetail = null) => {
    const isApprove = type === "approve";

    // Start Loader
    setViewBackdrop(true);

    const payload = {
      applicationId: rcoFeeVoucherDetails?.applicationId,
      applicationProgressId: isApprove ? 4 : 3,
      objectionStatus: isApprove ? 0 : 1,
      remarks: isApprove
        ? "RCO Fee Voucher Approved."
        : "RCO Fee Voucher Rejected.",
      remarksDetail: isApprove
        ? "RCO Fee Voucher Approved Successfully."
        : remarksDetail,
    };

    try {
      const response = await fetch(cfpBaseUrl + "rco/processRCOFeeVoucher", {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      // Stop loader here because we WILL show snackbar
      setViewBackdrop(false);

      if (result.status == 200) {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "error",
        });
      }

      return result;
    } catch (error) {

      // Stop loader on error
      setViewBackdrop(false);

      setSnackbar({
        open: true,
        message: "Something went wrong!",
        severity: "error",
      });
    }
  };

  const RCOFeeVoucherVerification = async (type, remarksDetail) => {
    const isApprove = type === "approve";
    let applicationProgressId = 3;

    if (dialogRowData?.isDiscAboveAYear && isApprove) {
      applicationProgressId = 5;
    } else if (!dialogRowData?.isDiscAboveAYear && isApprove) {
      applicationProgressId = 9;
    }

    const payload = {
      applicationId: rcoFeeVoucherDetails?.applicationId,
      applicationProgressId: applicationProgressId,
      objectionStatus: isApprove ? 0 : 1,
      remarks: isApprove
        ? "RCO fee voucher verified."
        : "RCO fee voucher rejected.",
      remarksDetail: remarksDetail,
    };

    try {
      // ✅ START LOADER
      setViewBackdrop(true);

      const response = await fetch(
        cfpBaseUrl + "rco/verifyOrRejectPaidRCOFeeVoucher",
        {
          method: "POST",
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      // Stop loader before showing snackbar
      setViewBackdrop(false);

      if (result.status == 200) {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "error",
        });
      }

      return result;
    } catch (error) {

      // Stop loader here also
      setViewBackdrop(false);

      setSnackbar({
        open: true,
        message: "Something went wrong!",
        severity: "error",
      });
    }
  };

  const DNFeeVoucherVerification = async (type, remarksDetail) => {
    const isApprove = type === "approve";
    let applicationProgressId = isApprove ? 9 : 7;

    const payload = {
      applicationId: dnApproveStep?.applicationId,
      applicationProgressId: applicationProgressId,
      objectionStatus: isApprove ? 0 : 1,
      remarks: isApprove ? "DN Payment Verified." : "DN Payment rejected.",
      remarksDetail: remarksDetail,
    };

    try {
      // ✅ START LOADER
      setViewBackdrop(true);

      const response = await fetch(
        cfpBaseUrl + "meterChangeOrder/verifyOrRejectPaidMCODemandNote",
        {
          method: "POST",
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      // Stop loader before showing snackbar
      setViewBackdrop(false);

      if (result.status == 200) {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: result.message,
          severity: "error",
        });
      }

      return result;
    } catch (error) {

      // Stop loader here also
      setViewBackdrop(false);

      setSnackbar({
        open: true,
        message: "Something went wrong!",
        severity: "error",
      });
    }
  };

  const onPressViewActivityLog = async () => {
    if (dialogRowData.applicationProgressId >= 3) {
      callAsyncGetDocumentsAPI(dialogRowData.applicationId);
    }
    await callEfileAPI(dialogRowData.applicationId, dialogRowData);
  };

  const minDistance = 41;

  const fieldFormik = useFormik({
    initialValues,
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema: Yup.lazy((values) => {
      const isRejected = values.iv_objection_Type === 1;
      const anyOtherReasonId =
        meterFaults &&
        meterFaults.find((fault) => fault.faultName === "Any other reason")
          ?.faultId;
      return Yup.object().shape({
        iv_objection_Type: Yup.string().required("Select site observation."),
        iv_meter_type: isRejected
          ? Yup.mixed().optional()
          : Yup.mixed().required("Select meter type!"),
        isReadingAccessible: isRejected
          ? Yup.string().optional()
          : Yup.string()
              .oneOf(["1", "0"])
              .required("Select if reading is accessible!"),
        isReferToMst: isRejected
          ? Yup.string().optional()
          : Yup.string().oneOf(["1", "0"]).required("Select if refer to M&T!"),
        isMeterAvailable: isRejected
          ? Yup.string().optional()
          : Yup.string().when([], {
              is: () => values.iv_objection_Type === 2,
              then: Yup.string()
                .oneOf(["1", "0"])
                .required("Select if Meter Avaiable!"),
              otherwise: Yup.string().optional(),
            }),
        isDefectiveCode: isRejected
          ? Yup.string().optional()
          : Yup.string().when([], {
              is: () => values.iv_objection_Type === 3,
              then: Yup.string()
                .oneOf(["1", "0"])
                .required("Select defective code!"),
              otherwise: Yup.string().optional(),
            }),
        iv_faultType: isRejected
          ? Yup.string().optional()
          : Yup.string().required("Select meter fault!"),
        iv_faultOtherReason: Yup.string().when("iv_faultType", {
          is: (val) => String(val) === String(anyOtherReasonId),
          then: Yup.string()
            .required("Please specify the reason.")
            .min(10, "Reason must be at least 10 characters."),
          otherwise: Yup.string().optional(),
        }),
      });
    }),
    onSubmit: async (values, { resetForm }) => {
      if (
        (values.iv_objection_Type == 2 && values.isMeterAvailable === "1") ||
        values.iv_objection_Type == 3
      ) {
        const hasEstimate = boqItems && boqItems.length > 0;
        const hasMeterImage = !!meterImageThumbnail;
        if (!hasMeterImage) {
          setSnackbar({
            open: true,
            message: "Meter image is required. Please upload a meter image first.",
            severity: "error",
          });
          setViewBackdrop(false);
          return;
        }
        if (!hasEstimate) {
          setErrormessageCostEstimation("Prepare Estimate is required.");
          setViewBackdrop(false);
          return;
        }
        setShowCostEstimation(true);
        setErrormessageCostEstimation("");
        setViewBackdrop(false);
        return;
      }
      if (values.iv_objection_Type === 1 && meterImageThumbnail) {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId: 4,
          objectionStatus: 1,
          submittedThrough: portalName,
          remarks: "Meter is healthy, MCO Rejected",
          remarksDetail: "Meter is healthy, MCO Rejected",
          siteObservationId: 1,
          meterFaultId: 0,
          defectiveCode: 0,
          isReadingAccessible: false,
          isReferedToMT: false,
          isMeterAvailable: false,
          meterImage: meterImageThumbnail,
          BoQItems: [],
          tariff: dialogRowData.tariffDesc,
          sanctionLoad: dialogRowData.sanctionedLoad,
                  amountOfGridSharing: 0,
          amountOfFeederRehab:0,
          civilWorkCharges: 0,
          fixedChargesOfMetering: 0,
          miscellaneousCharges: 0,
lessTheCost: 0,
          capitalCostAmount: 0,
          mtCharges: 0,
          labourCharges: 0,
          designVetteingFee: 0,
          consultancyCharges: 0,
          variationsCharges: 0,
          dismentalmentCharges: 0,
          earthingCharges: 0,
          serviceConnectionAmount:0,
          bankName: bankName,
          meterType: values.iv_meter_type || "",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(
          cfpBaseUrl + "meterChangeOrder/saveFieldSurveyAndCostEstimateForMCO",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result?.status === "200" || result?.status === 200) {
              setViewBackdrop(false);
              setErrormessageCostEstimation("");
              handleClose();
              setSnackbar({
                open: true,
                message: result?.message || "Submitted successfully",
                severity: "success",
              });
            } else {
              setViewBackdrop(false);
              setErrormessageCostEstimation(result?.message);
              setSnackbar({
                open: true,
                message: result?.message || "Something went wrong",
                severity: "error",
              });
            }
          })
          .catch((error) => {
            setViewBackdrop(false);
            setSnackbar({
              open: true,
              message: "Something went wrong",
              severity: "error",
            });
          });
      } else if (
        values.iv_objection_Type === 2 &&
        values.isMeterAvailable === "0" &&
        meterImageThumbnail
      ) {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          applicationProgressId:
            values.isReferToMst === "0" && values.isMeterAvailable === "0"
              ? 9
              : 5,
          objectionStatus: 0,
          submittedThrough: portalName,
          remarks: "MCO with cost",
          remarksDetail: "MCO with cost",
          siteObservationId: 2,
          meterFaultId: values.iv_faultType,
          defectiveCode: 0,
          isReadingAccessible:
            values.isReadingAccessible === "1" ? true : false,
          isReferedToMT: values.isReferToMst === "1" ? true : false,
          isMeterAvailable: values.isMeterAvailable === "1" ? true : false,
          meterImage: meterImageThumbnail,
          BoQItems: [],
          tariff: dialogRowData.tariffDesc,
          sanctionLoad: dialogRowData.sanctionedLoad,
          amountOfGridSharing: 0,
          amountOfFeederRehab:0,
          civilWorkCharges: 0,
          fixedChargesOfMetering: 0,
          miscellaneousCharges: 0,
lessTheCost: 0,
          capitalCostAmount: 0,
          mtCharges: 0,
          labourCharges: 0,
          designVetteingFee: 0,
          consultancyCharges: 0,
          variationsCharges: 0,
          dismentalmentCharges: 0,
          earthingCharges: 0,
          serviceConnectionAmount:0,
          bankName: bankName,
          meterType: values.iv_meter_type || "",
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(
          cfpBaseUrl + "meterChangeOrder/saveFieldSurveyAndCostEstimateForMCO",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result?.status === "200" || result?.status === 200) {
              setViewBackdrop(false);
              setErrormessageCostEstimation("");
              handleClose();
              setSnackbar({
                open: true,
                message: result?.message || "Submitted successfully",
                severity: "success",
              });
            } else {
              setViewBackdrop(false);
              setErrormessageCostEstimation(result?.message);
              setSnackbar({
                open: true,
                message: result?.message || "Something went wrong",
                severity: "error",
              });
            }
          })
          .catch((error) => {
            setViewBackdrop(false);
            setSnackbar({
              open: true,
              message: "Something went wrong",
              severity: "error",
            });
          });
      } else if (values.iv_objection_Type === 2 && values.isMeterAvailable === "1") {
        if (!meterImageThumbnail) {
          alert({
            open: true,
            message: "Meter image is required. Please upload a meter image first.",
            severity: "error",
          });
          return;
        }
        setShowCostEstimation(true);
      } else if (values.iv_objection_Type === 3) {
        if (!meterImageThumbnail) {
          alert({
            open: true,
            message: "Meter image is required. Please upload a meter image first.",
            severity: "error",
          });
          return;
        }
        setShowCostEstimation(true);
      }
    },
  });

  const dnRejectFormik = useFormik({
    initialValues: {
      reasonType: "",
      remarks: "",
    },
    validationSchema: Yup.object({
      reasonType: Yup.string().required("Please select a reason."),
      remarks: Yup.string()
        .required("Remarks are required.")
        .min(10, "Remarks must be at least 10 characters long."),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        setViewBackdrop(true);

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: dialogRowData.applicationId,
          objectionStatus: 0,
          applicationProgressId: values.reasonType,
          remarks: `Demand Note Issued Rejected`,
          remarksDetail: values.remarks,
          submittedThrough: portalName,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "meterChangeOrder/revertMCOApplication",
          requestOptions,
        );
        const result = await response.json();

        if (result?.status === "200" || result?.status === 200) {
          setSnackbar({
            open: true,
            message: result?.message || "Rejected successfully",
            severity: "success",
          });
          setDnRejectModalOpen(false);
          resetForm();
          handleClose();
        } else {
          setSnackbar({
            open: true,
            message: result?.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {
        setSnackbar({
          open: true,
          message: "Server error. Please try again.",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false);
      }
    },
  });

  useEffect(() => {
    const roundAmount = (value) => Math.round(Number(value) || 0);

    const roundedItemsAmount = roundAmount(itemsAmount);
    const roundedStoreCharges = roundAmount(storeCharges);
    const roundedInstallationCharges = roundAmount(installationCharges);
    const gridSharing = roundAmount(fieldFormik.values.iv_grid_sharing_cost);
    const feederRehab = roundAmount(fieldFormik.values.iv_feeder_rehab_charges);
    const civilWork = roundAmount(fieldFormik.values.iv_civil_work_charges);
    const fixedMetering = roundAmount(
      fieldFormik.values.iv_fixed_charges_of_metering,
    );
    const misc = roundAmount(fieldFormik.values.iv_miscellaneous_charges);
    const mtCharges = roundAmount(fieldFormik.values.iv_mt_charges);
    const labourCharges = roundAmount(fieldFormik.values.iv_labour_charges);
    const designWettingFee = roundAmount(
      fieldFormik.values.iv_design_wetting_fee,
    );
    const consultancyCharges = roundAmount(
      fieldFormik.values.iv_consultancy_charges,
    );
    const variationCharges = roundAmount(fieldFormik.values.iv_variation_charges);
    const dismantlementCharges = roundAmount(
      fieldFormik.values.iv_dismantlement_charges,
    );
    const earthingCharges = roundAmount(fieldFormik.values.iv_earthing_charges);
    const lessCost = roundAmount(fieldFormik.values.iv_less_the_cost);

    const totalCost =
      roundedItemsAmount +
      roundedStoreCharges +
      roundedInstallationCharges +
      gridSharing +
      feederRehab +
      civilWork +
      fixedMetering +
      misc +
      mtCharges +
      labourCharges +
      designWettingFee +
      consultancyCharges +
      variationCharges +
      dismantlementCharges +
      earthingCharges -
      lessCost;
    setGrandTotalCharges(totalCost);
  }, [
    itemsAmount,
    storeCharges,
    installationCharges,
    fieldFormik.values.iv_grid_sharing_cost,
    fieldFormik.values.iv_feeder_rehab_charges,
    fieldFormik.values.iv_civil_work_charges,
    fieldFormik.values.iv_fixed_charges_of_metering,
    fieldFormik.values.iv_miscellaneous_charges,
    fieldFormik.values.iv_mt_charges,
    fieldFormik.values.iv_labour_charges,
    fieldFormik.values.iv_design_wetting_fee,
    fieldFormik.values.iv_consultancy_charges,
    fieldFormik.values.iv_variation_charges,
    fieldFormik.values.iv_dismantlement_charges,
    fieldFormik.values.iv_earthing_charges,
    fieldFormik.values.iv_less_the_cost,
  ]);

  useEffect(() => {
    if (
      fieldFormik.values.iv_distance == 0 &&
      fieldFormik.values.iv_objection_Type == "No Issue"
    ) {
      fieldFormik.validateField("iv_sketch_diagram");
    }
  }, [fieldFormik.values.iv_distance]);

  // Removed duplicate useEffect - already handled at line 15975 with better dependency
  // useEffect(() => {
  //   setPartialValue(dialogRowData.subDivisionCode);
  // }, [dialogRowData]);

  // useEffect(() => {
  //   const { iv_fieldItemId } = fieldItemFormik.values;

  //   if (iv_fieldItemId && allMaterialList?.length > 0) {

  //     const item = allMaterialList.find(
  //       (it) =>
  //         String(it.item_Code || it.Item_Code)
  //           .trim()
  //           .toLowerCase() === String(iv_fieldItemId).trim().toLowerCase()
  //     );

  //     if (item) {
  //       fieldItemFormik.setFieldValue(
  //         "iv_fieldItemRate",
  //         item.item_Amount || item.Item_Amount || ""
  //       );
  //       fieldItemFormik.setFieldValue(
  //         "iv_fieldItemUnit",
  //         item.item_Unit || item.Item_Unit || ""
  //       );
  //     } else {
  //       fieldItemFormik.setFieldValue("iv_fieldItemRate", "");
  //       fieldItemFormik.setFieldValue("iv_fieldItemUnit", "");
  //     }
  //   }
  // }, [fieldItemFormik.values.iv_fieldItemId, allMaterialList]);

  // Removed duplicate useEffects - these are already defined at lines 16009-16066
  // useEffect(() => {
  //   if (foundId && foundId !== "") {
  //     setFoundInNc(foundId);
  //   }
  // }, [foundId]);

  // useLayoutEffect(() => {
  //   if (foundInNc) {
  //     handleRowClick(foundInNc);
  //   }
  // }, [foundInNc]);

  // useEffect(() => {
  //   let totalCost = totalCharges;
  //   ... (total cost calculation) ...
  //   setGrandTotalCharges(totalCost);
  // }, [...]);

  useEffect(() => {
    if (
      govtDeptCodesFromlocalStorage &&
      govtDeptCodesFromlocalStorage.length > 0
    ) {
      setGovtDeptCodes(govtDeptCodesFromlocalStorage);
    }
  }, [govtDeptCodesFromlocalStorage]);
  useEffect(() => {
    if (
      getClassificationCodesFromlocalStorage &&
      getClassificationCodesFromlocalStorage.length > 0
    ) {
      setStandardClassificationCodes(getClassificationCodesFromlocalStorage);
    }
  }, [getClassificationCodesFromlocalStorage]);

  //#endregion

  useImperativeHandle(ref, () => ({
    handleRowClick,
  }));

  const handleCostEstimationClose = () => {
    setShowCostEstimation(false);
  };

  useEffect(() => {}, [arrearsDetailsRefno]);

  const onPressCostEstimationConfirm = () => {
    const BoQItems = itemsArray.map((item) => ({
      qty: String(item.qty),
      itemCode: String(item.item_Code),
      itemAmount: String(item.amount),
    }));

    const roundAmount = (value) => Math.round(Number(value) || 0);
    const roundedItemsAmount = roundAmount(itemsAmount);
    const roundedStoreCharges = roundAmount(storeCharges);
    const roundedInstallationCharges = roundAmount(installationCharges);
    const roundedGridSharing = roundAmount(
      fieldFormik.values.iv_grid_sharing_cost,
    );
    const roundedFeederRehab = roundAmount(
      fieldFormik.values.iv_feeder_rehab_charges,
    );
    const roundedCivilWork = roundAmount(
      fieldFormik.values.iv_civil_work_charges,
    );
    const roundedFixedCharges = roundAmount(
      fieldFormik.values.iv_fixed_charges_of_metering,
    );
    const roundedMiscCharges = roundAmount(
      fieldFormik.values.iv_miscellaneous_charges,
    );
    const roundedMtCharges = roundAmount(fieldFormik.values.iv_mt_charges);
    const roundedLabourCharges = roundAmount(
      fieldFormik.values.iv_labour_charges,
    );
    const roundedDesignWettingFee = roundAmount(
      fieldFormik.values.iv_design_wetting_fee,
    );
    const roundedConsultancyCharges = roundAmount(
      fieldFormik.values.iv_consultancy_charges,
    );
    const roundedVariationCharges = roundAmount(
      fieldFormik.values.iv_variation_charges,
    );
    const roundedDismantlementCharges = roundAmount(
      fieldFormik.values.iv_dismantlement_charges,
    );
    const roundedEarthingCharges = roundAmount(
      fieldFormik.values.iv_earthing_charges,
    );
    const roundedLessTheCost = roundAmount(fieldFormik.values.iv_less_the_cost);

    const roundedCapitalCostAmount =
      roundedItemsAmount;

    setBoqItems(BoQItems);
    if (
      fieldFormik.values.iv_objection_Type === 2 &&
      fieldFormik.values.isMeterAvailable === "1"
    ) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: fieldFormik.values.isReferToMst === "0" ? 6 : 5,
        remarks: "MCO with cost",
        objectionStatus: 0,
        submittedThrough: portalName,
        remarksDetail: "MCO with cost",
        siteObservationId: fieldFormik.values.iv_objection_Type,
        meterFaultId: fieldFormik.values.iv_faultType,
        defectiveCode: 0,
        isReadingAccessible:
          fieldFormik.values.isReadingAccessible === "1" ? true : false,
        isReferedToMT: fieldFormik.values.isReferToMst === "1" ? true : false,
        isMeterAvailable:
          fieldFormik.values.isMeterAvailable === "1" ? true : false,
        meterImage: meterImageThumbnail ? meterImageThumbnail : "",
        tariff: dialogRowData.tariffDesc,
        sanctionLoad: dialogRowData.sanctionedLoad,
        capitalCostAmount: roundedCapitalCostAmount,
        civilWorkCharges: roundedCivilWork,
        fixedChargesOfMetering: roundedFixedCharges,
        miscellaneousCharges: roundedMiscCharges,
        amountOfGridSharing: roundedGridSharing,
        amountOfFeederRehab: roundedFeederRehab,
        lessTheCost: roundedLessTheCost,
        mtCharges: roundedMtCharges,
        labourCharges: roundedLabourCharges,
        designVetteingFee: roundedDesignWettingFee,
        consultancyCharges: roundedConsultancyCharges,
        variationsCharges: roundedVariationCharges,
        dismentalmentCharges: roundedDismantlementCharges,
        earthingCharges: roundedEarthingCharges,
        serviceConnectionAmount: grandTotalCharges,
        BoQItems: BoQItems,
        bankName: bankName,
        meterType: fieldFormik.values.iv_meter_type
          ? fieldFormik.values.iv_meter_type
          : "",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        cfpBaseUrl + "meterChangeOrder/saveFieldSurveyAndCostEstimateForMCO",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result?.status === "200" || result?.status === 200) {
            setViewBackdrop(false);
            setShowCostEstimation(false);
            setErrormessageCostEstimation("");
            handleClose();
            setSnackbar({
              open: true,
              message: result?.message || "Submitted successfully",
              severity: "success",
            });
          } else {
            setViewBackdrop(false);
            setErrormessageCostEstimation(result?.message);
            setSnackbar({
              open: true,
              message: result?.message || "Something went wrong",
              severity: "error",
            });
          }
        })
        .catch((error) => {
          setViewBackdrop(false);
          setSnackbar({
            open: true,
            message: "Something went wrong",
            severity: "error",
          });
        });
    } else if (
      fieldFormik.values.iv_objection_Type === 3 &&
      meterImageThumbnail
    ) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        applicationId: dialogRowData.applicationId,
        applicationProgressId: fieldFormik.values.isReferToMst === "1" ? 5 : 9,
        objectionStatus: 0,
        submittedThrough: portalName,
        remarks: "MCO without cost",
        remarksDetail: "MCO without cost",
        siteObservationId: 3,
        meterFaultId: fieldFormik.values.iv_faultType,
        defectiveCode: fieldFormik.values.isDefectiveCode === "1" ? 1 : 0,
        isReadingAccessible:
          fieldFormik.values.isReadingAccessible === "1" ? true : false,
        isReferedToMT: fieldFormik.values.isReferToMst === "1" ? true : false,
        isMeterAvailable:
          fieldFormik.values.isMeterAvailable === "1" ? true : false,
        meterImage: meterImageThumbnail,
        BoQItems: boqItems,
        tariff: dialogRowData.tariffDesc,
        sanctionLoad: dialogRowData.sanctionedLoad,
        capitalCostAmount: roundedCapitalCostAmount,
        civilWorkCharges: roundedCivilWork,
        fixedChargesOfMetering: roundedFixedCharges,
        miscellaneousCharges: roundedMiscCharges,
        amountOfGridSharing: roundedGridSharing,
        amountOfFeederRehab: roundedFeederRehab,
        lessTheCost: roundedLessTheCost,
        mtCharges: roundedMtCharges,
        labourCharges: roundedLabourCharges,
        designVetteingFee: roundedDesignWettingFee,
        consultancyCharges: roundedConsultancyCharges,
        variationsCharges: roundedVariationCharges,
        dismentalmentCharges: roundedDismantlementCharges,
        earthingCharges: roundedEarthingCharges,
        serviceConnectionAmount: grandTotalCharges,
        bankName: bankName,
        meterType: fieldFormik.values.iv_meter_type
          ? fieldFormik.values.iv_meter_type
          : "",
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        cfpBaseUrl + "meterChangeOrder/saveFieldSurveyAndCostEstimateForMCO",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result?.status === "200" || result?.status === 200) {
            setViewBackdrop(false);
            setShowCostEstimation(false);
            setErrormessageCostEstimation("");
            handleClose();
            setSnackbar({
              open: true,
              message: result?.message || "Submitted successfully",
              severity: "success",
            });
          } else {
            setViewBackdrop(false);
            setErrormessageCostEstimation(result?.message);
            setSnackbar({
              open: true,
              message: result?.message || "Something went wrong",
              severity: "error",
            });
          }
        })
        .catch((error) => {
          setViewBackdrop(false);
          setSnackbar({
            open: true,
            message: "Something went wrong",
            severity: "error",
          });
        });
    }
  };

  const onSaveCostEstimationConfirm = () => {
    setErrormessageBoqEstimation("");
    setShowBoq(false);
    const BoQItems = itemsArray.map((item) => ({
      qty: String(item.qty),
      itemCode: String(item.item_Code),
      itemAmount: String(item.amount),
    }));
    setBoqItems(BoQItems);
  };

  const isThreePhaseDialog = ["3 phase", "three phase"].includes(
    String(dialogRowData?.phase || "").trim().toLowerCase(),
  );

  useEffect(() => {
    if (isThreePhaseDialog) {
      if (fieldFormik.values.isReferToMst !== "1") {
        fieldFormik.setFieldValue("isReferToMst", "1");
      }
    }
  }, [isThreePhaseDialog, fieldFormik.values.isReferToMst]);

  const prepareEstimateIntegerFields = new Set([
    "iv_fieldItemQty",
    "iv_civil_work_charges",
    "iv_miscellaneous_charges",
    "iv_fixed_charges_of_metering",
    "iv_grid_sharing_cost",
    "iv_feeder_rehab_charges",
    "iv_mt_charges",
    "iv_labour_charges",
    "iv_design_wetting_fee",
    "iv_consultancy_charges",
    "iv_variation_charges",
    "iv_dismantlement_charges",
    "iv_earthing_charges",
    "iv_less_the_cost",
  ]);

  const restrictPrepareEstimateFractionKeys = (e) => {
    const fieldName = e.target?.name;
    if (!prepareEstimateIntegerFields.has(fieldName)) {
      return;
    }

    if ([".", ",", "e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  const restrictPrepareEstimateFractionPaste = (e) => {
    const fieldName = e.target?.name;
    if (!prepareEstimateIntegerFields.has(fieldName)) {
      return;
    }

    const pastedText = e.clipboardData?.getData("text") || "";
    if (/[^0-9]/.test(pastedText)) {
      e.preventDefault();
    }
  };

  const onPressAddPrepare = useCallback(() => {
    setShowBoq(true);
  }, []);

  useEffect(() => {
    // hide BOQ
    if (
      fieldFormik.values.iv_distance === 0 &&
      dialogRowData.applicationProgressId === 3
    ) {
      setShowBoq(false);
    }

    const isFesco = dialogRowData?.applicationId?.slice(3, 5) === "13";
    const newDistance = 41;

    if (fieldFormik.values.iv_estimated_distance !== newDistance) {
      fieldFormik.setFieldValue("iv_estimated_distance", newDistance);
    }
  }, [
    fieldFormik.values.iv_distance,
    dialogRowData.applicationId,
    dialogRowData.applicationProgressId,
  ]);

  useEffect(() => {
    // Only set iv_distance to null if objection type changed AND it's not already null
    if (
      fieldFormik.values.iv_objection_Type !== "No Issue" &&
      fieldFormik.values.iv_distance !== null
    ) {
      fieldFormik.setFieldValue("iv_distance", null);
    }
  }, [fieldFormik.values.iv_objection_Type]);

  // useEffect(() => {
  //   callMaterials()
  // }, [])

  // useEffect(() => {
  //   const count = fieldFormik.values.iv_no_of_meters_already_installed || 0;
  //   fieldFormik.setFieldValue(
  //     "installedMeterRefNos",
  //     Array(count).fill("")
  //   );
  // }, [fieldFormik.values.iv_no_of_meters_already_installed]);

  useEffect(() => {
    const count = fieldFormik.values.iv_no_of_meters_already_installed;
    const currentArray = fieldFormik.values.installedMeterRefNos || [];

    if (count > 0) {
      // Only update if the array length doesn't match
      if (currentArray.length !== count) {
        const newArray = Array(count)
          .fill("")
          .map((_, i) => currentArray[i] || "");
        fieldFormik.setFieldValue("installedMeterRefNos", newArray);
      }
    } else {
      // Only update if the array is not already empty
      if (currentArray.length > 0) {
        fieldFormik.setFieldValue("installedMeterRefNos", []);
      }
    }
  }, [fieldFormik.values.iv_no_of_meters_already_installed]);

  useEffect(() => {
    if (!boqItems || boqItems.length === 0) {
      // Only reset values if they're not already 0 to prevent unnecessary updates
      if (gridSharingCost !== 0) {
        fieldFormik.setFieldValue("iv_grid_sharing_cost", 0);
        setGridSharingCost(0);
      }
      if (feederRehabilitationCharges !== 0) {
        fieldFormik.setFieldValue("iv_feeder_rehab_charges", 0);
        setFeederRehabilitationCharges(0);
      }
      if (civilWorkCharges !== 0) {
        fieldFormik.setFieldValue("iv_civil_work_charges", 0);
        setCivilWorkCharges(0);
      }
      if (miscellaneousCharges !== 0) {
        fieldFormik.setFieldValue("iv_miscellaneous_charges", 0);
        setMiscellaneousCharges(0);
      }
      if (fixedChargesOfMetering !== 0) {
        fieldFormik.setFieldValue("iv_fixed_charges_of_metering", 0);
        setFixedChargesOfMetering(0);
      }
      if (lessTheCost !== 0) {
        fieldFormik.setFieldValue("iv_less_the_cost", 0);
        setLessTheCost(0);
      }
    }
  }, [boqItems]);

  useEffect(() => {
    const currentEstDistance = fieldFormik.values.iv_estimated_distance_yes;
    if (fieldFormik.values.iv_distance == 1 && currentEstDistance !== 1) {
      fieldFormik.setFieldValue("iv_estimated_distance_yes", 1);
    } else if (
      fieldFormik.values.iv_distance == 0 &&
      currentEstDistance !== 41
    ) {
      fieldFormik.setFieldValue("iv_estimated_distance_yes", 41);
    }
  }, [fieldFormik.values.iv_distance]);
  const callAssignmentAPI = async (applicationId, wfId) => {
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        assignedTo: wfId,
        lastModifiedBy: userId,
        applicationId: applicationId,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "workForce/assignToEmployee", requestOptions)
        .then(async (response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            let res = await response.json();
            alert(res.message);
          }
        })
        .then((result) => {
          // setLinemanAllocationSubPopUp(false)
          alert(result.message);
        })
        .catch(() => {});
    } catch (e) { /* ignored */ }
    setLinemanAllocationSubPopUp(false);
    setViewBackdrop(false);
  };

  const PaidArrearsImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "PaidArrearsImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        arrearPaymentReceiptFormik.handleChange,
        setArearPaidBillDocument,
        setArearPaidBillDocumentError,
        setArearPaidBillDocumentThumbnail,
        newFileName,
      );
    }
  };

  const OBJPaidArrearsImage = (event) => {
    if (event.target.files) {
      const newFileName =
        "PaidArrearsImage." + event.target.files[0].name.split(".").pop();
      handleFileUpload(
        event,
        arrearPaymentObjectionReceiptFormik.handleChange,
        setArearPaidBillDocument,
        setArearPaidBillDocumentError,
        setArearPaidBillDocumentThumbnail,
        newFileName,
      );
    }
  };

  useEffect(() => {
    return () => {
      // Cleanup blob URL if exists
      if (
        installedMeterImgThumbnail &&
        installedMeterImgThumbnail.startsWith("blob:")
      ) {
        URL.revokeObjectURL(installedMeterImgThumbnail);
      }
    };
  }, [installedMeterImgThumbnail]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";

    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const getNormalizedTariffName = (tariffCode, allTariffList) => {
    if (!tariffCode || !Array.isArray(allTariffList)) return "";

    const tariff = allTariffList.find(
      (t) => String(t.tariffCode) === String(tariffCode),
    );

    return tariff?.tariffName?.replace(/[^A-Za-z0-9]/g, "").toUpperCase() || "";
  };

  const handleOpenImg = () => setOpenImgDialog(true);
  const handleCloseImg = () => setOpenImgDialog(false);
  const handleOpenImgDN = () => setOpenImgDialogDN(true);
  const handleCloseImgDN = () => setOpenImgDialogDN(false);
  const handleDownloadMtReportImage = async () => {
    if (!mtReportImg) return;

    try {
      const response = await fetch(mtReportImg);
      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const applicationId = String(
        historyData?.applicationId || dialogRowData?.applicationId || "applicationid",
      )
        .trim()
        .replace(/[^A-Za-z0-9_-]/g, "_");
      const extension = blob.type.includes("png") ? "png" : "jpg";

      link.href = objectUrl;
      link.download = `MNT_report_${applicationId}.${extension}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      const link = document.createElement("a");
      const applicationId = String(
        historyData?.applicationId || dialogRowData?.applicationId || "applicationid",
      )
        .trim()
        .replace(/[^A-Za-z0-9_-]/g, "_");
      link.href = mtReportImg;
      link.download = `MNT_report_${applicationId}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  };
  const handleDownloadDnPaymentImage = async () => {
    if (!dnPaymentImg) return;

    try {
      const response = await fetch(dnPaymentImg);
      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const applicationId = String(
        historyData?.applicationId || dialogRowData?.applicationId || "applicationid",
      )
        .trim()
        .replace(/[^A-Za-z0-9_-]/g, "_");
      const extension = blob.type.includes("png") ? "png" : "jpg";

      link.href = objectUrl;
      link.download = `paid_dn_image_${applicationId}.${extension}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      const link = document.createElement("a");
      const applicationId = String(
        historyData?.applicationId || dialogRowData?.applicationId || "applicationid",
      )
        .trim()
        .replace(/[^A-Za-z0-9_-]/g, "_");
      link.href = dnPaymentImg;
      link.download = `paid_dn_image_${applicationId}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  };

  const DNApproveAPI = async (
    Token,
    applicationId,
    applicationProgressId,
    objectionStatus,
    remarks,
    portalName,
  ) => {
    setViewBackdrop(true);

    const myHeaders = new Headers();
    myHeaders.append("Authorization", Token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      applicationId: applicationId,
      applicationProgressId: applicationProgressId,
      objectionStatus: objectionStatus,
      remarks: remarks,
      remarksDetail: remarks,
      submittedThrough: portalName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    try {
      const response = await fetch(
        cfpBaseUrl + "meterChangeOrder/approveMCODemandNote",
        requestOptions,
      );
      const result = await response.json();

      if (result.status === "200") {
        setResponseMessage(result.message);
        setResponseType("success");
      } else {
        setResponseMessageError(result.message || "Unexpected error occurred.");
        setResponseType("error");
      }

      setOpenResponseModal(true);
      handleClose();
    } catch (error) {
      setResponseMessageError("Something went wrong. Please try again.");
      setResponseType("error");
      setOpenResponseModal(true);
    } finally {
      setViewBackdrop(false);
    }
  };

  const scoPart2Formik = useFormik({
    initialValues,
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema: Yup.object().shape({
      // iv_store_requisition_no: Yup.string()
      //   .required('Enter store requisition no.')
      //   .min(6, 'SRN should be 6 digits.')
      //   .max(6, 'SRN should be 6 digits.')
      //   .matches(/^[1-9][0-9]{5}$/, "SRN should be a 6-digit number and cannot start with 0."),
      // iv_store_requisition_date: Yup.date().max(new Date(), 'Requisition date must be in the past.').required('Enter requisition date.'),
      // iv_store_requisition_no: Yup.string()
      //   .required("Store Requisition No. is required")
      //   .length(6, "Must be 6 digits"),
      // iv_store_requisition_no: Yup.string()
      //   .when("$scoP2FillFlag", {
      //     is: 13, // agar flag 13 hai
      //     then: (schema) => schema.required("Store Requisition No. is required"),
      //     otherwise: (schema) =>
      //       schema
      //         .required("Store Requisition No. is required")
      //         .length(6, "Must be 6 digits"),
      //   }),

      iv_is_net_meter: Yup.string()
        .required("Please select Is Net Meter.")
        .test(
          "net-meter-requires-tod",
          "Net Meter can only be Yes when selected tariff has TOD.",
          function (value) {
            if (value !== "1") return true;
            return hasTodTariff(selectedMCOTariffObj);
          },
        ),
      iv_meter_category: Yup.string()
        .required("Please select meter category.")
        .oneOf(["00", "01", "02", "03"], "Please select a valid meter category."),
      iv_tariff_code: Yup.string().required("Please select a Tariff."),
      iv_total_kwh: Yup.string()
        .required("Total kWh is required.")
        .test(
          "total-kwh-range",
          function (value) {
            if (!hasTodTariff(selectedMCOTariffObj)) {
              return value === "1"
                ? true
                : this.createError({ message: "Value must be 1." });
            }

            const isNetMeter = this.parent?.iv_is_net_meter;
            if (isNetMeter === "1") {
              return value === "4"
                ? true
                : this.createError({ message: "Value must be 4 for Net Meter." });
            }

            return value === "2"
              ? true
              : this.createError({ message: "Value must be 2." });
          },
        ),

      iv_store_requisition_no: Yup.string().when([], {
        is: () => dialogRowData?.isMeterAvailable === false,
        then: Yup.string().optional().nullable(),
        otherwise: Yup.string()
          .required("Store Requisition No. is required")
          .matches(/^[0-9]+$/, "SRN should be number only.")
          .max(8, "Store Requisition No. must be at most 8 digits."),
      }),

      iv_store_requisition_date: Yup.string().when([], {
        is: () => dialogRowData?.isMeterAvailable === false,
        then: Yup.string().optional().nullable(),
        otherwise: Yup.string().required("Store Requisition Date is required"),
      }),
      // iv_sanctioned_load: Yup.number()
      //   .when([], {
      //     is: () => dialogRowData.connectionCategory === "Domestic",
      //     then: Yup.number()
      //       .min(2, "Load can't be less than 2.")
      //       .max(1000, "Residential Maximum Load 1000kW.")
      //       .required("Enter sanctioned load."),
      //   })
      //   .when([], {
      //     is: () => dialogRowData.connectionCategory === "Commercial",
      //     then: Yup.number()
      //       .min(2, "Load can't be less than 2.")
      //       .max(5000, "Commercial Maximum Load 5000kW.")
      //       .required("Enter sanctioned load."),
      //   })
      //   .when([], {
      //     is: () => dialogRowData.connectionCategory === "Industrial",
      //     then: Yup.number()
      //       .min(2, "Load can't be less than 2.")
      //       .required("Enter sanctioned load."),
      //   })
      //   .when([], {
      //     is: () => dialogRowData.connectionCategory === "Agriculture",
      //     then: Yup.number()
      //       .min(2, "Load can't be less than 2.")
      //       .max(5000, "Applied load cannot be more than 5000kW.")
      //       .required("Enter sanctioned load."),
      //   })
      //   .when([], {
      //     is: () =>
      //       [
      //         "Tubewell",
      //         "Temporary",
      //         "GeneralServices",
      //         "Electrification",
      //         "StreetLight",
      //         "CorporateCompany",
      //       ].includes(dialogRowData.connectionCategory),
      //     then: Yup.number()
      //       .min(2, "Load can't be less than 2.")
      //       .max(5000, "Applied load cannot be more than 5000kW.")
      //       .required("Enter sanctioned load."),
      //   })
      //   .required("Enter sanctioned load."),
      iv_seasonal_flag: Yup.mixed().when("phase", {
        is: () => phase != "Single Phase" || phase != "3 Phase",
        then: Yup.mixed().required("Select seasonal / non seasonal value."),
        otherwise: Yup.mixed().optional(),
      }),
      iv_meter_range: Yup.number("Range should be a number.")
  .min(4, "Range can't be less than 4.")
  .max(8, "Range can't be greater than 8.")
  .required("Enter meter range."),
      iv_meter_code1: Yup.string().when("iv_total_kwh", {
        is: "1",
        then: Yup.string()
          .oneOf(["000002"], "For Total kWh 1, meter code must be 000002.")
          .required("Enter meter code."),
        otherwise: Yup.string().when("iv_total_kwh", {
          is: (value) => Number(value) >= 2,
          then: Yup.string()
            .oneOf(
              ["050502"],
              "For Total kWh 2 or greater, meter code must be 050502.",
            )
            .required("Enter meter code."),
          otherwise: Yup.string()
            .matches(/^[0-9]{6}$/, "Code must be a 6-digit number.")
            .test(
              "valid-start",
              "The first two digits must be 00, 01, 02, 03, 04, or 05.",
              (value) => {
                if (!value) return false;
                const firstTwoDigits = parseInt(value.substring(0, 2), 10);
                return [0, 1, 2, 3, 4, 5].includes(firstTwoDigits);
              },
            )
            .test(
              "validate-3rd-digit",
              "The 3rd digit must be 0, 1, 2.",
              (value) => {
                if (!value) return false;
                const thirdDigit = parseInt(value.substring(2, 3), 10);
                return [0, 1, 2].includes(thirdDigit);
              },
            )
            .test(
              "validate-4th-digit",
              "The 4th digit must be 1, 2, 6, 7.",
              (value) => {
                if (!value) return false;
                const fourthDigit = parseInt(value.substring(3, 4), 10);
                return [1, 2, 6, 7].includes(fourthDigit);
              },
            )
            .test(
              "last-digits",
              "The last 2 digits must be 00, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13.",
              (value) => {
                if (!value) return false;
                const lastDigits = parseInt(value.substring(4), 10);
                return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(
                  lastDigits,
                );
              },
            )
            .required("Enter meter code."),
        }),
      }),
      iv_meter_code2: Yup.string().when("iv_total_kwh", {
        is: (value) => Number(value) >= 2,
        then: Yup.string()
          .oneOf(
            ["050602"],
            "For Total kWh 2 or greater, meter code must be 050602.",
          )
          .required("Enter meter code."),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_transformer_code: Yup.string()
        .matches(/^\d*$/, "Transformer code must contain digits only.")
        .optional(),
      iv_transformer_refNo: (function () {
        // Build base schema depending on company
        const base = Yup.string()
          .required("Transformer reference no is required.")
          .matches(/^[0-9]{14}$/, "Enter 14 digit transformer reference no as 01234567891234");

        // Add custom test: if dialogRowData.referenceNo exists, compare chars 3-7 (slice 2..7)
        return base.test(
          "matches-reference-subdivision",
          "Enter valid reference no.",
          function (value) {
            // If no dialog data to compare, pass
            try {
              const refNo = dialogRowData?.referenceNo;
              if (!refNo) return true;

              // If value empty and optional, let base required handle it
              if (!value) return false;

              const refSub = String(refNo).slice(2, 7);
              const transformerDigits = String(value || "").replace(/\D/g, "");
              if (transformerDigits.length < 7) return false;
              const transformerSub = transformerDigits.slice(2, 7);
              return transformerSub === refSub;
            } catch (e) {
              return true;
            }
          },
        );
      })(),

      iv_location_code: Yup.mixed().required("Select location."),
      iv_manufacturer_code: Yup.string().required("Select Manufacturer."),
      iv_meter_serial_no: Yup.string()
        .required("Enter meter serial no.")
        .matches(/^\d+$/, "Meter serial no. should contain digits only.")
        .length(10, "Meter serial no. should be exactly 10 digits."),

      iv_sim_number: Yup.string().when("iv_meter_typee", {
        is: (value) => Number(value) === 1,
        then: (schema) =>
          schema
            .required("Enter SIM number.")
            .matches(
              /^03\d{9}$/,
              "SIM number must start with 03 and be 11 digits.",
            ),
        otherwise: (schema) => schema.notRequired(),
      }),

      iv_sim_ID: Yup.string().when("iv_meter_typee", {
        is: (value) => Number(value) === 1,
        then: (schema) =>
          schema
            .required("Enter SIM ID.")
            .matches(/^\d+$/, "SIM ID must contain digits only.")
            .min(18, "SIM ID should be at least 18 digits.")
            .max(20, "SIM ID should not exceed 20 digits."),
        otherwise: (schema) => schema.notRequired(),
      }),

      iv_meter_reading: Yup.string().when("phase", {
        is: () => phase === "Single Phase",
        then: Yup.string()
          .required("Enter meter reading.")
          .test(
            "is-decimal-meter-reading",
            "Enter meter reading in numbers with up to 3 decimal places.",
            (value) => !value || /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
          ),
        otherwise: Yup.string().optional(),
      }),
      iv_meter_reading_peak_kwh: Yup.string()
        .nullable()
        .test(
          "is-decimal-optional-peak-kwh",
          "Enter peak reading in numbers with up to 3 decimal places.",
          (value) => !value || /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
        ),
      iv_meter_reading_off_peak_kwh: Yup.string()
        .nullable()
        .test(
          "is-decimal-optional-off-peak-kwh",
          "Enter off peak reading in numbers with up to 3 decimal places.",
          (value) => !value || /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
        ),
      iv_meter_reading_peak_kvarh: Yup.string()
        .nullable()
        .test(
          "is-decimal-optional-peak-kvarh",
          "Enter peak reading in numbers with up to 3 decimal places.",
          (value) => !value || /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
        ),
      iv_meter_reading_off_peak_kvarh: Yup.string()
        .nullable()
        .test(
          "is-decimal-optional-off-peak-kvarh",
          "Enter off peak reading in numbers with up to 3 decimal places.",
          (value) => !value || /^[0-9]+(\.[0-9]{1,3})?$/.test(value),
        ),
      iv_date_of_connection: Yup.date()
        .max(new Date(), "Connection date must be in the past.")
        .required("Enter connection date."),
      iv_connection_installer_name: Yup.string()
        .required("Enter installed by name.")
        .max(30, "Name should be less than 30 characters."),
      iv_installed_meter_image: Yup.mixed().required("Upload meter image."),
      // iv_meter_typee: Yup.mixed().required("Select meter type!"),
      iv_ct_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Nom in whole numbers greater than 0.",
          )
          .test(
            "is-positive",
            "CT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "ct-standard-values",
            "The CT Nom must be 100, 200, 300, 400, 600, 800, 1000.",
            (value) => {
              if (!value) return false; // Ensure value exists
              const ctNom = parseInt(value, 10);
              return [100, 200, 300, 400, 600, 800, 1000].includes(ctNom);
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_ct_denom: Yup.string().when("phase", {
        is: (phase) => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter CT Denom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter CT Denom in whole numbers greater than 0.",
          )
          .test(
            "is-positive",
            "CT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "is-less-than-nom",
            "CT Denom must be less than CT Nom.",
            function (value) {
              const { iv_ct_nom } = this.parent; // Access sibling field
              if (!iv_ct_nom || !value) return true; // Skip validation if either value is missing
              return (
                (iv_ct_nom == 1 && value == 1) ||
                parseInt(value, 10) < parseInt(iv_ct_nom, 10)
              );
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_nom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Nom in natural numbers greater than 0.",
          )
          .test(
            "is-positive",
            "PT Denom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          )
          .test(
            "is-less-than-nom",
            "PT Denom must be less than PT Nom.",
            function (value) {
              const { iv_pt_nom } = this.parent; // Access sibling field
              if (!iv_pt_nom || !value) return true; // Skip validation if either value is missing
              return parseInt(value, 10) >= parseInt(iv_pt_nom, 10);
            },
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_pt_denom: Yup.string().when("phase", {
        is: () => phase !== "Single Phase" && phase !== "3 Phase",
        then: Yup.string()
          .required("Enter PT Nom.")
          .matches(
            /^[1-9]\d*$/,
            "Enter PT Denom in natural numbers greater than 0.",
          )
          .test(
            "is-positive",
            "PT Nom must be greater than 0.",
            (value) => parseFloat(value) > 0,
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_reading_info: Yup.object()
        .test(
          "reading-rows-required",
          "Reading information rows are required.",
          function () {
            const readingRows = buildReadingRows(
              this.parent?.iv_total_kwh,
              selectedMCOTariffObj,
            );
            return readingRows.length > 0;
          },
        )
        .test(
          "reading-rows-complete",
          "Please fill Meter Reading for all reading rows.",
          function (value) {
            const readingRows = buildReadingRows(
              this.parent?.iv_total_kwh,
              selectedMCOTariffObj,
            );

            if (readingRows.length === 0) {
              return false;
            }

            const readingInfo = value || {};
            return readingRows.every((row) => {
              const rowData = readingInfo[row.key] || {};
              const meterReading = String(rowData.meterReading || "").trim();
              return Boolean(meterReading);
            });
          },
        ),
      iv_mdi: Yup.string().when("phase", {
        is: () => shouldCaptureMdiValues,
        then: Yup.string()
          .required("Enter MDI cumulative reading.")
          .matches(
            /^[1-9]\d*$/,
            "Enter MDI cumulative reading in numbers greater than 0.",
          )
          .test(
            "is-positive",
            "MDI cumulative reading must be greater than 0.",
            (value) => parseFloat(value) > 0,
          ),
        otherwise: Yup.string().optional().nullable(),
      }),
      iv_no_of_mdi_resets: Yup.string().when("phase", {
        is: () => shouldCaptureMdiValues,
        then: Yup.string()
          .max(5, "No. of MDI reset can not be more than 99999.")
          .min(1, "No. of MDI reset can not be less than 1.")
          .required("Enter No. of MDI reset.")
          .matches(/^[0-9]+$/, "Enter No. of MDI reset in numbers."),
        otherwise: Yup.string().optional().nullable(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      try {
        setRemovedMeterDetailError("");
        if (!installedMeterImageThumbnail) {
          setInstalledMeterImageError(
            "Upload the Installed meter image in JPG, PNG.",
          );
          setViewBackdrop(false);
          return;
        }

        // Check if storedMeterRemovedData exists
        if (!storedMeterRemovedData) {
          setRemovedMeterDetailError(
            "Please fill Removed Meter Detail before submitting.",
          );
          setViewBackdrop(false);
          return;
        }

        if (!validateReadingInfoRows()) {
          setSnackbar({
            open: true,
            message: "Please fill Meter Reading for all reading rows.",
            severity: "error",
          });
          setViewBackdrop(false);
          return;
        }
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const readingRows = buildReadingRows(values.iv_total_kwh, selectedMCOTariffObj);
        const readingInfo = values.iv_reading_info || {};
        const removedMeterRows = getRemovedMeterRowsForSubmit();
        const removeMeterInfo = buildRemoveMeterInfoArray(removedMeterRows);
        const installMeterInfo = buildInstallMeterInfoArray(
          readingRows,
          readingInfo,
          values,
        );

        if (!removeMeterInfo.length) {
          setRemovedMeterDetailError(
            "Please fill Removed Meter Detail before submitting.",
          );
          setViewBackdrop(false);
          return;
        }

        if (!installMeterInfo.length) {
          setSnackbar({
            open: true,
            message: "Please fill Reading Information before submitting.",
            severity: "error",
          });
          setViewBackdrop(false);
          return;
        }

        const submitTariffObj =
          findMCOTariffObj(
            values.iv_tariff_code,
            "",
            allMCOTariffList,
            allTariffList,
          ) || selectedMCOTariffObj;

        const mcoApiBody = {
          applicationId: dialogRowData?.applicationId || "",
          applicationProgressId:
            (dialogRowData?.applicationProgressId ?? 0) + 1 || 10,
          objectionStatus: 0,
          submittedThrough: portalName || "e-Operations",
          remarks: "Meter Installed.",
          remarksDetail: "Meter Installed Successfully.",
          referenceNo: dialogRowData?.referenceNo || "",
          customerId: dialogRowData?.customerId || "",
          mcoSubmittedThrough: "Web Portal",
          installedMeterImage: installedMeterImageThumbnail || "",
          installationDateTime: formatApiDateTime(values.iv_date_of_connection),
          storeRequisitionNo: values.iv_store_requisition_no?.trim()
            ? values.iv_store_requisition_no.trim().padStart(8, "0")
            : "",
          storeRequisitionDateTime: formatApiDateTime(
            values.iv_store_requisition_date,
          ),
          meterType: (() => {
            const raw = values.iv_meter_typee ?? values.iv_meter_type;
            if (raw === null || raw === undefined || raw === "") return "";
            const parsed = parseInt(raw, 10);
            return Number.isNaN(parsed) ? "" : parsed;
          })(),
          simId: values.iv_sim_ID || "",
          simNo: values.iv_sim_number || "",
          transformerRefNo: values.iv_transformer_refNo || "",
          sanctionedLoad: parseFloat(dialogRowData?.sanctionedLoad) || 0,
          currentTariff:
            resolveTariffCodeForApi(
              dialogRowData?.tariffCode ?? dialogRowData?.tariffDesc,
            ) || "",
          newTariff: resolveTariffCodeForApi(values.iv_tariff_code) || "",
          isNetMeter: values.iv_is_net_meter === "1" ? 1 : 0,
          todFlag: toApiBooleanFlag(getTariffFlagRaw(submitTariffObj, "tod")),
          mdiFlag: toApiBooleanFlag(getTariffFlagRaw(submitTariffObj, "mdi")),
          I_METER_CATEGORY: values.iv_meter_category || "",
          R_NO_KWH_METER: resolveRNoKwhMeterForSubmit(
            storedMeterRemovedData,
            removedMeterRows,
            ibsMaxRemovedSetNo,
          ),
          I_NO_KWH_METER: resolveINoKwhMeterForSubmit(values.iv_total_kwh),
          removeMeterInfo,
          installMeterInfo,
        };

        const response = await fetch(
          cfpBaseUrl + "meterChangeOrder/submitMCOMeterInstallation",
          {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(mcoApiBody),
            redirect: "follow",
          },
        );

        const result = await response.json();

        if (result?.status === "200" || result?.status === 200) {
          setStoredMeterRemovedData(null);
          setMeterRemovedSnapshotRows(null);
          setIbsMaxRemovedSetNo(0);

          resetForm();
          handleClose();

          setSnackbar({
            open: true,
            message: result?.message || "Meter installed successfully",
            severity: "success",
          });
        } else {
          setSnackbar({
            open: true,
            message: result?.message || "Something went wrong",
            severity: "error",
          });
        }
      } catch (error) {
        setSnackbar({
          open: true,
          message: "Server error. Please try again.",
          severity: "error",
        });
      } finally {
        setViewBackdrop(false);
      }
    },
  });

  const setScoPart2Field = (field, value) =>
    scoPart2Formik.setFieldValue(field, value, false);

  useEffect(() => {
    syncNetMeterFieldsWithTariff(selectedMCOTariffObj);
  }, [selectedMCOTariffObj]);

  useEffect(() => {
    if (Number(dialogRowData?.applicationProgressId) !== 9) return;
    const raw = dialogRowData?.meterType;
    const lockedValue =
      raw === 0 || raw === "0" || raw === 1 || raw === "1"
        ? String(raw)
        : null;
    if (
      lockedValue !== null &&
      String(scoPart2Formik.values.iv_meter_typee ?? "") !== lockedValue
    ) {
      setScoPart2Field("iv_meter_typee", lockedValue);
    }
  }, [
    dialogRowData?.applicationProgressId,
    dialogRowData?.meterType,
    scoPart2Formik.values.iv_meter_typee,
  ]);

  const meterInstallCanSubmit = useMemo(() => {
    if (Number(dialogRowData?.applicationProgressId) !== 9) return false;
    const values = scoPart2Formik.values || {};
    const needsStoreReq = dialogRowData?.isMeterAvailable !== false;
    const storeOk =
      !needsStoreReq ||
      (Boolean(String(values.iv_store_requisition_no || "").trim()) &&
        Boolean(String(values.iv_store_requisition_date || "").trim()));
    return (
      storeOk &&
      Boolean(String(values.iv_tariff_code || "").trim()) &&
      Boolean(String(values.iv_total_kwh || "").trim()) &&
      Boolean(String(values.iv_meter_category || "").trim()) &&
      Boolean(String(values.iv_meter_serial_no || "").trim()) &&
      Boolean(String(values.iv_manufacturer_code || "").trim()) &&
      Boolean(String(values.iv_date_of_connection || "").trim()) &&
      Boolean(storedMeterRemovedData) &&
      Boolean(installedMeterImageThumbnail) &&
      isReadingInfoComplete(false)
    );
  }, [
    dialogRowData?.applicationProgressId,
    dialogRowData?.isMeterAvailable,
    scoPart2Formik.values.iv_store_requisition_no,
    scoPart2Formik.values.iv_store_requisition_date,
    scoPart2Formik.values.iv_tariff_code,
    scoPart2Formik.values.iv_total_kwh,
    scoPart2Formik.values.iv_meter_category,
    scoPart2Formik.values.iv_meter_serial_no,
    scoPart2Formik.values.iv_manufacturer_code,
    scoPart2Formik.values.iv_date_of_connection,
    scoPart2Formik.values.iv_reading_info,
    storedMeterRemovedData,
    installedMeterImageThumbnail,
    selectedMCOTariffObj,
    openReadingInfoPopup,
    readingInfoDraft,
  ]);

  const readingInfoSaveEnabled = useMemo(
    () => openReadingInfoPopup && isReadingInfoComplete(true),
    [
      openReadingInfoPopup,
      readingInfoDraft,
      scoPart2Formik.values.iv_total_kwh,
      scoPart2Formik.values.iv_is_net_meter,
      selectedMCOTariffObj,
      meterRemovedSnapshotRows,
      storedMeterRemovedData,
    ],
  );

  useEffect(() => {
    if (storedMeterRemovedData) {
      setRemovedMeterDetailError("");
    }
  }, [storedMeterRemovedData]);

  useEffect(() => {
    if (shouldCaptureMdiValues) {
      return;
    }

    const currentMdi = String(scoPart2Formik.values.iv_mdi || "").trim();
    const currentResetCount = String(
      scoPart2Formik.values.iv_no_of_mdi_resets || "",
    ).trim();

    if (!currentMdi && !currentResetCount) {
      return;
    }

    scoPart2Formik.setFieldValue("iv_mdi", "", false);
    scoPart2Formik.setFieldValue("iv_no_of_mdi_resets", "", false);
  }, [
    shouldCaptureMdiValues,
    scoPart2Formik.values.iv_mdi,
    scoPart2Formik.values.iv_no_of_mdi_resets,
  ]);

  useEffect(() => {
    const totalKwh = String(scoPart2Formik.values.iv_total_kwh || "").trim();

    if (totalKwh === "1") {
      if (scoPart2Formik.values.iv_meter_code1 !== "000002") {
        scoPart2Formik.setFieldValue("iv_meter_code1", "000002", false);
      }
      if (scoPart2Formik.values.iv_meter_code2) {
        scoPart2Formik.setFieldValue("iv_meter_code2", "", false);
      }
      return;
    }

    if (Number(totalKwh) >= 2) {
      if (scoPart2Formik.values.iv_meter_code1 !== "050502") {
        scoPart2Formik.setFieldValue("iv_meter_code1", "050502", false);
      }
      if (scoPart2Formik.values.iv_meter_code2 !== "050602") {
        scoPart2Formik.setFieldValue("iv_meter_code2", "050602", false);
      }
      return;
    }

    if (scoPart2Formik.values.iv_meter_code1 || scoPart2Formik.values.iv_meter_code2) {
      scoPart2Formik.setFieldValue("iv_meter_code1", "", false);
      scoPart2Formik.setFieldValue("iv_meter_code2", "", false);
    }
  }, [scoPart2Formik.values.iv_total_kwh]);

  useEffect(() => {
    const readingRows = buildReadingRows(
      scoPart2Formik?.values?.iv_total_kwh,
      selectedMCOTariffObj,
    );

    if (readingRows.length === 0) {
      if (Object.keys(scoPart2Formik.values.iv_reading_info || {}).length > 0) {
        scoPart2Formik.setFieldValue("iv_reading_info", {}, false);
      }
      return;
    }

    const currentReadingInfo = scoPart2Formik.values.iv_reading_info || {};
    const nextReadingInfo = {};

    readingRows.forEach((row) => {
      const existingRow = currentReadingInfo[row.key] || {};
      nextReadingInfo[row.key] = {
        ...existingRow,
        ...getReadingRowBaseData(row),
        meterReading: String(existingRow.meterReading || ""),
      };
    });

    const currentForRows = readingRows.reduce((acc, row) => {
      acc[row.key] = currentReadingInfo[row.key] || {};
      return acc;
    }, {});

    if (JSON.stringify(currentForRows) !== JSON.stringify(nextReadingInfo)) {
      scoPart2Formik.setFieldValue("iv_reading_info", nextReadingInfo, false);
    }
  }, [
    scoPart2Formik.values.iv_total_kwh,
    scoPart2Formik.values.iv_is_net_meter,
    selectedMCOTariffObj,
    meterRemovedSnapshotRows,
    storedMeterRemovedData,
    ibsMeterIdBySetNo,
    scoPart2Formik.values.iv_meter_serial_no,
    scoPart2Formik.values.iv_manufacturer_code,
    scoPart2Formik.values.iv_meter_range,
    scoPart2Formik.values.iv_location_code,
    scoPart2Formik.values.iv_meter_code1,
    scoPart2Formik.values.iv_meter_code2,
    scoPart2Formik.values.iv_ct_nom,
    scoPart2Formik.values.iv_ct_denom,
    scoPart2Formik.values.iv_pt_nom,
    scoPart2Formik.values.iv_pt_denom,
    scoPart2Formik.values.iv_meter_typee,
    dialogRowData?.meterType,
  ]);

  const readingInfoTopError =
    readingInfoError ||
    (scoPart2Formik.submitCount > 0 &&
    typeof scoPart2Formik?.errors?.iv_reading_info === "string"
      ? scoPart2Formik.errors.iv_reading_info
      : "");

  const hasReadingInfoData = Object.values(
    scoPart2Formik.values?.iv_reading_info || {},
  ).some((row) => String(row?.meterReading || "").trim());

  const resolveMeterCount = (
    detailsObj,
    keyCandidates = [],
    fallbackValue = 0,
  ) => {
    for (const key of keyCandidates) {
      const rawValue = detailsObj?.[key];
      if (rawValue === null || rawValue === undefined || rawValue === "") {
        continue;
      }
      const parsed = Number(rawValue);
      if (Number.isFinite(parsed) && parsed > 0) {
        return Math.floor(parsed);
      }
    }

    const fallbackParsed = Number(fallbackValue);
    return Number.isFinite(fallbackParsed) && fallbackParsed > 0
      ? Math.floor(fallbackParsed)
      : 0;
  };

  const getRemovedMeterCount = (detailsObj) =>
    resolveMeterCount(detailsObj, [
      "R_NO_KWH_METER",
      "rNoKwhMeter",
      "r_no_kwh_meter",
    ]);

  const getInstalledMeterCount = (detailsObj) =>
    resolveMeterCount(detailsObj, [
      "I_NO_KWH_METER",
      "iNoKwhMeter",
      "i_no_kwh_meter",
      "iv_total_kwh",
    ]);

  const hasDisplayValue = (value) => {
    const parsed = String(value ?? "").trim().toLowerCase();
    return !["", "-", "null", "undefined", "nan"].includes(parsed);
  };

  const hasDisplayAmount = (value) => {
    if (value === null || value === undefined || value === "") {
      return false;
    }

    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) && parsedValue !== 0;
  };

  useEffect(() => {
    const amountFieldLabels = new Set([
      "Capital Cost Amount",
      "Installation Charges (8%)",
      "Civil Work Charges",
      "Fixed Charges Of Metering",
      "Miscellaneous Charges",
      "Amount of Grid Sharing",
      "Amount of Feeder Rehab",
      "M&T Charges",
      "Labour Charges",
      "Design Wetting Fee",
      "Consultancy Charges",
      "Variation Charges",
      "Dismantlement Charges",
      "Earthing Charges",
      "Less the Cost",
      "Grand Total",
      "Fixed Charges",
      "RCO Fee",
      "Total Fee",
      "Arrears Amount",
    ]);

    const timer = setTimeout(() => {
      const dialogNodes = document.querySelectorAll('[role="dialog"]');

      dialogNodes.forEach((dialogNode) => {
        const labelNodes = dialogNode.querySelectorAll("label.field-label");

        labelNodes.forEach((labelNode) => {
          const labelText = String(labelNode.textContent || "").replace(/\s+/g, " ").trim();
          const isStoreChargesField = labelText.startsWith("Store Charges (");
          const isAmountField = amountFieldLabels.has(labelText) || isStoreChargesField;

          if (!isAmountField) {
            return;
          }

          const wrapperNode = labelNode.closest("div");
          const inputNode = wrapperNode?.querySelector("input, textarea");
          const rawValue = String(inputNode?.value || "").trim();
          const normalizedValue = rawValue.toLowerCase();

          const parsedValue = Number(rawValue.replace(/,/g, "").replace(/^-/, ""));
          const shouldHide =
            rawValue === "" ||
            normalizedValue === "n/a" ||
            (Number.isFinite(parsedValue) && parsedValue === 0);

          if (wrapperNode) {
            wrapperNode.style.display = shouldHide ? "none" : "";
          }
        });
      });
    }, 0);

    return () => clearTimeout(timer);
  }, [
    historyData,
    arrearVerifiedSubPopUp,
    rcoFeeVoucherSubmissionSubPopUp,
    rcoFeeVoucherVerificationSubPopUp,
    fieldSurveySubPopUp,
    dnApprovalSubPopUp,
    dnSubmissionSubPopUp,
    dnVerificationSubPopUp,
  ]);

  const buildRemovedMeterRows = (detailsObj) => {
    const count = getRemovedMeterCount(detailsObj);
    const typeConfig = [
      {
        label: "KWH",
        mrKey: "R_MASTER_READING_KWH_",
        rdKey: "R_METER_READING_KWH_",
        auKey: "R_ADVANCE_UNIT_KWH_",
      },
      {
        label: "KVARH",
        mrKey: "R_MASTER_READING_KVARH_",
        rdKey: "R_METER_READING_KVARH_",
        auKey: "R_ADVANCE_UNIT_KVARH_",
      },
      {
        label: "MDI",
        mrKey: "R_MASTER_READING_MDI_",
        rdKey: "R_METER_READING_MDI_",
        auKey: "R_ADVANCE_UNIT_MDI_",
      },
    ];

    const rows = [];
    for (let setNo = 1; setNo <= count; setNo++) {
      const activeTypes = typeConfig.filter((type) =>
        [
          detailsObj?.[`${type.mrKey}${setNo}`],
          detailsObj?.[`${type.rdKey}${setNo}`],
          detailsObj?.[`${type.auKey}${setNo}`],
        ].some(hasDisplayValue),
      );

      const typesToRender = activeTypes.length > 0 ? activeTypes : [typeConfig[0]];

      typesToRender.forEach((type) => {
        const typeSuffix = type.label;
        rows.push({
          setNo,
          meterType:
            type.label === "KWH"
              ? 1
              : type.label === "KVARH"
                ? 2
                : type.label === "MDI"
                  ? 3
                  : type.label,
          serialNo: detailsObj?.R_METER_SERIAL_NO ?? "-",
          multiplyFactor: detailsObj?.[`R_MULTIPLYING_FACTOR_${setNo}`] ?? "-",
          masterReading: detailsObj?.[`${type.mrKey}${setNo}`] ?? "-",
          meterReading: detailsObj?.[`${type.rdKey}${setNo}`] ?? "-",
          advanceUnits: detailsObj?.[`${type.auKey}${setNo}`] ?? "-",
          roundingCompCode: detailsObj?.[`R_ROUNDING_COMP_CODE_${type.label}_${setNo}`] ?? "-",
          meterId: detailsObj?.[`R_METER_ID_${typeSuffix}_${setNo}`],
          removeMeterId: detailsObj?.[`R_METER_ID_${typeSuffix}_${setNo}`],
        });
      });
    }

    return tagRemovedRowsWithNetMeterFlag(rows);
  };

  const buildInstalledMeterRows = (detailsObj) => {
    const count = getInstalledMeterCount(detailsObj);
    const typeConfig = [
      {
        label: "KWH",
        rangeKey: "I_METER_RANGE_KWH_",
        readKey: "I_METER_READ_KWH_",
      },
      {
        label: "KVARH",
        rangeKey: "I_METER_RANGE_KVARH_",
        readKey: "I_METER_READ_KVARH_",
      },
      {
        label: "MDI",
        rangeKey: "I_METER_RANGE_MDI_",
        readKey: "I_METER_READ_MDI_",
      },
    ];

    const rows = [];
    for (let setNo = 1; setNo <= count; setNo++) {
      const activeTypes = typeConfig.filter((type) => {
        const hasTypeReading = [
          detailsObj?.[`${type.rangeKey}${setNo}`],
          detailsObj?.[`${type.readKey}${setNo}`],
        ].some(hasDisplayValue);

        if (type.label !== "MDI") {
          return hasTypeReading;
        }

        return (
          hasTypeReading ||
          [detailsObj?.I_MDI_RESET_NO, detailsObj?.I_MDI_CUMM_READ].some(
            hasDisplayValue,
          )
        );
      });

      const typesToRender = activeTypes.length > 0 ? activeTypes : [typeConfig[0]];

      typesToRender.forEach((type) => {
        rows.push({
          setNo,
          meterType: type.label,
          meterNumber: detailsObj?.I_METER_SERIAL_NO ?? "-",
          meterLocation: detailsObj?.I_LOCATION_CODE ?? "-",
          meterManufacturing: detailsObj?.I_MANUFACTURE_CODE ?? "-",
          meterCode: detailsObj?.[`I_METER_CD_${setNo}`] ?? "-",
          multiplyFactor: detailsObj?.[`I_MDI_MULTIPLYING_FACTOR_${setNo}`] ?? "-",
          meterRange: detailsObj?.[`${type.rangeKey}${setNo}`] ?? "-",
          meterReading: detailsObj?.[`${type.readKey}${setNo}`] ?? "-",
          feederCode: detailsObj?.I_FEEDER_CODE ?? "-",
          mdiResetNo: type.label === "MDI" ? (detailsObj?.I_MDI_RESET_NO ?? "-") : "-",
          mdiCumRead: type.label === "MDI" ? (detailsObj?.I_MDI_CUMM_READ ?? "-") : "-",
        });
      });
    }

    return rows;
  };

  const formatMeterTransTypeLabel = (transType) => {
    const typeCode = resolveRemovedMeterTransType(transType);
    if (typeCode === 1) return "KWH";
    if (typeCode === 2) return "KVARH";
    if (typeCode === 3) return "MDI";
    return hasDisplayValue(transType) ? String(transType) : "-";
  };

  const hasMeterTypeIdValue = (value) =>
    value !== null && value !== undefined && String(value).trim() !== "";

  const getMeterTypeDisplayLabelById = (typeOrId) => {
    if (!hasMeterTypeIdValue(typeOrId)) return "-";
    const typeCode = resolveRemovedMeterTransType(typeOrId);
    if (typeCode >= 1 && typeCode <= 3) {
      return formatMeterTransTypeLabel(typeCode);
    }
    return "-";
  };

  /** CP138 installedMeterProfile: installMeterId 1=KWH, 2=KVARH, 3=MDI. */
  const getInstalledMeterTypeDisplayLabel = (row = {}) => {
    const fromInstallMeterId = getMeterTypeDisplayLabelById(row.installMeterId);
    if (fromInstallMeterId !== "-") return fromInstallMeterId;

    const fromMeterType = getMeterTypeDisplayLabelById(row.meterType);
    if (fromMeterType !== "-") return fromMeterType;

    const fromMeterCode = resolveInstallMeterTypeFromCode(row.meterCode);
    return fromMeterCode || "-";
  };

  /** Display label: removeMeterId/installMeterId 1=KWH, 2=KVARH, 3=MDI (CP138 getCP138Data). */
  const getRemovedMeterTypeDisplayLabel = (row = {}) => {
    const removeMeterId = row.removeMeterId ?? row.meterId;
    if (hasMeterTypeIdValue(removeMeterId)) {
      const fromRemoveMeterId = getMeterTypeDisplayLabelById(removeMeterId);
      if (fromRemoveMeterId !== "-") return fromRemoveMeterId;
    }

    const fromInstallMeterId = getMeterTypeDisplayLabelById(row.installMeterId);
    if (fromInstallMeterId !== "-") return fromInstallMeterId;

    const fromMeterType = getMeterTypeDisplayLabelById(row.meterType);
    if (fromMeterType !== "-") return fromMeterType;

    const fromTransType = getMeterTypeDisplayLabelById(row.transType);
    if (fromTransType !== "-") return fromTransType;

    const fromMeterCode = resolveInstallMeterTypeFromCode(row.meterCode);
    return fromMeterCode || "-";
  };

  const formatProfileCellValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    return value;
  };

  const resolveInstallMeterTypeFromCode = (meterCode) => {
    const code = String(meterCode || "");
    if (code.includes("06")) return "KVARH";
    if (code.includes("08")) return "MDI";
    return "KWH";
  };

  const profileIndicatesNetMeter = (profile, setNoKey) =>
    (profile || []).some((item) => Number(item?.[setNoKey]) === 4);

  const buildRemovedMeterRowsFromProfile = (profile = []) => {
    const isNetMeterProfile = profileIndicatesNetMeter(profile, "removeSetNo");

    return profile.map((item) => ({
      setNo: item.removeSetNo,
      meterType: resolveRemovedMeterTransType(
        item.removeMeterId ?? item.meterType,
      ),
      serialNo: formatProfileCellValue(item.removeMeterSerial),
      multiplyFactor: formatProfileCellValue(item.removedMultiplyingFactor),
      masterReading: formatProfileCellValue(item.removeMeterMasterReading),
      meterReading: formatProfileCellValue(item.removeMeterReading),
      advanceUnits: formatProfileCellValue(
        item.removedAdvanceUnits ?? item.removeCons,
      ),
      roundingCompCode: formatProfileCellValue(item.removeRoundComCode),
      meterId: item.removeMeterId,
      removeMeterId: item.removeMeterId,
      tariffCd: meterRemovedTariffCd,
      isCp138ProfileRow: true,
      isNetMeterProfile,
    }));
  };

  const buildInstalledMeterRowsFromProfile = (profile = []) => {
    const isNetMeterProfile = profileIndicatesNetMeter(profile, "installSetNo");

    return profile.map((item) => ({
      setNo: item.installSetNo,
      installMeterId: item.installMeterId,
      meterType: resolveRemovedMeterTransType(
        item.installMeterId ?? item.meterType,
      ),
      meterNumber: formatProfileCellValue(item.installMeterSerial),
      meterLocation: formatProfileCellValue(item.installLocationCode),
      meterManufacturing: formatProfileCellValue(item.installMeterMNFG),
      meterCode: formatProfileCellValue(item.installMeterCode),
      multiplyFactor: formatProfileCellValue(item.installMultiplyingFactor),
      meterRange: formatProfileCellValue(item.installMeterRange),
      meterReading: formatProfileCellValue(item.installMeterReading),
      feederCode: formatProfileCellValue(item.installMeterFeederCode),
      mdiResetNo: formatProfileCellValue(item.installMDIResetNo),
      mdiCumRead: formatProfileCellValue(item.installCummulativeMDI),
      tariffCd: meterRemovedTariffCd,
      isCp138ProfileRow: true,
      isNetMeterProfile,
    }));
  };

  const getRemovedMeterTableRows = (detailsObj) => {
    if (detailsObj?.removedMeterProfile?.length) {
      return buildRemovedMeterRowsFromProfile(detailsObj.removedMeterProfile);
    }
    return buildRemovedMeterRows(detailsObj);
  };

  const getInstalledMeterTableRows = (detailsObj) => {
    if (detailsObj?.installedMeterProfile?.length) {
      return buildInstalledMeterRowsFromProfile(detailsObj.installedMeterProfile);
    }
    return buildInstalledMeterRows(detailsObj);
  };

  useEffect(() => {
    if (!openReadingInfoPopup) {
      setReadingInfoDraft({});
      return;
    }

    const draft = {};
    const readingRows = buildReadingRows(
      scoPart2Formik.values.iv_total_kwh,
      selectedMCOTariffObj,
    );

    readingRows.forEach((row) => {
      const rowValue = scoPart2Formik.values?.iv_reading_info?.[row.key];
      draft[row.key] = String(rowValue?.meterReading || "");
    });

    setReadingInfoDraft(draft);
  }, [
    openReadingInfoPopup,
    scoPart2Formik.values.iv_total_kwh,
    scoPart2Formik.values.iv_is_net_meter,
    selectedMCOTariffObj,
    meterRemovedSnapshotRows,
    storedMeterRemovedData,
  ]);

  useEffect(() => {
    if (!open) {
      setOpenMeterRemovedPopup(false);
      setOpenReadingInfoPopup(false);
    }
  }, [open]);

  const handleReadingInfoSave = async () => {
    const isValid = validateReadingInfoRows();

    if (!isValid) {
      // mark touched to show validation
      await scoPart2Formik.setFieldTouched("iv_reading_info", true, false);
      return;
    }

    setReadingInfoError("");

    // Build the new iv_reading_info object from draft and base data
    const readingRows = buildReadingRows(
      scoPart2Formik.values.iv_total_kwh,
      selectedMCOTariffObj,
    );

    const newReadingInfo = {};
    readingRows.forEach((row) => {
      const base = getReadingRowBaseData(row);
      const draftVal = readingInfoDraft && Object.prototype.hasOwnProperty.call(readingInfoDraft, row.key)
        ? String(readingInfoDraft[row.key] || "")
        : String((scoPart2Formik.values?.iv_reading_info?.[row.key]?.meterReading) || "");

      newReadingInfo[row.key] = {
        ...base,
        meterReading: draftVal,
      };
    });

    // commit to Formik
    await scoPart2Formik.setFieldValue("iv_reading_info", newReadingInfo, false);

    // Auto-populate iv_meter_reading for Normal meters
    const isNormalMeter =
      scoPart2Formik.values.iv_meter_typee !== "" &&
      scoPart2Formik.values.iv_meter_typee != null &&
      Number(scoPart2Formik.values.iv_meter_typee) === 0;
    if (isNormalMeter) {
      const normalMeterReading = newReadingInfo?.['1_1']?.meterReading;
      if (normalMeterReading) {
        await scoPart2Formik.setFieldValue('iv_meter_reading', normalMeterReading);
      }
    }

    // clear draft and close
    setReadingInfoDraft({});
    setOpenReadingInfoPopup(false);
  };

  const renderReadingInfoTable = () => {
    const totalKwhValid = isTotalKwhValidForReading();
    const readingRows = totalKwhValid
      ? buildReadingRows(
          scoPart2Formik.values.iv_total_kwh,
          selectedMCOTariffObj,
        )
      : [];

    return (
      <Box sx={{ m: 0 }}>
        {readingInfoTopError && (
          <div
            style={{
              background: "#ffebee",
              border: "1px solid #f44336",
              borderRadius: 8,
              padding: "12px 16px",
              marginBottom: 16,
              color: "#c62828",
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            {readingInfoTopError}
          </div>
        )}
        {!totalKwhValid ? (
          <div
            style={{
              background: "#fff8e1",
              border: "1px solid #ffe082",
              borderRadius: 8,
              padding: "16px 20px",
              color: "#6d4c00",
              fontSize: 14,
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            Please enter a valid Total kWh (2 for standard meter, 4 for Net
            Meter) to load reading rows.
          </div>
        ) : (
        <div
          style={{
            overflowX: "auto",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: 0,
              fontSize: 13,
            }}
          >
            <thead>
              <tr>
                {[
                  "Set No",
                  "Meter Type",
                  "Meter Serial No",
                  "Meter Manufacturer",
                  "Meter Range",
                  "Meter Location",
                  "Meter Code",
                  "Multiply Factor",
                  "Meter Reading",
                ].map((header) => (
                  <th
                    key={header}
                    style={{
                      background: "#006ad1",
                      color: "#fff",
                      padding: "11px 10px",
                      textAlign: "center",
                      fontWeight: 600,
                      fontSize: 12,
                      borderRight: "1px solid rgba(255,255,255,0.15)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {readingRows.length === 0 ? (
                <tr>
                  <td
                    colSpan={9}
                    style={{
                      textAlign: "center",
                      padding: "16px",
                      color: "#888",
                    }}
                  >
                    No reading information data available.
                  </td>
                </tr>
              ) : (
                readingRows.map((row, idx) => {
                  const rowData =
                    scoPart2Formik.values?.iv_reading_info?.[row.key] || {};
                  const baseData = getReadingRowBaseData(row);
                  const resolvedRow = {
                    ...rowData,
                    ...baseData,
                    meterReading: rowData.meterReading || "",
                  };
                  const setNoNum = Number(row.setNo);
                  const isOffPeakRow = setNoNum % 2 === 1;

                  return (
                    <tr
                      key={row.key}
                      style={{
                        background: idx % 2 === 0 ? "#fafafe" : "#f4f4fb",
                      }}
                    >
                      <td style={tdStyle}>
                        <Chip>{resolvedRow.setNoLabel || ""}</Chip>
                      </td>
                      <td style={tdStyle}>
                        <Chip>{resolvedRow.meterTypeLabel || ""}</Chip>
                      </td>
                      <td style={tdStyle}>
                        <input
                          readOnly
                          value={resolvedRow.meterSerialNo || ""}
                          style={{
                            width: 100,
                            border: "1.5px solid #c7c7e8",
                            borderRadius: 6,
                            padding: "4px 8px",
                            fontSize: 13,
                            textAlign: "center",
                            background: "#f2f2fa",
                            color: "#333",
                            outline: "none",
                            cursor: "default",
                          }}
                        />
                      </td>
                      <td style={tdStyle}>
                        <input
                          readOnly
                          value={resolvedRow.meterManufacturer || ""}
                          style={{
                            width: 100,
                            border: "1.5px solid #c7c7e8",
                            borderRadius: 6,
                            padding: "4px 8px",
                            fontSize: 13,
                            textAlign: "center",
                            background: "#f2f2fa",
                            color: "#333",
                            outline: "none",
                            cursor: "default",
                          }}
                        />
                      </td>
                      <td style={tdStyle}>
                        <ReadonlyInput value={resolvedRow.meterRange || ""} />
                      </td>
                      <td style={tdStyle}>
                        <ReadonlyInput value={resolvedRow.meterLocation || ""} />
                      </td>
                      <td style={tdStyle}>
                        <ReadonlyInput
                          value={
                            isOffPeakRow
                              ? resolvedRow.meterCodeOffPeak || ""
                              : resolvedRow.meterCodePeak || ""
                          }
                        />
                      </td>
                      <td style={tdStyle}>
                        <ReadonlyInput value={resolvedRow.multiplyFactor || ""} />
                      </td>
                      <td style={tdStyle}>
                        <input
                          type="text"
                          inputMode="decimal"
                          value={
                            Object.prototype.hasOwnProperty.call(
                              readingInfoDraft,
                              row.key,
                            )
                              ? readingInfoDraft[row.key]
                              : resolvedRow.meterReading || ""
                          }
                          onChange={(e) => {
                            const nextValue = sanitizeDecimalInput(e.target.value);
                            setReadingInfoDraft((prev) => ({
                              ...prev,
                              [row.key]: nextValue,
                            }));
                            handleReadingInfoChange(
                              row.key,
                              "meterReading",
                              nextValue,
                            );
                          }}
                          onKeyDown={restrictToDecimalInput}
                          onKeyDownCapture={(e) => e.stopPropagation()}
                          onKeyUpCapture={(e) => e.stopPropagation()}
                          style={{
                            width: 88,
                            border: "1.5px solid #c7c7e8",
                            borderRadius: 6,
                            padding: "6px 8px",
                            fontSize: 13,
                            textAlign: "center",
                            background: "#fff",
                            color: "#333",
                            outline: "none",
                            transition: "border-color 0.15s",
                          }}
                          onFocus={(e) => (e.target.style.borderColor = "#006ad1")}
                          onBlur={(e) => (e.target.style.borderColor = "#c7c7e8")}
                        />
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        )}
      </Box>
    );
  };

  const handleBatchEditClick = () => {
    setShowUpdateBatchPopup(true);
  };

  // Function to fetch meter profile from API
  const fetchMeterRemovedData = async (customerId) => {
    setMeterRemovedLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const response = await fetch(
        cfpBaseUrl + "meterChangeOrder/getIBSMeterProfile",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({ customerId: customerId }),
          redirect: "follow",
        },
      );
      const result = await response.json();
      const profileData = Array.isArray(result?.data) ? result.data : [];
      const isSuccessStatus =
        result?.status === 200 ||
        result?.status === "200" ||
        response.ok;

      if (isSuccessStatus && profileData.length > 0) {
        setMeterRemovedTariffCd(String(profileData[0]?.TARIFF_CD ?? "").trim());
        setIbsMeterIdBySetNo(buildIbsMeterIdMap(profileData));
        setIbsMaxRemovedSetNo(getMaxSetNoFromIbsProfile(profileData));
        const isNetMeterProfile = ibsProfileIndicatesNetMeter(profileData);
        const mappedRows = profileData.map((item) => {
          const masterReading =
            item.METER_READING === null || item.METER_READING === undefined
              ? ""
              : item.METER_READING;
          const meterReading =
            item.METER_READING === null || item.METER_READING === undefined
              ? ""
              : item.METER_READING;
          const multiplyFactor =
            item.MULTIPLY_FACTOR === null || item.MULTIPLY_FACTOR === undefined
              ? ""
              : item.MULTIPLY_FACTOR;
          const meterTypeFromMeterId = resolveRemovedMeterTransType(item.METER_ID);
          const meterTypeFromCode = resolveInstallMeterTypeFromCode(
            item.METER_CODE,
          );
          const meterType =
            meterTypeFromMeterId >= 1 && meterTypeFromMeterId <= 3
              ? meterTypeFromMeterId
              : meterTypeFromCode === "KVARH"
                ? 2
                : meterTypeFromCode === "MDI"
                  ? 3
                  : 1;
          return {
            setNo: item.SET_NO ?? "",
            tariffCd: String(item.TARIFF_CD ?? "").trim(),
            meterType,
            meterCode: item.METER_CODE || "",
            meterId: item.METER_ID,
            removeMeterId: item.METER_ID,
            serialNo: item.METER_SERIAL_NO || "",
            multiplyFactor,
            masterReading,
            meterReading,
            advanceUnits: computeMeterRemovedAdvanceUnits(
              masterReading,
              meterReading,
              multiplyFactor,
            ),
            roundingCompCode: "",
            isNetMeterProfile,
          };
        });
        applyMeterRemovedRows(mappedRows);
      } else {
        setIbsMeterIdBySetNo({});
        setIbsMaxRemovedSetNo(0);
        setMeterRemovedSnapshotRows(null);
        setMeterRemovedDraftRows([
          {
            setNo: 1,
            meterType: "",
            serialNo: "",
            multiplyFactor: "",
            masterReading: "",
            meterReading: "",
            advanceUnits: "",
            roundingCompCode: "",
          },
        ]);
        setMeterRemovedError(
          result?.message || "No meter profile found for this customer.",
        );
      }
    } catch (error) {
      setIbsMeterIdBySetNo({});
      setIbsMaxRemovedSetNo(0);
      setMeterRemovedSnapshotRows(null);
      setMeterRemovedDraftRows([
        {
          setNo: 1,
          meterType: "",
          serialNo: "",
          multiplyFactor: "",
          masterReading: "",
          meterReading: "",
          advanceUnits: "",
          roundingCompCode: "",
        },
      ]);
      setMeterRemovedError(
        "Unable to load removed meter profile. Please try again.",
      );
    } finally {
      setMeterRemovedLoading(false);
    }
  };

  const [rows, setRows] = useState([
    {
      setNo: 1,
      meterType: "",
      serialNo: "",
      multiplyFactor: "",
      masterReading: "",
      meterReading: "",
      advanceUnits: "",
      roundingCompCode: "",
    },
  ]);

  const cloneMeterRemovedRows = (sourceRows = []) =>
    sourceRows.map((row) => ({ ...row }));

  const setMeterRemovedDraftRows = (nextRows) => {
    const cloned = cloneMeterRemovedRows(nextRows);
    setRows(cloned);
    setMeterRemovedRowCount(cloned.length);
  };

  const applyMeterRemovedRows = (nextRows) => {
    const cloned = cloneMeterRemovedRows(nextRows);
    setRows(cloned);
    setMeterRemovedSnapshotRows(cloned);
    setMeterRemovedRowCount(cloned.length);
  };

  const resetMeterRemovedPopupDraft = () => {
    if (meterRemovedSnapshotRows?.length) {
      setRows(cloneMeterRemovedRows(meterRemovedSnapshotRows));
    }
    setMeterRemovedError("");
  };

  const closeMeterRemovedPopup = () => {
    resetMeterRemovedPopupDraft();
    setOpenMeterRemovedPopup(false);
  };

  const normalizeStoredRemovedMeterRows = (storedRows) =>
    tagRemovedRowsWithNetMeterFlag(
      storedRows.map((row) => ({
        ...row,
        masterReading:
          row.masterReading === "-" ? "" : String(row.masterReading ?? ""),
        meterReading:
          row.meterReading === "-" ? "" : String(row.meterReading ?? ""),
        serialNo: row.serialNo === "-" ? "" : String(row.serialNo ?? ""),
        multiplyFactor:
          row.multiplyFactor === "-" ? "" : String(row.multiplyFactor ?? ""),
        advanceUnits:
          row.advanceUnits === "-" ? "" : String(row.advanceUnits ?? ""),
        roundingCompCode:
          row.roundingCompCode === "-"
            ? ""
            : String(row.roundingCompCode ?? ""),
      })),
    );

  const resolveSavedMeterRemovedRows = () => {
    if (
      meterRemovedSnapshotRows?.length > 0 &&
      areRemovedMeterRowsPopulated(meterRemovedSnapshotRows)
    ) {
      return meterRemovedSnapshotRows;
    }

    if (storedMeterRemovedData?.removedMeterProfile?.length) {
      const profileRows = buildRemovedMeterRowsFromProfile(
        storedMeterRemovedData.removedMeterProfile,
      );
      if (areRemovedMeterRowsPopulated(profileRows)) {
        return profileRows;
      }
    }

    if (storedMeterRemovedData) {
      const legacyRows = buildRemovedMeterRows(storedMeterRemovedData);
      if (areRemovedMeterRowsPopulated(legacyRows)) {
        return legacyRows;
      }
    }

    return [];
  };

  const openMeterRemovedPopupDialog = async () => {
    const customerId = String(dialogRowData?.customerId ?? "").trim();
    setMeterRemovedError("");
    setOpenMeterRemovedPopup(true);

    const savedRows = resolveSavedMeterRemovedRows();
    if (areRemovedMeterRowsPopulated(savedRows)) {
      const editRows = normalizeStoredRemovedMeterRows(savedRows);
      setRows(cloneMeterRemovedRows(editRows));
      setMeterRemovedRowCount(editRows.length);
      return;
    }

    if (!customerId) {
      setMeterRemovedDraftRows([
        {
          setNo: 1,
          meterType: "",
          serialNo: "",
          multiplyFactor: "",
          masterReading: "",
          meterReading: "",
          advanceUnits: "",
          roundingCompCode: "",
        },
      ]);
      setMeterRemovedError(
        "Customer ID is missing. Cannot load removed meter profile.",
      );
      return;
    }

    await fetchMeterRemovedData(customerId);
  };

  const tdStyle = {
    padding: "8px 8px",
    textAlign: "center",
    borderBottom: "1px solid #e8e8f0",
  };

  const meterInstalledSetNoCellStyle = {
    ...tdStyle,
    minWidth: 118,
    width: 118,
    maxWidth: 140,
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: 1.35,
    verticalAlign: "middle",
  };

  const meterInstalledTypeCellStyle = {
    ...tdStyle,
    minWidth: 56,
    width: 56,
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  };

  function Chip({ children }) {
    return (
      <span
        style={{
          display: "inline-block",
          background: "#eef",
          border: "1.5px solid #c7c7e8",
          borderRadius: 6,
          padding: "3px 14px",
          fontSize: 13,
          fontWeight: 500,
          color: "#3a3a6e",
          minWidth: 32,
        }}
      >
        {children}
      </span>
    );
  }

  function ReadonlyInput({ value, highlight }) {
    return (
      <input
        readOnly
        value={value}
        style={{
          width: 80,
          border: "1.5px solid #c7c7e8",
          borderRadius: 6,
          padding: "4px 8px",
          fontSize: 13,
          textAlign: "center",
          background: highlight ? "#eef0ff" : "#f2f2fa",
          color: "#333",
          outline: "none",
          cursor: "default",
        }}
      />
    );
  }

  function EditableInput({ value, onChange }) {
    return (
      <input
        type="text"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={false}
        readOnly={false}
        style={{
          width: 88,
          border: "1.5px solid #c7c7e8",
          borderRadius: 6,
          padding: "6px 8px",
          fontSize: 13,
          textAlign: "center",
          background: "#fff",
          color: "#333",
          outline: "none",
          transition: "border-color 0.15s",
        }}
        onFocus={(e) => (e.target.style.borderColor = "#006ad1")}
        onBlur={(e) => (e.target.style.borderColor = "#c7c7e8")}
      />
    );
  }

  const getMeterTypeLabel = (meterTypeOrRow, rowMaybe) => {
    if (
      meterTypeOrRow &&
      typeof meterTypeOrRow === "object" &&
      !Array.isArray(meterTypeOrRow)
    ) {
      return getRemovedMeterTypeDisplayLabel(meterTypeOrRow);
    }
    return getRemovedMeterTypeDisplayLabel({
      meterType: meterTypeOrRow,
      ...(rowMaybe || {}),
    });
  };

  const getMcoResultDialogMeta = (severity, message = "") => {
    const msg = String(message).toLowerCase();
    if (severity === "error") {
      return { title: "Request Failed", isReject: true };
    }
    if (
      msg.includes("reject") ||
      msg.includes("objection") ||
      msg.includes("declined")
    ) {
      return { title: "Request Rejected", isReject: true };
    }
    if (
      msg.includes("submit") ||
      msg.includes("uploaded") ||
      msg.includes("upload")
    ) {
      return { title: "Submitted Successfully", isReject: false };
    }
    if (msg.includes("verif")) {
      return { title: "Verified Successfully", isReject: false };
    }
    return { title: "Request Approved", isReject: false };
  };

  const handleCloseSnackbarDialog = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
    if (snackbar.severity === "success") {
      handleClose();
    }
  };

  const handleCloseResponseModal = () => {
    setOpenResponseModal(false);
    setResponseMessage("");
    setResponseMessageError("");
    arrearPaymentReceiptFormik.values.iv_arrear_paid_bill_document = null;
    arrearPaymentReceiptFormik.values.iv_arrear_payment_date = "";
    arrearPaymentReceiptFormik.values.iv_remarks_detail = "";
    arrearPaymentObjectionReceiptFormik.values.iv_obj_arrear_paid_bill_document =
      null;
    arrearPaymentObjectionReceiptFormik.values.iv__obj_arrear_payment_date = "";
    arrearPaymentObjectionReceiptFormik.values.iv_obj_remarks_detail = "";
  };

  const snackbarDialogMeta = getMcoResultDialogMeta(
    snackbar.severity,
    snackbar.message,
  );
  const responseModalMeta = getMcoResultDialogMeta(
    responseMessageError ? "error" : "success",
    responseMessageError || responseMessage,
  );

  return (
    <>
      <ServiceDashboardTables
        enabled={props.showTable && currentPath === "/meter-change-request-table"}
        isLoadingNormal={isLoad}
        isLoadingOverdue={isLoadd}
        normalTitle={`Meter Change Order ( ${numberFormatting(totalRecordsNormal) ? numberFormatting(totalRecordsNormal) : "-"} )`}
        overdueCount={numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"}
        normalColumns={tblColumns}
        overdueColumns={tblColumnsOverDue}
        normalData={reconnectionApplicationsToDataGrid}
        overdueData={reconnectionApplicationsOverDueToDataGrid}
        onRowClick={handleRowClick}
        mobileFields={["applicationId", "applicantName", "applicationStatusId"]}
        showCompanyFilter={code == 10}
        companies={companies}
        selectedOfficeCode={selectedOfficeCode}
        onOfficeCodeChange={setSelectedOfficeCode}
        normalTableProps={{
          firstPage: handleFirstPageNormal,
          lastPage: handleLastPageNormal,
          totalPages: totalPagesNormal,
          totalRecords: totalRecordsNormal,
          currentPage: currentPageNormal,
          handleFilterDateFrom: handleDateFromFilterNormal,
          handleFilterDateTo: handleDateToFilterNormal,
          resetDateFilter: handleResetDateFilterNormal,
          handleFilterProgressId: handleProgressIdFilterNormal,
          handleFilterObjectionStatus: handleObjectionStatusFilterNormal,
          resetProgressIdFilter: handleResetProgressIdFilterNormal,
          resetObjectionStatusFilter: handleResetObjectionStatusFilterNormal,
          nextPage: handleNextPageNormal,
          previousPage: handlePreviousPageNormal,
        }}
        overdueTableProps={{
          firstPage: handleFirstPageOverdue,
          nextPage: handleNextPageOverdue,
          previousPage: handlePreviousPageOverdue,
          lastPage: handleLastPageOverdue,
          handleFilterDateFrom: handleDateFromFilterOverdue,
          handleFilterDateTo: handleDateToFilterOverdue,
          resetDateFilter: handleResetDateFilterOverdue,
          resetProgressIdFilter: handleResetProgressIdFilterOverdue,
          resetObjectionStatusFilter: handleResetObjectionStatusFilterOverdue,
          handleFilterProgressId: handleProgressIdFilterOverdue,
          handleFilterObjectionStatus: handleObjectionStatusFilterOverdue,
          totalPages: totalPagesOverdue,
          totalRecords: totalRecordsOverdue,
          currentPage: currentPageOverdue,
        }}
      />

      {/* Main Popup */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="xl"
        {...workflowDialogShellProps(isWorkflowMobile)}
        className={workflowDialogClassName("main-dialog rco-workflow-dialog", isWorkflowMobile)}
        PaperProps={{ className: "rco-workflow-dialog-paper" }}
      >
        <DialogTitle className="dialog-title">
          <div className="rco-dialog-header">
              <Typography className="applicationTitleText">
                Meter Change Order -
              <span style={{ color: "white" }}>
                  {dialogRowData.applicationProgressId === 0 &&
                    " Document Uploading"}
                  {dialogRowData.applicationProgressId === 1 &&
                    " Document Verification"}
                  {dialogRowData.applicationProgressId === 2 &&
                    " Approval / Rejection"}
                    {dialogRowData.applicationProgressId === 3 &&
                    " Arrear Verification"}
                  {dialogRowData.applicationProgressId === 4 && " Field Survey"}
                {dialogRowData.applicationProgressId === 5 &&
                  " M&T Report Submission"}
                  {dialogRowData.applicationProgressId === 6 && " DN Approval"}
                  {dialogRowData.applicationProgressId === 7 &&
                    " DN Submission"}
                  {dialogRowData.applicationProgressId === 8 &&
                    " DN Payment Verification"}
                  {dialogRowData.applicationProgressId === 9 &&
                    " Meter Installation"}
                  {dialogRowData.applicationProgressId === 10 &&
                    " Forward To RO"}
                  {dialogRowData.applicationProgressId === 11 &&
                    " Ready For Billing"}
                  {dialogRowData.applicationProgressId === 12 &&
                    " Application Completed"}
                </span>
              </Typography>
            <button
              type="button"
              className="rco-print-btn"
                onClick={() => downloadEFile(dialogRowData)}
              aria-label="Print E-File"
            >
              <PrintIcon />
            </button>
            <button
              type="button"
              className="closeIcon"
                onClick={handleClose}
              aria-label="Close dialog"
            >
              <CloseIcon id="clearPopup" sx={{ color: "white" }} />
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div" className="dialog-content">
            <Grid container className="headercontainer">
              <Grid item lg={12} className="status-bar">
                <StepProgressBar
                  array={rcoStatusBarArray}
                  applicationProgressId={
                    Number(dialogRowData.applicationProgressId) === 11
                      ? 10.5
                      : dialogRowData.applicationProgressId
                  }
                  skippedSteps={(() => {
                    const isMCO = Boolean(dialogRowData.isMCOWithCost);
                    const isReferred = Boolean(dialogRowData.isReferToMT);
                    const isMeterAvailable = Boolean(
                      dialogRowData.isMeterAvailable,
                    );
                    const pid = Number(dialogRowData.applicationProgressId);

                   if (isMCO && !isReferred && !isMeterAvailable && pid >= 9)
                      return [5, 6, 7, 8];
                    if (isMCO && !isReferred && isMeterAvailable && pid >= 6)
                      return [5];
                    if (isMCO && isReferred && pid === 5) return [];
                    if (!isMCO && isReferred && pid === 5) return [];
                    if (!isMCO && !isReferred && pid >= 9) return [5, 6, 7, 8];
                    if (isMCO && isReferred && !isMeterAvailable && pid >= 9)
                      return [6, 7, 8];
                    if (isMCO && isReferred && isMeterAvailable && pid === 6)
                      return [];
                    if (!isMCO && isReferred && pid >= 9) return [6, 7, 8];

                    return [];
                  })()}
                  openDetailsPopUp={() => {}}
                  pageName="Meter Change Order"
                />
              </Grid>
              <Grid item xs={12} className="application-details">
                <div className="rco-application-details-body">
                  <div className="rco-details-grid rco-details-grid--mco">
                    <div className="first-row-item rco-details-grid__app-id">
                    <p className="prop-title">Application Id</p>
                    <p className="prop-detail">
                      {dialogRowData?.applicationId ?? "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__name">
                    <p className="prop-title">Applicant Name</p>
                    <p className="prop-detail">
                      {dialogRowData?.consumerName ?? "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__cnic">
                    <p className="prop-title">Applicant CNIC</p>
                    <p className="prop-detail">
                      {dialogRowData?.consumerCNIC ?? "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__father-name">
                    <p className="prop-title">Father Name</p>
                    <p className="prop-detail">
                      {dialogRowData.consumerFatherName
                        ? dialogRowData.consumerFatherName
                        : "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__sanct-load">
                    <p className="prop-title">Sanct. Load (kW)</p>
                    <p className="prop-detail">
                      {dialogRowData?.sanctionedLoad ?? "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__conn-type">
                    <p className="prop-title">Connection Type</p>
                    <p className="prop-detail">
                      {dialogRowData?.connectionCategory ?? "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__meter-type">
                    <p className="prop-title">Meter Type</p>
                    <p className="prop-detail">
                        {getMeterType(dialogRowData?.meterPhaseType)}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__tariff">
                    <p className="prop-title">Tariff</p>
                    <p className="prop-detail">
                      {dialogRowData?.tariffDesc ?? "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__area-type">
                    <p className="prop-title">Area Type</p>
                    <p className="prop-detail">
                      {dialogRowData?.areaType === "U"
                        ? "Urban"
                        : dialogRowData?.areaType === "R"
                          ? "Rural"
                          : "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__subdivision">
                    <p className="prop-title">Subdivision</p>
                    <p className="prop-detail">
                      {subdivisionName(
                        dialogRowData?.subDivisionCode,
                        subDivisions,
                      ) ?? "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__ref-no">
                    <p className="prop-title">Ref. No.</p>
                    <p className="prop-detail">
                      {dialogRowData?.referenceNo ?? "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__consumer-id">
                    <p className="prop-title">Consumer Id.</p>
                    <p className="prop-detail">
                      {dialogRowData?.customerId ?? "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__phone">
                    <p className="prop-title">Phone No.</p>
                    <p className="prop-detail">
                      {dialogRowData?.applicantMobileNo ?? "-"}
                    </p>
                    </div>
                    <div className="first-row-item rco-details-grid__address">
                    <p className="prop-title">Address</p>
                    <p className="prop-detail">
                      {dialogRowData?.consumerAddress ?? "-"}
                    </p>
                </div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} className="rco-workflow-panels-wrap">
                <div className="rco-workflow-panels">
                  <div className="processing-summary">
                <div className="rco-activity-log-head">
                  <p className="title">Activity Log</p>
                  {eFileData && eFileData.length > 0 ? (
                    <button
                      type="button"
                      className="rco-activity-view-detail-btn"
                      onClick={() => setActivityLogDetailOpen(true)}
                    >
                      <VisibilityOutlinedIcon />
                      Timeline
                    </button>
                  ) : null}
                </div>

                <div className="rco-activity-log-body">
                {viewDropBackForEfile ? (
                  <div className="rco-load-activity-wrap rco-load-activity-wrap--loading">
                    <AppLoader size={30} />
                  </div>
                ) : eFileData && eFileData.length > 0 ? (
                  <ProcessingSummaryTableForCoa
                    key={tableDataProcessingSummary.length}
                    data={tableDataProcessingSummary}
                    columns={tableColumnsProcessingSummary}
                    openDetailsPopUp={(fullRow) => {
                      openDetailsPopUp(fullRow._raw);
                    }}
                  />
                ) : (
                  <div className="rco-load-activity-wrap">
                    <button
                      onClick={onPressViewActivityLog}
                      type="button"
                      className="rco-load-activity-btn"
                    >
                      Load Activity Log
                    </button>
                  </div>
                )}
                </div>
                  </div>
                  <div className="action-form">
                <div className="fields">
                  {dialogRowData.applicationProgressId === 0 ? (
                    <>
                      <h3 className="step-title">Documents Pending</h3>
                      <div className="description-box description-box--error">
                        <p className="group-description">
                          <InfoIcon className="icon" />
                          {CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                          )
                            ? "To process application, some documents are yet to be provided by the customer. If available, you can upload the remaining documents by clicking below button."
                            : "To process application, some documents are yet to be provided by the customer."}
                        </p>
                      </div>
                    </>
                  ) : dialogRowData.applicationProgressId === 1 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                      "Document Verification",
                    ) ? (
                      <>
                        <h3 className="step-title">Attached Documents</h3>
                        <Grid
                          className="document-verification-container"
                          container
                          spacing={1}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            marginTop: "1%",
                            padding: "2%",
                          }}
                        >
                          {error && (
                            <Error
                              error={error}
                              onClose={errorCloses}
                              backgroundColor="#FFC0CB"
                              textColor="#bb0303"
                              iconColor="#bb0303"
                            />
                          )}
                          {(dialogRowData.applicantCNICFront ||
                            dialogRowData.applicantCNICBack) && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor: getDocumentBackGroundColor(
                                    flag_applicantCNICFront,
                                  ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!copyOfApplicantCNICVerifyPopUp) {
                                        setCopyOfApplicantCNICVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    {dialogRowData.applicantCNICFront &&
                                    dialogRowData.applicantCNICFront.slice(
                                      0,
                                      6,
                                    ) == "data:i" ? (
                                      <Base64Image
                                        data={dialogRowData.applicantCNICFront}
                                        width="80"
                                      />
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {dialogRowData.applicantCNICBack &&
                                    dialogRowData.applicantCNICBack.slice(
                                      0,
                                      6,
                                    ) === "data:i" ? (
                                      flag_applicantCNICFront === 1 ||
                                      flag_applicantCNICBack === 1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.applicantCNICBack
                                            }
                                            width="80"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : flag_applicantCNICFront === -1 ||
                                        flag_applicantCNICBack === -1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.applicantCNICBack
                                            }
                                            width="80"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={dialogRowData.applicantCNICBack}
                                          width="80"
                                        />
                                      )
                                    ) : (
                                      flag_applicantCNICFront === 1 ||
                                      flag_applicantCNICBack === 1 ? (
                                        <>
                                          <Base64Image data={pdfIcon} width="40" />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : flag_applicantCNICFront === -1 ||
                                        flag_applicantCNICBack === -1 ? (
                                        <>
                                          <Base64Image data={pdfIcon} width="40" />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : (
                                        <Base64Image data={pdfIcon} width="40" />
                                      )
                                    )}
                                    {copyOfApplicantCNICVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={
                                          copyOfApplicantCNICVerifyPopUp
                                        }
                                        hideDocVerifyPopup={
                                          hideCopyOfApplicantCNICVerifyAlert
                                        }
                                        documentName="Applicant CNIC"
                                        documentImage={
                                          dialogRowData.applicantCNICFront
                                        }
                                        backDocumentImage={
                                          dialogRowData.applicantCNICBack
                                        }
                                        width={"100%"}
                                        document={
                                          dialogRowData.applicantCNICFront
                                        }
                                        documentFlag={
                                          dialogRowData.applicantCNICFrontFlag
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          applicantCNICBackObjectionRemarks
                                        }
                                        titleToUpdateFlag="copyOfApplicantCNIC"
                                        flag_document={flag_applicantCNICFront}
                                        flag_documentBack={
                                          flag_applicantCNICBack
                                        }
                                      />
                                    )}
                                  </div>
                                </Grid>
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Applicant's CNIC.</p>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}

                          {/* Electricity Bill Document */}
                          {dialogRowData.scannedCopyOfNearByElectricityBill && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor: getDocumentBackGroundColor(
                                    flag_scannedCopyOfNearByElectricityBill,
                                  ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!nearByBillVerifyPopUp) {
                                        setNearByBillVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    {dialogRowData.scannedCopyOfNearByElectricityBill &&
                                    dialogRowData.scannedCopyOfNearByElectricityBill.slice(
                                      0,
                                      6,
                                    ) == "data:i" ? (
                                      flag_scannedCopyOfNearByElectricityBill ===
                                      1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.scannedCopyOfNearByElectricityBill
                                            }
                                            width="80"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : flag_scannedCopyOfNearByElectricityBill ===
                                        -1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.scannedCopyOfNearByElectricityBill
                                            }
                                            width="80"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={
                                            dialogRowData.scannedCopyOfNearByElectricityBill
                                          }
                                          width="80"
                                        />
                                      )
                                    ) : flag_scannedCopyOfNearByElectricityBill ===
                                      1 ? (
                                      <>
                                        <Base64Image
                                          data={pdfIcon}
                                          width="40"
                                        />
                                        <img
                                          src={tickicon}
                                          width="25px"
                                          height="25px"
                                          alt="Tick Icon"
                                          className="doc-verification-status-icon"
                                        />
                                      </>
                                    ) : flag_scannedCopyOfNearByElectricityBill ===
                                      -1 ? (
                                      <>
                                        <Base64Image
                                          data={pdfIcon}
                                          width="40"
                                        />
                                        <img
                                          src={crossIcon}
                                          width="25px"
                                          height="25px"
                                          alt="Cross Icon"
                                          className="doc-verification-status-icon"
                                        />
                                      </>
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {nearByBillVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={nearByBillVerifyPopUp}
                                        hideDocVerifyPopup={
                                          hideNearByBillVerifyAlert
                                        }
                                        documentName="Electricity Bill"
                                        documentImage={
                                          dialogRowData.scannedCopyOfNearByElectricityBill
                                        }
                                        width={"100%"}
                                        document={
                                          dialogRowData.scannedCopyOfNearByElectricityBill
                                        }
                                        documentFlag={
                                          flag_scannedCopyOfNearByElectricityBill
                                        }
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          scannedCopyOfNearByElectricityBillObjectionRemarks
                                        }
                                        titleToUpdateFlag="scannedCopyOfNearByElectricityBill"
                                        flag_document={
                                          flag_scannedCopyOfNearByElectricityBill
                                        }
                                      />
                                    )}
                                  </div>
                                </Grid>
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Electricity Bill</p>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}

                          {/* Any Other Document */}
                          {dialogRowData.anyOtherDocument && (
                            <Grid item lg={2}>
                              <Grid
                                container
                                sx={{
                                  backgroundColor: getDocumentBackGroundColor(
                                    flag_anyOtherDocument,
                                  ),
                                  borderRadius: "10px",
                                  minHeight: "125px",
                                  height: "auto",
                                }}
                              >
                                <Grid
                                  item
                                  lg={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: "5px",
                                  }}
                                >
                                  <div
                                    onClick={() => {
                                      if (!anyOtherDocumentVerifyPopUp) {
                                        setAnyOtherDocumentVerifyPopUp(true);
                                      }
                                    }}
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    {dialogRowData.anyOtherDocument &&
                                    dialogRowData.anyOtherDocument.slice(
                                      0,
                                      6,
                                    ) == "data:i" ? (
                                      flag_anyOtherDocument === 1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.anyOtherDocument
                                            }
                                            width="80"
                                          />
                                          <img
                                            src={tickicon}
                                            width="25px"
                                            height="25px"
                                            alt="Tick Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : flag_anyOtherDocument === -1 ? (
                                        <>
                                          <Base64Image
                                            data={
                                              dialogRowData.anyOtherDocument
                                            }
                                            width="80"
                                          />
                                          <img
                                            src={crossIcon}
                                            width="25px"
                                            height="25px"
                                            alt="Cross Icon"
                                            className="doc-verification-status-icon"
                                          />
                                        </>
                                      ) : (
                                        <Base64Image
                                          data={dialogRowData.anyOtherDocument}
                                          width="80"
                                        />
                                      )
                                    ) : flag_anyOtherDocument === 1 ? (
                                      <>
                                        <Base64Image
                                          data={pdfIcon}
                                          width="40"
                                        />
                                        <img
                                          src={tickicon}
                                          width="25px"
                                          height="25px"
                                          alt="Tick Icon"
                                          className="doc-verification-status-icon"
                                        />
                                      </>
                                    ) : flag_anyOtherDocument === -1 ? (
                                      <>
                                        <Base64Image
                                          data={pdfIcon}
                                          width="40"
                                        />
                                        <img
                                          src={crossIcon}
                                          width="25px"
                                          height="25px"
                                          alt="Cross Icon"
                                          className="doc-verification-status-icon"
                                        />
                                      </>
                                    ) : (
                                      <Base64Image data={pdfIcon} width="40" />
                                    )}
                                    {anyOtherDocumentVerifyPopUp && (
                                      <OpenBase64ImageInPopup
                                        docVerifyPopUp={
                                          anyOtherDocumentVerifyPopUp
                                        }
                                        hideDocVerifyPopup={
                                          hideAnyOtherDocumentVerifyAlert
                                        }
                                        documentName="Other Document"
                                        documentImage={
                                          dialogRowData.anyOtherDocument
                                        }
                                        width={"100%"}
                                        document={
                                          dialogRowData.anyOtherDocument
                                        }
                                        documentFlag={flag_anyOtherDocument}
                                        applicationProgressId={
                                          dialogRowData.applicationProgressId
                                        }
                                        objectionStatus={
                                          dialogRowData.objectionStatus
                                        }
                                        updateDocFlag={updateDocFlag}
                                        documentRemarks={
                                          anyOtherDocumentObjectionRemarks
                                        }
                                        titleToUpdateFlag="anyOtherDocument"
                                        flag_document={flag_anyOtherDocument}
                                      />
                                    )}
                                  </div>
                                </Grid>
                                <Grid item lg={12} className="tittlegrid">
                                  <p className="docTitle">Other Document</p>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                          <div
    // className="description-box description-box--error"
    style={{
      marginTop: "1%",
      display: "flex",
      justifyContent: "center",
      width: "100%",
    }}
  >
    {reconnectionHistoryLoading ? (
      <p className="group-description">
        <InfoIcon className="icon" /> Loading MCO history...
      </p>
    ) : (
      <div style={{ width: "100%", padding: "0 12px 12px", boxSizing: "border-box" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
            fontSize: 20,
            borderRadius: 12,
            overflow: "hidden",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            backgroundColor: "#fff",
          }}
        >
          <thead>
            <tr>
              <th
                colSpan={4}
                style={{
                  background: "#185FA5",
                  color: "#fff",
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: 700,
                  fontSize: 15,
                  letterSpacing: "0.04em",
                  borderBottom: "1px solid rgba(255,255,255,0.22)",
                }}
              >
                MCO History
              </th>
            </tr>
            <tr>
              {["Reference No", "Disconnection Date", "Type", "Tariff Code"].map(
                (header) => (
                  <th
                    key={header}
                    style={{
                      background: "#185FA5",
                      color: "#fff",
                      padding: "14px",
                      textAlign: "center",
                      fontWeight: 600,
                      fontSize: 13,
                      letterSpacing: "0.05em",
                      borderRight: "1px solid rgba(255,255,255,0.18)",
                      borderBottom: "1px solid #dfe7f2",
                    }}
                  >
                    {header}
                  </th>
                )
              )}
            </tr>
          </thead>

         <tbody>
  {reconnectionHistoryRows.length > 0 ? (
    reconnectionHistoryRows.map((row, index) => (
      <tr
        key={`${row?.REFERENCE_NO || "ref"}-${index}`}
        style={{ borderBottom: "1px solid #dfe7f2" }}
      >
        <td style={{ borderRight: "1px solid #e7edf5", padding: "10px 12px", textAlign: "center" }}>
          {row?.REFERENCE_NO || "-"}
        </td>
        <td style={{ borderRight: "1px solid #e7edf5", padding: "10px 12px", textAlign: "center" }}>
          {row?.DISCONNECTION_DATE
            ? convertDate(row.DISCONNECTION_DATE)
            : "-"}
        </td>
        <td style={{ borderRight: "1px solid #e7edf5", padding: "10px 12px", textAlign: "center" }}>{row?.TYPE || "-"}</td>
        <td style={{ padding: "10px 12px", textAlign: "center" }}>{row?.TARIFF_CODE ?? "-"}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={4} style={{ textAlign: "center", padding: "10px",color:'#db6767',fontWeight:'bold' }}>
        No data found
      </td>
    </tr>
  )}
</tbody>
        </table>
      </div>
    )}
  </div>
                      </>
                    ) : (
                      <>
                        <h3 className="step-title">Documents Verification</h3>
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" /> Document verification
                            is in process by the Customer Service Lead.
                          </p>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 1 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">Documents Objection</h3>
                      <Grid
                        className="document-verification-container"
                        container
                        spacing={1}
                        sx={{ display: "flex", justifyContent: "flex-start" }}
                      >
                        {(dialogRowData.applicantCNICFront ||
                          dialogRowData.applicantCNICBack) && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(
                                  flag_applicantCNICFront,
                                ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Applicant's CNIC.</p>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingBottom: "5px",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!copyOfApplicantCNICVerifyPopUp) {
                                      setCopyOfApplicantCNICVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: "column",
                                  }}
                                >
                                  {dialogRowData.applicantCNICFront &&
                                  dialogRowData.applicantCNICFront.slice(
                                    0,
                                    6,
                                  ) == "data:i" ? (
                                    <Base64Image
                                      data={dialogRowData.applicantCNICFront}
                                      width="80"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {dialogRowData.applicantCNICBack &&
                                  dialogRowData.applicantCNICBack.slice(0, 6) ==
                                    "data:i" ? (
                                    <Base64Image
                                      data={dialogRowData.applicantCNICBack}
                                      width="80"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {copyOfApplicantCNICVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={
                                        copyOfApplicantCNICVerifyPopUp
                                      }
                                      hideDocVerifyPopup={
                                        hideCopyOfApplicantCNICVerifyAlert
                                      }
                                      documentName="Applicant CNIC"
                                      documentImage={
                                        dialogRowData.applicantCNICFront
                                      }
                                      backDocumentImage={
                                        dialogRowData.applicantCNICBack
                                      }
                                      width={400}
                                      document={
                                        dialogRowData.applicantCNICFront
                                      }
                                      documentFlag={
                                        dialogRowData.applicantCNICFrontFlag
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        applicantCNICFrontObjectionRemarks
                                      }
                                      titleToUpdateFlag="copyOfApplicantCNIC"
                                      flag_document={flag_applicantCNICFront}
                                      flag_documentBack={flag_applicantCNICBack}
                                    />
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {/* Electricity Bill Document - Objection View */}
                        {dialogRowData.scannedCopyOfNearByElectricityBill && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(
                                  flag_scannedCopyOfNearByElectricityBill,
                                ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Electricity Bill</p>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingBottom: "5px",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!nearByBillVerifyPopUp) {
                                      setNearByBillVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: "column",
                                  }}
                                >
                                  {dialogRowData.scannedCopyOfNearByElectricityBill &&
                                  dialogRowData.scannedCopyOfNearByElectricityBill.slice(
                                    0,
                                    6,
                                  ) == "data:i" ? (
                                    <Base64Image
                                      data={
                                        dialogRowData.scannedCopyOfNearByElectricityBill
                                      }
                                      width="80"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {nearByBillVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={nearByBillVerifyPopUp}
                                      hideDocVerifyPopup={
                                        hideNearByBillVerifyAlert
                                      }
                                      documentName="Electricity Bill"
                                      documentImage={
                                        dialogRowData.scannedCopyOfNearByElectricityBill
                                      }
                                      width={400}
                                      document={
                                        dialogRowData.scannedCopyOfNearByElectricityBill
                                      }
                                      documentFlag={
                                        flag_scannedCopyOfNearByElectricityBill
                                      }
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        scannedCopyOfNearByElectricityBillObjectionRemarks
                                      }
                                      titleToUpdateFlag="scannedCopyOfNearByElectricityBill"
                                      flag_document={
                                        flag_scannedCopyOfNearByElectricityBill
                                      }
                                    />
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {/* Any Other Document - Objection View */}
                        {dialogRowData.anyOtherDocument && (
                          <Grid item lg={2}>
                            <Grid
                              container
                              sx={{
                                backgroundColor: getDocumentBackGroundColor(
                                  flag_anyOtherDocument,
                                ),
                                borderRadius: "10px",
                                minHeight: "125px",
                                height: "auto",
                              }}
                            >
                              <Grid item lg={12} className="tittlegrid">
                                <p className="docTitle">Other Document</p>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  paddingBottom: "5px",
                                }}
                              >
                                <div
                                  onClick={() => {
                                    if (!anyOtherDocumentVerifyPopUp) {
                                      setAnyOtherDocumentVerifyPopUp(true);
                                    }
                                  }}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: "column",
                                  }}
                                >
                                  {dialogRowData.anyOtherDocument &&
                                  dialogRowData.anyOtherDocument.slice(0, 6) ==
                                    "data:i" ? (
                                    <Base64Image
                                      data={dialogRowData.anyOtherDocument}
                                      width="80"
                                    />
                                  ) : (
                                    <Base64Image data={pdfIcon} width="40" />
                                  )}
                                  {anyOtherDocumentVerifyPopUp && (
                                    <OpenBase64ImageInPopup
                                      docVerifyPopUp={
                                        anyOtherDocumentVerifyPopUp
                                      }
                                      hideDocVerifyPopup={
                                        hideAnyOtherDocumentVerifyAlert
                                      }
                                      documentName="Other Document"
                                      documentImage={
                                        dialogRowData.anyOtherDocument
                                      }
                                      width={400}
                                      document={dialogRowData.anyOtherDocument}
                                      documentFlag={flag_anyOtherDocument}
                                      applicationProgressId={
                                        dialogRowData.applicationProgressId
                                      }
                                      objectionStatus={
                                        dialogRowData.objectionStatus
                                      }
                                      updateDocFlag={updateDocFlag}
                                      documentRemarks={
                                        anyOtherDocumentObjectionRemarks
                                      }
                                      titleToUpdateFlag="anyOtherDocument"
                                      flag_document={flag_anyOtherDocument}
                                    />
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </>
                  ) : dialogRowData.applicationProgressId === 2 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval / Rejection",
                      ) &&
                      /* ========== LOAD <= 15 ========== */
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        /* ========== LOAD 15–70 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        /* ========== LOAD 70–500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        /* ========== LOAD > 500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500))  ? (
                      <>
  <h3 className="step-title" style={{ textAlign: "center" }}>
    Approval / Rejection
  </h3>

  <div
    // className="description-box description-box--error"
    style={{
      marginTop: "1%",
      display: "flex",
      justifyContent: "center",
      width: "100%",
    }}
  >
    {reconnectionHistoryLoading ? (
      <p className="group-description">
        <InfoIcon className="icon" /> Loading MCO history...
      </p>
    ) : (
      <div style={{ width: "100%", padding: "0 12px 12px", boxSizing: "border-box" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
            fontSize: 20,
            borderRadius: 12,
            overflow: "hidden",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            backgroundColor: "#fff",
          }}
        >
          <thead>
            <tr>
              <th
                colSpan={4}
                style={{
                  background: "#185FA5",
                  color: "#fff",
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: 700,
                  fontSize: 15,
                  letterSpacing: "0.04em",
                  borderBottom: "1px solid rgba(255,255,255,0.22)",
                }}
              >
                MCO History
              </th>
            </tr>
            <tr>
              {["Reference No", "Disconnection Date", "Type", "Tariff Code"].map(
                (header) => (
                  <th
                    key={header}
                    style={{
                      background: "#185FA5",
                      color: "#fff",
                      padding: "14px",
                      textAlign: "center",
                      fontWeight: 600,
                      fontSize: 13,
                      letterSpacing: "0.05em",
                      borderRight: "1px solid rgba(255,255,255,0.18)",
                      borderBottom: "1px solid #dfe7f2",
                    }}
                  >
                    {header}
                  </th>
                )
              )}
            </tr>
          </thead>

         <tbody>
  {reconnectionHistoryRows.length > 0 ? (
    reconnectionHistoryRows.map((row, index) => (
      <tr
        key={`${row?.REFERENCE_NO || "ref"}-${index}`}
        style={{ borderBottom: "1px solid #dfe7f2" }}
      >
        <td style={{ borderRight: "1px solid #e7edf5", padding: "10px 12px", textAlign: "center" }}>
          {row?.REFERENCE_NO || "-"}
        </td>
        <td style={{ borderRight: "1px solid #e7edf5", padding: "10px 12px", textAlign: "center" }}>
          {row?.DISCONNECTION_DATE
            ? convertDate(row.DISCONNECTION_DATE)
            : "-"}
        </td>
        <td style={{ borderRight: "1px solid #e7edf5", padding: "10px 12px", textAlign: "center" }}>{row?.TYPE || "-"}</td>
        <td style={{ padding: "10px 12px", textAlign: "center" }}>{row?.TARIFF_CODE ?? "-"}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={4} style={{ textAlign: "center", padding: "10px",color:'#db6767',fontWeight:'bold' }}>
        No data found
      </td>
    </tr>
  )}
</tbody>
        </table>
      </div>
    )}
  </div>
</>
                    ) : (
                      <>
                        <h3 className="step-title">Approval / Rejection</h3>
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" /> The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 2 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 1) ? (
                    
                      <>
                        <h3 className="step-title">Approval / Rejection</h3>
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" /> Application Rejected.
                          </p>
                        </div>
                      </>
                    ) 
                   : dialogRowData.applicationProgressId === 3 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title step-title--with-action"
                      >
                          <h4>Arrear Verification</h4>
                        {paymentStatus === "Arrear exists" && (
                          <Box className="step-title__actions">
                            <Button
                              className="rco-bill-btn"
                              variant="outlined"
                              onClick={() =>
                                downloadBill(dialogRowData.referenceNo)
                              }
                            >
                              <PrintIcon /> Bill
                            </Button>
                          </Box>
                        )}
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Arrears Verification",
                      ) &&
                      /* ========== LOAD <= 15 ========== */
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        /* ========== LOAD 15–70 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        /* ========== LOAD 70–500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        /* ========== LOAD > 500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          <Grid
                            container
                            className="field-survey-container"
                            spacing={3}
                          >
                            {!paymentStatus && (
                              <>
                                <Grid
                                  item
                                  lg={12}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "20px",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "20px",
                                      color: "#666",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    Click the button below to check arrears.
                                  </Typography>
                                </Grid>

                                <Grid
                                  item
                                  lg={12}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <button
                                    onClick={() => referenceApi(dialogRowData)}
                                    style={{
                                      backgroundColor: "#003971",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "20px",
                                      padding: "10px 40px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                    }}
                                    className="view-button"
                                  >
                                    Check Arrears
                                  </button>
                                </Grid>
                              </>
                            )}

                            {paymentStatus && (
                              <Grid
                                item
                                lg={12}
                                sx={{
                                  textAlign: "center",
                                  marginTop: "20px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    color:
                                      paymentStatus === "No arrear exists"
                                        ? "green"
                                        : "red",
                                    fontSize: "28px",
                                  }}
                                >
                                  {paymentStatus}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                          {paymentStatus === "Arrear exists" && (
                            <>
                              <Grid
                                container
                                className="dn-payment-submission-container rco-arrear-top-row"
                              >
                                <Grid item lg={4} className="item">
                                  <Typography className="title">
                                    Arrear Amount
                                  </Typography>
                                  <Typography className="value">
                                    {arrearAmount
                                      ? numberFormatting(arrearAmount)
                                      : "-"}
                                  </Typography>
                                </Grid>
                                <Grid item lg={4} className="item">
                                  <Typography className="title">
                                    Bill Month
                                  </Typography>
                                  <Typography className="value">
                                    {billMonth ? convertDate(billMonth) : "-"}
                                  </Typography>
                                </Grid>
                                <Grid item lg={4} className="item">
                                  <Typography className="title">
                                    Paid Bill Receipt
                                  </Typography>

                                  {arearPaidBillDocument ? (
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      className="rco-arrear-upload-btn"
                                      startIcon={
                                        <CloseIcon
                                          sx={{ color: "red" }}
                                          onClick={() => {
                                            setArearPaidBillDocument("");
                                            setArearPaidBillDocumentThumbnail(
                                              "",
                                            );

                                            arrearPaymentReceiptFormik.setFieldValue(
                                              "iv_arrear_paid_bill_document",
                                              "",
                                            );

                                            arrearPaymentReceiptFormik.setFieldTouched(
                                              "iv_arrear_paid_bill_document",
                                              true,
                                              true,
                                            );
                                          }}
                                        />
                                      }
                                    >
                                      {arearPaidBillDocumentThumbnail && (
                                        <>
                                          {arearPaidBillDocumentThumbnail.startsWith(
                                            "data:image/",
                                          ) ? (
                                            <img
                                              src={
                                                arearPaidBillDocumentThumbnail
                                              }
                                              alt="arear Paid receipt"
                                              width="80"
                                            />
                                          ) : arearPaidBillDocumentThumbnail.startsWith(
                                              "data:application/pdf",
                                            ) ? (
                                            <img
                                              src={pdfIcon}
                                              alt="arear Paid receipt"
                                              width="80"
                                            />
                                          ) : null}
                                        </>
                                      )}
                                    </Button>
                                  ) : (
                                      <Button
                                        variant="outlined"
                                        component="label"
                                        startIcon={<FileUploadOutlinedIcon />}
                                      className="rco-arrear-upload-btn"
                                      >
                                        Upload
                                        <input
                                          hidden
                                          accept={documentExtensions}
                                          id="iv_arrear_paid_bill_document"
                                          name="iv_arrear_paid_bill_document"
                                          type="file"
                                          onChange={PaidArrearsImage}
                                        />
                                      </Button>
                                  )}

                                  <Box className="form-error">
                                    {arearPaidBillDocumentError
                                      ? arearPaidBillDocumentError
                                      : null}
                                  </Box>
                                  <Box className="form-error">
                                    {arrearPaymentReceiptFormik.errors
                                      .iv_arrear_paid_bill_document &&
                                    arrearPaymentReceiptFormik.touched
                                      .iv_arrear_paid_bill_document
                                      ? arrearPaymentReceiptFormik.errors
                                          .iv_arrear_paid_bill_document
                                      : null}
                                  </Box>
                                </Grid>
                                </Grid>

                                <Grid
                                container
                                className="dn-payment-submission-container rco-arrear-bottom-row"
                                >
                                <Grid item lg={6} className="item">
                                  <Typography className="title">
                                    Payment Date
                                  </Typography>

                                  <TextField
                                    fullWidth
                                    size="small"
                                    id="iv_arrear_payment_date_field"
                                    name="iv_arrear_payment_date"
                                    type="date"
                                    value={
                                      arrearPaymentReceiptFormik.values
                                        .iv_arrear_payment_date
                                    }
                                    onChange={
                                      arrearPaymentReceiptFormik.handleChange
                                    }
                                    onBlur={
                                      arrearPaymentReceiptFormik.handleBlur
                                    }
                                    sx={{
                                      backgroundColor: "white",
                                      "& .MuiInputBase-root": {
                                        cursor: "pointer",
                                      },
                                    }}
                                    onClick={() =>
                                      document
                                        .getElementById(
                                          "iv_arrear_payment_date_field",
                                        )
                                        ?.showPicker?.()
                                    }
                                    inputProps={{
                                      max: new Date()
                                        .toISOString()
                                        .split("T")[0],
                                    }}
                                  />

                                  <Box className="form-error">
                                    {arrearPaymentReceiptFormik.touched
                                      .iv_arrear_payment_date &&
                                    arrearPaymentReceiptFormik.errors
                                      .iv_arrear_payment_date
                                      ? arrearPaymentReceiptFormik.errors
                                          .iv_arrear_payment_date
                                      : null}
                                  </Box>
                                </Grid>

                                <Grid item lg={6} className="item">
                                  <Typography className="title">
                                    Remarks Details
                                  </Typography>

                                  <TextField
                                    fullWidth
                                    size="small"
                                    id="iv_remarks_detail"
                                    name="iv_remarks_detail"
                                    placeholder="Enter remarks..."
                                    value={
                                      arrearPaymentReceiptFormik.values
                                        .iv_remarks_detail
                                    }
                                    onChange={
                                      arrearPaymentReceiptFormik.handleChange
                                    }
                                    onBlur={
                                      arrearPaymentReceiptFormik.handleBlur
                                    }
                                    sx={{
                                      backgroundColor: "white",
                                    }}
                                  />

                                  <Box className="form-error">
                                    {arrearPaymentReceiptFormik.touched
                                      .iv_remarks_detail &&
                                    arrearPaymentReceiptFormik.errors
                                      .iv_remarks_detail
                                      ? arrearPaymentReceiptFormik.errors
                                          .iv_remarks_detail
                                      : null}
                                  </Box>
                                </Grid>
                              </Grid>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 3 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <Grid
                        container
                        className="step-title step-title--with-action"
                      >
                          <h4>Arrear Objection</h4>
                        {paymentStatus === "Arrear exists" && (
                          <Box className="step-title__actions">
                            <Button
                              className="rco-bill-btn"
                              variant="outlined"
                              onClick={() =>
                                downloadBill(dialogRowData.referenceNo)
                              }
                            >
                              <PrintIcon /> Bill
                            </Button>
                          </Box>
                        )}
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Arrears Verification",
                      ) &&
                      /* ========== LOAD <= 15 ========== */
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        /* ========== LOAD 15–70 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        /* ========== LOAD 70–500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        /* ========== LOAD > 500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          <Grid
                            container
                            className="field-survey-container"
                            spacing={3}
                          >
                            {!paymentStatus && (
                              <>
                                <Grid
                                  item
                                  lg={12}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "20px",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      color: "#666",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    Click the button below to check arrears.
                                  </Typography>
                                </Grid>

                                <Grid
                                  item
                                  lg={12}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <button
                                    onClick={() => referenceApi(dialogRowData)}
                                    style={{
                                      backgroundColor: "#003971",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "20px",
                                      padding: "10px 40px",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                    }}
                                    className="view-button"
                                  >
                                    Check Arrears
                                  </button>
                                </Grid>
                              </>
                            )}

                            {paymentStatus && (
                              <Grid
                                item
                                lg={12}
                                sx={{
                                  textAlign: "center",
                                  marginTop: "20px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    color:
                                      paymentStatus === "No arrear exists"
                                        ? "green"
                                        : "red",
                                    fontSize: "28px",
                                  }}
                                >
                                  {paymentStatus}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                          {paymentStatus === "Arrear exists" && (
                            <>
                              <Grid
                                container
                                className="dn-payment-submission-container rco-arrear-top-row"
                              >
                                <Grid item lg={4} className="item">
                                  <Typography className="title">
                                    Arrear Amount
                                  </Typography>
                                  <Typography className="value">
                                    {arrearAmount
                                      ? numberFormatting(arrearAmount)
                                      : "-"}
                                  </Typography>
                                </Grid>
                                <Grid item lg={4} className="item">
                                  <Typography className="title">
                                    Bill Month
                                  </Typography>
                                  <Typography className="value">
                                    {billMonth ? convertDate(billMonth) : "-"}
                                  </Typography>
                                </Grid>
                                <Grid item lg={4} className="item">
                                  <Typography className="title">
                                    Paid Bill Receipt
                                  </Typography>

                                  {arearPaidBillDocument ? (
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      className="rco-arrear-upload-btn"
                                      startIcon={
                                        <CloseIcon
                                          sx={{ color: "red" }}
                                          onClick={() => {
                                            setArearPaidBillDocument("");
                                            setArearPaidBillDocumentThumbnail(
                                              "",
                                            );

                                            arrearPaymentObjectionReceiptFormik.setFieldValue(
                                              "iv_obj_arrear_paid_bill_document",
                                              "",
                                            );

                                            arrearPaymentObjectionReceiptFormik.setFieldTouched(
                                              "iv_obj_arrear_paid_bill_document",
                                              true,
                                              true,
                                            );
                                          }}
                                        />
                                      }
                                    >
                                      {arearPaidBillDocumentThumbnail && (
                                        <>
                                          {arearPaidBillDocumentThumbnail.startsWith(
                                            "data:image/",
                                          ) ? (
                                            <img
                                              src={
                                                arearPaidBillDocumentThumbnail
                                              }
                                              alt="arear Paid receipt"
                                              width="80"
                                            />
                                          ) : arearPaidBillDocumentThumbnail.startsWith(
                                              "data:application/pdf",
                                            ) ? (
                                            <img
                                              src={pdfIcon}
                                              alt="arear Paid receipt"
                                              width="80"
                                            />
                                          ) : null}
                                        </>
                                      )}
                                    </Button>
                                  ) : (
                                      <Button
                                        variant="outlined"
                                        component="label"
                                        startIcon={<FileUploadOutlinedIcon />}
                                      className="rco-arrear-upload-btn"
                                      >
                                        Upload
                                        <input
                                          hidden
                                          accept={documentExtensions}
                                          id="iv_obj_arrear_paid_bill_document"
                                          name="iv_obj_arrear_paid_bill_document"
                                          type="file"
                                          onChange={OBJPaidArrearsImage}
                                        />
                                      </Button>
                                  )}

                                  <Box className="form-error">
                                    {arearPaidBillDocumentError
                                      ? arearPaidBillDocumentError
                                      : null}
                                  </Box>
                                  <Box className="form-error">
                                    {arrearPaymentObjectionReceiptFormik.errors
                                      .iv_obj_arrear_paid_bill_document &&
                                    arrearPaymentObjectionReceiptFormik.touched
                                      .iv_obj_arrear_paid_bill_document
                                      ? arrearPaymentObjectionReceiptFormik
                                          .errors
                                          .iv_obj_arrear_paid_bill_document
                                      : null}
                                  </Box>
                                </Grid>
                                </Grid>

                                <Grid
                                container
                                className="dn-payment-submission-container rco-arrear-bottom-row"
                                >
                                <Grid item lg={6} className="item">
                                  <Typography className="title">
                                    Payment Date
                                  </Typography>

                                  <TextField
                                    fullWidth
                                    size="small"
                                    id="iv__obj_arrear_payment_date_field"
                                    name="iv__obj_arrear_payment_date"
                                    type="date"
                                    value={
                                      arrearPaymentObjectionReceiptFormik.values
                                        .iv__obj_arrear_payment_date
                                    }
                                    onChange={
                                      arrearPaymentObjectionReceiptFormik.handleChange
                                    }
                                    onBlur={
                                      arrearPaymentObjectionReceiptFormik.handleBlur
                                    }
                                    sx={{
                                      backgroundColor: "white",
                                      "& .MuiInputBase-root": {
                                        cursor: "pointer",
                                      },
                                    }}
                                    onClick={() =>
                                      document
                                        .getElementById(
                                          "iv__obj_arrear_payment_date_field",
                                        )
                                        ?.showPicker?.()
                                    }
                                    inputProps={{
                                      max: new Date()
                                        .toISOString()
                                        .split("T")[0],
                                    }}
                                  />

                                  <Box className="form-error">
                                    {arrearPaymentObjectionReceiptFormik.touched
                                      .iv__obj_arrear_payment_date &&
                                    arrearPaymentObjectionReceiptFormik.errors
                                      .iv__obj_arrear_payment_date
                                      ? arrearPaymentObjectionReceiptFormik
                                          .errors.iv__obj_arrear_payment_date
                                      : null}
                                  </Box>
                                </Grid>

                                <Grid item lg={6} className="item">
                                  <Typography className="title">
                                    Remarks Details
                                  </Typography>

                                  <TextField
                                    fullWidth
                                    size="small"
                                    id="iv_obj_remarks_detail"
                                    name="iv_obj_remarks_detail"
                                    placeholder="Enter remarks..."
                                    value={
                                      arrearPaymentObjectionReceiptFormik.values
                                        .iv_obj_remarks_detail
                                    }
                                    onChange={
                                      arrearPaymentObjectionReceiptFormik.handleChange
                                    }
                                    onBlur={
                                      arrearPaymentObjectionReceiptFormik.handleBlur
                                    }
                                    sx={{
                                      backgroundColor: "white",
                                    }}
                                  />

                                  <Box className="form-error">
                                    {arrearPaymentObjectionReceiptFormik.touched
                                      .iv_obj_remarks_detail &&
                                    arrearPaymentObjectionReceiptFormik.errors
                                      .iv_obj_remarks_detail
                                      ? arrearPaymentObjectionReceiptFormik
                                          .errors.iv_obj_remarks_detail
                                      : null}
                                  </Box>
                                </Grid>
                              </Grid>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 4 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                        }}
                      >
                        <h4 style={{ textAlign: "center", width: "100%" }}>
                          Field Survey
                        </h4>
                      </div>
                      {fieldSurveyError && (
                        <div
                          style={{
                            backgroundColor: "#FFF3F3",
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                            padding: "1%",
                            boxSizing: "border-box",
                            justifyContent: "space-between",
                            marginBottom: "1%",
                          }}
                        >
                          <div
                            style={{
                              backgroundColor: "#FFF3F3",
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: "1%",
                              width: "100%",
                              padding: "1%",
                              alignItems: "center",
                            }}
                          >
                            <ErrorIcon
                              style={{ color: "#bb0303", marginRight: "1%" }}
                            />

                            <p
                              style={{
                                color: "#bb0303",
                              }}
                            >
                              {fieldSurveyError}
                            </p>
                          </div>
                          <CloseIcon
                            onClick={errorCloses}
                            style={{
                              color: "#bb0303",
                              marginRight: "2%",
                              marginTop: "1%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      )}
                      {errormessageCostEstimation && (
                        <>
                          <div
                            style={{
                              backgroundColor: "#FFF3F3",
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                              padding: "1%",
                              boxSizing: "border-box",
                              justifyContent: "space-between",
                              marginBottom: "1%",
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: "#FFF3F3",
                                display: "flex",
                                flexDirection: "row",
                                marginLeft: "1%",
                                width: "100%",
                                padding: "1%",
                                alignItems: "center",
                              }}
                            >
                              <ErrorIcon
                                style={{
                                  color: "#bb0303",
                                  marginRight: "1%",
                                }}
                              />
                              <p
                                style={{
                                  color: "#bb0303",
                                }}
                              >
                                {errormessageCostEstimation}
                              </p>
                            </div>
                          </div>
                        </>
                      )}
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Field Survey",
                      ) &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        // ─── 0–70 kW — but MUST NOT be A1/A2/A3 ───────────────────────────────
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        // ─── 15–70 kW — any tariff (this allows A1/A2/A3 above 15 kW) ─────────
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        // ─── 70–500 kW ────────────────────────────────────────────────────────
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        // ─── > 500 kW ─────────────────────────────────────────────────────────
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <Grid
                          container
                          spacing={2}
                          className="field-survey-container"
                          alignItems="flex-start"
                          sx={{ padding: "8px 0" }}
                        >
                          {/* ══════════════════════════════════════════════════════════════ */}
                          {/*                    ROW 1: DROPDOWNS & RADIO BUTTONS             */}
                          {/* ══════════════════════════════════════════════════════════════ */}

                          {/* Site Observation */}
                          <Grid item lg={3} md={4} sm={6} xs={12}>
                            <Typography className="fieldLabel">
                              Site Observation
                            </Typography>
                            <Select
                              value={fieldFormik.values.iv_objection_Type}
                              onChange={(e) => {
                                fieldFormik.handleChange(e);
                                // Reset all form fields when site observation changes
                                fieldFormik.setFieldValue("iv_faultType", "");
                                fieldFormik.setFieldValue("isReadingAccessible", "");
                                fieldFormik.setFieldValue(
                                  "isReferToMst",
                                  isThreePhaseDialog ? "1" : "",
                                );
                                fieldFormik.setFieldValue("iv_meter_typee", "");
                                fieldFormik.setFieldValue("iv_meter_type", "");
                                fieldFormik.setFieldValue("isMeterAvailable", "");
                                // Reset all prepare estimate fieldFormik values
                                fieldFormik.setFieldValue("iv_grid_sharing_cost", 0);
                                fieldFormik.setFieldValue("iv_feeder_rehab_charges", 0);
                                fieldFormik.setFieldValue("iv_civil_work_charges", 0);
                                fieldFormik.setFieldValue("iv_fixed_charges_of_metering", 0);
                                fieldFormik.setFieldValue("iv_miscellaneous_charges", 0);
                                fieldFormik.setFieldValue("iv_less_the_cost", 0);
                                fieldFormik.setFieldValue("iv_mt_charges", 0);
                                fieldFormik.setFieldValue("iv_labour_charges", 0);
                                fieldFormik.setFieldValue("iv_design_wetting_fee", 0);
                                fieldFormik.setFieldValue("iv_consultancy_charges", 0);
                                fieldFormik.setFieldValue("iv_variation_charges", 0);
                                fieldFormik.setFieldValue("iv_dismantlement_charges", 0);
                                fieldFormik.setFieldValue("iv_earthing_charges", 0);
                                fieldFormik.setFieldValue("iv_items_array", []);
                                fieldFormik.setFieldValue("iv_fieldItemId", "");
                                fieldFormik.setFieldValue("iv_fieldItemQty", "");
                                fieldFormik.setFieldValue("iv_fieldItemRate", "");
                                fieldFormik.setFieldValue("iv_fieldItemUnit", "");
                                fieldFormik.setFieldValue("iv_fieldItemAmount", "");
                                // Reset state variables
                                setItemsArray([]);
                                setBoqItems([]);
                                setTotalCharges(0);
                                setGridSharingCost(0);
                                setFeederRehabilitationCharges(0);
                                setCivilWorkCharges(0);
                                setFixedChargesOfMetering(0);
                                setMiscellaneousCharges(0);
                                setLessTheCost(0);
                                setInstallationCharges(null);
                                setItemsAmount(null);
                                setStoreCharges(null);
                                // Reset images and documents
                                setMeterImage(null);
                                setMeterImageThumbnail("");
                                setMeterImageError("");
                                setSketchDiagram(null);
                                setSketchDiagramThumbnail("");
                                setSketchDiagramError(null);
                              }}
                              onBlur={fieldFormik.handleBlur}
                              className="fieldBatch"
                              name="iv_objection_Type"
                              id="iv_objection_Type"
                              displayEmpty
                              sx={{ width: "100%", backgroundColor: "white" }}
                            >
                              <MenuItem value="" disabled>
                                Select Observation
                              </MenuItem>
                              {dialogRowData.applicationProgressId === 4
                                ? fsObservations.map((option) => (
                                    <MenuItem
                                      key={option.observationId}
                                      value={option.observationId}
                                    >
                                      {option.observationName}
                                    </MenuItem>
                                  ))
                                : null}
                            </Select>
                            {fieldFormik.touched.iv_objection_Type &&
                              fieldFormik.errors.iv_objection_Type && (
                                <p className="form-error">
                                  {fieldFormik.errors.iv_objection_Type}
                                </p>
                              )}
                          </Grid>

                          {fieldFormik.values.iv_objection_Type !== 1 && (
                            <>
                              {/* Meter Fault */}
                              <Grid item lg={2} md={4} sm={6} xs={12}>
                                <Typography className="fieldLabel">
                                  Meter Fault
                                </Typography>
                                <Select
                                  value={fieldFormik.values.iv_faultType}
                                  onChange={fieldFormik.handleChange}
                                  onBlur={fieldFormik.handleBlur}
                                  className="fieldBatch"
                                  name="iv_faultType"
                                  id="iv_faultType"
                                  displayEmpty
                                  sx={{
                                    width: "100%",
                                    backgroundColor: "white",
                                  }}
                                >
                                  <MenuItem value="" disabled>
                                    Select Fault
                                  </MenuItem>
                                  {meterFaults.map((fault) => (
                                    <MenuItem
                                      key={fault.faultId}
                                      value={fault.faultId}
                                    >
                                      {fault.faultName}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {fieldFormik.touched.iv_faultType &&
                                  fieldFormik.errors.iv_faultType && (
                                    <p className="form-error">
                                      {fieldFormik.errors.iv_faultType}
                                    </p>
                                  )}
                              </Grid>

                              {/* Is Reading Accessible */}
                              <Grid item lg={2.4} md={3} sm={6} xs={12}>
                                <Typography className="fieldLabel">
                                  Is Reading Accessible?
                                </Typography>
                                <FormControl
                                  className="form-control"
                                  sx={{ width: "100%" }}
                                >
                                  <RadioGroup
                                    row
                                    name="isReadingAccessible"
                                    value={
                                      fieldFormik.values.isReadingAccessible
                                    }
                                    onChange={fieldFormik.handleChange}
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      flexWrap: "nowrap",
                                      gap: 0.5,
                                      mt: 0.5,
                                    }}
                                  >
                                    <FormControlLabel
                                      value="1"
                                      control={<Radio size="small" />}
                                      label="Yes"
                                      sx={{
                                        backgroundColor: "white",
                                        padding: "2px 10px",
                                        borderRadius: "6px",
                                        border: "1px solid #ddd",
                                        margin: 0,
                                        "& .MuiFormControlLabel-label": {
                                          fontSize: "13px",
                                        },
                                      }}
                                    />
                                    <FormControlLabel
                                      value="0"
                                      control={<Radio size="small" />}
                                      label="No"
                                      sx={{
                                        backgroundColor: "white",
                                        padding: "2px 10px",
                                        borderRadius: "6px",
                                        border: "1px solid #ddd",
                                        margin: 0,
                                        "& .MuiFormControlLabel-label": {
                                          fontSize: "13px",
                                        },
                                      }}
                                    />
                                  </RadioGroup>
                                </FormControl>
                                {fieldFormik.touched.isReadingAccessible &&
                                  fieldFormik.errors.isReadingAccessible && (
                                    <p className="form-error">
                                      {fieldFormik.errors.isReadingAccessible}
                                    </p>
                                  )}
                              </Grid>

                              {/* Is Refer to M&T */}
                              <Grid item lg={2.2} md={3} sm={6} xs={12}>
                                <Typography className="fieldLabel">
                                  Is Refer to M&T?
                                </Typography>
                                <FormControl
                                  className="form-control"
                                  sx={{ width: "100%" }}
                                >
                                  <RadioGroup
                                    row
                                    name="isReferToMst"
                                    value={fieldFormik.values.isReferToMst}
                                    onChange={
                                      isThreePhaseDialog
                                        ? undefined
                                        : fieldFormik.handleChange
                                    }
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      flexWrap: "nowrap",
                                      gap: 0.5,
                                      mt: 0.5,
                                    }}
                                  >
                                    <FormControlLabel
                                      value="1"
                                      control={<Radio size="small" />}
                                      label="Yes"
                                      disabled={isThreePhaseDialog}
                                      sx={{
                                        backgroundColor: "white",
                                        padding: "2px 10px",
                                        borderRadius: "6px",
                                        border: "1px solid #ddd",
                                        margin: 0,
                                        "& .MuiFormControlLabel-label": {
                                          fontSize: "13px",
                                        },
                                      }}
                                    />
                                    <FormControlLabel
                                      value="0"
                                      control={<Radio size="small" />}
                                      label="No"
                                      disabled={isThreePhaseDialog}
                                      sx={{
                                        backgroundColor: "white",
                                        padding: "2px 10px",
                                        borderRadius: "6px",
                                        border: "1px solid #ddd",
                                        margin: 0,
                                        "& .MuiFormControlLabel-label": {
                                          fontSize: "13px",
                                        },
                                      }}
                                    />
                                  </RadioGroup>
                                </FormControl>
                                {fieldFormik.touched.isReferToMst &&
                                  fieldFormik.errors.isReferToMst && (
                                    <p className="form-error">
                                      {fieldFormik.errors.isReferToMst}
                                    </p>
                                  )}
                              </Grid>

                              {/* ══════════════════════════════════════════════════════════════ */}
                              {/*                    ROW 2: ADDITIONAL FIELDS                    */}
                              {/* ══════════════════════════════════════════════════════════════ */}

                              {/* Fault Other Reason */}
                              {fieldFormik.values.iv_faultType ===
                                meterFaults.find(
                                  (fault) =>
                                    fault.faultName === "Any other reason",
                                )?.faultId && (
                                <Grid item lg={3} md={4} sm={6} xs={12}>
                                  <Typography className="fieldLabel">
                                    Specify Reason
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    className="fieldReferenceNo"
                                    size="small"
                                    type="text"
                                    name="iv_faultOtherReason"
                                    id="iv_faultOtherReason"
                                    placeholder="Enter reason"
                                    autoComplete="off"
                                    value={
                                      fieldFormik.values.iv_faultOtherReason
                                    }
                                    onChange={(e) => {
                                      fieldFormik.handleChange(e);
                                      fieldFormik.setFieldTouched(
                                        "iv_faultOtherReason",
                                        true,
                                        true,
                                      );
                                    }}
                                    onBlur={(e) => {
                                      fieldFormik.handleBlur(e);
                                      fieldFormik.setFieldTouched(
                                        "iv_faultOtherReason",
                                        true,
                                        true,
                                      );
                                    }}
                                    sx={{
                                      backgroundColor: "white",
                                      width: "100%",
                                      "& .MuiInputBase-root": { height: 45 },
                                    }}
                                  />
                                  {fieldFormik.touched.iv_faultOtherReason &&
                                    fieldFormik.errors.iv_faultOtherReason && (
                                      <p className="form-error">
                                        {fieldFormik.errors.iv_faultOtherReason}
                                      </p>
                                    )}
                                </Grid>
                              )}

                              {/* Defective Code - only for MCO Without Cost */}
                              {fieldFormik.values.iv_objection_Type === 3 && (
                                <Grid item lg={2} md={3} sm={6} xs={12}>
                                  <Typography className="fieldLabel">
                                    Defective Code
                                  </Typography>
                                  <FormControl
                                    className="form-control"
                                    sx={{ width: "100%" }}
                                  >
                                    <RadioGroup
                                      row
                                      name="isDefectiveCode"
                                      value={fieldFormik.values.isDefectiveCode}
                                      onChange={fieldFormik.handleChange}
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        flexWrap: "nowrap",
                                        gap: 0.5,
                                        mt: 0.5,
                                      }}
                                    >
                                      <FormControlLabel
                                        value="1"
                                        control={<Radio size="small" />}
                                        label="Yes"
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "2px 10px",
                                          borderRadius: "6px",
                                          border: "1px solid #ddd",
                                          margin: 0,
                                          "& .MuiFormControlLabel-label": {
                                            fontSize: "13px",
                                          },
                                        }}
                                      />
                                      <FormControlLabel
                                        value="0"
                                        control={<Radio size="small" />}
                                        label="No"
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "2px 10px",
                                          borderRadius: "6px",
                                          border: "1px solid #ddd",
                                          margin: 0,
                                          "& .MuiFormControlLabel-label": {
                                            fontSize: "13px",
                                          },
                                        }}
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                  {fieldFormik.touched.isDefectiveCode &&
                                    fieldFormik.errors.isDefectiveCode && (
                                      <p className="form-error">
                                        {fieldFormik.errors.isDefectiveCode}
                                      </p>
                                    )}
                                </Grid>
                              )}

                              {/* Meter Type - from dialogRowData.meterPhaseType (0=Normal, 1=Smart). Locked when value exists; editable only when null. */}
                              {(fieldFormik.values.iv_objection_Type === 2 ||
                                fieldFormik.values.iv_objection_Type === 3) &&
                                (() => {
                                  const raw = dialogRowData?.meterPhaseType;
                                  const lockedValue =
                                    raw === 0 ||
                                    raw === "0" ||
                                    raw === 1 ||
                                    raw === "1"
                                      ? String(raw)
                                      : null;
                                  const isMeterTypeLocked = lockedValue !== null;

                                  if (
                                    isMeterTypeLocked &&
                                    fieldFormik.values.iv_meter_type !==
                                      lockedValue
                                  ) {
                                    setTimeout(() => {
                                        fieldFormik.setFieldValue(
                                          "iv_meter_type",
                                        lockedValue,
                                    );
                                    }, 0);
                                  }

                                  return (
                                    <Grid item lg={2.4} md={4} sm={6} xs={12}>
                                      <Typography className="fieldLabel">
                                        Meter Type
                                      </Typography>
                                      <FormControl
                                        className="form-control"
                                        sx={{ width: "100%" }}
                                        disabled={isMeterTypeLocked}
                                      >
                                        <RadioGroup
                                          row
                                          name="iv_meter_type"
                                          value={
                                            isMeterTypeLocked
                                              ? lockedValue
                                              : fieldFormik.values
                                                  .iv_meter_type ?? ""
                                          }
                                          onChange={
                                            isMeterTypeLocked
                                              ? undefined
                                              : fieldFormik.handleChange
                                          }
                                          sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            flexWrap: "nowrap",
                                            gap: 0.5,
                                            mt: 0.5,
                                          }}
                                        >
                                          <FormControlLabel
                                            value="1"
                                            control={<Radio size="small" />}
                                            label="Smart"
                                            disabled={isMeterTypeLocked}
                                            sx={{
                                              backgroundColor:
                                                isMeterTypeLocked &&
                                                lockedValue === "1"
                                                  ? "#e3f2fd"
                                                  : "white",
                                              padding: "2px 10px",
                                              borderRadius: "6px",
                                              border: "1px solid #ddd",
                                              margin: 0,
                                              "& .MuiFormControlLabel-label": {
                                                fontSize: "13px",
                                              },
                                            }}
                                          />
                                          <FormControlLabel
                                            value="0"
                                            control={<Radio size="small" />}
                                            label="Normal"
                                            disabled={isMeterTypeLocked}
                                            sx={{
                                              backgroundColor:
                                                isMeterTypeLocked &&
                                                lockedValue === "0"
                                                  ? "#e3f2fd"
                                                  : "white",
                                              padding: "2px 10px",
                                              borderRadius: "6px",
                                              border: "1px solid #ddd",
                                              margin: 0,
                                              "& .MuiFormControlLabel-label": {
                                                fontSize: "13px",
                                              },
                                            }}
                                          />
                                        </RadioGroup>
                                      </FormControl>
                                      {fieldFormik.touched.iv_meter_type &&
                                        fieldFormik.errors.iv_meter_type && (
                                          <p className="form-error">
                                            {fieldFormik.errors.iv_meter_type}
                                          </p>
                                        )}
                                    </Grid>
                                  );
                                })()}

                              {/* Prepare Estimate - for MCO Without Cost */}
                              {fieldFormik.values.iv_objection_Type === 3 && (
                                <Grid item lg={1.8} md={3} sm={6} xs={12}>
                                  <Typography className="fieldLabel">
                                    {boqItems && boqItems.length > 0
                                      ? "Edit Estimate"
                                      : "Prepare Estimate"}
                                  </Typography>
                                  {boqItems.length === 0 ? (
                                    <Button
                                      variant="contained"
                                      fullWidth
                                      className="rco-field-survey-prepare-btn"
                                      startIcon={<AddIcon />}
                                      onClick={handlePrepareEstimate}
                                    >
                                      Prepare Estimate
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="contained"
                                      fullWidth
                                      className="rco-field-survey-prepare-btn rco-field-survey-prepare-btn--edit"
                                      startIcon={<EditIcon />}
                                      onClick={handleEditEstimate}
                                    >
                                      Edit Estimate
                                    </Button>
                                  )}
                                  {errormessageBoqEstimation && (
                                    <Typography
                                      variant="body2"
                                      color="error"
                                      sx={{ mt: 1 }}
                                    >
                                      {errormessageBoqEstimation}
                                    </Typography>
                                  )}
                                  {errormessageCostEstimation &&
                                    (errormessageCostEstimation.includes(
                                      "Prepare Estimate",
                                    ) ||
                                      errormessageCostEstimation.includes(
                                        "Meter Image",
                                      )) && (
                                      <Typography
                                        variant="body2"
                                        color="error"
                                        sx={{ mt: 1 }}
                                      >
                                        {errormessageCostEstimation}
                                      </Typography>
                                    )}
                                </Grid>
                              )}

                              {/* Is Meter Available - only for MCO With Cost */}
                              {fieldFormik.values.iv_objection_Type === 2 && (
                                <Grid item lg={2.2} md={3} sm={6} xs={12}>
                                  <Typography className="fieldLabel">
                                    Is Meter Available?
                                  </Typography>
                                  <FormControl
                                    className="form-control"
                                    sx={{ width: "100%" }}
                                  >
                                    <RadioGroup
                                      row
                                      name="isMeterAvailable"
                                      value={
                                        fieldFormik.values.isMeterAvailable
                                      }
                                      onChange={fieldFormik.handleChange}
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        flexWrap: "nowrap",
                                        gap: 0.5,
                                        mt: 0.5,
                                      }}
                                    >
                                      <FormControlLabel
                                        value="1"
                                        control={<Radio size="small" />}
                                        label="Yes"
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "2px 10px",
                                          borderRadius: "6px",
                                          border: "1px solid #ddd",
                                          margin: 0,
                                          "& .MuiFormControlLabel-label": {
                                            fontSize: "13px",
                                          },
                                        }}
                                      />
                                      <FormControlLabel
                                        value="0"
                                        control={<Radio size="small" />}
                                        label="No"
                                        sx={{
                                          backgroundColor: "white",
                                          padding: "2px 10px",
                                          borderRadius: "6px",
                                          border: "1px solid #ddd",
                                          margin: 0,
                                          "& .MuiFormControlLabel-label": {
                                            fontSize: "13px",
                                          },
                                        }}
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                  {fieldFormik.touched.isMeterAvailable &&
                                    fieldFormik.errors.isMeterAvailable && (
                                      <p className="form-error">
                                        {fieldFormik.errors.isMeterAvailable}
                                      </p>
                                    )}
                                </Grid>
                              )}

                              {/* Prepare Estimate - for MCO With Cost when meter is available */}
                              {fieldFormik.values.iv_objection_Type === 2 &&
                                fieldFormik.values.isMeterAvailable === "1" && (
                                  <Grid item lg={1.8} md={3} sm={6} xs={12}>
                                    <Typography className="fieldLabel">
                                      {boqItems && boqItems.length > 0
                                        ? "Edit Estimate"
                                        : "Prepare Estimate"}
                                    </Typography>
                                    {boqItems.length === 0 ? (
                                      <Button
                                        variant="contained"
                                        fullWidth
                                        className="rco-field-survey-prepare-btn"
                                        startIcon={<AddIcon />}
                                        onClick={handlePrepareEstimate}
                                      >
                                        Prepare Estimate
                                      </Button>
                                    ) : (
                                      <Button
                                        variant="contained"
                                        fullWidth
                                        className="rco-field-survey-prepare-btn rco-field-survey-prepare-btn--edit"
                                        startIcon={<EditIcon />}
                                        onClick={handleEditEstimate}
                                      >
                                        Edit Estimate
                                      </Button>
                                    )}
                                    {errormessageBoqEstimation && (
                                      <Typography
                                        variant="body2"
                                        color="error"
                                        sx={{ mt: 1 }}
                                      >
                                        {errormessageBoqEstimation}
                                      </Typography>
                                    )}
                                    {errormessageCostEstimation &&
                                      (errormessageCostEstimation.includes(
                                        "Prepare Estimate",
                                      ) ||
                                        errormessageCostEstimation.includes(
                                          "Meter Image",
                                        )) && (
                                        <Typography
                                          variant="body2"
                                          color="error"
                                          sx={{ mt: 1 }}
                                        >
                                          {errormessageCostEstimation}
                                        </Typography>
                                      )}
                                  </Grid>
                                )}
                            </>
                          )}

                          {/* Meter Image - always visible */}
                          <Grid item lg={1.8} md={3} sm={6} xs={12}>
                            <Typography className="fieldLabel">
                              Meter Image
                            </Typography>
                            {meterImage ? (
                              <div className="rco-field-survey-image-preview">
                                  {meterImageThumbnail && (
                                    <>
                                      {meterImageThumbnail.startsWith(
                                        "data:image/",
                                      ) ? (
                                        <img
                                          src={meterImageThumbnail}
                                          alt="Meter"
                                        />
                                      ) : meterImageThumbnail.startsWith(
                                          "data:application/pdf",
                                        ) ? (
                                        <img
                                          src={pdfIcon}
                                          alt="Meter PDF"
                                        />
                                      ) : null}
                                    </>
                                  )}
                                <button
                                  type="button"
                                  className="rco-field-survey-image-preview__remove"
                                  onClick={() => {
                                    setMeterImage(undefined);
                                    setMeterImageThumbnail("");
                                  }}
                                  aria-label="Remove meter image"
                                >
                                  <CloseIcon />
                                </button>
                              </div>
                            ) : (
                              <>
                                <Button
                                  variant="outlined"
                                  component="label"
                                  fullWidth
                                  startIcon={<FileUploadOutlinedIcon />}
                                  className="rco-field-survey-upload"
                                >
                                  Upload
                                  <input
                                    hidden
                                    accept={documentExtensions}
                                    type="file"
                                    onChange={MeterImageUpload}
                                  />
                                </Button>
                                <Box className="form-error">
                                  {meterImageError ? meterImageError : null}
                                </Box>
                              </>
                            )}
                          </Grid>
                        </Grid>
                      ) : (
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 4 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <h3 className="step-title">Field Survey Objection</h3>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Field Survey",
                      ) ? (
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            {dialogRowData.remarks}{" "}
                          </p>
                        </div>
                      ) : (
                        <>
                          <div className="description-box description-box--error">
                            <p className="group-description">
                              <InfoIcon className="icon" />
                              The application has been objected at field survey
                              stage. : {dialogRowData.remarks}{" "}
                            </p>
                          </div>
                        </>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 5 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>M&T Report Submission</h4>
                        </Grid>
                        <Grid item lg={1}></Grid>
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "M&T Report",
                      ) &&
                      /* ========== LOAD <= 15 ========== */
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        /* ========== LOAD 15–70 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        /* ========== LOAD 70–500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        /* ========== LOAD > 500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          <div className="rco-dn-submission-form">
                            <div className="rco-dn-submission-form__field">
                              <label
                                className="fieldLabel"
                                htmlFor="iv_mandt_report_no"
                              >
                                M&T Report No
                              </label>
                              <TextField
                                variant="outlined"
                                required
                                type="text"
                                autoComplete="off"
                                name="iv_mandt_report_no"
                                id="iv_mandt_report_no"
                                size="small"
                                fullWidth
                                value={
                                  mandtReceiptFormik.values.iv_mandt_report_no
                                }
                                onChange={(e) => {
                                  const onlyNumbers = e.target.value.replace(
                                    /[^0-9]/g,
                                    "",
                                  );
                                  mandtReceiptFormik.setFieldValue(
                                    "iv_mandt_report_no",
                                    onlyNumbers,
                                  );
                                }}
                                onBlur={mandtReceiptFormik.handleBlur}
                              />
                                {mandtReceiptFormik.errors.iv_mandt_report_no &&
                              mandtReceiptFormik.touched.iv_mandt_report_no ? (
                                <p className="rco-dn-submission-form__error">
                                  {mandtReceiptFormik.errors.iv_mandt_report_no}
                                </p>
                              ) : null}
                            </div>

                            <div className="rco-dn-submission-form__field">
                              <label
                                className="fieldLabel"
                                htmlFor="iv_mandt_payment_date"
                              >
                                M&T Report Date
                              </label>
                              <input
                                id="iv_mandt_payment_date"
                                name="iv_mandt_payment_date"
                                value={
                                  mandtReceiptFormik.values
                                    .iv_mandt_payment_date ?? ""
                                }
                                onChange={mandtReceiptFormik.handleChange}
                                onBlur={mandtReceiptFormik.handleBlur}
                                max={new Date().toISOString().split("T")[0]}
                                type="date"
                                className="rco-dn-submission-date"
                              />
                              {mandtReceiptFormik.errors.iv_mandt_payment_date &&
                              mandtReceiptFormik.touched.iv_mandt_payment_date ? (
                                <p className="rco-dn-submission-form__error">
                                  {
                                    mandtReceiptFormik.errors
                                      .iv_mandt_payment_date
                                  }
                                </p>
                              ) : null}
                            </div>

                            <div className="rco-dn-submission-form__field">
                              <label
                                className="fieldLabel"
                                htmlFor="iv_mandt_receipt_image"
                              >
                                M&T Report
                              </label>
                              {mandtReceiptImage ? (
                                <div className="rco-dn-receipt-preview">
                                    {mandtReceiptImageThumbnail && (
                                      <>
                                        {mandtReceiptImageThumbnail.startsWith(
                                          "data:image/",
                                        ) ? (
                                          <img
                                            src={mandtReceiptImageThumbnail}
                                            alt="M&T Report"
                                          />
                                        ) : mandtReceiptImageThumbnail.startsWith(
                                            "data:application/pdf",
                                          ) ? (
                                          <img
                                            src={pdfIcon}
                                            alt="M&T Report PDF"
                                          />
                                        ) : null}
                                      </>
                                    )}
                                  <button
                                    type="button"
                                    className="rco-dn-receipt-preview__remove"
                                    onClick={() => {
                                      setMandtReceiptImage("");
                                      setMandtReceiptImageThumbnail("");
                                      setMandtReceiptImageError(null);
                                      mandtReceiptFormik.setFieldValue(
                                        "iv_mandt_receipt_image",
                                        "",
                                      );
                                      mandtReceiptFormik.setFieldTouched(
                                        "iv_mandt_receipt_image",
                                        false,
                                      );
                                    }}
                                    aria-label="Remove M&T report"
                                  >
                                    <CloseIcon />
                                  </button>
                                </div>
                              ) : (
                                  <Button
                                    variant="outlined"
                                    component="label"
                                    startIcon={<FileUploadOutlinedIcon />}
                                  className="rco-dn-submission-upload"
                                  >
                                    Upload
                                    <input
                                      hidden
                                      accept={documentExtensions}
                                      id="iv_mandt_receipt_image"
                                      name="iv_mandt_receipt_image"
                                      type="file"
                                      onChange={MAndTReceiptImage}
                                      onBlur={() =>
                                        mandtReceiptFormik.setFieldTouched(
                                          "iv_mandt_receipt_image",
                                          true,
                                        )
                                      }
                                    />
                                  </Button>
                              )}
                              {mandtReceiptImageError ? (
                                <p className="rco-dn-submission-form__error">
                                  {mandtReceiptImageError}
                                </p>
                              ) : mandtReceiptFormik.errors.iv_mandt_receipt_image &&
                                mandtReceiptFormik.touched.iv_mandt_receipt_image ? (
                                <p className="rco-dn-submission-form__error">
                                  {
                                    mandtReceiptFormik.errors
                                  .iv_mandt_receipt_image
                                  }
                                </p>
                              ) : null}
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 6 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title"
                        sx={{ marginBottom: "1%", padding: "0.5%" }}
                      >
                        <Grid item lg={1}></Grid>
                        <Grid item lg={10} sx={{ textAlign: "center" }}>
                          <h4>DN Approval</h4>
                        </Grid>
                        <Grid item lg={1}></Grid>
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "DN Approval",
                      ) &&
                      /* ========== LOAD <= 15 ========== */
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        /* ========== LOAD 15–70 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        /* ========== LOAD 70–500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        /* ========== LOAD > 500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          {dnApproveStep && (
                            <Grid
                              container
                              spacing={2}
                              className="dn-payment-submission-container"
                            >
                              {(() => {
                                const roundOff = (value) =>
                                  Math.round(parseFloat(value) || 0);
                                const total = roundOff(
                                  dnApproveStep.serviceConnectionAmount,
                                );
                                const fields = [
                                  {
                                    label: "Issue Date",
                                    value: dnApproveStep.issueDate
                                      ? convertDate(dnApproveStep.issueDate)
                                      : null,
                                  },
                                  {
                                    label: "Due Date",
                                    value: dnApproveStep.dueDate
                                      ? convertDate(dnApproveStep.dueDate)
                                      : null,
                                  },
                                  {
                                    label: "Bank Name",
                                    value: dnApproveStep.bankName,
                                  },
                                  {
                                    label: "Grand Total",
                                    value: total,
                                  },
                                ];

                                const hasRaw = (value) => {
                                  if (value === null || value === undefined)
                                    return false;
                                  if (
                                    typeof value === "string" &&
                                    value.trim() === ""
                                  )
                                    return false;

                                  const normalized =
                                    typeof value === "string"
                                      ? value.replace(/,/g, "").trim()
                                      : value;
                                  const numericValue = Number(normalized);

                                  if (
                                    !Number.isNaN(numericValue) &&
                                    numericValue === 0
                                  )
                                    return false;

                                  return true;
                                };

                                const visibleFields = fields.filter((item) => {
                                  if (item.label === "Issue Date")
                                    return hasRaw(dnApproveStep.issueDate);
                                  if (item.label === "Due Date")
                                    return hasRaw(dnApproveStep.dueDate);
                                  if (item.label === "Bank Name")
                                    return hasRaw(dnApproveStep.bankName);
                                  if (item.label === "Grand Total")
                                    return hasRaw(dnApproveStep.serviceConnectionAmount);
                                  return true;
                                });

                                return visibleFields.map((item, index) => {
                                  const isFirstRow = index < 3;
                                  return (
                                    <Grid
                                      item
                                      key={index}
                                      className="item"
                                      sx={{
                                        flexBasis: {
                                          xs: "100%",
                                          md: isFirstRow ? "50%" : "33.3333%",
                                          lg: isFirstRow ? "33.3333%" : "20%",
                                        },
                                        maxWidth: {
                                          xs: "100%",
                                          md: isFirstRow ? "50%" : "33.3333%",
                                          lg: isFirstRow ? "33.3333%" : "20%",
                                        },
                                      }}
                                    >
                                      <Typography
                                        className="title"
                                        sx={{
                                          fontWeight: 600,
                                          color:
                                            item.label === "Grand Total"
                                              ? "#1976d2"
                                              : "#333",
                                        }}
                                      >
                                        {item.label}
                                      </Typography>
                                      <Typography
                                        className="value"
                                        sx={
                                          item.label === "Grand Total"
                                            ? {
                                                backgroundColor:
                                                  "#1976d2 !important",
                                                color: "#fff !important",
                                                fontSize: "1.1rem",
                                              }
                                            : { color: "#444" }
                                        }
                                      >
                                        {["Issue Date", "Due Date"].includes(
                                          item.label,
                                        )
                                          ? item.value
                                          : item.label === "Bank Name"
                                            ? item.value || "N/A"
                                            : numberFormatting(item.value)}
                                      </Typography>
                                    </Grid>
                                  );
                                });
                              })()}
                            </Grid>
                          )}
                        </>
                      ) : (
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 7 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title step-title--with-action"
                      >
                          <h4>DN Submission</h4>
                        <Box className="step-title__actions">
                          <Button
                            variant="outlined"
                            onClick={() => downloadDNPDF(dialogRowData)}
                            className="rco-bill-btn"
                          >
                            <PrintIcon /> DN
                          </Button>
                        </Box>
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "DN Submission",
                      ) ? (
                        <>
                          {dnApproveStep && (
                            <Grid
                              container
                              spacing={2}
                              className="dn-payment-submission-container"
                            >
                              {(() => {
                                const roundOff = (value) =>
                                  Math.round(parseFloat(value) || 0);
                                const total = roundOff(
                                  dnApproveStep.serviceConnectionAmount,
                                );
                                const fields = [
                                  {
                                    label: "Issue Date",
                                    value: dnApproveStep.issueDate
                                      ? convertDate(dnApproveStep.issueDate)
                                      : null,
                                  },
                                  {
                                    label: "Due Date",
                                    value: dnApproveStep.dueDate
                                      ? convertDate(dnApproveStep.dueDate)
                                      : null,
                                  },
                                  {
                                    label: "Bank Name",
                                    value: dnApproveStep.bankName,
                                  },
                                  {
                                    label: "Grand Total",
                                    value: total,
                                  },
                                ];

                                const hasRaw = (value) => {
                                  if (value === null || value === undefined)
                                    return false;
                                  if (
                                    typeof value === "string" &&
                                    value.trim() === ""
                                  )
                                    return false;

                                  const normalized =
                                    typeof value === "string"
                                      ? value.replace(/,/g, "").trim()
                                      : value;
                                  const numericValue = Number(normalized);

                                  if (
                                    !Number.isNaN(numericValue) &&
                                    numericValue === 0
                                  )
                                    return false;

                                  return true;
                                };

                                const visibleFields = fields.filter((item) => {
                                  if (item.label === "Issue Date")
                                    return hasRaw(dnApproveStep.issueDate);
                                  if (item.label === "Due Date")
                                    return hasRaw(dnApproveStep.dueDate);
                                  if (item.label === "Bank Name")
                                    return hasRaw(dnApproveStep.bankName);
                                  if (item.label === "Grand Total")
                                    return hasRaw(dnApproveStep.serviceConnectionAmount);
                                  return true;
                                });

                                return visibleFields.map((item, index) => {
                                  const isFirstRow = index < 3;
                                  return (
                                    <Grid
                                      item
                                      key={index}
                                      className="item"
                                      sx={{
                                        flexBasis: {
                                          xs: "100%",
                                          md: isFirstRow ? "50%" : "33.3333%",
                                          lg: isFirstRow ? "33.3333%" : "20%",
                                        },
                                        maxWidth: {
                                          xs: "100%",
                                          md: isFirstRow ? "50%" : "33.3333%",
                                          lg: isFirstRow ? "33.3333%" : "20%",
                                        },
                                      }}
                                    >
                                      <Typography
                                        className="title"
                                        sx={{
                                          fontWeight: 600,
                                          color:
                                            item.label === "Grand Total"
                                              ? "#1976d2"
                                              : "#333",
                                        }}
                                      >
                                        {item.label}
                                      </Typography>
                                      <Typography
                                        className="value"
                                        sx={
                                          item.label === "Grand Total"
                                            ? {
                                                backgroundColor:
                                                  "#1976d2 !important",
                                                color: "#fff !important",
                                                fontSize: "1.1rem",
                                              }
                                            : { color: "#444" }
                                        }
                                      >
                                        {["Issue Date", "Due Date"].includes(
                                          item.label,
                                        )
                                          ? item.value
                                          : item.label === "Bank Name"
                                            ? item.value || "N/A"
                                            : numberFormatting(item.value)}
                                      </Typography>
                                    </Grid>
                                  );
                                });
                              })()}
                            </Grid>
                          )}
                          <div className="rco-dn-submission-form">
                            <div className="rco-dn-submission-form__field">
                              <label
                                className="fieldLabel"
                                htmlFor="iv_dn_receipt_image"
                              >
                                Receipt Image
                              </label>
                              {dnReceiptImage ? (
                                <div className="rco-dn-receipt-preview">
                                    {dnReceiptImageThumbnail && (
                                      <>
                                        {dnReceiptImageThumbnail.startsWith(
                                          "data:image/",
                                        ) ? (
                                          <img
                                            src={dnReceiptImageThumbnail}
                                            alt="DN Receipt"
                                          />
                                        ) : dnReceiptImageThumbnail.startsWith(
                                            "data:application/pdf",
                                          ) ? (
                                          <img
                                            src={pdfIcon}
                                            alt="DN Receipt PDF"
                                          />
                                        ) : null}
                                      </>
                                    )}
                                  <button
                                    type="button"
                                    className="rco-dn-receipt-preview__remove"
                                    onClick={() => {
                                      setDnReceiptImage("");
                                      setDnReceiptImageThumbnail("");
                                      setDnReceiptImageError("");
                                      dnReceiptFormik.setFieldValue(
                                        "iv_dn_receipt_image",
                                        "",
                                      );
                                      dnReceiptFormik.setFieldTouched(
                                        "iv_dn_receipt_image",
                                        false,
                                      );
                                    }}
                                    aria-label="Remove receipt"
                                  >
                                    <CloseIcon />
                                  </button>
                                </div>
                              ) : (
                                  <Button
                                    variant="outlined"
                                    component="label"
                                    startIcon={<FileUploadOutlinedIcon />}
                                  className="rco-dn-submission-upload"
                                  >
                                    Upload
                                    <input
                                      hidden
                                      accept={documentExtensions}
                                      id="iv_dn_receipt_image"
                                      name="iv_dn_receipt_image"
                                      type="file"
                                      onChange={DnReceiptImage}
                                      onBlur={() =>
                                        dnReceiptFormik.setFieldTouched(
                                          "iv_dn_receipt_image",
                                          true,
                                        )
                                      }
                                    />
                                  </Button>
                              )}
                              {dnReceiptImageError ? (
                                <p className="rco-dn-submission-form__error">
                                  {dnReceiptImageError}
                                </p>
                              ) : null}
                            </div>

                            <div className="rco-dn-submission-form__field">
                              <label
                                className="fieldLabel"
                                htmlFor="iv_dn_fee_payment_date"
                              >
                                Payment Date
                              </label>
                              <input
                                id="iv_dn_fee_payment_date"
                                name="iv_dn_fee_payment_date"
                                value={
                                  dnReceiptFormik.values.iv_dn_fee_payment_date ??
                                  ""
                                }
                                onChange={dnReceiptFormik.handleChange}
                                onBlur={dnReceiptFormik.handleBlur}
                                type="date"
                                className="rco-dn-submission-date"
                                min={
                                  dnDets.issueDate
                                    ? dnDets.issueDate.slice(0, 10)
                                    : ""
                                }
                                max={
                                  dnDets.dueDate
                                    ? new Date().toISOString().split("T")[0] <=
                                      dnDets.dueDate.slice(0, 10)
                                      ? new Date().toISOString().split("T")[0]
                                      : dnDets.dueDate.slice(0, 10)
                                    : ""
                                }
                              />
                              {dnReceiptFormik.errors.iv_dn_fee_payment_date &&
                              dnReceiptFormik.touched.iv_dn_fee_payment_date ? (
                                <p className="rco-dn-submission-form__error">
                                  {dnReceiptFormik.errors.iv_dn_fee_payment_date}
                                </p>
                              ) : null}
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 7 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      <Grid
                        container
                        className="step-title step-title--with-action"
                      >
                          <h4>DN Objection</h4>
                        <Box className="step-title__actions">
                          <Button
                            variant="outlined"
                            onClick={() => downloadDNPDF(dialogRowData)}
                            className="rco-bill-btn"
                          >
                            <PrintIcon /> DN
                          </Button>
                        </Box>
                      </Grid>
                      {
                        // CheckPermissions(permissions, 'General Services', 'Change of Name', 'Workflow Permissions', 'DN Approval') &&
                        CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "DN Submission",
                        ) ? (
                          <>
                            {dnApproveStep && (
                            <Grid
                              container
                              spacing={2}
                              className="dn-payment-submission-container"
                            >
                              {(() => {
                                const roundOff = (value) =>
                                  Math.round(parseFloat(value) || 0);
                                const total = roundOff(
                                  dnApproveStep.serviceConnectionAmount,
                                );
                                const fields = [
                                  {
                                    label: "Issue Date",
                                    value: dnApproveStep.issueDate
                                      ? convertDate(dnApproveStep.issueDate)
                                      : null,
                                  },
                                  {
                                    label: "Due Date",
                                    value: dnApproveStep.dueDate
                                      ? convertDate(dnApproveStep.dueDate)
                                      : null,
                                  },
                                  {
                                    label: "Bank Name",
                                    value: dnApproveStep.bankName,
                                  },
                                  {
                                    label: "Grand Total",
                                    value: total,
                                  },
                                ];

                                const hasRaw = (value) => {
                                  if (value === null || value === undefined)
                                    return false;
                                  if (
                                    typeof value === "string" &&
                                    value.trim() === ""
                                  )
                                    return false;

                                  const normalized =
                                    typeof value === "string"
                                      ? value.replace(/,/g, "").trim()
                                      : value;
                                  const numericValue = Number(normalized);

                                  if (
                                    !Number.isNaN(numericValue) &&
                                    numericValue === 0
                                  )
                                    return false;

                                  return true;
                                };

                                const visibleFields = fields.filter((item) => {
                                  if (item.label === "Issue Date")
                                    return hasRaw(dnApproveStep.issueDate);
                                  if (item.label === "Due Date")
                                    return hasRaw(dnApproveStep.dueDate);
                                  if (item.label === "Bank Name")
                                    return hasRaw(dnApproveStep.bankName);
                                  if (item.label === "Grand Total")
                                    return hasRaw(dnApproveStep.serviceConnectionAmount);
                                  return true;
                                });

                                return visibleFields.map((item, index) => {
                                  const isFirstRow = index < 3;
                                  return (
                                    <Grid
                                      item
                                      key={index}
                                      className="item"
                                      sx={{
                                        flexBasis: {
                                          xs: "100%",
                                          md: isFirstRow ? "50%" : "33.3333%",
                                          lg: isFirstRow ? "33.3333%" : "20%",
                                        },
                                        maxWidth: {
                                          xs: "100%",
                                          md: isFirstRow ? "50%" : "33.3333%",
                                          lg: isFirstRow ? "33.3333%" : "20%",
                                        },
                                      }}
                                    >
                                      <Typography
                                        className="title"
                                        sx={{
                                          fontWeight: 600,
                                          color:
                                            item.label === "Grand Total"
                                              ? "#1976d2"
                                              : "#333",
                                        }}
                                      >
                                        {item.label}
                                      </Typography>
                                      <Typography
                                        className="value"
                                        sx={
                                          item.label === "Grand Total"
                                            ? {
                                                backgroundColor:
                                                  "#1976d2 !important",
                                                color: "#fff !important",
                                                fontSize: "1.1rem",
                                              }
                                            : { color: "#444" }
                                        }
                                      >
                                        {["Issue Date", "Due Date"].includes(
                                          item.label,
                                        )
                                          ? item.value
                                          : item.label === "Bank Name"
                                            ? item.value || "N/A"
                                            : numberFormatting(item.value)}
                                      </Typography>
                                    </Grid>
                                  );
                                });
                              })()}
                            </Grid>
                          )}
                            <div className="rco-dn-submission-form">
                              <div className="rco-dn-submission-form__field">
                                <label
                                  className="fieldLabel"
                                  htmlFor="iv_dn_receipt_image_obj"
                                >
                                  Receipt Image
                                </label>
                                {dnReceiptImage ? (
                                  <div className="rco-dn-receipt-preview">
                                      {dnReceiptImageThumbnail && (
                                        <>
                                          {dnReceiptImageThumbnail.startsWith(
                                            "data:image/",
                                          ) ? (
                                            <img
                                              src={dnReceiptImageThumbnail}
                                              alt="DN Receipt"
                                            />
                                          ) : dnReceiptImageThumbnail.startsWith(
                                              "data:application/pdf",
                                            ) ? (
                                            <img
                                              src={pdfIcon}
                                              alt="DN Receipt PDF"
                                            />
                                          ) : null}
                                        </>
                                      )}
                                    <button
                                      type="button"
                                      className="rco-dn-receipt-preview__remove"
                                      onClick={() => {
                                        setDnReceiptImage("");
                                        setDnReceiptImageThumbnail("");
                                        setDnReceiptImageError("");
                                        dnReceiptFormik.setFieldValue(
                                          "iv_dn_receipt_image",
                                          "",
                                        );
                                        dnReceiptFormik.setFieldTouched(
                                          "iv_dn_receipt_image",
                                          false,
                                        );
                                      }}
                                      aria-label="Remove receipt"
                                    >
                                      <CloseIcon />
                                    </button>
                                  </div>
                                ) : (
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      startIcon={<FileUploadOutlinedIcon />}
                                    className="rco-dn-submission-upload"
                                    >
                                      Upload
                                      <input
                                        hidden
                                        accept={documentExtensions}
                                      id="iv_dn_receipt_image_obj"
                                        name="iv_dn_receipt_image"
                                        type="file"
                                        onChange={DnReceiptImage}
                                        onBlur={() =>
                                          dnReceiptFormik.setFieldTouched(
                                            "iv_dn_receipt_image",
                                            true,
                                          )
                                        }
                                      />
                                    </Button>
                                )}
                                {dnReceiptImageError ? (
                                  <p className="rco-dn-submission-form__error">
                                    {dnReceiptImageError}
                                  </p>
                                ) : null}
                              </div>

                              <div className="rco-dn-submission-form__field">
                                <label
                                  className="fieldLabel"
                                  htmlFor="iv_dn_fee_payment_date_obj"
                                >
                                  Payment Date
                                </label>
                                <input
                                  id="iv_dn_fee_payment_date_obj"
                                  name="iv_dn_fee_payment_date"
                                  value={
                                    dnReceiptFormik.values
                                      .iv_dn_fee_payment_date ?? ""
                                  }
                                  onChange={dnReceiptFormik.handleChange}
                                  onBlur={dnReceiptFormik.handleBlur}
                                  type="date"
                                  className="rco-dn-submission-date"
                                  min={
                                    dnDets.issueDate
                                      ? dnDets.issueDate.slice(0, 10)
                                      : ""
                                  }
                                  max={
                                    dnDets.dueDate
                                      ? new Date()
                                          .toISOString()
                                          .split("T")[0] <=
                                        dnDets.dueDate.slice(0, 10)
                                        ? new Date().toISOString().split("T")[0]
                                        : dnDets.dueDate.slice(0, 10)
                                      : ""
                                  }
                                />
                                  {dnReceiptFormik.errors
                                    .iv_dn_fee_payment_date &&
                                dnReceiptFormik.touched.iv_dn_fee_payment_date ? (
                                  <p className="rco-dn-submission-form__error">
                                    {
                                      dnReceiptFormik.errors
                                        .iv_dn_fee_payment_date
                                    }
                                  </p>
                                ) : null}
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="description-box description-box--error">
                            <p className="group-description">
                              <InfoIcon className="icon" />
                              The application is in process by sanctioning
                              authority.
                            </p>
                          </div>
                        )
                      }
                    </>
                  ) : dialogRowData.applicationProgressId === 8 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title step-title--with-action"
                      >
                          <h4>DN Payment Verification</h4>
                        <Box className="step-title__actions">
                          <Button
                            variant="outlined"
                            onClick={() => downloadDNPDF(dialogRowData)}
                            className="rco-bill-btn"
                          >
                            <PrintIcon /> DN
                          </Button>
                        </Box>
                      </Grid>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "DN Payment Verification",
                      ) &&
                      // ──────────────────────────────────────────────────────────────
                      // Updated approval eligibility conditions (as requested)
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        // ─── 0–70 kW — but MUST NOT be A1/A2/A3 ───────────────────────────────
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        // ─── 15–70 kW — any tariff (this allows A1/A2/A3 above 15 kW) ─────────
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        // ─── 70–500 kW ────────────────────────────────────────────────────────
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        // ─── > 500 kW ─────────────────────────────────────────────────────────
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          {dnApproveStep && (
                            <Grid
                              container
                              spacing={2}
                              className="dn-payment-submission-container"
                            >
                              {(() => {
                                const roundOff = (value) =>
                                  Math.round(parseFloat(value) || 0);
                                const total = roundOff(
                                  dnApproveStep.serviceConnectionAmount,
                                );
                                const fields = [
                                  {
                                    label: "Issue Date",
                                    value: dnApproveStep.issueDate
                                      ? convertDate(dnApproveStep.issueDate)
                                      : null,
                                  },
                                  {
                                    label: "Due Date",
                                    value: dnApproveStep.dueDate
                                      ? convertDate(dnApproveStep.dueDate)
                                      : null,
                                  },
                                  {
                                    label: "Bank Name",
                                    value: dnApproveStep.bankName,
                                  },
                                  {
                                    label: "Grand Total",
                                    value: total,
                                  },
                                ];

                                const hasRaw = (value) => {
                                  if (value === null || value === undefined)
                                    return false;
                                  if (
                                    typeof value === "string" &&
                                    value.trim() === ""
                                  )
                                    return false;

                                  const normalized =
                                    typeof value === "string"
                                      ? value.replace(/,/g, "").trim()
                                      : value;
                                  const numericValue = Number(normalized);

                                  if (
                                    !Number.isNaN(numericValue) &&
                                    numericValue === 0
                                  )
                                    return false;

                                  return true;
                                };

                                const visibleFields = fields.filter((item) => {
                                  if (item.label === "Issue Date")
                                    return hasRaw(dnApproveStep.issueDate);
                                  if (item.label === "Due Date")
                                    return hasRaw(dnApproveStep.dueDate);
                                  if (item.label === "Bank Name")
                                    return hasRaw(dnApproveStep.bankName);
                                  if (item.label === "Grand Total")
                                    return hasRaw(dnApproveStep.serviceConnectionAmount);
                                  return true;
                                });

                                return visibleFields.map((item, index) => {
                                  const isFirstRow = index < 3;
                                  return (
                                    <Grid
                                      item
                                      key={index}
                                      className="item"
                                      sx={{
                                        flexBasis: {
                                          xs: "100%",
                                          md: isFirstRow ? "50%" : "33.3333%",
                                          lg: isFirstRow ? "33.3333%" : "20%",
                                        },
                                        maxWidth: {
                                          xs: "100%",
                                          md: isFirstRow ? "50%" : "33.3333%",
                                          lg: isFirstRow ? "33.3333%" : "20%",
                                        },
                                      }}
                                    >
                                      <Typography
                                        className="title"
                                        sx={{
                                          fontWeight: 600,
                                          color:
                                            item.label === "Grand Total"
                                              ? "#1976d2"
                                              : "#333",
                                        }}
                                      >
                                        {item.label}
                                      </Typography>
                                      <Typography
                                        className="value"
                                        sx={
                                          item.label === "Grand Total"
                                            ? {
                                                backgroundColor:
                                                  "#1976d2 !important",
                                                color: "#fff !important",
                                                fontSize: "1.1rem",
                                              }
                                            : { color: "#444" }
                                        }
                                      >
                                        {["Issue Date", "Due Date"].includes(
                                          item.label,
                                        )
                                          ? item.value
                                          : item.label === "Bank Name"
                                            ? item.value || "N/A"
                                            : numberFormatting(item.value)}
                                      </Typography>
                                    </Grid>
                                  );
                                });
                              })()}
                            </Grid>
                          )}
                          <Grid container className="paidDnContainer">
                            <Grid item lg={3} className="item">
                              <Typography className="title">
                                Payment Date
                              </Typography>
                              <Typography className="value">
                                {dnDets.paymentDate
                                  ? convertDateDDMMYY(dnDets.paymentDate)
                                  : "-"}
                              </Typography>
                            </Grid>
                            <Grid item lg={4} className="item">
                              <Typography className="title">
                                Paid DN Image
                              </Typography>
                              <div
                                className="rco-paid-dn-image docContainer"
                                onClick={handleOpenImgDN}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    handleOpenImgDN();
                                  }
                                }}
                              >
                                <img
                                  src={paidDNVoucherImg}
                                  alt="Paid DN"
                                />
                              </div>
                            </Grid>
                          </Grid>
                        </>
                      ) : (
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 9 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                        }}
                      >
                        <h4 style={{ textAlign: "center", width: "100%" }}>
                          Meter Installation
                        </h4>
                      </div>

                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Meter Installation",
                      ) &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        // ≤ 70 kW AND NOT A1/A2/A3
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        // 15–70 kW (general 70 permission)
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        // 70–500 kW
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        // > 500 kW
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          <Grid
                            container
                            spacing={2}
                            className="field-survey-container meter-installation-container"
                          >

                              {/* Installed Meter Configuration Section */}
                            <Grid
                              item
                              lg={12}
                              className="group-title-item"
                              sx={{ mt: 0, mb: 0.5 }}
                            >
                              <Typography variant="h6" color="#006ad1">
                                Installed Meter Configuration
                              </Typography>
                            </Grid>
                            {/* ══════════════════════════════════════════════════════════════ */}
                            {/*                    ROW 1: STORE INFORMATION                    */}
                            {/* ══════════════════════════════════════════════════════════════ */}

                            {/* Is Net Meter Radio Button */}
                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Is Net Meter?
                              </Typography>
                              <FormControl>
                                <RadioGroup
                                  row
                                  name="iv_is_net_meter"
                                  value={
                                    isNetMeterFieldLocked(selectedMCOTariffObj)
                                      ? "0"
                                      : scoPart2Formik.values.iv_is_net_meter || "0"
                                  }
                                  onChange={(e) => {
                                    if (isNetMeterFieldLocked(selectedMCOTariffObj)) {
                                      return;
                                    }
                                    const val = e.target.value;
                                    scoPart2Formik.setFieldValue("iv_is_net_meter", val, false);
                                    if (val === "0" && scoPart2Formik.values.iv_total_kwh === "4") {
                                      scoPart2Formik.setFieldValue("iv_total_kwh", "", false);
                                    }
                                    if (val === "1" && scoPart2Formik.values.iv_total_kwh === "2") {
                                      scoPart2Formik.setFieldValue("iv_total_kwh", "", false);
                                    }
                                  }}
                                >
                                  <FormControlLabel
                                    value="1"
                                    control={<Radio size="small" />}
                                    label="Yes"
                                    disabled={!canSelectNetMeterYes()}
                                  />
                                  <FormControlLabel
                                    value="0"
                                    control={<Radio size="small" />}
                                    label="No"
                                    disabled={isNetMeterFieldLocked(selectedMCOTariffObj)}
                                  />
                                </RadioGroup>
                              </FormControl>
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_is_net_meter &&
                                (scoPart2Formik.touched.iv_is_net_meter ||
                                  scoPart2Formik.submitCount > 0)
                                  ? scoPart2Formik.errors.iv_is_net_meter
                                  : null}
                              </p>
                            </Grid>

                            {/* Meter Category Dropdown */}
                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Meter Category
                              </Typography>
                              <FormControl fullWidth size="small">
                                <Select
                                  name="iv_meter_category"
                                  value={scoPart2Formik.values.iv_meter_category}
                                  onChange={(e) =>
                                    setScoPart2Field(
                                      "iv_meter_category",
                                      e.target.value,
                                    )
                                  }
                                  onBlur={() =>
                                    scoPart2Formik.setFieldTouched(
                                      "iv_meter_category",
                                      true,
                                    )
                                  }
                                  displayEmpty
                                  sx={{
                                    backgroundColor: "#fff",
                                    "& .MuiSelect-select": {
                                      backgroundColor: "#fff",
                                    },
                                  }}
                                >
                                  <MenuItem value="">Select Category</MenuItem>
                                  <MenuItem value="00">00 Normal</MenuItem>
                                  <MenuItem value="01">01 AMI</MenuItem>
                                  <MenuItem value="02">02 RF</MenuItem>
                                  <MenuItem value="03">03 AMR</MenuItem>
                                </Select>
                              </FormControl>
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_meter_category &&
                                (scoPart2Formik.touched.iv_meter_category ||
                                  scoPart2Formik.submitCount > 0)
                                  ? scoPart2Formik.errors.iv_meter_category
                                  : null}
                              </p>
                            </Grid>

                            {/* Tariff Dropdown */}
                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Tariff
                              </Typography>
                              <FormControl fullWidth size="small">
                                <Select
                                  name="iv_tariff_code"
                                  value={
    scoPart2Formik.values.iv_tariff_code
      ? scoPart2Formik.values.iv_tariff_code
      : dialogRowData?.tariffDesc || ""
  }
  disabled={true}
                                  onChange={(e) =>
                                    {
                                      scoPart2Formik.setFieldValue(
                                        "iv_tariff_code",
                                        e.target.value,
                                      );
                                      handleTariffSelection(e.target.value);
                                      scoPart2Formik.setFieldValue(
                                        "iv_total_kwh",'');
                                    }
                                  }
                                  onBlur={() =>
                                    scoPart2Formik.setFieldTouched(
                                      "iv_tariff_code",
                                      true,
                                    )
                                  }
                                  displayEmpty
                                  sx={{
                                    backgroundColor: "#fff",
                                    "& .MuiSelect-select": {
                                      backgroundColor: "#fff",
                                    },
                                  }}
                                >
                                  <MenuItem value="">
                                    <em>Select Tariff</em>
                                  </MenuItem>
                                  {allTariffList &&
                                    allTariffList.map((tariff, idx) => (
                                      <MenuItem
                                        key={idx}
                                        value={tariff.tariffName}
                                      >
                                        {tariff.tariffName}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_tariff_code &&
                                (scoPart2Formik.touched.iv_tariff_code ||
                                  scoPart2Formik.submitCount > 0)
                                  ? scoPart2Formik.errors.iv_tariff_code
                                  : null}
                              </p>
                            </Grid>

                            {/* Total kWh */}
                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Total kWh
                              </Typography>
                              <TextField
                                fullWidth
                                size="small"
                                name="iv_total_kwh"
                                value={
                                  isNetMeterFieldLocked(selectedMCOTariffObj)
                                    ? "1"
                                    : scoPart2Formik.values.iv_total_kwh
                                }
                                disabled={isNetMeterFieldLocked(selectedMCOTariffObj)}
                                inputProps={{ maxLength: 1 }}
                                sx={{
                                  backgroundColor: "#fff",
                                  "& .MuiInputBase-root": {
                                    backgroundColor: "#fff",
                                  },
                                }}
                                onChange={(e) => {
                                  if (isNetMeterFieldLocked(selectedMCOTariffObj)) {
                                    return;
                                  }
                                  const val = e.target.value.replace(/\D/g, "");
                                  scoPart2Formik.setFieldValue("iv_total_kwh", val, false);
                                }}
                                onBlur={scoPart2Formik.handleBlur}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_total_kwh &&
                                (scoPart2Formik.touched.iv_total_kwh ||
                                  scoPart2Formik.submitCount > 0)
                                  ? scoPart2Formik.errors.iv_total_kwh
                                  : null}
                              </p>
                            </Grid>

                            {/* 1. Store Requisition No */}
                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Store Requisition No.
                              </Typography>
                              <TextField
                                fullWidth
                                className="fieldCoverageMarla"
                                name="iv_store_requisition_no"
                                value={
                                  scoPart2Formik.values
                                    .iv_store_requisition_no || ""
                                }
                                onChange={(e) => {
                                  const val = e.target.value.replace(/\D/g, "");
                                  if (val.length <= 8) {
                                    setScoPart2Field(
                                      "iv_store_requisition_no",
                                      val,
                                    );
                                  }
                                }}
                                onBlur={(e) => {
                                  let val = e.target.value.trim();
                                  if (val) {
                                    val = val.padStart(8, "0");
                                    setScoPart2Field(
                                      "iv_store_requisition_no",
                                      val,
                                    );
                                  }
                                  scoPart2Formik.handleBlur(e);
                                }}
                                inputProps={{ maxLength: 8 }}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors
                                  .iv_store_requisition_no &&
                                scoPart2Formik.touched.iv_store_requisition_no
                                  ? scoPart2Formik.errors
                                      .iv_store_requisition_no
                                  : null}
                              </p>
                            </Grid>

                            {/* 2. Store Req. Date */}
                            <Grid item lg={1.5}>
                              <Typography className="fieldLabel">
                                Store Req. Date
                              </Typography>
                              <TextField
                                fullWidth
                                id="iv_store_requisition_date_field"
                                name="iv_store_requisition_date"
                                className="fieldReferenceNo"
                                type="date"
                                value={
                                  scoPart2Formik.values
                                    .iv_store_requisition_date || ""
                                }
                                onChange={scoPart2Formik.handleChange}
                                inputProps={{
                                  max: new Date().toISOString().split("T")[0],
                                }}
                                onBlur={scoPart2Formik.handleBlur}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                  backgroundColor: "#fff",
                                  borderRadius: "4px",
                                  "& .MuiInputBase-root": {
                                    cursor: "pointer",
                                  },
                                  "& .MuiInputBase-input": {
                                    backgroundColor: "#fff",
                                    cursor: "pointer",
                                  },
                                }}
                                onClick={(e) =>
                                  e.currentTarget
                                    .querySelector('input[type="date"]')
                                    ?.showPicker?.()
                                }
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors
                                  .iv_store_requisition_date &&
                                scoPart2Formik.touched.iv_store_requisition_date
                                  ? scoPart2Formik.errors
                                      .iv_store_requisition_date
                                  : null}
                              </p>
                            </Grid>

                            {/* 3. Meter Manufacturer */}
                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Meter Manufacturer
                              </Typography>
                              <Autocomplete
                                id="iv_manufacturer_code"
                                name="iv_manufacturer_code"
                                value={
                                  manufacturerCode?.code
                                    ? manufacturerCode
                                    : null
                                }
                                options={manufacturesList}
                                isOptionEqualToValue={(option, value) =>
                                  String(option?.code || "") ===
                                  String(value?.code || "")
                                }
                                getOptionLabel={(option) =>
                                  option.code
                                    ? `${option.name} ${option.code}`
                                    : ""
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="outlined"
                                    className="fieldBatch1"
                                    placeholder="Select Manufacturer"
                                    value={inputValue}
                                    onChange={(e) =>
                                      setInputValue(e.target.value)
                                    }
                                    sx={{
                                      height: "10px",
                                      "& .MuiInputBase-input": {
                                        fontSize: "13px",
                                        height: "12px",
                                      },
                                      "& .MuiInputBase-input::placeholder": {
                                        color: "#000",
                                        opacity: 1,
                                      },
                                    }}
                                  />
                                )}
                                onChange={(event, value) => {
                                  if (value) {
                                    setManufcaturerCode(value);
                                    setScoPart2Field(
                                      "iv_manufacturer_code",
                                      value.code,
                                    );
                                  } else {
                                    setManufcaturerCode({ code: null, name: "" });
                                    setScoPart2Field(
                                      "iv_manufacturer_code",
                                      "",
                                    );
                                  }
                                }}
                                filterOptions={(options) =>
                                  filterOptions(
                                    options,
                                    { inputValue: debouncedInputValue },
                                    ["code", "name"],
                                  )
                                }
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_manufacturer_code &&
                                (scoPart2Formik.touched.iv_manufacturer_code ||
                                  scoPart2Formik.submitCount > 0)
                                  ? scoPart2Formik.errors.iv_manufacturer_code
                                  : null}
                              </p>
                            </Grid>

                            {/* 4. Meter Serial No */}
                            <Grid item lg={1.5}>
                              <Typography className="fieldLabel">
                                Meter Serial No.
                              </Typography>
                              <TextField
                                fullWidth
                                name="iv_meter_serial_no"
                                className="fieldCoverageMarla"
                                value={
                                  scoPart2Formik.values.iv_meter_serial_no || ""
                                }
                                onChange={(e) => {
                                  const digitsOnly = e.target.value.replace(
                                    /\D/g,
                                    "",
                                  );
                                  setScoPart2Field(
                                    "iv_meter_serial_no",
                                    digitsOnly,
                                  );
                                }}
                                onBlur={scoPart2Formik.handleBlur}
                                inputProps={{
                                  maxLength: 10,
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                              />
                              <p className="form-error">
                                {scoPart2Formik.touched.iv_meter_serial_no &&
                                scoPart2Formik.errors.iv_meter_serial_no
                                  ? scoPart2Formik.errors.iv_meter_serial_no
                                  : null}
                              </p>
                            </Grid>

                            {/* 5. Meter Type - from dialogRowData.meterType (0=Normal, 1=Smart). Locked when value exists; editable only when null. */}
                            {(() => {
                              const raw = dialogRowData?.meterType;
                              const lockedValue =
                                raw === 0 ||
                                raw === "0" ||
                                raw === 1 ||
                                raw === "1"
                                  ? String(raw)
                                  : null;
                              const isMeterTypeLocked = lockedValue !== null;

                              return (
                            <Grid item lg={2.5}>
                              <Typography
                                className="fieldLabel"
                                sx={{ fontSize: "16px", color: "#006ad1" }}
                              >
                                Meter Type
                              </Typography>
                              <FormControl
                                disabled={isMeterTypeLocked}
                                error={
                                  scoPart2Formik.touched.iv_meter_typee &&
                                  Boolean(scoPart2Formik.errors.iv_meter_typee)
                                }
                                sx={{ width: "100%" }}
                              >
                                <RadioGroup
                                  row
                                  className="radio-group"
                                  name="iv_meter_typee"
                                  value={
                                    isMeterTypeLocked
                                      ? lockedValue
                                      : scoPart2Formik.values.iv_meter_typee ??
                                        ""
                                  }
                                  onChange={
                                    isMeterTypeLocked
                                      ? undefined
                                      : scoPart2Formik.handleChange
                                  }
                                  disabled={isMeterTypeLocked}
                                >
                                  <FormControlLabel
                                    value="1"
                                    control={<Radio />}
                                    label="Smart"
                                    disabled={isMeterTypeLocked}
                                  />
                                  <FormControlLabel
                                    value="0"
                                    control={<Radio />}
                                    label="Normal"
                                    disabled={isMeterTypeLocked}
                                  />
                                </RadioGroup>
                                <Box className="form-error">
                                  {scoPart2Formik.errors.iv_meter_typee &&
                                  scoPart2Formik.touched.iv_meter_typee
                                    ? scoPart2Formik.errors.iv_meter_typee
                                    : null}
                                </Box>
                              </FormControl>
                            </Grid>
                              );
                            })()}

                            {/* 6. Meter Range */}
                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Meter Range
                              </Typography>
                              <TextField
                                fullWidth
                                name="iv_meter_range"
                                className="fieldCoverageMarla"
                                type="number"
                                value={
                                  scoPart2Formik.values.iv_meter_range || ""
                                }
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                inputProps={{ min: 0 }}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_meter_range &&
                                scoPart2Formik.touched.iv_meter_range
                                  ? scoPart2Formik.errors.iv_meter_range
                                  : null}
                              </p>
                            </Grid>

                            <Grid item lg={1.5}>
                              <Typography className="fieldLabel">
                                Multiply Factor
                              </Typography>
                              <TextField
                                fullWidth
                                disabled
                                value={calculateMF(
                                  scoPart2Formik.values.iv_ct_nom,
                                  scoPart2Formik.values.iv_ct_denom,
                                  scoPart2Formik.values.iv_pt_nom,
                                  scoPart2Formik.values.iv_pt_denom,
                                )}
                                className="fieldCoverageMarla"
                              />
                            </Grid>

                            {/* ══════════════════════════════════════════════════════════════ */}
                            {/*                    ROW 2: METER CODES                          */}
                            {/* ══════════════════════════════════════════════════════════════ */}

                            {/* 7. Meter Code (Off Peak) */}
                            <Grid item lg={2}>
                              <Typography
                                className="fieldLabel"
                                sx={{ fontSize: "16px", color: "#006ad1" }}
                              >
                                Meter Code{" "}
                                {Number(scoPart2Formik.values.iv_total_kwh) >= 2
                                  ? "(Off Peak)"
                                  : ""}
                              </Typography>
                              <TextField
                                fullWidth
                                name="iv_meter_code1"
                                className="fieldCoverageMarla"
                                value={
                                  scoPart2Formik.values.iv_meter_code1 || ""
                                }
                                onChange={(e) =>
                                  setScoPart2Field(
                                    "iv_meter_code1",
                                    e.target.value.replace(/\D/g, ""),
                                  )
                                }
                                onKeyDown={restrictToNumericInput}
                                onBlur={scoPart2Formik.handleBlur}
                                inputProps={{ maxLength: 6 }}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_meter_code1 &&
                                scoPart2Formik.touched.iv_meter_code1
                                  ? scoPart2Formik.errors.iv_meter_code1
                                  : null}
                              </p>
                            </Grid>

                            {/* 8. Meter Code (Peak) - only if not single phase */}
                            {Number(scoPart2Formik.values.iv_total_kwh) >= 2 && (
                              <Grid item lg={2}>
                                <Typography
                                  className="fieldLabel"
                                  sx={{ fontSize: "16px", color: "#006ad1" }}
                                >
                                  Meter Code (Peak)
                                </Typography>
                                <TextField
                                  fullWidth
                                  name="iv_meter_code2"
                                  className="fieldCoverageMarla"
                                  value={
                                    scoPart2Formik.values.iv_meter_code2 || ""
                                  }
                                  onChange={(e) =>
                                    setScoPart2Field(
                                      "iv_meter_code2",
                                      e.target.value.replace(/\D/g, ""),
                                    )
                                  }
                                  onKeyDown={restrictToNumericInput}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{ maxLength: 6 }}
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_meter_code2 &&
                                  scoPart2Formik.touched.iv_meter_code2
                                    ? scoPart2Formik.errors.iv_meter_code2
                                    : null}
                                </p>
                              </Grid>
                            )}

                            {/* 9. Installed By */}
                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Installed By
                              </Typography>
                              <TextField
                                fullWidth
                                disabled={true}
                                name="iv_connection_installer_name"
                                className="fieldCoverageMarla"
                                value={
                                  scoPart2Formik.values
                                    .iv_connection_installer_name || ""
                                }
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors
                                  .iv_connection_installer_name &&
                                scoPart2Formik.touched
                                  .iv_connection_installer_name
                                  ? scoPart2Formik.errors
                                      .iv_connection_installer_name
                                  : null}
                              </p>
                            </Grid>

                            {/* 10. Installation Date */}
                            <Grid item lg={1.5}>
                              <Typography className="fieldLabel">
                                Installation Date
                              </Typography>
                              <FormControl
                                fullWidth
                                error={
                                  scoPart2Formik.touched
                                    .iv_date_of_connection &&
                                  Boolean(
                                    scoPart2Formik.errors.iv_date_of_connection,
                                  )
                                }
                              >
                                <TextField
                                  id="iv_date_of_connection_field"
                                  name="iv_date_of_connection"
                                  className="fieldReferenceNo"
                                  type="date"
                                  value={
                                    scoPart2Formik.values
                                      .iv_date_of_connection || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  inputProps={{
                                    min:
                                      dialogRowData?.creationDate?.split(
                                        "T",
                                      )[0] || undefined,
                                    max: new Date().toISOString().split("T")[0],
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                  variant="outlined"
                                  sx={{
                                    backgroundColor: "#fff",
                                    borderRadius: "4px",
                                    "& .MuiInputBase-root": {
                                      cursor: "pointer",
                                    },
                                    "& .MuiInputBase-input": {
                                      backgroundColor: "#fff",
                                      cursor: "pointer",
                                    },
                                  }}
                                  onClick={(e) =>
                                    e.currentTarget
                                      .querySelector('input[type="date"]')
                                      ?.showPicker?.()
                                  }
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors
                                    .iv_date_of_connection &&
                                  scoPart2Formik.touched.iv_date_of_connection
                                    ? scoPart2Formik.errors
                                        .iv_date_of_connection
                                    : null}
                                </p>
                              </FormControl>
                            </Grid>

                            {/* 11. Transformer Code */}
                            <Grid item lg={1.5}>
                              <Typography className="fieldLabel">
                                Transformer Code
                              </Typography>
                              <TextField
                                fullWidth
                                name="iv_transformer_code"
                                value={
                                  scoPart2Formik.values.iv_transformer_code ||
                                  ""
                                }
                                onChange={scoPart2Formik.handleChange}
                                onBlur={scoPart2Formik.handleBlur}
                                className="fieldCoverageMarla"
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                              />
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_transformer_code &&
                                scoPart2Formik.touched.iv_transformer_code
                                  ? scoPart2Formik.errors.iv_transformer_code
                                  : null}
                              </p>
                            </Grid>

                            {/* 12. Transformer Ref No */}
                            <Grid item lg={2}>
                              <Typography className="fieldLabel">
                                Transformer Ref No.
                              </Typography>
                              <TextField
                                fullWidth
                                name="iv_transformer_refNo"
                                value={
                                  scoPart2Formik.values.iv_transformer_refNo ||
                                  ""
                                }
                                onChange={(e) => {
                                  const digitsOnly = e.target.value.replace(
                                    /\D/g,
                                    "",
                                  );
                                  setScoPart2Field(
                                    "iv_transformer_refNo",
                                    digitsOnly,
                                  );
                                }}
                                onBlur={scoPart2Formik.handleBlur}
                                inputProps={{
                                  maxLength: 14,
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                }}
                                className="fieldCoverageMarla"
                              />
                              <p className="form-error">
                                {scoPart2Formik.touched.iv_transformer_refNo &&
                                scoPart2Formik.errors.iv_transformer_refNo
                                  ? scoPart2Formik.errors.iv_transformer_refNo
                                  : null}
                              </p>
                            </Grid>

                            {/* ══════════════════════════════════════════════════════════════ */}
                            {/*                    ROW 3: LOCATION & IMAGE                     */}
                            {/* ══════════════════════════════════════════════════════════════ */}

                            {/* 13. Meter Location */}
                            <Grid item lg={3}>
                              <Typography
                                className="fieldLabel"
                                sx={{ fontSize: "16px", color: "#006ad1" }}
                              >
                                Meter Location
                              </Typography>
                              <FormControl
                                fullWidth
                                size="small"
                                error={
                                  scoPart2Formik.touched.iv_location_code &&
                                  Boolean(
                                    scoPart2Formik.errors.iv_location_code,
                                  )
                                }
                              >
                                <Select
                                  name="iv_location_code"
                                  value={
                                    scoPart2Formik.values.iv_location_code || ""
                                  }
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={() =>
                                    scoPart2Formik.setFieldTouched(
                                      "iv_location_code",
                                      true,
                                    )
                                  }
                                  displayEmpty
                                  sx={{
                                    backgroundColor: "#fff",
                                    "& .MuiSelect-select": {
                                      backgroundColor: "#fff",
                                    },
                                  }}
                                >
                                  <MenuItem value="">
                                    <em>Select Location</em>
                                  </MenuItem>
                                  <MenuItem value="P">Pole</MenuItem>
                                  <MenuItem value="O">Outside</MenuItem>
                                  <MenuItem value="I">Inside</MenuItem>
                                </Select>
                              </FormControl>
                              <p className="form-error">
                                {scoPart2Formik.errors.iv_location_code &&
                                (scoPart2Formik.touched.iv_location_code ||
                                  scoPart2Formik.submitCount > 0)
                                  ? scoPart2Formik.errors.iv_location_code
                                  : null}
                              </p>
                            </Grid>

                            {/* Seasonal / Non-Seasonal (Industrial only) */}
                            {(dialogRowData?.connectionType?.toLowerCase() ===
                              "industrial" ||
                              dialogRowData?.connectionType ===
                                "Industrial") && (
                              <Grid item lg={4}>
                                <Typography className="fieldLabel">
                                  Seasonal / Non-Seasonal
                                </Typography>
                                <FormControl
                                  error={
                                    scoPart2Formik.touched.iv_seasonal_flag &&
                                    Boolean(
                                      scoPart2Formik.errors.iv_seasonal_flag,
                                    )
                                  }
                                >
                                  <RadioGroup
                                    className="radio-group"
                                    row
                                    name="iv_seasonal_flag"
                                    value={
                                      scoPart2Formik.values.iv_seasonal_flag ??
                                      ""
                                    }
                                    onChange={scoPart2Formik.handleChange}
                                  >
                                    <FormControlLabel
                                      value="1"
                                      control={<Radio />}
                                      label="Seasonal"
                                    />
                                    <FormControlLabel
                                      value="0"
                                      control={<Radio />}
                                      label="Non-Seasonal"
                                    />
                                  </RadioGroup>
                                  <p className="form-error">
                                    {scoPart2Formik.errors.iv_seasonal_flag &&
                                    scoPart2Formik.touched.iv_seasonal_flag
                                      ? scoPart2Formik.errors.iv_seasonal_flag
                                      : null}
                                  </p>
                                </FormControl>
                              </Grid>
                            )}

                            {/* Smart Meter Fields - Sim No & Sim Id */}
                            {Number(
                              scoPart2Formik.values.iv_meter_typee ??
                                dialogRowData?.meterType,
                            ) === 1 && (
                              <>
                                <Grid item lg={1.5}>
                                  <Typography className="fieldLabel">
                                    Sim No.
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    name="iv_sim_number"
                                    className="fieldCoverageMarla"
                                    value={
                                      scoPart2Formik.values.iv_sim_number || ""
                                    }
                                    onChange={(e) => {
                                      const digitsOnly = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      );
                                      setScoPart2Field(
                                        "iv_sim_number",
                                        digitsOnly,
                                      );
                                    }}
                                    onBlur={scoPart2Formik.handleBlur}
                                    inputProps={{
                                      maxLength: 11,
                                      inputMode: "numeric",
                                      pattern: "[0-9]*",
                                    }}
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.touched.iv_sim_number &&
                                    scoPart2Formik.errors.iv_sim_number
                                      ? scoPart2Formik.errors.iv_sim_number
                                      : null}
                                  </p>
                                </Grid>

                                <Grid item lg={2.5}>
                                  <Typography className="fieldLabel">
                                    Sim Id.
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    className="fieldCoverageMarla"
                                    name="iv_sim_ID"
                                    value={
                                      scoPart2Formik.values.iv_sim_ID || ""
                                    }
                                    onChange={(e) => {
                                      const digitsOnly = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      );
                                      setScoPart2Field(
                                        "iv_sim_ID",
                                        digitsOnly,
                                      );
                                    }}
                                    onBlur={scoPart2Formik.handleBlur}
                                    inputProps={{
                                      maxLength: 20,
                                      inputMode: "numeric",
                                      pattern: "[0-9]*",
                                    }}
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.touched.iv_sim_ID &&
                                    scoPart2Formik.errors.iv_sim_ID
                                      ? scoPart2Formik.errors.iv_sim_ID
                                      : null}
                                  </p>
                                </Grid>
                              </>
                            )}

                            <Grid item className="meter-installation-footer">
                              <Box className="meter-installation-footer__inner">
                                <Box className="meter-installation-footer__image">
                              <Typography className="fieldLabel">
                                Installed Meter Image
                              </Typography>

                              <Box sx={{ mt: 1 }}>
                                {scoPart2Formik.values
                                  .iv_installed_meter_image ||
                                installedMeterImage ? (
                                  // ── Preview + Remove button ──
                                  <Box
                                    sx={{
                                      position: "relative",
                                      display: "inline-block",
                                      border: "1px solid #ddd",
                                      borderRadius: "8px",
                                      overflow: "hidden",
                                      background: "#f9f9f9",
                                    }}
                                  >
                                    <img
                                      src={
                                        installedMeterImage // fallback to your preview state
                                      }
                                      alt="Installed Meter Preview"
                                      style={{
                                        maxWidth: "180px",
                                        maxHeight: "180px",
                                        objectFit: "contain",
                                        display: "block",
                                      }}
                                    />

                                    {/* Red cross button */}
                                    <Button
                                      size="small"
                                      color="error"
                                      variant="contained"
                                      sx={{
                                        position: "absolute",
                                        top: 4,
                                        right: 4,
                                        minWidth: "28px",
                                        height: "28px",
                                        p: 0,
                                        borderRadius: "50%",
                                        backgroundColor:
                                          "rgba(211, 47, 47, 0.9)",
                                        "&:hover": {
                                          backgroundColor:
                                            "rgba(211, 47, 47, 1)",
                                        },
                                      }}
                                      onClick={() => {
                                        // Clear both Formik value and preview
                                        setScoPart2Field(
                                          "iv_installed_meter_image",
                                          "",
                                        );
                                        setInstalledMeterImage(null); // your preview state
                                        setInstalledMeterImageThumbnail?.(""); // if you have thumbnail too
                                        setInstalledMeterImageError("");
                                      }}
                                    >
                                      <CloseIcon fontSize="small" />
                                    </Button>
                                  </Box>
                                ) : (
                                  // ── Upload button when nothing is selected ──
                                  <Button
                                    variant="outlined"
                                    component="label"
                                    startIcon={<FileUploadOutlinedIcon />}
                                    sx={{
                                      textTransform: "none",
                                      borderColor: "#1976d2",
                                      color: "#1976d2",
                                      "&:hover": {
                                        borderColor: "#1565c0",
                                        backgroundColor:
                                          "rgba(25, 118, 210, 0.04)",
                                      },
                                    }}
                                  >
                                    Upload Image
                                    <input
                                      type="file"
                                      hidden
                                      accept="image/jpeg,image/png,image/jpg,.jpeg,.jpg,.png"
                                      onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        if (!file) return;

                                        const maxSize = 2 * 1024 * 1024;
                                        const documentValidate =
                                          documentValidation(file, maxSize);
                                        if (documentValidate === 1) {
                                          setInstalledMeterImageError("");
                                          const reader = new FileReader();
                                          reader.onload = () => {
                                            const base64 = reader.result;
                                            setInstalledMeterImage(base64);
                                            setInstalledMeterImageThumbnail?.(
                                              base64,
                                            );
                                            setScoPart2Field(
                                              "iv_installed_meter_image",
                                              base64,
                                            );
                                          };
                                          reader.readAsDataURL(file);
                                        } else if (documentValidate === 2) {
                                          setInstalledMeterImageError(
                                            "File size exceeds " +
                                              maxSize / 1024 / 1024 +
                                              "MB limit.",
                                          );
                                        } else {
                                          setInstalledMeterImageError(
                                            "Invalid file type. Only JPG, PNG, and PDF are allowed.",
                                          );
                                        }

                                        e.target.value = "";
                                      }}
                                    />
                                  </Button>
                                )}

                                {(installedMeterImageError ||
                                  (scoPart2Formik.touched
                                    .iv_installed_meter_image &&
                                    scoPart2Formik.errors
                                      .iv_installed_meter_image)) && (
                                  <p className="form-error">
                                    {installedMeterImageError ||
                                      scoPart2Formik.errors
                                        .iv_installed_meter_image}
                                  </p>
                                )}
                              </Box>
                                </Box>

                                <Box className="meter-installation-footer__sections">
                                  <Typography
                                    variant="h6"
                                    className="meter-installation-footer__section-title"
                                  >
                                Removed Meter Details
                              </Typography>
                                  <Typography
                                    variant="h6"
                                    className="meter-installation-footer__section-title"
                                  >
                                    Installed Meter Reading Information
                                  </Typography>
                                  <Box className="meter-installation-footer__section-action">
                              <button
                                type="button"
                                onClick={openMeterRemovedPopupDialog}
                                style={{
                                  background: storedMeterRemovedData
                                    ? "linear-gradient(135deg, #0b573b, #4bdfa7)"
                                    : "#006ad1",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: 8,
                                  padding: "10px 22px",
                                  fontSize: 14,
                                  fontWeight: 600,
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                  whiteSpace: "nowrap",
                                  boxShadow: storedMeterRemovedData
                                    ? "0 2px 8px rgba(11,87,59,0.35)"
                                    : "0 2px 8px rgba(0,106,209,0.35)",
                                }}
                              >
                                {storedMeterRemovedData ? (
                                  <EditIcon style={{ fontSize: 18 }} />
                                ) : (
                                  <span style={{ fontSize: 18, lineHeight: 1 }}>
                                    +
                                  </span>
                                )}{" "}
                                {storedMeterRemovedData
                                  ? "Edit Removed Meter Detail"
                                  : "Add Removed Meter Detail"}
                              </button>
                              {removedMeterDetailError && (
                                <div
                                  style={{
                                    color: "#c62828",
                                    fontSize: 13,
                                    marginTop: 6,
                                    fontWeight: 500,
                                  }}
                                >
                                  {removedMeterDetailError}
                                </div>
                              )}
                                  </Box>
                                  <Box className="meter-installation-footer__section-action">
                                    <button
                                      type="button"
                                      onClick={() => setOpenReadingInfoPopup(true)}
                                      style={{
                                        background: hasReadingInfoData
                                          ? "linear-gradient(135deg, #0b573b, #4bdfa7)"
                                          : "#006ad1",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: 8,
                                        padding: "10px 22px",
                                        fontSize: 14,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                        boxShadow: hasReadingInfoData
                                          ? "0 2px 8px rgba(11,87,59,0.35)"
                                          : "0 2px 8px rgba(0,106,209,0.35)",
                                      }}
                                    >
                                      {hasReadingInfoData ? (
                                        <EditIcon style={{ fontSize: 18 }} />
                                      ) : (
                                        <span style={{ fontSize: 18, lineHeight: 1 }}>
                                          +
                                        </span>
                                      )}
                                      {hasReadingInfoData
                                        ? "Edit Reading Information"
                                        : "Add Reading Information"}
                                    </button>
                                    {readingInfoTopError && (
                                      <div
                                        style={{
                                          color: "#c62828",
                                          fontSize: 13,
                                          marginTop: 6,
                                          fontWeight: 500,
                                        }}
                                      >
                                        {readingInfoTopError}
                                      </div>
                                    )}
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>

 {/* Loading Backdrop for Meter Removed API */}
                            <Backdrop
                              sx={{ color: "#fff", zIndex: 9999 }}
                              open={meterRemovedLoading}
                            >
                              <AppLoader />
                            </Backdrop>

                            {/* Backdrop for Meter Removed Popup */}
                            {openMeterRemovedPopup && (
                              <div
                                onClick={closeMeterRemovedPopup}
                                style={{
                                  position: "fixed",
                                  inset: 0,
                                  background: "rgba(15,15,30,0.55)",
                                  backdropFilter: "blur(3px)",
                                  zIndex: 1000,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {/* Dialog */}
                                <div
                                  onClick={(e) => e.stopPropagation()}
                                  style={{
                                    background: "#fff",
                                    borderRadius: 16,
                                    padding: "28px 32px",
                                    width: "min(96vw, 1100px)",
                                    boxShadow: "0 24px 60px rgba(0,0,0,0.18)",
                                    maxHeight: "90vh",
                                    overflowY: "auto",
                                  }}
                                >
                                  <h2
                                    style={{
                                      margin: "0 0 20px",
                                      fontSize: 18,
                                      fontWeight: 600,
                                      color: "#1e1e3a",
                                    }}
                                  >
                                    Meter Removed
                                  </h2>

                                  {/* Error Message */}
                                  {meterRemovedError && (
                                    <div
                                      style={{
                                        background: "#ffebee",
                                        border: "1px solid #f44336",
                                        borderRadius: 8,
                                        padding: "12px 16px",
                                        marginBottom: 16,
                                        color: "#c62828",
                                        fontSize: 14,
                                        fontWeight: 500,
                                      }}
                                    >
                                      {meterRemovedError}
                                    </div>
                                  )}

                                  <div style={{ overflowX: "auto" }}>
                                    <table
                                      style={{
                                        width: "100%",
                                        borderCollapse: "separate",
                                        borderSpacing: 0,
                                        fontSize: 13,
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          {[
                                            "Set No",
                                            "Meter Type",
                                            "Serial No",
                                            "Multiply Factor",
                                            "Master Reading",
                                            "Meter Reading",
                                            "Advance Units",
                                            "Rounding Comp Code",
                                          ].map((h) => (
                                            <th
                                              key={h}
                                              style={{
                                                background: "#006ad1",
                                                color: "#fff",
                                                padding: "11px 10px",
                                                textAlign: "center",
                                                fontWeight: 600,
                                                fontSize: 12,
                                                borderRight:
                                                  "1px solid rgba(255,255,255,0.15)",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {h}
                                            </th>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {rows.map((row, idx) => (
                                          <tr
                                            key={idx}
                                            style={{
                                              background:
                                                idx % 2 === 0
                                                  ? "#fafafe"
                                                  : "#f4f4fb",
                                            }}
                                          >
                                            {/* Set No - readonly from API */}
                                            <td style={tdStyle}>
                                              <Chip>
                                                {getMeterRemovedSetNoLabel(row)}
                                              </Chip>
                                            </td>
                                            {/* Meter Type - readonly from API */}
                                            <td style={tdStyle}>
                                              <Chip>
                                                {getRemovedMeterTypeDisplayLabel(
                                                  row,
                                                )}
                                              </Chip>
                                            </td>
                                            {/* Serial No - readonly from API */}
                                            <td style={tdStyle}>
                                              <input
                                                readOnly
                                                value={row.serialNo}
                                                style={{
                                                  width: 100,
                                                  border: "1.5px solid #c7c7e8",
                                                  borderRadius: 6,
                                                  padding: "4px 8px",
                                                  fontSize: 13,
                                                  textAlign: "center",
                                                  background: "#f2f2fa",
                                                  color: "#333",
                                                  outline: "none",
                                                  cursor: "default",
                                                }}
                                              />
                                            </td>
                                            {/* Multiply Factor - readonly from API */}
                                            <td style={tdStyle}>
                                              <input
                                                readOnly
                                                value={row.multiplyFactor}
                                                style={{
                                                  width: 80,
                                                  border: "1.5px solid #c7c7e8",
                                                  borderRadius: 6,
                                                  padding: "4px 8px",
                                                  fontSize: 13,
                                                  textAlign: "center",
                                                  background: "#f2f2fa",
                                                  color: "#333",
                                                  outline: "none",
                                                  cursor: "default",
                                                }}
                                              />
                                            </td>
                                            {/* Master Reading - readonly from API */}
                                            <td style={tdStyle}>
                                              <input
                                                readOnly
                                                value={row.masterReading ?? ""}
                                                style={{
                                                  width: 80,
                                                  border: "1.5px solid #c7c7e8",
                                                  borderRadius: 6,
                                                  padding: "4px 8px",
                                                  fontSize: 13,
                                                  textAlign: "center",
                                                  background: "#eef0ff",
                                                  color: "#333",
                                                  outline: "none",
                                                  cursor: "default",
                                                }}
                                              />
                                            </td>
                                            {/* Meter Reading - editable by user */}
                                            <td style={tdStyle}>
                                              <input
                                                type="text"
                                                inputMode="decimal"
                                                value={row.meterReading ?? ""}
                                                onChange={(e) => {
                                                  const newValue = sanitizeDecimalInput(
                                                    e.target.value,
                                                  );
                                                  handleChange(
                                                    idx,
                                                    "meterReading",
                                                    newValue,
                                                  );
                                                  // Real-time validation
                                                  const meterReading =
                                                    parseRemovedMeterReading(newValue) ?? 0;
                                                  const masterReading =
                                                    parseRemovedMeterReading(
                                                      row.masterReading,
                                                    ) ?? 0;
                                                  if (
                                                    isValidMeterReadingInput(newValue) &&
                                                    meterReading < masterReading
                                                  ) {
                                                    setMeterRemovedError(
                                                      `Row ${idx + 1}: Meter Reading (${meterReading}) should be equal to or greater than Master Reading (${masterReading})`,
                                                    );
                                                  } else {
                                                    setMeterRemovedError("");
                                                  }
                                                }}
                                                onKeyDown={restrictToDecimalInput}
                                                style={{
                                                  width: 88,
                                                  border:
                                                    isValidMeterReadingInput(row.meterReading) &&
                                                    (parseRemovedMeterReading(row.meterReading) ?? 0) <
                                                      (parseRemovedMeterReading(row.masterReading) ?? 0)
                                                      ? "2px solid #f44336"
                                                      : "1.5px solid #c7c7e8",
                                                  borderRadius: 6,
                                                  padding: "6px 8px",
                                                  fontSize: 13,
                                                  textAlign: "center",
                                                  background:
                                                    isValidMeterReadingInput(row.meterReading) &&
                                                    (parseRemovedMeterReading(row.meterReading) ?? 0) <
                                                      (parseRemovedMeterReading(row.masterReading) ?? 0)
                                                      ? "#ffebee"
                                                      : "#fff",
                                                  color: "#333",
                                                  outline: "none",
                                                }}
                                              />
                                            </td>
                                            {/* Advance Units = (Meter Reading - Master Reading) * Multiply Factor */}
                                            <td style={tdStyle}>
                                              <input
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                value={
                                                  row.advanceUnits !==
                                                    undefined &&
                                                  row.advanceUnits !== null &&
                                                  row.advanceUnits !== ""
                                                    ? String(row.advanceUnits)
                                                    : computeMeterRemovedAdvanceUnits(
                                                        row.masterReading,
                                                        row.meterReading,
                                                        row.multiplyFactor,
                                                      )
                                                }
                                                disabled
                                                readOnly
                                                style={{
                                                  width: 88,
                                                  border: "1.5px solid #c7c7e8",
                                                  borderRadius: 6,
                                                  padding: "6px 8px",
                                                  fontSize: 13,
                                                  textAlign: "center",
                                                  background: "#f2f2fa",
                                                  color: "#333",
                                                  outline: "none",
                                                }}
                                              />
                                            </td>
                                            {/* Rounding Comp Code - editable by user */}
                                            <td style={tdStyle}>
                                              <input
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                maxLength={3}
                                                value={
                                                  row.roundingCompCode || ""
                                                }
                                                onChange={(e) =>
                                                  handleChange(
                                                    idx,
                                                    "roundingCompCode",
                                                    e.target.value
                                                      .replace(/\D/g, "")
                                                      .slice(0, 3),
                                                  )
                                                }
                                                onKeyDown={restrictToNumericInput}
                                                style={{
                                                  width: 88,
                                                  border: "1.5px solid #c7c7e8",
                                                  borderRadius: 6,
                                                  padding: "6px 8px",
                                                  fontSize: 13,
                                                  textAlign: "center",
                                                  background: "#fff",
                                                  color: "#333",
                                                  outline: "none",
                                                }}
                                              />
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>

                                  {/* Actions */}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      gap: 12,
                                      marginTop: 24,
                                    }}
                                  >
                                    <button
                                      onClick={closeMeterRemovedPopup}
                                      style={{
                                        background: "#fff",
                                        color: "#555",
                                        border: "1.5px solid #ddd",
                                        borderRadius: 8,
                                        padding: "9px 22px",
                                        fontSize: 13,
                                        fontWeight: 500,
                                        cursor: "pointer",
                                      }}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      onClick={handleSubmit}
                                      style={{
                                        background: "#006ad1",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: 8,
                                        padding: "9px 22px",
                                        fontSize: 13,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        boxShadow:
                                          "0 2px 8px rgba(0,106,209,0.3)",
                                      }}
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                            {openReadingInfoPopup && (
                              <div
                                onClick={() => setOpenReadingInfoPopup(false)}
                                style={{
                                  position: "fixed",
                                  inset: 0,
                                  background: "rgba(15,15,30,0.55)",
                                  backdropFilter: "blur(3px)",
                                  zIndex: 1000,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  onClick={(e) => e.stopPropagation()}
                                  style={{
                                    background: "#fff",
                                    borderRadius: 16,
                                    padding: "28px 32px",
                                    width: "min(96vw, 1100px)",
                                    boxShadow: "0 24px 60px rgba(0,0,0,0.18)",
                                    maxHeight: "90vh",
                                    overflowY: "auto",
                                  }}
                                >
                                  <h2
                                    style={{
                                      margin: "0 0 20px",
                                      fontSize: 18,
                                      fontWeight: 600,
                                      color: "#1e1e3a",
                                    }}
                                  >
                                    Reading Information
                                  </h2>

                                  {renderReadingInfoTable()}

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      gap: 12,
                                      marginTop: 24,
                                    }}
                                  >
                                    <button
                                      type="button"
                                      onClick={() => setOpenReadingInfoPopup(false)}
                                      style={{
                                        background: "#fff",
                                        color: "#555",
                                        border: "1.5px solid #ddd",
                                        borderRadius: 8,
                                        padding: "9px 22px",
                                        fontSize: 13,
                                        fontWeight: 500,
                                        cursor: "pointer",
                                      }}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      onClick={handleReadingInfoSave}
                                      disabled={!readingInfoSaveEnabled}
                                      style={{
                                        background: readingInfoSaveEnabled
                                          ? "#006ad1"
                                          : "#cccccc",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: 8,
                                        padding: "9px 22px",
                                        fontSize: 13,
                                        fontWeight: 600,
                                        cursor: readingInfoSaveEnabled
                                          ? "pointer"
                                          : "not-allowed",
                                        boxShadow: readingInfoSaveEnabled
                                          ? "0 2px 8px rgba(0,106,209,0.3)"
                                          : "none",
                                      }}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* {phase === "Single Phase" && (
                              <Grid item lg={2.3}>
                                <Typography className="fieldLabel">
                                  Meter Reading
                                </Typography>
                                <TextField
                                  name="iv_meter_reading"
                                  value={scoPart2Formik.values.iv_meter_reading}
                                  type="text"
                                  fullWidth
                                  onChange={scoPart2Formik.handleChange}
                                  onBlur={scoPart2Formik.handleBlur}
                                  className="fieldCoverageMarla"
                                />
                                <p className="form-error">
                                  {scoPart2Formik.errors.iv_meter_reading &&
                                  scoPart2Formik.touched.iv_meter_reading
                                    ? scoPart2Formik.errors.iv_meter_reading
                                    : null}
                                </p>
                              </Grid>
                            )}
                            {(phase === "3 Phase" ||
                              phase === "MDI (LT)(CT)" ||
                              phase === "MDI (HT)(CT/PT)") && (
                              <>
                                <Grid item lg={1.5}>
                                  <Typography className="fieldLabel">
                                    Peak (kWh)
                                  </Typography>
                                  <TextField
                                    name="iv_meter_reading_peak_kwh"
                                    value={
                                      scoPart2Formik.values
                                        .iv_meter_reading_peak_kwh
                                    }
                                    type="text"
                                    fullWidth
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    className="fieldCoverageMarla"
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors
                                      .iv_meter_reading_peak_kwh &&
                                    scoPart2Formik.touched
                                      .iv_meter_reading_peak_kwh
                                      ? scoPart2Formik.errors
                                          .iv_meter_reading_peak_kwh
                                      : null}
                                  </p>
                                </Grid>
                                <Grid item lg={1.5}>
                                  <Typography className="fieldLabel">
                                    Off Peak (kWh)
                                  </Typography>
                                  <TextField
                                    name="iv_meter_reading_off_peak_kwh"
                                    value={
                                      scoPart2Formik.values
                                        .iv_meter_reading_off_peak_kwh
                                    }
                                    type="text"
                                    fullWidth
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    className="fieldCoverageMarla"
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors
                                      .iv_meter_reading_off_peak_kwh &&
                                    scoPart2Formik.touched
                                      .iv_meter_reading_off_peak_kwh
                                      ? scoPart2Formik.errors
                                          .iv_meter_reading_off_peak_kwh
                                      : null}
                                  </p>
                                </Grid>
                              </>
                            )} */}
                            {(phase === "MDI (LT)(CT)" ||
                              phase === "MDI (HT)(CT/PT)") && (
                              <>
                                {/* <Grid item lg={1.5}>
                                  <Typography className="fieldLabel">
                                    Peak (kVARh)
                                  </Typography>
                                  <TextField
                                    name="iv_meter_reading_peak_kvarh"
                                    value={
                                      scoPart2Formik.values
                                        .iv_meter_reading_peak_kvarh
                                    }
                                    type="text"
                                    fullWidth
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    className="fieldCoverageMarla"
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors
                                      .iv_meter_reading_peak_kvarh &&
                                    scoPart2Formik.touched
                                      .iv_meter_reading_peak_kvarh
                                      ? scoPart2Formik.errors
                                          .iv_meter_reading_peak_kvarh
                                      : null}
                                  </p>
                                </Grid>
                                <Grid item lg={1.5}>
                                  <Typography className="fieldLabel">
                                    Off Peak (kVARh)
                                  </Typography>
                                  <TextField
                                    name="iv_meter_reading_off_peak_kvarh"
                                    value={
                                      scoPart2Formik.values
                                        .iv_meter_reading_off_peak_kvarh
                                    }
                                    type="text"
                                    fullWidth
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    className="fieldCoverageMarla"
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors
                                      .iv_meter_reading_off_peak_kvarh &&
                                    scoPart2Formik.touched
                                      .iv_meter_reading_off_peak_kvarh
                                      ? scoPart2Formik.errors
                                          .iv_meter_reading_off_peak_kvarh
                                      : null}
                                  </p>
                                </Grid> */}
                                {/* 
                               
                                <Grid item lg={2}></Grid> */}
                                <Grid item lg={1.5}>
                                  <Typography className="fieldLabel">
                                    MDI Cumm. Reading
                                  </Typography>
                                  <TextField
                                    name="iv_mdi"
                                    value={scoPart2Formik.values.iv_mdi}
                                    type="text"
                                    fullWidth
                                    disabled={!shouldCaptureMdiValues}
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    className="fieldCoverageMarla"
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors.iv_mdi &&
                                    scoPart2Formik.touched.iv_mdi
                                      ? scoPart2Formik.errors.iv_mdi
                                      : null}
                                  </p>
                                </Grid>
                                 <Grid item lg={1.5}>
                                  <Typography className="fieldLabel">
                                    No. of MDI Resets
                                  </Typography>
                                  <TextField
                                    name="iv_no_of_mdi_resets"
                                    value={
                                      scoPart2Formik.values.iv_no_of_mdi_resets
                                    }
                                    type="text"
                                    fullWidth
                                    disabled={!shouldCaptureMdiValues}
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    className="fieldCoverageMarla"
                                  />
                                  <p className="form-error">
                                    {scoPart2Formik.errors
                                      .iv_no_of_mdi_resets &&
                                    scoPart2Formik.touched.iv_no_of_mdi_resets
                                      ? scoPart2Formik.errors
                                          .iv_no_of_mdi_resets
                                      : null}
                                  </p>
                                </Grid>
                                <Grid item lg={2}>
                                  <Typography className="fieldLabel">
                                    CT Ratio
                                  </Typography>
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "3px",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Select
                                      sx={{ width: "100%" }}
                                      value={scoPart2Formik.values.iv_ct_nom}
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      displayEmpty
                                      className="fieldBatch1"
                                      name="iv_ct_nom"
                                      id="iv_ct_nom"
                                      MenuProps={{
                                        PaperProps: {
                                          style: {
                                            width: 35,
                                          },
                                        },
                                      }}
                                    >
                                      <MenuItem
                                        value=""
                                        sx={{ fontSize: "12px" }}
                                      >
                                        Select CT
                                      </MenuItem>
                                      <MenuItem
                                        value="100"
                                        sx={{ fontSize: "12px" }}
                                      >
                                        100
                                      </MenuItem>
                                      <MenuItem
                                        value="200"
                                        sx={{ fontSize: "12px" }}
                                      >
                                        200
                                      </MenuItem>
                                      <MenuItem
                                        value="300"
                                        sx={{ fontSize: "12px" }}
                                      >
                                        300
                                      </MenuItem>
                                      <MenuItem
                                        value="400"
                                        sx={{ fontSize: "12px" }}
                                      >
                                        400
                                      </MenuItem>
                                      <MenuItem
                                        value="600"
                                        sx={{ fontSize: "12px" }}
                                      >
                                        600
                                      </MenuItem>
                                      <MenuItem
                                        value="800"
                                        sx={{ fontSize: "12px" }}
                                      >
                                        800
                                      </MenuItem>
                                      <MenuItem
                                        value="1000"
                                        sx={{ fontSize: "12px" }}
                                      >
                                        1000
                                      </MenuItem>
                                    </Select>
                                    /
                                    <TextField
                                      name="iv_ct_denom"
                                      value={scoPart2Formik.values.iv_ct_denom}
                                      type="text"
                                      autoComplete="off"
                                      fullWidth
                                      disabled={true}
                                      onChange={scoPart2Formik.handleChange}
                                      onBlur={scoPart2Formik.handleBlur}
                                      className="fieldCoverageMarla"
                                    />
                                  </div>
                                  <p className="form-error">
                                    {scoPart2Formik.errors.iv_ct_nom &&
                                    scoPart2Formik.touched.iv_ct_nom
                                      ? scoPart2Formik.errors.iv_ct_nom
                                      : null}
                                  </p>
                                  <p className="form-error">
                                    {scoPart2Formik.errors.iv_ct_denom &&
                                    scoPart2Formik.touched.iv_ct_denom
                                      ? scoPart2Formik.errors.iv_ct_denom
                                      : null}
                                  </p>
                                </Grid>
                                {phase != "Single Phase" &&
                                  phase != "3 Phase" &&
                                  phase != "MDI (LT)(CT)" && (
                                    <Grid item lg={2}>
                                      <Typography className="fieldLabel">
                                        PT Ratio
                                      </Typography>
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "3px",
                                          alignItems: "center",
                                        }}
                                      >
                                        <TextField
                                          name="iv_pt_nom"
                                          value={
                                            scoPart2Formik.values.iv_pt_nom
                                          }
                                          type="text"
                                          fullWidth
                                          disabled={true}
                                          onChange={scoPart2Formik.handleChange}
                                          onBlur={scoPart2Formik.handleBlur}
                                          className="fieldCoverageMarla"
                                        />
                                        /
                                        <TextField
                                          name="iv_pt_denom"
                                          value={
                                            scoPart2Formik.values.iv_pt_denom
                                          }
                                          type="text"
                                          fullWidth
                                          disabled={true}
                                          onChange={scoPart2Formik.handleChange}
                                          onBlur={scoPart2Formik.handleBlur}
                                          className="fieldCoverageMarla"
                                        />
                                      </div>
                                      <p className="form-error">
                                        {scoPart2Formik.errors.iv_pt_nom &&
                                        scoPart2Formik.touched.iv_pt_nom
                                          ? scoPart2Formik.errors.iv_pt_nom
                                          : null}
                                      </p>
                                      <p className="form-error">
                                        {scoPart2Formik.errors.iv_pt_denom &&
                                        scoPart2Formik.touched.iv_pt_denom
                                          ? scoPart2Formik.errors.iv_pt_denom
                                          : null}
                                      </p>
                                    </Grid>
                                  )}

                                <Grid item lg={1}>
                                  <Typography className="fieldLabel">
                                    MF
                                  </Typography>
                                  <input
                                    name="iv_mf"
                                    value={
                                      calculateMF(
                                        scoPart2Formik.values.iv_ct_nom,
                                        scoPart2Formik.values.iv_ct_denom,
                                        scoPart2Formik.values.iv_pt_nom,
                                        scoPart2Formik.values.iv_pt_denom,
                                      ) ?? ""
                                    }
                                    type="text"
                                    disabled
                                    style={{
                                      backgroundColor: "#006ad1",
                                      color: "white",
                                      padding: "10px",
                                      borderRadius: "5px",
                                      border: "none",
                                      width: "90%",
                                      fontSize: "18px",
                                    }}
                                    onChange={scoPart2Formik.handleChange}
                                    onBlur={scoPart2Formik.handleBlur}
                                    className="fieldCoverageMarla"
                                  />
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </>
                      ) : (
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 10 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                        }}
                      >
                        <h4 style={{ textAlign: "center", width: "100%" }}>
                          Forward to RO
                        </h4>
                      </div>

                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Forward to RO",
                      ) &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        // ≤ 70 kW AND NOT A1/A2/A3
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        // 15–70 kW (general 70 permission)
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        // 70–500 kW
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        // > 500 kW
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          

                          {/* ── Meter Removed ─────────────────────────────── */}
                          {(() => {
                            const removedRows = getRemovedMeterTableRows(scoDetails);
                            return (
                              <Box sx={{ m: 2 }}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    mb: 1,
                                    gap: 2,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontWeight: 600,
                                      color: "#003971",
                                      fontSize: "18px",
                                    }}
                                  >
                                    Meter Removed
                                  </Typography>

                                  {dialogRowData?.isReferToMT === true ? (
                                    <Box sx={{ minWidth: { lg: "300px", md: "260px", xs: "220px" } }}>
                                      {approvalDocumentThumbnail ? (
                                        <Button
                                          variant="outlined"
                                          component="label"
                                          startIcon={
                                            <CloseIcon
                                              sx={{ color: "red" }}
                                              onClick={() => {
                                                setApprovalDocument("");
                                                setApprovalDocumentThumbnail("");
                                                setApprovalDocumentError("");
                                              }}
                                            />
                                          }
                                          sx={{
                                            width: "100%",
                                            backgroundColor: "white",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {approvalDocumentThumbnail.startsWith(
                                            "data:image/",
                                          ) ? (
                                            <img
                                              src={approvalDocumentThumbnail}
                                              alt="Approval document"
                                              width="80"
                                            />
                                          ) : approvalDocumentThumbnail.startsWith(
                                              "data:application/pdf",
                                            ) ? (
                                            <img
                                              src={pdfIcon}
                                              alt="Approval document"
                                              width="80"
                                            />
                                          ) : null}
                                        </Button>
                                      ) : (
                                        <Button
                                          variant="outlined"
                                          component="label"
                                          startIcon={<FileUploadOutlinedIcon />}
                                          sx={{
                                            width: "100%",
                                            backgroundColor: "white",
                                            justifyContent: "flex-start",
                                          }}
                                        >
                                          Upload Approval Document
                                          <input
                                            hidden
                                            accept={documentExtensions}
                                            id="approval_document"
                                            name="approval_document"
                                            type="file"
                                            onChange={ApprovalDocumentImage}
                                          />
                                        </Button>
                                      )}

                                      <Box
                                        sx={{
                                          color: "red",
                                          marginTop: "1%",
                                          fontSize: "0.85rem",
                                        }}
                                      >
                                        {approvalDocumentError}
                                      </Box>
                                    </Box>
                                  ) : null}
                                </Box>
                                <div
                                  style={{
                                    overflowX: "auto",
                                    borderRadius: 8,
                                    border: "1px solid #e0e4ef",
                                  }}
                                >
                                  <table
                                    style={{
                                      width: "100%",
                                      borderCollapse: "separate",
                                      borderSpacing: 0,
                                      fontSize: 13,
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        {[
                                          "Set No",
                                          "Meter Type",
                                          "Serial No",
                                          "Multiply Factor",
                                          "Master Reading",
                                          "Meter Reading",
                                          "Advance Units",
                                          "Rounding Comp Code",
                                        ].map((h) => (
                                          <th
                                            key={h}
                                            style={{
                                              background: "#006ad1",
                                              color: "#fff",
                                              padding: "11px 10px",
                                              textAlign: "center",
                                              fontWeight: 600,
                                              fontSize: 12,
                                              borderRight:
                                                "1px solid rgba(255,255,255,0.15)",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {h}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {removedRows.length > 0 ? (
                                        removedRows.map((row, idx) => (
                                          <tr
                                            key={idx}
                                            style={{
                                              background:
                                                idx % 2 === 0
                                                  ? "#fafafe"
                                                  : "#f4f4fb",
                                            }}
                                          >
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {getMeterRemovedSetNoLabel(row)}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {getRemovedMeterTypeDisplayLabel(row)}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.serialNo}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.multiplyFactor}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.masterReading}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.meterReading}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.advanceUnits}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.roundingCompCode}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={8}
                                            style={{
                                              textAlign: "center",
                                              padding: "16px",
                                              color: "#888",
                                            }}
                                          >
                                            No removed meter data available.
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Box>
                            );
                          })()}

                          {/* ── Meter Installed ───────────────────────────── */}
                          {(() => {
                            const installedRows = getInstalledMeterTableRows(
                              scoDetails,
                            );
                            return (
                              <Box sx={{ m: 2, mt: 3 }}>
                                <Typography
                                  sx={{
                                    fontWeight: 600,
                                    mb: 1,
                                    color: "#003971",
                                    fontSize: "18px",
                                  }}
                                >
                                  Meter Installed
                                </Typography>
                                <div
                                  style={{
                                    overflowX: "auto",
                                    borderRadius: 8,
                                    border: "1px solid #e0e4ef",
                                  }}
                                >
                                  <table
                                    style={{
                                      width: "100%",
                                      borderCollapse: "collapse",
                                      borderSpacing: 0,
                                      fontSize: 13,
                                      tableLayout: "fixed",
                                    }}
                                  >
                                    <colgroup>
                                      <col style={{ width: "118px" }} />
                                      <col style={{ width: "56px" }} />
                                      <col style={{ width: "88px" }} />
                                      <col style={{ width: "52px" }} />
                                      <col style={{ width: "56px" }} />
                                      <col style={{ width: "72px" }} />
                                      <col style={{ width: "40px" }} />
                                      <col style={{ width: "48px" }} />
                                      <col style={{ width: "56px" }} />
                                      <col style={{ width: "64px" }} />
                                      <col style={{ width: "56px" }} />
                                      <col style={{ width: "56px" }} />
                                    </colgroup>
                                    <thead>
                                      <tr>
                                        {[
                                          "Set No",
                                          "Meter Type",
                                          "Meter Number",
                                          "Meter Location",
                                          "Meter Mfg.",
                                          "Meter Code",
                                          "MF",
                                          "Range",
                                          "Reading",
                                          "Feeder Code",
                                          "MDI Reset",
                                          "MDI Cum",
                                        ].map((h) => (
                                          <th
                                            key={h}
                                            style={{
                                              background: "#006ad1",
                                              color: "#fff",
                                              padding: "11px 10px",
                                              textAlign: "center",
                                              fontWeight: 600,
                                              fontSize: 12,
                                              borderRight:
                                                "1px solid rgba(255,255,255,0.15)",
                                              whiteSpace: "normal",
                                              wordBreak: "break-word",
                                              lineHeight: 1.3,
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            {h}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {installedRows.length > 0 ? (
                                        installedRows.map((row, idx) => (
                                          <tr
                                            key={idx}
                                            style={{
                                              background:
                                                idx % 2 === 0
                                                  ? "#fafafe"
                                                  : "#f4f4fb",
                                            }}
                                          >
                                            <td style={meterInstalledSetNoCellStyle}>
                                              {getMeterRemovedSetNoLabel(row)}
                                            </td>
                                            <td style={meterInstalledTypeCellStyle}>
                                              {getInstalledMeterTypeDisplayLabel(row)}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterNumber}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterLocation}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterManufacturing}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterCode}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.multiplyFactor}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterRange}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterReading}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.feederCode}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.mdiResetNo}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.mdiCumRead}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={12}
                                            style={{
                                              textAlign: "center",
                                              padding: "16px",
                                              color: "#888",
                                            }}
                                          >
                                            No installed meter data available.
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Box>
                            );
                          })()}

                        </>
                      ) : (
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 11 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <div
                        className="step-title"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "1%",
                          alignItems: "center",
                        }}
                      >
                        <h4
                          style={{
                            textAlign: "center",
                            width: "100%",
                            marginTop: "0.5%",
                          }}
                        >
                          Ready for Billing
                        </h4>
                      </div>

                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Post for Billing",
                      ) &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) ? (
                        <>
                          {/* ── Meter Removed ─────────────────────────────── */}
                          {(() => {
                            const removedRows = getRemovedMeterTableRows(scoDetails);
                            return (
                              <Box sx={{ m: 2 }}>
                                <Typography
                                  sx={{
                                    fontWeight: 600,
                                    mb: 1,
                                    color: "#003971",
                                    fontSize: "18px",
                                  }}
                                >
                                  Meter Removed
                                </Typography>
                                <div
                                  style={{
                                    overflowX: "auto",
                                    borderRadius: 8,
                                    border: "1px solid #e0e4ef",
                                  }}
                                >
                                  <table
                                    style={{
                                      width: "100%",
                                      borderCollapse: "separate",
                                      borderSpacing: 0,
                                      fontSize: 13,
                                    }}
                                  >
                                    <thead>
                                      <tr>
                                        {[
                                          "Set No",
                                          "Meter Type",
                                          "Serial No",
                                          "Multiply Factor",
                                          "Master Reading",
                                          "Meter Reading",
                                          "Advance Units",
                                          "Rounding Comp Code",
                                        ].map((h) => (
                                          <th
                                            key={h}
                                            style={{
                                              background: "#006ad1",
                                              color: "#fff",
                                              padding: "11px 10px",
                                              textAlign: "center",
                                              fontWeight: 600,
                                              fontSize: 12,
                                              borderRight:
                                                "1px solid rgba(255,255,255,0.15)",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {h}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {removedRows.length > 0 ? (
                                        removedRows.map((row, idx) => (
                                          <tr
                                            key={idx}
                                            style={{
                                              background:
                                                idx % 2 === 0
                                                  ? "#fafafe"
                                                  : "#f4f4fb",
                                            }}
                                          >
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {getMeterRemovedSetNoLabel(row)}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {getRemovedMeterTypeDisplayLabel(row)}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.serialNo}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.multiplyFactor}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.masterReading}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.meterReading}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.advanceUnits}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                              }}
                                            >
                                              {row.roundingCompCode}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={8}
                                            style={{
                                              textAlign: "center",
                                              padding: "16px",
                                              color: "#888",
                                            }}
                                          >
                                            No removed meter data available.
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Box>
                            );
                          })()}

                          {/* ── Meter Installed ───────────────────────────── */}
                          {(() => {
                            const installedRows = getInstalledMeterTableRows(
                              scoDetails,
                            );
                            return (
                              <Box sx={{ m: 2, mt: 3 }}>
                                <Typography
                                  sx={{
                                    fontWeight: 600,
                                    mb: 1,
                                    color: "#003971",
                                    fontSize: "18px",
                                  }}
                                >
                                  Meter Installed
                                </Typography>
                                <div
                                  style={{
                                    overflowX: "auto",
                                    borderRadius: 8,
                                    border: "1px solid #e0e4ef",
                                  }}
                                >
                                  <table
                                    style={{
                                      width: "100%",
                                      borderCollapse: "collapse",
                                      borderSpacing: 0,
                                      fontSize: 13,
                                      tableLayout: "fixed",
                                    }}
                                  >
                                    <colgroup>
                                      <col style={{ width: "118px" }} />
                                      <col style={{ width: "56px" }} />
                                      <col style={{ width: "88px" }} />
                                      <col style={{ width: "52px" }} />
                                      <col style={{ width: "56px" }} />
                                      <col style={{ width: "72px" }} />
                                      <col style={{ width: "40px" }} />
                                      <col style={{ width: "48px" }} />
                                      <col style={{ width: "56px" }} />
                                      <col style={{ width: "64px" }} />
                                      <col style={{ width: "56px" }} />
                                      <col style={{ width: "56px" }} />
                                    </colgroup>
                                    <thead>
                                      <tr>
                                        {[
                                          "Set No",
                                          "Meter Type",
                                          "Meter Number",
                                          "Meter Location",
                                          "Meter Mfg.",
                                          "Meter Code",
                                          "MF",
                                          "Range",
                                          "Reading",
                                          "Feeder Code",
                                          "MDI Reset",
                                          "MDI Cum",
                                        ].map((h) => (
                                          <th
                                            key={h}
                                            style={{
                                              background: "#006ad1",
                                              color: "#fff",
                                              padding: "11px 10px",
                                              textAlign: "center",
                                              fontWeight: 600,
                                              fontSize: 12,
                                              borderRight:
                                                "1px solid rgba(255,255,255,0.15)",
                                              whiteSpace: "normal",
                                              wordBreak: "break-word",
                                              lineHeight: 1.3,
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            {h}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {installedRows.length > 0 ? (
                                        installedRows.map((row, idx) => (
                                          <tr
                                            key={idx}
                                            style={{
                                              background:
                                                idx % 2 === 0
                                                  ? "#fafafe"
                                                  : "#f4f4fb",
                                            }}
                                          >
                                            <td style={meterInstalledSetNoCellStyle}>
                                              {getMeterRemovedSetNoLabel(row)}
                                            </td>
                                            <td style={meterInstalledTypeCellStyle}>
                                              {getInstalledMeterTypeDisplayLabel(row)}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterNumber}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterLocation}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterManufacturing}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterCode}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.multiplyFactor}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterRange}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.meterReading}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.feederCode}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.mdiResetNo}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom:
                                                  "1px solid #e8e8f0",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {row.mdiCumRead}
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={12}
                                            style={{
                                              textAlign: "center",
                                              padding: "16px",
                                              color: "#888",
                                            }}
                                          >
                                            No installed meter data available.
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Box>
                            );
                          })()}
                        </>
                      ) : (
                        <div className="description-box description-box--error">
                          <p className="group-description">
                            <InfoIcon className="icon" />
                            The application is in process by sanctioning
                            authority.
                          </p>
                        </div>
                      )}
                    </>
                  ) : dialogRowData.applicationProgressId === 12 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      <Grid
                        container
                        className="step-title step-title--with-action"
                      >
                        <h4>Application Completed</h4>
                        <Box className="step-title__actions">
                        <Button
                          variant="outlined"
                          onClick={() =>
                            downloadCP138PDF(dialogRowData, scoDetails)
                          }
                            className="rco-bill-btn"
                          >
                            <PrintIcon /> CP-138
                        </Button>
                        </Box>
                      </Grid>
                      <Box
                        sx={{
                          color: "#00B091",
                          marginTop: "2%",
                          backgroundColor: "#DFFFE4",
                          padding: "1%",
                          width: "95%",
                          display: "flex",
                          flexDirection: "row",
                          marginLeft: "1%",
                        }}
                      >
                        <ErrorIcon
                          style={{ color: "#00B091", marginLeft: "1%" }}
                        />
                        <h4
                          style={{
                            marginLeft: "10px",
                            fontSize: "1vw",
                            fontWeight: "normal",
                          }}
                        >
                          {/* Application sent to level-1 (IBS). */}
                          Application Completed.
                        </h4>
                      </Box>
                    </>
                  ) : null}
                </div>
                <div className="actions">
                  {dialogRowData.applicationProgressId === 0 ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Basic Permissions",
                        "Update",
                      ) ? (
                        <button
                          onClick={() =>
                            navigate("/new-connection-update", {
                              state: { dialogRowData },
                            })
                          }
                          className="view-button"
                        >
                          Upload Pending Documents
                        </button>
                      ) : null}
                    </>
                  ) : dialogRowData.applicationProgressId === 1 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Document Verification",
                    ) && (
                      <>
                        {dialogRowData.applicantCNICFrontFlag !== 1 ||
                        dialogRowData.applicantCNICBackFlag !== 1 ? (
                          <>
                            <button
                              disabled={
                                !flag_applicantCNICFront ||
                                !flag_applicantCNICBack ||
                                flag_applicantCNICBack === "2" ||
                                flag_applicantCNICFront === "2" ||
                                !flag_scannedCopyOfNearByElectricityBill ||
                                flag_scannedCopyOfNearByElectricityBill ===
                                  "2" ||
                                (dialogRowData.anyOtherDocument &&
                                  (!flag_anyOtherDocument ||
                                    flag_anyOtherDocument === "2"))
                              }
                              onClick={() => updateDocumentStatus()}
                              className="view-button"
                              style={{
                                backgroundColor:
                                  flag_applicantCNICFront === -1 ||
                                  flag_applicantCNICBack === -1 ||
                                  flag_scannedCopyOfNearByElectricityBill ===
                                    -1 ||
                                  flag_anyOtherDocument === -1
                                    ? "#E11B3C"
                                    : "#003971",
                              }}
                            >
                              {flag_applicantCNICFront === -1 ||
                              flag_applicantCNICBack === -1 ||
                              flag_scannedCopyOfNearByElectricityBill === -1 ||
                              flag_anyOtherDocument === -1
                                ? "Reject"
                                : "Verify"}
                            </button>
                          </>
                        ) : null}
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 1 &&
                    dialogRowData.objectionStatus === 1 ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Basic Permissions",
                        "Update",
                      ) ? (
                        <>
                          <button
                            type="button"
                            onClick={() => {
                              setOpen(false);
                              if (!props.showTable && typeof props.onCloseSearchResults === 'function') {
                                props.onCloseSearchResults();
                              }
                              navigate("/meter-change-request-update", {
                                state: { dialogRowData },
                              });
                            }}
                            className="view-button"
                          >
                            Re-Upload Document
                          </button>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ): dialogRowData.applicationProgressId === 2 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval / Rejection",
                      ) &&
                      /* ========== LOAD <= 15 ========== */
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "15",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 15 &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A1",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A1")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A2",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A2")) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A3",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A3")))) ||
                        /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 70 &&
                          !["A1", "A2", "A3"].some((code) =>
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith(code),
                          )) ||
                        /* ========== LOAD 15–70 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "70",
                        ) &&
                          dialogRowData.sanctionedLoad > 15 &&
                          dialogRowData.sanctionedLoad <= 70) ||
                        /* ========== LOAD 70–500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "500",
                        ) &&
                          dialogRowData.sanctionedLoad > 70 &&
                          dialogRowData.sanctionedLoad <= 500) ||
                        /* ========== LOAD > 500 ========== */
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "5000",
                        ) &&
                          dialogRowData.sanctionedLoad > 500)) && (
                      <>
                     
                        <div>
                                <button
                            type="button"
                                  className="view-button"
                            onClick={handleApprovalRejectionApprove}
                          >
                            Approve
                                </button>
                                <button
                            type="button"
                            className="reject-button"
                            onClick={openApprovalRejectionRejectDialog}
                          >
                            Reject
                                </button>
                        </div>
                           <Dialog
                             open={approvalRejectDialogOpen}
                             onClose={closeApprovalRejectionRejectDialog}
                             className="rco-remarks-dialog rco-remarks-dialog--reject"
                             fullWidth
                             maxWidth="sm"
                             PaperProps={{ className: "rco-remarks-dialog__paper" }}
                           >
                             <DialogTitle className="rco-remarks-dialog__title">
                               <div className="rco-remarks-dialog__header">
                                 <Typography className="rco-remarks-dialog__heading">
                                   Reject Application
                               </Typography>
                                 <button
                                   type="button"
                                   className="rco-remarks-dialog__close"
                                   onClick={closeApprovalRejectionRejectDialog}
                                   aria-label="Close dialog"
                                 >
                                   <CloseIcon id="clearPopup" />
                                 </button>
                               </div>
                             </DialogTitle>
                             <DialogContent className="rco-remarks-dialog__content">
                               <TextField
                                 autoFocus
                                 fullWidth
                                 multiline
                                 minRows={5}
                                 maxRows={8}
                                 variant="outlined"
                                 placeholder="Enter rejection remarks"
                                 value={approvalRejectRemarks}
                                 onChange={(e) => {
                                   setApprovalRejectRemarks(e.target.value);
                                   if (approvalRejectRemarksError) {
                                     setApprovalRejectRemarksError("");
                                   }
                                 }}
                                 className="rco-remarks-dialog__textarea"
                               />
                               {approvalRejectRemarksError ? (
                                 <p className="rco-remarks-dialog__error">
                                 {approvalRejectRemarksError}
                                 </p>
                               ) : null}
                             </DialogContent>
                             <DialogActions className="rco-remarks-dialog__actions">
                               <Button
                                 type="button"
                                 onClick={closeApprovalRejectionRejectDialog}
                                 className="rco-remarks-dialog__btn rco-remarks-dialog__btn--cancel"
                               >
                                 Cancel
                               </Button>
                               <Button
                                 type="button"
                                 onClick={handleApprovalRejectionReject}
                                 className="rco-remarks-dialog__btn rco-remarks-dialog__btn--confirm"
                               >
                                 Submit
                               </Button>
                             </DialogActions>
                           </Dialog>
                      </>
                    )
                  )  : dialogRowData.applicationProgressId === 3 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Arrears Verification",
                    ) &&
                    /* ========== LOAD <= 15 ========== */
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      /* ========== LOAD 15–70 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      /* ========== LOAD 70–500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      /* ========== LOAD > 500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <>
                        <Grid container spacing={2} justifyContent="end">
                          {paymentStatus === "No arrear exists" && (
                            <Grid item>
                              <button
                                className="view-button"
                                onClick={() =>
                                  callArrearVerificationAPI(
                                    dialogRowData.applicationId,
                                    dialogRowData.applicationProgressId + 1,
                                    0,
                                    "Arrear Verified.",
                                    "Arrear Verified.",
                                    0,
                                    "",
                                    null,
                                  )
                                }
                              >
                                Approve
                              </button>
                            </Grid>
                          )}

                          {paymentStatus === "Arrear exists" && (
                            <>
                              <Grid item>
                                <button
                                  className="reject-button"
                                  onClick={() =>
                                    callArrearVerificationAPI(
                                      dialogRowData.applicationId,
                                      dialogRowData.applicationProgressId,
                                      1,
                                      "Arrear Rejected.",
                                      `Arrear Rejected.`,
                                      arrearAmount,
                                      billMonth,
                                      null,
                                    )
                                  }
                                >
                                  Reject
                                </button>
                              </Grid>

                              <Grid item>
                                <button
                                  className="view-button"
                                  onClick={
                                    arrearPaymentReceiptFormik.handleSubmit
                                  }
                                >
                                  Approve
                                </button>
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 3 &&
                    dialogRowData.objectionStatus === 1 ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Arrears Verification",
                    ) &&
                    /* ========== LOAD <= 15 ========== */
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      /* ========== LOAD 15–70 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      /* ========== LOAD 70–500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      /* ========== LOAD > 500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <>
                        <Grid container spacing={2} justifyContent="end">
                          {paymentStatus === "No arrear exists" && (
                            <Grid item>
                              <button
                                className="view-button"
                                onClick={() =>
                                  callArrearVerificationAPI(
                                    dialogRowData.applicationId,
                                    dialogRowData.applicationProgressId + 1,
                                    1,
                                    "Arrear Verified.",
                                    "Arrear Verified.",
                                    0,
                                    "",
                                    null,
                                  )
                                }
                              >
                                Approve
                              </button>
                            </Grid>
                          )}

                          {paymentStatus === "Arrear exists" && (
                            <>
                              <Grid item>
                                <button
                                  className="reject-button"
                                  onClick={() =>
                                    callArrearVerificationAPI(
                                      dialogRowData.applicationId,
                                      dialogRowData.applicationProgressId,
                                      1,
                                      "Arrear Rejected.",
                                      `Arrear Rejected.`,
                                      arrearAmount,
                                      billMonth,
                                      null,
                                    )
                                  }
                                >
                                  Reject
                                </button>
                              </Grid>

                              <Grid item>
                                <button
                                  className="view-button"
                                  onClick={
                                    arrearPaymentObjectionReceiptFormik.handleSubmit
                                  }
                                >
                                  Approve
                                </button>
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 4 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                        {CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Field Survey",
                        ) &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "15",
                          ) &&
                            dialogRowData.sanctionedLoad > 0 &&
                            dialogRowData.sanctionedLoad <= 15 &&
                            ((CheckPermissions(
                              permissions,
                              "General Services",
                              "Meter Change Order",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A1",
                            ) &&
                              getNormalizedTariffName(
                                dialogRowData.tariffCode,
                                allTariffList,
                              ).startsWith("A1")) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Meter Change Order",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A2",
                              ) &&
                                getNormalizedTariffName(
                                  dialogRowData.tariffCode,
                                  allTariffList,
                                ).startsWith("A2")) ||
                              (CheckPermissions(
                                permissions,
                                "General Services",
                                "Meter Change Order",
                                "Workflow Permissions",
                                "Approval Category",
                                "Tariff Authority",
                                "A3",
                              ) &&
                                getNormalizedTariffName(
                                  dialogRowData.tariffCode,
                                  allTariffList,
                                ).startsWith("A3")))) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Meter Change Order",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "70",
                            ) &&
                              dialogRowData.sanctionedLoad > 0 &&
                              dialogRowData.sanctionedLoad <= 70 &&
                              !["A1", "A2", "A3"].some((code) =>
                                getNormalizedTariffName(
                                  dialogRowData.tariffCode,
                                  allTariffList,
                                ).startsWith(code),
                              )) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Meter Change Order",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "70",
                            ) &&
                              dialogRowData.sanctionedLoad > 15 &&
                              dialogRowData.sanctionedLoad <= 70) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Meter Change Order",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "500",
                            ) &&
                              dialogRowData.sanctionedLoad > 70 &&
                              dialogRowData.sanctionedLoad <= 500) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Meter Change Order",
                              "Workflow Permissions",
                              "Approval Category",
                              "Load Sanctioning",
                              "5000",
                            ) &&
                              dialogRowData.sanctionedLoad > 500)) && (
                            <div>
                              <button
                                onClick={async () => {
                                  if (!meterImage && !meterImageThumbnail) {
                                    setMeterImageError(
                                      "Upload the Meter Image in JPG, PNG or PDF format.",
                                    );
                                  } else {
                                    setMeterImageError("");
                                  }
                                  await fieldFormik.handleSubmit();
                                }}
                                type="button"
                                className="view-button"
                              >
                                Submit
                              </button>
                      </div>
                          )}
                    </>
                  ) : dialogRowData.applicationProgressId === 5 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "M&T Report",
                    ) && (
                      <>
                        <div>
                          <button
                            className="view-button"
                            onClick={handleMandtReceiptSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 6 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    <>
                      {CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "DN Approval",
                      ) &&
                        ((CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Load Sanctioning",
                          "15",
                        ) &&
                          dialogRowData.sanctionedLoad > 0 &&
                          dialogRowData.sanctionedLoad <= 15 &&
                          ((CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Tariff Authority",
                            "A1",
                          ) &&
                            getNormalizedTariffName(
                              dialogRowData.tariffCode,
                              allTariffList,
                            ).startsWith("A1")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Meter Change Order",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A2",
                            ) &&
                              getNormalizedTariffName(
                                dialogRowData.tariffCode,
                                allTariffList,
                              ).startsWith("A2")) ||
                            (CheckPermissions(
                              permissions,
                              "General Services",
                              "Meter Change Order",
                              "Workflow Permissions",
                              "Approval Category",
                              "Tariff Authority",
                              "A3",
                            ) &&
                              getNormalizedTariffName(
                                dialogRowData.tariffCode,
                                allTariffList,
                              ).startsWith("A3")))) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70",
                          ) &&
                            dialogRowData.sanctionedLoad > 0 &&
                            dialogRowData.sanctionedLoad <= 70 &&
                            !["A1", "A2", "A3"].some((code) =>
                              getNormalizedTariffName(
                                dialogRowData.tariffCode,
                                allTariffList,
                              ).startsWith(code),
                            )) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "70",
                          ) &&
                            dialogRowData.sanctionedLoad > 15 &&
                            dialogRowData.sanctionedLoad <= 70) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "500",
                          ) &&
                            dialogRowData.sanctionedLoad > 70 &&
                            dialogRowData.sanctionedLoad <= 500) ||
                          (CheckPermissions(
                            permissions,
                            "General Services",
                            "Meter Change Order",
                            "Workflow Permissions",
                            "Approval Category",
                            "Load Sanctioning",
                            "5000",
                          ) &&
                            dialogRowData.sanctionedLoad > 500)) && (
                          <div>
                            <button
                              onClick={() => {
                                DNApproveAPI(
                                  token,
                                  dialogRowData.applicationId,
                                  dialogRowData.applicationProgressId + 1,
                                  0,
                                  "Demand Note approved.",
                                  portalName,
                                );
                              }}
                              className="view-button"
                            >
                              Approve
                            </button>

                            <button
                              onClick={() => setDnRejectModalOpen(true)}
                              className="reject-button"
                            >
                              Reject
                            </button>
                          </div>
                        )}
                    </>
                  ) : dialogRowData.applicationProgressId === 7 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "DN Submission",
                    ) && (
                      <>
                        <div>
                          <button
                            className="view-button"
                            onClick={handleDnReceiptSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 7 &&
                    dialogRowData.objectionStatus === 1 ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "DN Submission",
                    ) && (
                      <>
                        <div>
                          <button
                            className="view-button"
                            onClick={handleDnReceiptSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 8 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "DN Payment Verification",
                    ) &&
                    /* ========== LOAD <= 15 ========== */
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      /* ========== LOAD 15–70 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      /* ========== LOAD 70–500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      /* ========== LOAD > 500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <>
                        <div>
                          <button
                            onClick={() => {
                              setVoucherActionTypeForDN("approve");
                              setOpenVoucherActionModalForDN(true);
                            }}
                            className="view-button"
                          >
                            Approve
                          </button>

                          <button
                            onClick={() => {
                              setVoucherActionTypeForDN("reject");
                              setOpenVoucherActionModalForDN(true);
                            }}
                            className="reject-button"
                          >
                            Reject
                          </button>
                        </div>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 9 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Meter Installation",
                    ) &&
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      // ≤ 70 kW AND NOT A1/A2/A3
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      // 15–70 kW (general 70 permission)
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      // 70–500 kW
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      // > 500 kW
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <div>
                        <button
                          type="button"
                          onClick={handleMeterInstallSubmit}
                          disabled={!meterInstallCanSubmit}
                          className="view-button"
                          style={{
                            backgroundColor: meterInstallCanSubmit ? "#003971" : "#cccccc",
                            cursor: meterInstallCanSubmit ? "pointer" : "not-allowed",
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    )
                  ) : dialogRowData.applicationProgressId === 10 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Forward to RO",
                    ) &&
                    /* ========== LOAD <= 15 (A1/A2/A3) ========== */
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ["A1", "A2", "A3"].some((code) =>
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith(code),
                      )) ||
                      /* ========== LOAD <= 70 (Exclude A1/A2/A3) ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      /* ========== LOAD 15–70 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      /* ========== LOAD 70–500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      /* ========== LOAD > 500 ========== */
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <>
                        <button
                          onClick={handleForwardToROApprove}
                          type="submit"
                          className="view-button"
                          style={{ marginLeft: "10px" }}
                        >
                          Approve
                        </button>
                      </>
                    )
                  ) : dialogRowData.applicationProgressId === 11 &&
                    (dialogRowData.objectionStatus === 0 ||
                      dialogRowData.objectionStatus === 2) ? (
                    CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Post for Billing",
                    ) &&
                    ((CheckPermissions(
                      permissions,
                      "General Services",
                      "Meter Change Order",
                      "Workflow Permissions",
                      "Approval Category",
                      "Load Sanctioning",
                      "15",
                    ) &&
                      dialogRowData.sanctionedLoad > 0 &&
                      dialogRowData.sanctionedLoad <= 15 &&
                      ((CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Tariff Authority",
                        "A1",
                      ) &&
                        getNormalizedTariffName(
                          dialogRowData.tariffCode,
                          allTariffList,
                        ).startsWith("A1")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A2",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A2")) ||
                        (CheckPermissions(
                          permissions,
                          "General Services",
                          "Meter Change Order",
                          "Workflow Permissions",
                          "Approval Category",
                          "Tariff Authority",
                          "A3",
                        ) &&
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith("A3")))) ||
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 0 &&
                        dialogRowData.sanctionedLoad <= 70 &&
                        !["A1", "A2", "A3"].some((code) =>
                          getNormalizedTariffName(
                            dialogRowData.tariffCode,
                            allTariffList,
                          ).startsWith(code),
                        )) ||
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "70",
                      ) &&
                        dialogRowData.sanctionedLoad > 15 &&
                        dialogRowData.sanctionedLoad <= 70) ||
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "500",
                      ) &&
                        dialogRowData.sanctionedLoad > 70 &&
                        dialogRowData.sanctionedLoad <= 500) ||
                      (CheckPermissions(
                        permissions,
                        "General Services",
                        "Meter Change Order",
                        "Workflow Permissions",
                        "Approval Category",
                        "Load Sanctioning",
                        "5000",
                      ) &&
                        dialogRowData.sanctionedLoad > 500)) && (
                      <>
                        <button
                          onClick={() =>
                            callPostedToIBSForBilling(
                              dialogRowData.applicationId,
                              dialogRowData.applicationProgressId + 1,
                              0,
                              "Application post for billing.",
                              "Application post for billing.",
                            )
                          }
                          type="submit"
                          className="view-button"
                          style={{ marginLeft: "10px" }}
                        >
                          Approve
                        </button>
                      </>
                    )
                  ) : null}
                </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Basic Info Update Dialog */}
      <Dialog
        open={showEditPopup}
        onClose={() => {
          setShowEditPopup(false);
          editBasicInfoFormik.resetForm();
        }}
        fullWidth={true}
        maxWidth="lg"
        className="alert-popups"
      >
        <DialogTitle className="dialog-title">
          Basic Information
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setShowEditPopup(false);
                editBasicInfoFormik.resetForm();
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText component="div" className="dialog-content-text">
            <Typography variant="h3" className="group-title">
              Applicant's Details
            </Typography>
            <div className="field-container">
              <Typography>Name</Typography>
              <TextField
                required
                type="text"
                className="textfield"
                name="iv_applicant_name"
                value={editBasicInfoFormik.values.iv_applicant_name}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_applicant_name &&
                editBasicInfoFormik.touched.iv_applicant_name
                  ? editBasicInfoFormik.errors.iv_applicant_name
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography>
                {dialogRowData.applicantRelationType === "Father's Name"
                  ? "Father's Name"
                  : "Husband's Name"}
              </Typography>
              <TextField
                required
                type="text"
                name="iv_relative_name"
                value={editBasicInfoFormik.values.iv_relative_name}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                className="textfield"
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_relative_name &&
                editBasicInfoFormik.touched.iv_relative_name
                  ? editBasicInfoFormik.errors.iv_relative_name
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography>CNIC</Typography>
              <TextField
                required
                type="text"
                name="iv_applicant_cnic"
                value={editBasicInfoFormik.values.iv_applicant_cnic}
                inputProps={{ maxLength: 13 }}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                className="textfield"
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_applicant_cnic &&
                editBasicInfoFormik.touched.iv_applicant_cnic
                  ? editBasicInfoFormik.errors.iv_applicant_cnic
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography>Phone No.</Typography>
              <TextField
                required
                type="text"
                name="iv_applicant_phone"
                value={editBasicInfoFormik.values.iv_applicant_phone}
                inputProps={{ maxLength: 11 }}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                className="textfield"
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_applicant_phone &&
                editBasicInfoFormik.touched.iv_applicant_phone
                  ? editBasicInfoFormik.errors.iv_applicant_phone
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography>Email (optional)</Typography>
              <TextField
                type="email"
                name="iv_applicant_email"
                value={editBasicInfoFormik.values.iv_applicant_email}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                className="textfield"
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_applicant_email &&
                editBasicInfoFormik.touched.iv_applicant_email
                  ? editBasicInfoFormik.errors.iv_applicant_email
                  : null}
              </Box>
            </div>
            <Typography variant="h3" className="group-title">
              Address Details
            </Typography>
            {dialogRowData.areaType === "Urban" && (
              <>
                <div className="field-container">
                  <Typography>House / Shop</Typography>
                  <TextField
                    required
                    type="text"
                    name="iv_house"
                    value={editBasicInfoFormik.values.iv_house}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_house &&
                    editBasicInfoFormik.touched.iv_house
                      ? editBasicInfoFormik.errors.iv_house
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>Street</Typography>
                  <TextField
                    required
                    type="text"
                    name="iv_street"
                    value={editBasicInfoFormik.values.iv_street}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_street &&
                    editBasicInfoFormik.touched.iv_street
                      ? editBasicInfoFormik.errors.iv_street
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>Sector / Block / Phase / Mohala</Typography>
                  <TextField
                    required
                    type="email"
                    name="iv_sector_block_phase_mohala"
                    value={
                      editBasicInfoFormik.values.iv_sector_block_phase_mohala
                    }
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_sector_block_phase_mohala &&
                    editBasicInfoFormik.touched.iv_sector_block_phase_mohala
                      ? editBasicInfoFormik.errors.iv_sector_block_phase_mohala
                      : null}
                  </Box>
                </div>
              </>
            )}
            {dialogRowData.areaType === "Rural" && (
              <>
                <div className="field-container">
                  <Typography>Basti / Chak / Street</Typography>
                  <TextField
                    required
                    type="email"
                    name="iv_chak_street"
                    value={editBasicInfoFormik.values.iv_chak_street}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_chak_street &&
                    editBasicInfoFormik.touched.iv_chak_street
                      ? editBasicInfoFormik.errors.iv_chak_street
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>Village</Typography>
                  <TextField
                    required
                    type="email"
                    name="iv_village"
                    value={editBasicInfoFormik.values.iv_village}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_village &&
                    editBasicInfoFormik.touched.iv_village
                      ? editBasicInfoFormik.errors.iv_village
                      : null}
                  </Box>
                </div>
              </>
            )}
            <div className="field-container">
              <Typography>Town / Tehsil</Typography>
              <TextField
                required
                type="email"
                name="iv_town_tehsil"
                value={editBasicInfoFormik.values.iv_town_tehsil}
                onChange={editBasicInfoFormik.handleChange}
                onBlur={editBasicInfoFormik.handleBlur}
                className="textfield"
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_town_tehsil &&
                editBasicInfoFormik.touched.iv_town_tehsil
                  ? editBasicInfoFormik.errors.iv_town_tehsil
                  : null}
              </Box>
            </div>
            <div className="field-container">
              <Typography>District / City</Typography>
              <Autocomplete
                id="iv_city_district"
                name="iv_city_district"
                autoComplete={false}
                options={cities ? cities : []}
                value={editBasicInfoFormik.values.iv_city_district}
                filterOptions={filterOptionsCityDistrict}
                onChange={(event, newValue) => {
                  if (newValue) {
                    editBasicInfoFormik.handleChange("iv_city_district")(
                      newValue,
                    );
                  }
                }}
                onBlur={editBasicInfoFormik.handleBlur}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    type="text"
                    className="textInputFieldAutoSelect"
                  />
                )}
              />
              <Box className="form-error">
                {editBasicInfoFormik.errors.iv_city_district &&
                editBasicInfoFormik.touched.iv_city_district
                  ? editBasicInfoFormik.errors.iv_city_district
                  : null}
              </Box>
            </div>
            {dialogRowData.applicantStatus === "Tenant" && (
              <>
                <Typography variant="h3" className="group-title">
                  Owner's Details
                </Typography>
                <div className="field-container">
                  <Typography>Name</Typography>
                  <TextField
                    required
                    type="text"
                    className="textfield"
                    name="iv_owner_name"
                    value={editBasicInfoFormik.values.iv_owner_name}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_owner_name &&
                    editBasicInfoFormik.touched.iv_owner_name
                      ? editBasicInfoFormik.errors.iv_owner_name
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>CNIC</Typography>
                  <TextField
                    required
                    type="text"
                    name="iv_owner_cnic"
                    value={editBasicInfoFormik.values.iv_owner_cnic}
                    inputProps={{ maxLength: 13 }}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_owner_cnic &&
                    editBasicInfoFormik.touched.iv_owner_cnic
                      ? editBasicInfoFormik.errors.iv_owner_cnic
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>Phone No.</Typography>
                  <TextField
                    required
                    type="text"
                    name="iv_owner_phone"
                    value={editBasicInfoFormik.values.iv_owner_phone}
                    inputProps={{ maxLength: 11 }}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_owner_phone &&
                    editBasicInfoFormik.touched.iv_owner_phone
                      ? editBasicInfoFormik.errors.iv_owner_phone
                      : null}
                  </Box>
                </div>
                <div className="field-container">
                  <Typography>Email (optional)</Typography>
                  <TextField
                    type="email"
                    name="iv_owner_email"
                    value={editBasicInfoFormik.values.iv_owner_email}
                    onChange={editBasicInfoFormik.handleChange}
                    onBlur={editBasicInfoFormik.handleBlur}
                    className="textfield"
                  />
                  <Box className="form-error">
                    {editBasicInfoFormik.errors.iv_owner_email &&
                    editBasicInfoFormik.touched.iv_owner_email
                      ? editBasicInfoFormik.errors.iv_owner_email
                      : null}
                  </Box>
                </div>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className="arrearBtn"
            sx={{ width: "15%" }}
            onClick={editBasicInfoFormik.handleSubmit}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Objection Dialog */}
      <Dialog
        open={objectionPopUpOpen}
        onClose={hideObjectionPopup}
        fullWidth={true}
        maxWidth={"sm"}
        className="objectionDialog"
        ref={formik.resetForm}
      >
        <DialogTitle className="objection-dialog-title">
          <Grid container className="objectionheadercontainer">
            <Grid item className="applicationTitleGrid">
              <p className="applicationTitleText">Rejection Reason </p>
            </Grid>
            <Grid item className="closeIcon">
              <CloseIcon id="clearPopup" onClick={hideObjectionPopup} />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className="objection-dialog-content">
          <DialogContentText component="div" className="objection-dialog-content-text">
            <TextField
              type="text"
              name="iv_objection_Type"
              id="iv_objection_Type"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.iv_objection_Type}
              className="objection-input"
            />
            <Box className="from-Error">
              {formik.errors.iv_objection_Type &&
              formik.touched.iv_objection_Type
                ? formik.errors.iv_objection_Type
                : null}
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="objection-dialog-action">
          <button
            onClick={() => {
              deleteFieldSurvey(dialogRowData.applicationId);
              setObjectionPopUpOpen(false);
            }}
            type="submit"
            className="submit-button"
          >
            Submit
          </button>
        </DialogActions>
      </Dialog>

      {/* Arrears Rejection Removal Alert */}
      <Dialog
        open={rejectionRemovalAlert}
        onClose={hideRejectionRemovalAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className="rejection-removal"
      >
        <DialogTitle className="dialog-title">
          Arrears Verification
          <Box sx={{ marginRight: "2%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                setArearPaidBillDocument("");
                setArearPaidBillDocumentThumbnail("");
                setRejectionRemovalAlert(false);
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent>
          {CheckPermissions(
            permissions,
            "General Services",
            "Meter Change Order",
            "Workflow Permissions",
            "Arrear Bill Uploading",
          ) ? (
            <>
              <Grid
                container
                item
                lg={12}
                sx={{ display: "flex", flexDirection: "row" }}
              >
                <Grid
                  item
                  lg={4}
                  sx={{
                    marginTop: "2%",
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "8%",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "normal",
                      marginBottom: "1%",
                      color: "#808080",
                    }}
                  >
                    Payment Date
                  </Typography>
                  <input
                    name="iv_arear_paid_bill_date"
                    value={
                      arearBillDocumentFormik.values.iv_arear_paid_bill_date
                    }
                    onChange={arearBillDocumentFormik.handleChange}
                    onBlur={arearBillDocumentFormik.handleBlur}
                    type="date"
                    style={{
                      padding: "10px", // Corrected syntax
                      borderRadius: "5px", // Enclosed in quotes
                      border: "1px solid #ccc", // Corrected syntax and enclosed in quotes
                      marginBottom: "10px",
                      width: "100%", // Corrected syntax and enclosed in quotes
                    }}
                    // min={dnDetails.issueDate.slice(0, 10)}
                    max={new Date().toISOString().split("T")[0]}
                  />
                  <Box
                    className="form-error"
                    sx={{ color: "red", marginTop: "1%" }}
                  >
                    {arearBillDocumentFormik.errors.iv_arear_paid_bill_date &&
                    arearBillDocumentFormik.touched.iv_arear_paid_bill_date
                      ? arearBillDocumentFormik.errors.iv_arear_paid_bill_date
                      : null}
                  </Box>
                </Grid>
                <Grid item lg={6} sx={{ marginTop: "2%", marginRight: "8%" }}>
                  <Typography
                    sx={{
                      fontWeight: "normal",
                      marginBottom: "1%",
                      color: "#808080",
                    }}
                  >
                    Paid Bill Image
                  </Typography>
                  {arearPaidBillDocument ? (
                    <>
                      <Button
                        varient="outlined"
                        component="label"
                        startIcon={
                          <CloseIcon
                            sx={{ color: "red" }}
                            onClick={() => {
                              setArearPaidBillDocument("");
                            }}
                          />
                        }
                      >
                        {arearPaidBillDocumentThumbnail && (
                          <img
                            src={arearPaidBillDocumentThumbnail}
                            alt="Arear paid bill"
                            width="100"
                          />
                        )}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                        className="btn"
                        sx={{ marginTop: "2%", width: "70%" }}
                      >
                        Upload
                        <input
                          hidden
                          accept={documentExtensions}
                          id="iv_arear_paid_bill_document"
                          name="iv_arear_paid_bill_document"
                          type="file"
                          onChange={ArearPaidBillDocument}
                        />
                      </Button>
                    </>
                  )}
                  <Box
                    className="documentError"
                    sx={{ color: "red", marginTop: "1%" }}
                  >
                    {arearBillDocumentFormik.errors
                      .iv_arear_paid_bill_document &&
                    arearBillDocumentFormik.touched.iv_arear_paid_bill_document
                      ? arearBillDocumentFormik.errors
                          .iv_arear_paid_bill_document
                      : null}
                  </Box>
                </Grid>
              </Grid>
            </>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className="confirmButton"
            sx={{ width: "30%", textTransform: "capitalize" }}
            onClick={arearBillDocumentFormik.handleSubmit}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Field Rejection Removal Alert */}
      <Dialog
        open={fieldRejectionRemovalAlert}
        onClose={hideFieldRejectionRemovalAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className="rejection-removal"
      >
        <DialogTitle className="dialog-title">Confirm</DialogTitle>
        <DialogContent>
          {dialogRowData.applicationProgressId === 5 ? (
            <DialogContentText component="div">
              Are you sure you want to remove the field survey objection for
              application id: {dialogRowData.applicationId}?
            </DialogContentText>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            className="confirmButton"
            onClick={() =>
              callChangeObjectionStatus(
                2,
                "Field Objection Removed",
                "Field Objection has been Removed",
              )
            }
          >
            Confirm
          </Button>
          <Button
            className="confirmButton"
            onClick={hideFieldRejectionRemovalAlert}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* DN Payment Rejection Alert */}
      <Dialog
        open={dnPaymentRejectAlert}
        onClose={hideDnPaymentRejectAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className=""
      >
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <Typography className="fieldLabel">
              Are you sure the demand notice payment is un-verified?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              callChangeProgressIdAPI(
                5,
                "DN Payment Submitted",
                "DN Payment Unverified",
              );
              setDnPaymentRejectAlert(false);
            }}
          >
            Submit
          </Button>
          <Button onClick={hideDnPaymentRejectAlert}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* RCO Part 1 Approval Alert */}
      <Dialog
        open={rcoPart1ApproveAlert}
        onClose={hideRCOPart1ApproveAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className=""
      >
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <Typography className="fieldLabel">
              Are you sure you want to approve the RCO?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              rcoPart1Formik.handleSubmit();
              setRcoPart1ApproveAlert(false);
            }}
          >
            Submit
          </Button>
          <Button onClick={hideRCOPart1ApproveAlert}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* RCO Part 2 Approval Alert */}
      <Dialog
        open={rcoPart2ApproveAlert}
        onClose={hideRCOPart2ApproveAlert}
        fullWidth={true}
        maxWidth={"sm"}
        className=""
      >
        <DialogTitle>Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <Typography className="fieldLabel">
              Are you sure you want to approve the RCO Part-2?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              rcoPart2Formik.handleSubmit();
              setRcoPart2ApproveAlert(false);
            }}
          >
            Submit
          </Button>
          <Button onClick={hideRCOPart2ApproveAlert}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop>

      {/* Approval / Rejection Sub Pop Up */}
      <RcoActivityLogDialog
        open={approvalRejectionSubPopUp}
        onClose={() => {
          setApprovalRejectionSubPopUp(false);
          setHistoryData(null);
        }}
        title={
          historyData?.applicationProgressId === 3 && historyData.objectionStatus === 0
            ? "Approval Details"
            : historyData?.applicationProgressId === 2 && historyData.objectionStatus === 1
              ? "Rejection Details"
              : ""
        }
        variant={
          historyData?.applicationProgressId === 2 && historyData.objectionStatus === 1
            ? "action"
            : "submitted"
        }
        footer={
          historyData
            ? `Application ${
                historyData?.applicationProgressId === 3 && historyData.objectionStatus === 0
                  ? "Approved by: "
                  : historyData?.applicationProgressId === 2 && historyData.objectionStatus === 1
                    ? "Rejected by: "
                    : ""
              }${historyData?.lastModifiedBy || "-"} on: ${
                historyData?.lastModificationDate
                  ? convertDatewithTime(historyData.lastModificationDate)
                  : "-"
              }`
            : null
        }
      >
        <div className="wf-application-details-body">
          {historyData && (
            <div className="rco-history-details-grid rco-history-details-grid--2col">
              <div>
                <label className="field-label">Remarks</label>
                <TextField fullWidth value={historyData.remarks || "N/A"} InputProps={{ readOnly: true }} size="small" disabled />
              </div>
              <div>
                <label className="field-label">Remarks Details</label>
                <TextField fullWidth value={historyData.remarksDetail || "N/A"} InputProps={{ readOnly: true }} size="small" disabled />
              </div>
            </div>
          )}
        </div>
      </RcoActivityLogDialog>

      {/* Documents Verified Sub Pop Up */}
      <RcoActivityLogDialog
        open={documentsVerifiedSubPopUp}
        onClose={() => {
          setDocumentsVerifiedSubPopUp(false);
          setHistoryData(null);
        }}
        title={`Documents ${
          historyData?.remarks === "Documents Verified."
              ? "Verified"
              : historyData?.remarks === "Documents Rejected."
                ? "Rejected"
                : historyData?.remarks === "Documents Re-uploaded."
                  ? "Re-Uploaded"
                : ""
        }`}
        variant={
          historyData?.remarks === "Documents Rejected." ? "action" : "submitted"
        }
        footer={
          historyData
            ? `Documents ${
                historyData?.remarks === "Documents Verified."
                  ? "Verified"
                  : historyData?.remarks === "Documents Rejected."
                    ? "Objected"
                    : historyData?.remarks === "Documents Re-uploaded."
                      ? "Re-Uploaded"
                      : "Submitted"
              } by: ${historyData?.lastModifiedBy || historyData?.createdBy} on: ${
                historyData?.lastModificationDate
                  ? convertDatewithTime(historyData.lastModificationDate)
                  : historyData?.creationDate
                    ? convertDatewithTime(historyData.creationDate)
                    : ""
              }`
            : null
        }
      >
        <div className="wf-application-details-body">
          {historyData?.remarks === "Documents Verified." ? (
            <p className="rco-history-status-banner rco-history-status-banner--success">
              Documents have been verified successfully.
            </p>
          ) : historyData?.remarks === "Documents Rejected." ? (
            <p className="rco-history-status-banner rco-history-status-banner--reject">
              Documents have been rejected.
            </p>
          ) : historyData?.remarks === "Documents Re-uploaded." ? (
            <p className="rco-history-status-banner rco-history-status-banner--reupload">
              Documents have been re-uploaded.
            </p>
          ) : null}
          <div className="rco-history-image-row">
            {popUpfrontImg ? (
              <RcoHistoryDoc
                label="Front Document Image"
                  src={popUpfrontImg}
                  alt="Front Document"
                documentFlag={historyData?.applicantCNICFrontFlag}
              />
            ) : null}
            {popUpBackImg ? (
              <RcoHistoryDoc
                label="Back Document Image"
                  src={popUpBackImg}
                  alt="Back Document"
                documentFlag={historyData?.applicantCNICBackFlag}
              />
            ) : null}
            {popUpEBillImg ? (
              <RcoHistoryDoc
                label="Electricity Bill Image"
                  src={popUpEBillImg}
                  alt="Electricity Bill"
                documentFlag={historyData?.electricityBillImageFlag}
              />
            ) : null}
            {popUpEAnyOtherImg ? (
              <RcoHistoryDoc
                label="Any Other Document Image"
                  src={popUpEAnyOtherImg}
                  alt="Any Other Document"
                documentFlag={historyData?.anyOtherDocumentFlag}
              />
            ) : null}
          </div>
        </div>
      </RcoActivityLogDialog>

      {/*Arrears Verification Sub Pop Up  */}
      <RcoActivityLogDialog
        open={arrearVerifiedSubPopUp}
        onClose={() => {
          setArrearVerifiedSubPopUp(false);
          setHistoryData(null);
        }}
        title={`Arrear ${historyData?.remarks === "Arrear Verified." ? "Verification" : "Rejection"} Details`}
        variant={historyData?.remarks !== "Arrear Verified." ? "action" : "submitted"}
        footer={
          historyData
            ? `Arrear ${historyData?.remarks === "Arrear Verified." ? "Verified" : "Rejected"} by: ${historyData?.lastModifiedBy || "-"} on: ${
                historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
              }`
            : null
        }
      >
        <div className="wf-application-details-body">
          {historyData && (
            <div className="rco-history-details-grid">
              <div>
                <label className="field-label">Remarks</label>
                <TextField fullWidth value={historyData.remarks || "N/A"} InputProps={{ readOnly: true }} size="small" disabled />
              </div>
              <div style={{ gridColumn: "span 2" }}>
                <label className="field-label">Remarks Details</label>
                <TextField fullWidth value={historyData.remarksDetail || "N/A"} InputProps={{ readOnly: true }} size="small" disabled />
              </div>
              {paidArrearImg && (
                <>
                  <div>
                    <label className="field-label">Arrears Amount</label>
                    <TextField fullWidth value={historyData.arrearsAmount || "N/A"} InputProps={{ readOnly: true }} size="small" disabled />
                  </div>
                  <div>
                    <label className="field-label">Arrears Month</label>
                    <TextField fullWidth value={convertDateDDMMYY(historyData.arrearsMonth) || "N/A"} InputProps={{ readOnly: true }} size="small" disabled />
                  </div>
                  <div>
                    <label className="field-label">Arrears Payment Date</label>
                    <TextField fullWidth value={convertDateDDMMYY(historyData.arrearsPaymentDate) || "N/A"} InputProps={{ readOnly: true }} size="small" disabled />
                  </div>
                  <div className="rco-history-image-row">
                    <RcoHistoryDoc label="Paid Arrears Image" src={paidArrearImg} alt="Paid Arrears" />
                  </div>
                </>
              )}
                </div>
              )}
            </div>
      </RcoActivityLogDialog>

      {/* Field Survey and Cost Estimation Sub Pop Up */}
      <RcoActivityLogDialog
        open={rcoFeeVoucherSubmissionSubPopUp}
        onClose={() => { setRcoFeeVoucherSubmissionSubPopUp(false); setHistoryData(null); }}
        title={historyData?.remarks === "Meter is healthy, MCO Rejected" ? "Field Survey & Cost Estimation Objection" : historyData?.remarks === "MCO with cost" || historyData?.remarks === "MCO without cost" ? "Field Survey & Cost Estimation Details" : ""}
        variant={historyData?.remarks === "Meter is healthy, MCO Rejected" ? "action" : "submitted"}
        footer={historyData?.remarks === "Meter is healthy, MCO Rejected"
            ? `Field Survey Objection by: ${historyData?.lastModifiedBy || "-"} on: ${
                historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
              }`
            : historyData?.remarks === "MCO with cost" || historyData?.remarks === "MCO without cost"
              ? `Field Survey And Cost Estimation Saved by: ${historyData?.lastModifiedBy || "-"} on: ${
                  historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
                }`
              : null}
      >
        <div className="wf-application-details-body">
          {historyData?.remarks === "Meter is healthy, MCO Rejected" && (
            <div
              className="rco-history-details-grid"
            >
              {/* Row 1 */}
              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
          )}

          {historyData?.remarks === "MCO with cost" ||
          historyData?.remarks === "MCO without cost" ? (
            <div
              className="rco-history-details-grid"
            >
              <div>
                <label className="field-label">Capital Cost Amount</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.capitalCostAmount)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Store Charges ({String(historyData?.applicationId || dialogRowData?.applicationId || "").startsWith("MC-13") ? "0%" : "12%"})</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA((Number(historyData?.capitalCostAmount) || 0) * (String(historyData?.applicationId || dialogRowData?.applicationId || "").startsWith("MC-13") ? 0 : 0.12))
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Installation Charges (8%)</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(((Number(historyData?.capitalCostAmount) || 0) + (Number(historyData?.capitalCostAmount) || 0) * (String(historyData?.applicationId || dialogRowData?.applicationId || "").startsWith("MC-13") ? 0 : 0.12)) * 0.08)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Civil Work Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.civilWorkCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Fixed Charges Of Metering</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.fixedChargesOfMetering)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 3 */}

              <div>
                <label className="field-label">Miscellaneous Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.miscellaneousCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Amount of Grid Sharing</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.amountOfGridSharing)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Amount of Feeder Rehab</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.amountOfFeederRehab)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">M&T Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.mtCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 2 */}

              <div>
                <label className="field-label">Labour Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.labourCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Design Wetting Fee</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.designVetteingFee)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Consultancy Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.consultancyCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 3 */}

              <div>
                <label className="field-label">Variation Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.variationsCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Dismantlement Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.dismentalmentCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Earthing Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.earthingCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 4 */}

              {/* <div>
                <label className="field-label">Capital Cost Amount</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.capitalCostAmount)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div> */}

              {hasLessTheCostValue(historyData?.lessTheCost) && (
              <div>
                <label className="field-label">Less the Cost</label>
                <TextField
                  fullWidth
                  value={
                    formatNegativeAmountOrNA(historyData?.lessTheCost)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
              )}

              <div>
                  <label className="field-label">Grand Total</label>
                  <TextField
                    fullWidth
                    value={
                      historyData?.serviceConnectionAmount !== null && historyData?.serviceConnectionAmount !== undefined && historyData?.serviceConnectionAmount !== "" ? formatAmountOrNA(historyData?.serviceConnectionAmount) : formatAmountOrNA(historyData?.capitalCostAmount)
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 4 */}

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
          ) : null}

            {meterImg && (
            <div className="rco-history-image-row">
              <RcoHistoryDoc label="Meter Image" src={meterImg} alt="Meter" />
            </div>
          )}
        </div>
      </RcoActivityLogDialog>

      {/*Field Survey  Objection Sub Pop Up  */}
      <RcoActivityLogDialog
        open={fieldSurveySubPopUp}
        onClose={() => { setFieldSurveySubPopUp(false); setHistoryData(null); }}
        title={historyData?.objectionStatus === 1 && historyData?.applicationProgressId === 6
            ? "Field Survey Objection"
            : historyData?.objectionStatus === 0 && historyData?.applicationProgressId === 6 && historyData?.remarks == "Revert to Cost Estimation"
              ? "Revert To Field Survey And Cost Estimation"
              : historyData?.objectionStatus === 0 && historyData?.applicationProgressId === 6 && historyData?.remarks == "RCO fee voucher verified."
                ? "RCO Fee Verification Details"
                : historyData?.objectionStatus === 0 && historyData?.applicationProgressId === 6
                  ? "Field Survey Objection Removal"
                  : historyData?.objectionStatus === 0 && historyData?.applicationProgressId === 7
                    ? "Field Survey And Cost Estimation Submission"
                    : ""}
        variant={historyData?.objectionStatus === 1 && historyData?.applicationProgressId === 6 ? "action" : "submitted"}
        footer={historyData?.applicationProgressId === 6 && historyData?.objectionStatus === 1
            ? `Field Survey Objection by: ${historyData?.lastModifiedBy || "-"} on: ${
                historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
              }`
            : historyData && historyData.applicationProgressId === 6 && historyData.objectionStatus === 0 && historyData.remarks === "Revert to Cost Estimation"
              ? `Reverted to Cost Estimation by: ${historyData?.lastModifiedBy || "-"} on: ${
                  historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
                }`
              : historyData && historyData.applicationProgressId === 6 && historyData.objectionStatus === 0 && historyData?.remarks == "RCO fee voucher verified."
                ? `RCO Fee Voucher Verified by: ${historyData?.lastModifiedBy || "-"} on: ${
                    historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
                  }`
                : historyData && historyData.applicationProgressId === 6 && historyData.objectionStatus === 0
                  ? `Field Survey Objection Removed by: ${historyData?.lastModifiedBy || "-"} on: ${
                      historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
                    }`
                  : historyData?.applicationProgressId === 7 && historyData?.objectionStatus === 0
                    ? `Field Survey And Cost Estimation Saved by: ${historyData?.lastModifiedBy || "-"} on: ${
                        historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
                      }`
                    : null}
      >
        <div className="wf-application-details-body">
          {historyData &&
            historyData?.applicationProgressId === 6 &&
            historyData?.objectionStatus === 1 && (
              <div
                className="rco-history-details-grid"
              >
                {/* Row 1 */}
                <div>
                  <label className="field-label">Remarks</label>
                  <TextField
                    fullWidth
                    value={historyData.remarks || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Remarks Detail</label>
                  <TextField
                    fullWidth
                    value={historyData.remarksDetail || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>
              </div>
            )}

          {historyData &&
          historyData.applicationProgressId === 6 &&
          historyData.objectionStatus === 0 &&
          historyData.remarks === "Revert to Cost Estimation" ? (
            <div
              className="rco-history-details-grid"
            >
              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
          ) : historyData &&
            historyData.applicationProgressId === 6 &&
            historyData.objectionStatus === 0 &&
            historyData?.remarks == "RCO fee voucher verified." ? (
            <div
              className="rco-history-details-grid"
            >
              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
          ) : historyData &&
            historyData.applicationProgressId === 6 &&
            historyData.objectionStatus === 0 ? (
            <div
              className="rco-history-details-grid"
            >
              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
          ) : null}

          {historyData &&
            historyData?.applicationProgressId === 7 &&
            historyData?.objectionStatus === 0 && (
             <div
              className="rco-history-details-grid"
            >
              <div>
                <label className="field-label">Capital Cost Amount</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.capitalCostAmount)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Store Charges ({String(historyData?.applicationId || dialogRowData?.applicationId || "").startsWith("MC-13") ? "0%" : "12%"})</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA((Number(historyData?.capitalCostAmount) || 0) * (String(historyData?.applicationId || dialogRowData?.applicationId || "").startsWith("MC-13") ? 0 : 0.12))
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Installation Charges (8%)</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(((Number(historyData?.capitalCostAmount) || 0) + (Number(historyData?.capitalCostAmount) || 0) * (String(historyData?.applicationId || dialogRowData?.applicationId || "").startsWith("MC-13") ? 0 : 0.12)) * 0.08)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Civil Work Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.civilWorkCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Fixed Charges Of Metering</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.fixedChargesOfMetering)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 3 */}

              <div>
                <label className="field-label">Miscellaneous Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.miscellaneousCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Amount of Grid Sharing</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.amountOfGridSharing)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Amount of Feeder Rehab</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.amountOfFeederRehab)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">M&T Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.mtCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 2 */}

              <div>
                <label className="field-label">Labour Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.labourCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Design Wetting Fee</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.designVetteingFee)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Consultancy Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.consultancyCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 3 */}

              <div>
                <label className="field-label">Variation Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.variationsCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Dismantlement Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.dismentalmentCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              <div>
                <label className="field-label">Earthing Charges</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.earthingCharges)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 4 */}

              {/* <div>
                <label className="field-label">Capital Cost Amount</label>
                <TextField
                  fullWidth
                  value={
                    formatAmountOrNA(historyData?.capitalCostAmount)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div> */}

              {hasLessTheCostValue(historyData?.lessTheCost) && (
              <div>
                <label className="field-label">Less the Cost</label>
                <TextField
                  fullWidth
                  value={
                    formatNegativeAmountOrNA(historyData?.lessTheCost)
                  }
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
              )}

              <div>
                  <label className="field-label">Grand Total</label>
                  <TextField
                    fullWidth
                    value={
                      historyData?.serviceConnectionAmount !== null && historyData?.serviceConnectionAmount !== undefined && historyData?.serviceConnectionAmount !== "" ? formatAmountOrNA(historyData?.serviceConnectionAmount) : formatAmountOrNA(historyData?.capitalCostAmount)
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 4 */}

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
            )}
        </div>
      </RcoActivityLogDialog>

      {/*M&T Submission Sub Pop Up  */}
      <RcoActivityLogDialog
        open={mtSubmissionSubPopUp}
        onClose={() => { setMtSubmissionSubPopUp(false); setHistoryData(null); }}
        title={`${historyData?.objectionStatus === 0 && (historyData?.historyProgressId === 8 || historyData?.historyProgressId === 5) ? "M&T Submission" : ""} Details`}
        variant={"submitted"}
        footer={historyData && (historyData?.historyProgressId === 8 || historyData?.historyProgressId === 5) && historyData?.objectionStatus === 0
            ? `M&T Submitted by: ${historyData?.lastModifiedBy || "-"} on: ${
                historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
              }`
            : null}
        headerAction={mtReportImg ? (
          <button type="button" className="rco-history-print-btn" onClick={handleDownloadMtReportImage} aria-label="download m&t report image">
                <FileDownloadIcon />
          </button>
        ) : null}
      >
        <div className="wf-application-details-body">
          {historyData &&
            (historyData?.historyProgressId === 8 ||
              historyData?.historyProgressId === 5) &&
            historyData?.objectionStatus === 0 && (
              <div
                className="rco-history-details-grid"
              >
              

                <div>
                  <label className="field-label">Remarks</label>
                  <TextField
                    fullWidth
                    value={historyData.remarks || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Remarks Detail</label>
                  <TextField
                    fullWidth
                    value={historyData.remarksDetail || "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">M&T Report Number</label>
                  <TextField
                    fullWidth
                    value={historyData?.["m&TReportNo"] ?? "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">M&T Report Date</label>
                  <TextField
                    fullWidth
                    value={historyData?.["m&TReportDate"] ?? "N/A"}
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

                {/* Image with Title */}
                {mtReportImg && (
                  <div className="rco-history-image-row">
                    <RcoHistoryDoc
                      label="M&T Report Image"
                      src={mtReportImg}
                      alt="M&T Report"
                    />
                  </div>
                )}
              </div>
            )}
        </div>
      </RcoActivityLogDialog>

      {/*DN Approval Sub Pop Up  */}
      <RcoActivityLogDialog
        open={dnApprovalSubPopUp}
        onClose={() => { setDnApprovalSubPopUp(false); setHistoryData(null); }}
        title={`${historyData && historyData?.objectionStatus === 0 && historyData?.historyProgressId === 6 ? "DN Approval" : ""} Details`}
        variant={"submitted"}
        footer={historyData && historyData?.historyProgressId === 6 && historyData?.objectionStatus === 0
            ? `DN Approval by: ${historyData?.lastModifiedBy || "-"} on: ${
                historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
              }`
            : null}
      >
        <div className="wf-application-details-body">
          {historyData &&
            historyData?.historyProgressId === 6 &&
            historyData?.objectionStatus === 0 && (
              <div
              className="rco-history-details-grid"
            >
              <div>
                  <label className="field-label">Grand Total</label>
                  <TextField
                    fullWidth
                    value={
                      formatAmountOrNA(historyData?.serviceConnectionAmount)
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 4 */}

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
            )}
        </div>
      </RcoActivityLogDialog>

      {/*DN Submission Sub Pop Up  */}
      <RcoActivityLogDialog
        open={dnSubmissionSubPopUp}
        onClose={() => { setDnSubmissionSubPopUp(false); setHistoryData(null); }}
        title={`${historyData?.objectionStatus === 0 && historyData?.historyProgressId === 7 ? "DN Submission" : historyData?.objectionStatus === 1 && historyData?.historyProgressId === 6 ? "DN Rejected" : ""} Details`}
        variant={historyData?.objectionStatus === 1 && historyData?.historyProgressId === 6 ? "action" : "submitted"}
        footer={historyData && historyData?.historyProgressId === 7 && historyData?.objectionStatus === 0
            ? `DN Submitted by: ${historyData?.lastModifiedBy || "-"} on: ${
                historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
              }`
            : historyData && historyData?.historyProgressId === 6 && historyData?.objectionStatus === 1
              ? `DN Submitted by: ${historyData?.lastModifiedBy || "-"} on: ${
                  historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
                }`
              : null}
        headerAction={dnPaymentImg ? (
          <button type="button" className="rco-history-print-btn" onClick={handleDownloadDnPaymentImage} aria-label="download paid dn image">
                <FileDownloadIcon />
          </button>
        ) : null}
      >
        <div className="wf-application-details-body">
          {historyData &&
            historyData?.historyProgressId === 7 &&
            historyData?.objectionStatus === 0 && (
             <div
              className="rco-history-details-grid"
            >
              <div>
                  <label className="field-label">Grand Total</label>
                  <TextField
                    fullWidth
                    value={
                      formatAmountOrNA(historyData?.serviceConnectionAmount)
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 4 */}

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
                {dnPaymentImg && (
                  <div className="rco-history-image-row">
                    <RcoHistoryDoc
                      label="DN Image"
                      src={dnPaymentImg}
                      alt="DN Image"
                    />
                  </div>
                )}
            </div>
            )}

          {historyData &&
            historyData?.historyProgressId === 6 &&
            historyData?.objectionStatus === 1 && (
             <div
              className="rco-history-details-grid"
            >
              <div>
                  <label className="field-label">Grand Total</label>
                  <TextField
                    fullWidth
                    value={
                      formatAmountOrNA(historyData?.serviceConnectionAmount)
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 4 */}

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
            </div>
            )}
        </div>
      </RcoActivityLogDialog>

      {/*DN Verification Sub Pop Up  */}
      <RcoActivityLogDialog
        open={dnVerificationSubPopUp}
        onClose={() => { setDnVerificationSubPopUp(false); setHistoryData(null); }}
        title={`${(historyData?.objectionStatus === 0 || historyData?.objectionStatus === 1) && historyData?.historyProgressId === 8 ? "DN Verification" : ""} Details`}
        variant={"submitted"}
        footer={historyData && historyData?.historyProgressId === 8 && (historyData?.objectionStatus === 0 || historyData?.objectionStatus === 1)
            ? `DN Verified by: ${historyData?.lastModifiedBy || "-"} on: ${
                historyData?.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : "-"
              }`
            : null}
        headerAction={dnPaymentImg ? (
          <button type="button" className="rco-history-print-btn" onClick={handleDownloadDnPaymentImage} aria-label="download paid dn image">
                <FileDownloadIcon />
          </button>
        ) : null}
      >
        <div className="wf-application-details-body">
          {historyData &&
            historyData?.historyProgressId === 8 &&
            (historyData?.objectionStatus === 0 || historyData?.objectionStatus === 1) && (
             <div
              className="rco-history-details-grid"
            >
              <div>
                  <label className="field-label">Grand Total</label>
                  <TextField
                    fullWidth
                    value={
                      formatAmountOrNA(historyData?.serviceConnectionAmount)
                    }
                    InputProps={{ readOnly: true }}
                    size="small"
                    disabled
                  />
                </div>

              <div>
                <label className="field-label">Remarks</label>
                <TextField
                  fullWidth
                  value={historyData.remarks || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>

              {/* Row 4 */}

              <div>
                <label className="field-label">Remarks Detail</label>
                <TextField
                  fullWidth
                  value={historyData.remarksDetail || "N/A"}
                  InputProps={{ readOnly: true }}
                  size="small"
                  disabled
                />
              </div>
                {dnPaymentImg && (
                  <div className="rco-history-image-row">
                    <RcoHistoryDoc
                      label="DN Image"
                      src={dnPaymentImg}
                      alt="DN Image"
                    />
                  </div>
                )}
            </div>
              
            )}
        </div>
      </RcoActivityLogDialog>

      {/* Meter Installation Sub Pop Up */}
      <RcoActivityLogDialog
        open={meterInstalationSubPopUp}
        onClose={() => { setMeterInstalationSubPopUp(false); setHistoryData(null); }}
        title={historyData && historyData.historyProgressId === 9 && historyData.objectionStatus === 0 ? "Meter Installation Details" : ""}
        variant={"submitted"}
        footer={historyData && historyData.historyProgressId === 9 && historyData.objectionStatus === 0
            ? `Meter Re-Installed by: ${historyData.lastModifiedBy} on: ${
                historyData.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : ""
              }`
            : null}
      >
        <div className="wf-application-details-body">
          {historyData &&
            historyData.historyProgressId === 9 &&
            historyData.objectionStatus === 0 && (
              <div className="rco-history-details-grid">
                <div>
                  <label className="field-label">Store Requisition No</label>
                  <TextField
                    fullWidth
                    value={
                      historyData.storeRequisitionNo
                        ? historyData.storeRequisitionNo
                        : "N/A"
                    }
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    size="small"
                    disabled
                  />
                </div>
                <div>
                  <label className="field-label">
                    Store Requisition Date Time
                  </label>
                  <TextField
                    fullWidth
                    value={
                      historyData.storeRequisitionDateTime
                        ? formatDate(historyData.storeRequisitionDateTime)
                        : "N/A"
                    }
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    size="small"
                    disabled
                  />
                </div>
                <div>
                  <label className="field-label">Meter Reinstalled At</label>
                  <TextField
                    fullWidth
                    value={
                      historyData.installationDateTime
                        ? formatDate(historyData.installationDateTime)
                        : "N/A"
                    }
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    size="small"
                    disabled
                  />
                </div>

                {reInstalledMeterImg && (
                  <div className="rco-history-image-row">
                    <RcoHistoryDoc
                      label="Reinstalled Meter Image"
                      src={reInstalledMeterImg}
                      alt="Reinstalled Meter"
                    />
                  </div>
                )}
              </div>
            )}
        </div>
      </RcoActivityLogDialog>

      {/* Forward To RO Sub Pop Up */}
      <RcoActivityLogDialog
        open={forwardToROSubPopUp}
        onClose={() => { setForwardToROSubPopUp(false); setHistoryData(null); }}
        title={historyData && historyData.historyProgressId === 10 && historyData.objectionStatus === 0 ? "Forward To RO Details" : ""}
        variant={"submitted"}
        footer={historyData && historyData.historyProgressId === 10 && historyData.objectionStatus === 0
            ? `Forward to RO Approved by: ${historyData.lastModifiedBy} on: ${
                historyData.lastModificationDate ? convertDatewithTime(historyData.lastModificationDate) : ""
              }`
            : null}
      >
        <div className="wf-application-details-body">
          {historyData &&
            historyData.historyProgressId === 10 &&
            historyData.objectionStatus === 0 && (
              <div className="rco-history-details-grid">
                <div>
                  <label className="field-label">MCO Approved By</label>
                  <TextField
                    fullWidth
                    value={
                      historyData.mcoApprovedBy
                        ? historyData.mcoApprovedBy
                        : "N/A"
                    }
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">MCO Approved At</label>
                  <TextField
                    fullWidth
                    value={
                      historyData.mcoApprovedDateTime
                        ? formatDate(historyData.mcoApprovedDateTime)
                        : "N/A"
                    }
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Remarks</label>
                  <TextField
                    fullWidth
                    value={historyData.remarks || "N/A"}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    size="small"
                    disabled
                  />
                </div>

                <div>
                  <label className="field-label">Remarks Details</label>
                  <TextField
                    fullWidth
                    value={historyData.remarksDetail || "N/A"}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                    size="small"
                    disabled
                  />
                </div>

                {approvalDocImg && historyData.isReferToMT === true && (
                  <div className="rco-history-image-row">
                    <RcoHistoryDoc
                      label="Approval Document"
                      src={approvalDocImg}
                      alt="Approval Document"
                    />
                  </div>
                )}
              </div>
            )}
        </div>
      </RcoActivityLogDialog>

      {/* Ready For Billing Sub Pop Up */}
      <RcoActivityLogDialog
        open={readyForBillingSubPopUp}
        onClose={() => {
          setreadyForBillingSubPopUp(false);
          setHistoryData(null);
        }}
        title="Ready For Billing Details"
        variant="submitted"
        footer={
          historyData &&
          historyData.historyProgressId === 11 &&
          historyData.objectionStatus === 0
            ? `Ready For Billing Approved by: ${historyData.lastModifiedBy} on: ${
                historyData.lastModificationDate
                  ? convertDatewithTime(historyData.lastModificationDate)
                  : ""
              }`
            : null
        }
      >
        <div className="wf-application-details-body">
          {historyData &&
            historyData.historyProgressId === 11 &&
            historyData.objectionStatus === 0 && (
              <div className="rco-history-details-grid rco-history-details-grid--2col">
                <div>
                  <label className="field-label">Remarks</label>
                  <TextField fullWidth value={historyData.remarks || "N/A"} InputProps={{ readOnly: true }} size="small" disabled />
                </div>
                <div>
                  <label className="field-label">Remarks Details</label>
                  <TextField fullWidth value={historyData.remarksDetail || "N/A"} InputProps={{ readOnly: true }} size="small" disabled />
                </div>
              </div>
            )}
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={applicationSubittedPopUp}
        onClose={() => {
          setApplicationSubmittedPopUp(false);
        }}
        title="Application Submitted"
        footer={`Application Submitted by: ${dialogRowData.consumerName} on: ${convertDatewithTime(dialogRowData.creationDate)}`}
      >
        <div className="wf-application-details-body">
          <p className="wf-section-label">Application Details</p>
          <div className="wf-details-grid">
            <RcoHistoryField
              label="Application Id"
              value={dialogRowData.applicationId}
              span={2}
            />
            <RcoHistoryField
              label="Applicant Name"
              value={dialogRowData.consumerName}
              span={2}
            />
            <RcoHistoryField
              label="Applicant CNIC."
              value={dialogRowData.consumerCNIC}
            />
            <RcoHistoryField
              label={
                dialogRowData.applicantRelationType
                    ? sodowo(dialogRowData.applicantRelationType)
                  : "-"
              }
              value={
                dialogRowData.applicantRelativeName
                    ? dialogRowData.applicantRelativeName
                  : "-"
              }
            />
            <RcoHistoryField
              label="Applied Date"
              value={convertDate(dialogRowData.creationDate)}
            />
            <RcoHistoryField
              label="Subdivision"
              value={subdivisionName(
                dialogRowData.subDivisionCode,
                subDivisions,
              )}
            />
            <RcoHistoryField
              label="Applied Load"
              value={dialogRowData.sanctionedLoad}
            />
            <RcoHistoryField
              label="Connection Type"
              value={dialogRowData.connectionCategory}
            />
            <RcoHistoryField
              label="Sub. Through"
              value={dialogRowData.submittedThrough}
            />
            <RcoHistoryField
              label="Applicant Address"
              value={dialogRowData.premisesAddress}
              span="full"
            />
          </div>
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={fieldSurveyedSubPopUp}
        onClose={() => {
          setFieldSurveyedSubPopUp(false);
        }}
        title="Field Surveyed"
        footer={`Field Surveyed by: ${
          eFileData.find((item) => item.remarks == "Field Surveyed")
            ? eFileData.find((item) => item.remarks == "Field Surveyed")
                .lastModifiedBy
            : ""
        } ${
          eFileData.find((item) => item.remarks == "Field Surveyed")
            ? "(" +
              eFileData.find((item) => item.remarks == "Field Surveyed")
                .roleName +
              ")"
            : ""
        } on: ${
          eFileData.find((item) => item.remarks == "Field Surveyed")
            ? convertDatewithTime(
                eFileData.find((item) => item.remarks == "Field Surveyed")
                  .lastModificationDate,
              )
            : ""
        }`}
      >
        <div className="wf-application-details-body">
          <div className="wf-details-grid">
            <RcoHistoryField
              label="Dist. within 40m"
              value={
                fieldSurveyData
                    ? fieldSurveyData.isLTLWI40Flag === 1
                      ? "Yes"
                      : "No"
                  : "-"
              }
            />
            {fieldSurveyData.isLTLWI40Flag !== 1 ? (
              <RcoHistoryField
                label="Est. Distance (m)"
                value={
                  fieldSurveyData
                      ? fieldSurveyData.estDistanceInMeter
                        ? fieldSurveyData.estDistanceInMeter
                        : "-"
                    : "-"
                }
              />
            ) : null}
            <RcoHistoryField
              label="Area (Marla)"
              value={
                fieldSurveyData
                    ? fieldSurveyData.areaMarla
                      ? fieldSurveyData.areaMarla
                      : "-"
                  : "-"
              }
            />
            <RcoHistoryField
              label="No. of Meters Installed"
              value={
                fieldSurveyData
                    ? fieldSurveyData.noOfMeterInstalled
                      ? fieldSurveyData.noOfMeterInstalled
                      : "-"
                  : "-"
              }
            />
            {fieldSurveyData.sketchDiagram ? (
              <div className="wf-detail-item">
                <p className="prop-title">Sketch Diagram</p>
                  <div className="prop-detail">
                    <a
                      href="#"
                      onClick={() =>
                        openBase64Image(fieldSurveyData.sketchDiagram)
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="image"
                    >
                      <Base64Image
                        data={fieldSurveyData.sketchDiagram}
                        width={80}
                      />
                    </a>
                  </div>
              </div>
            ) : null}
              {fieldSurveyData.installedMeterRefNos[0].installedMeterRefNo &&
              fieldSurveyData.installedMeterRefNos.map((item, index) => (
                <RcoHistoryField
                  key={`meter-ref-${index}`}
                  label={`Meter ${index + 1} Ref. No.`}
                  value={item.installedMeterRefNo}
                />
              ))}
          </div>
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={referenceNoAllocatedSubPopUp}
        onClose={() => {
          setReferenceNoAllocatedSubPopUp(false);
        }}
        title="Reference No. Allocated"
        headerAction={
          <button
            type="button"
            className="rco-history-print-btn"
              onClick={() => downloadDNPDF(dialogRowData)}
          >
            <PrintIcon />
          </button>
        }
        footer={`Demand Notice Approved by: ${
          eFileData.find((item) => item.remarks == "Demand Notice Created")
              ? eFileData.find(
                  (item) => item.remarks == "Demand Notice Created",
                ).lastModifiedBy
            : ""
        } ${
          eFileData.find((item) => item.remarks == "Demand Notice Created")
              ? "(" +
                eFileData.find(
                  (item) => item.remarks == "Demand Notice Created",
                ).roleName +
                ")"
            : ""
        } on: ${
          eFileData.find((item) => item.remarks == "Demand Notice Created")
              ? convertDatewithTime(
                  eFileData.find(
                    (item) => item.remarks == "Demand Notice Created",
                  ).lastModificationDate,
                )
            : ""
        }`}
      >
        <div className="wf-application-details-body">
          <div className="wf-details-grid">
            <RcoHistoryField
              label="Demand Notice No."
              value={dnDetails ? dnDetails.demandNoticeNo : "-"}
            />
            <RcoHistoryField
              label="Reference No."
              value={dnDetails ? dnDetails.connectionAccountNo : "-"}
            />
            <RcoHistoryField
              label="DN Issue Date"
              value={dnDetails ? convertDate(dnDetails.issueDate) : "-"}
            />
            <RcoHistoryField
              label="DN Due Date"
              value={dnDetails ? convertDate(dnDetails.dueDate) : "-"}
            />
            <RcoHistoryField
              label="Capital Cost"
              value={
                dnDetails
                  ? dnDetails.capitalCostAmount
                    ? numberFormatting(dnDetails.capitalCostAmount)
                    : "-"
                  : "-"
              }
            />
            <RcoHistoryField
              label="Security Cost"
              value={
                dnDetails
                  ? dnDetails.securityDepositeAmount
                    ? numberFormatting(dnDetails.securityDepositeAmount)
                    : "-"
                  : "-"
              }
            />
            <RcoHistoryField
              label="Total Cost"
              value={
                dnDetails.capitalCostAmount || dnDetails.securityDepositeAmount
                  ? numberFormatting(
                      parseInt(dnDetails.capitalCostAmount) +
                        parseInt(dnDetails.securityDepositeAmount) +
                        (!isNaN(parseInt(dnDetails.amountOfGridSharing))
                          ? parseInt(dnDetails.amountOfGridSharing)
                          : 0) +
                        (!isNaN(parseInt(dnDetails.amountOfFeederRehab))
                          ? parseInt(dnDetails.amountOfFeederRehab)
                          : 0),
                    )
                  : "-"
              }
            />
            <RcoHistoryField
              label="Bank Name"
              value={dnDetails ? dnDetails.bankName : "-"}
            />
          </div>
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={dnPaymentSubmittedSubPopUp}
        onClose={() => {
          setDnPaymentSubmittedSubPopUp(false);
        }}
        title="DN Payment Submitted"
        footer={`Paid Demand Notice Image Uploaded by: ${
          eFileData.find((item) => item.remarks == "Demand Notice Paid")
            ? eFileData.find((item) => item.remarks == "Demand Notice Paid")
                .lastModifiedBy
            : ""
        } ${
          eFileData.find((item) => item.remarks == "Demand Notice Paid")
            ? "(" +
              eFileData.find((item) => item.remarks == "Demand Notice Paid")
                .roleName +
              ")"
            : ""
        } on: ${
          eFileData.find((item) => item.remarks == "Demand Notice Paid")
            ? convertDatewithTime(
                eFileData.find((item) => item.remarks == "Demand Notice Paid")
                  .lastModificationDate,
              )
            : ""
        }`}
      >
        <div className="wf-application-details-body">
          <div className="wf-details-grid">
            <RcoHistoryField
              label="Demand Notice No."
              value={
                paidDnImageDetails
                    ? paidDnImageDetails.demandNoticeNo
                      ? paidDnImageDetails.demandNoticeNo
                      : "-"
                  : "-"
              }
            />
            <RcoHistoryField
              label="Payment Date"
              value={
                paidDnImageDetails
                    ? paidDnImageDetails.paymentDate
                      ? convertDate(paidDnImageDetails.paymentDate)
                      : "-"
                  : "-"
              }
            />
            {paidDnImageDetails.paidDNImage ? (
              <div className="wf-detail-item">
                <p className="prop-title">Paid DN Image</p>
                  <div className="prop-detail">
                    <a
                      href="#"
                      onClick={() =>
                        openBase64Image(paidDnImageDetails.paidDNImage)
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="item"
                    >
                      <Base64Image
                        data={paidDnImageDetails.paidDNImage}
                        width={80}
                      />
                    </a>
                  </div>
              </div>
            ) : null}
          </div>
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={dnPaymentVerifiedSubPopUp}
        onClose={() => {
          setDnPaymentVerifiedSubPopUp(false);
        }}
        title="DN Payment Verified"
        footer={`Demand Notice Payment Verified by: ${paidDnImageDetails.paidDNImageVerifiedBy} (CSL) on: ${convertDatewithTime(
          paidDnImageDetails.paidDNImageVerifiedDateTime,
        )}`}
      >
        <div className="wf-application-details-body">
          <div className="wf-details-grid">
            <RcoHistoryField
              label="Demand Notice No."
              value={paidDnImageDetails ? paidDnImageDetails.demandNoticeNo : "-"}
            />
            <RcoHistoryField
              label="Payment Date"
              value={
                paidDnImageDetails
                    ? convertDate(paidDnImageDetails.paymentDate)
                  : "-"
              }
            />
            {paidDnImageDetails.paidDNImage ? (
              <div className="wf-detail-item">
                <p className="prop-title">Paid DN Image</p>
                  <div className="prop-detail">
                    <a
                      href="#"
                      onClick={() =>
                        openBase64Image(paidDnImageDetails.paidDNImage)
                      }
                      target="_blank"
                      rel="noreferrer"
                      className="item"
                    >
                      <Base64Image
                        data={paidDnImageDetails.paidDNImage}
                        width={80}
                      />
                    </a>
                  </div>
              </div>
            ) : null}
          </div>
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={serviceConnectionOrderedSubPopUp}
        onClose={() => {
          setServiceConnectionOrderedSubPopUp(false);
        }}
        title="Service Connection Ordered"
        footer={`Service Connection Order Issued by: ${
          eFileData.find((item) => item.remarks == "DN Payment Verified")
              ? eFileData.find((item) => item.remarks == "DN Payment Verified")
                  .lastModifiedBy
            : ""
        } ${
          eFileData.find((item) => item.remarks == "DN Payment Verified")
              ? "(" +
                eFileData.find((item) => item.remarks == "DN Payment Verified")
                  .roleName +
                ")"
            : ""
        } on: ${
          eFileData.find((item) => item.remarks == "DN Payment Verified")
              ? convertDatewithTime(
                  eFileData.find(
                    (item) => item.remarks == "DN Payment Verified",
                  ).lastModificationDate,
                )
            : ""
        }`}
      >
        <div className="wf-application-details-body">
          <div className="wf-details-grid">
            <RcoHistoryField
              label="RCO No."
              value={rcoDetails ? rcoDetails.rcoId : "-"}
            />
            <RcoHistoryField
              label="Feeder Code"
              value={rcoDetails ? rcoDetails.feederNo : "-"}
            />
            <RcoHistoryField
              label="Feeder Name"
              value={rcoDetails ? rcoDetails.feederNo : "-"}
            />
            <RcoHistoryField
              label="Batch"
              value={rcoDetails ? rcoDetails.batch : "-"}
            />
            <RcoHistoryField
              label="S/Btch."
              value={rcoDetails ? rcoDetails.subBatch : "-"}
            />
            <RcoHistoryField
              label="R/U"
              value={rcoDetails ? rcoDetails.urbanRural : "-"}
            />
            <RcoHistoryField
              label="F/P"
              value={rcoDetails ? rcoDetails.fataPata : "-"}
            />
            <RcoHistoryField
              label="F.Gvt./A.&L.Bds./P.Gvt"
              value={
                rcoDetails ? (rcoDetails.fGovt ? rcoDetails.fGovt : "-") : "-"
              }
            />
            <RcoHistoryField
              label="Cantonment Board"
              value={
                rcoDetails
                  ? rcoDetails.cantonmentBoard
                    ? rcoDetails.cantonmentBoard
                    : "-"
                  : "-"
              }
            />
            <RcoHistoryField
              label="P.Gvt./A.&L.Bds./P.Gvt."
              value={
                rcoDetails ? (rcoDetails.pGovt ? rcoDetails.pGovt : "-") : "-"
              }
            />
            <RcoHistoryField
              label="Local Bodies"
              value={
                rcoDetails
                  ? rcoDetails.localBodies
                    ? rcoDetails.localBodies
                    : "-"
                  : "-"
              }
            />
          </div>
        </div>
      </RcoActivityLogDialog>

      <RcoActivityLogDialog
        open={meterInstalledSubPopUp}
        onClose={() => {
          setMeterInstalledSubPopUp(false);
        }}
        title="Meter Installed"
        footer={`Meter Installation Verified by: ${
          eFileData.find((item) => item.remarks == "Meter Installed")
            ? eFileData.find((item) => item.remarks == "Meter Installed")
                .lastModifiedBy
            : ""
        } ${
          eFileData.find((item) => item.remarks == "Meter Installed")
            ? "(" +
              eFileData.find((item) => item.remarks == "Meter Installed")
                .roleName +
              ")"
            : ""
        } on: ${
          eFileData.find((item) => item.remarks == "Meter Installed")
            ? convertDatewithTime(
                eFileData.find((item) => item.remarks == "Meter Installed")
                  .lastModificationDate,
              )
            : ""
        }`}
      >
        <div className="wf-application-details-body">
          {rcoDetails.rcoP2FillFlag ? (
            <>
              <p className="wf-section-label">Store Requisition Info</p>
              <div className="wf-details-grid">
                <RcoHistoryField
                  label="SR No."
                  value={rcoDetails ? rcoDetails.storeRequisitionNo : "-"}
                />
                <RcoHistoryField
                  label="SR Date"
                  value={rcoDetails ? rcoDetails.storeRequisitionDate : "-"}
                />
                <RcoHistoryField
                  label="Transformer Code"
                  value={
                    rcoDetails
                        ? rcoDetails.installedTransformerCapacity
                          ? rcoDetails.installedTransformerCapacity
                          : "-"
                      : "-"
                  }
                />
                <RcoHistoryField
                  label="Seasonal / Non Seasonal"
                  value={
                    rcoDetails
                        ? rcoDetails.seasonalFlag === 1
                          ? "Yes"
                          : "No"
                      : "-"
                  }
                />
              </div>
              <p className="wf-section-label">Meter Info</p>
              <div className="wf-details-grid">
                <RcoHistoryField
                  label="Meter No."
                  value={rcoDetails ? rcoDetails.meterNo : "-"}
                />
                <RcoHistoryField
                  label="Meter Id"
                  value={
                    rcoDetails
                        ? rcoDetails.meterId
                          ? rcoDetails.meterId
                          : "-"
                      : "-"
                  }
                />
                <RcoHistoryField
                  label="Manuf. Code"
                  value={rcoDetails ? rcoDetails.manufacturerCode : "-"}
                />
                <RcoHistoryField
                  label="Meter Read."
                  value={rcoDetails ? rcoDetails.meterReading : "-"}
                />
                <RcoHistoryField
                  label="Multi. Factor"
                  value={rcoDetails ? rcoDetails.multiplyingFactor : "-"}
                />
                <RcoHistoryField
                  label="Loc. Code"
                  value={
                    rcoDetails
                        ? rcoDetails.locationCode
                          ? rcoDetails.locationCode
                          : "-"
                      : "-"
                  }
                />
              </div>
              <p className="wf-section-label">Connection Installation Info</p>
              <div className="wf-details-grid">
                <RcoHistoryField
                  label="Installed By"
                  value={
                    rcoDetails
                        ? rcoDetails.connectionInstallerName
                          ? rcoDetails.connectionInstallerName
                          : "-"
                      : "-"
                  }
                />
                <RcoHistoryField
                  label="Install. Date"
                  value={
                    rcoDetails
                        ? rcoDetails.dateOfReConnection
                          ? convertDate(rcoDetails.dateOfReConnection)
                          : "-"
                      : "-"
                  }
                />
                <RcoHistoryField
                  label="Cp-78 Itm. No."
                  value={
                    rcoDetails
                        ? rcoDetails.cp78ItemNo
                          ? rcoDetails.cp78ItemNo
                          : "-"
                      : "-"
                  }
                />
                <RcoHistoryField
                  label="Sec. Slp/PB No."
                  value={
                    rcoDetails
                        ? rcoDetails.securitySlipOrPriceBondNo
                          ? rcoDetails.securitySlipOrPriceBondNo
                          : "-"
                      : "-"
                  }
                />
                <RcoHistoryField
                  label="TU. / NTU."
                  value={
                    rcoDetails
                        ? rcoDetails.tieUpNonTieUp
                          ? rcoDetails.tieUpNonTieUp === 0
                            ? "Non-Tie Up"
                            : "Tie Up"
                          : "-"
                      : "-"
                  }
                />
              </div>
            </>
          ) : null}
        </div>
      </RcoActivityLogDialog>

      <Dialog
        open={newConnectionPopup}
        onClose={handleCloses}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundAttached">
            <DoneIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle">
            {" "}
            DN Generated
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p className="applicationSubmit">
              {" "}
              Your Demand Note has been generated successfully.
            </p>
            <p className="trackId"> {dialogRowData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => downloadDNPDF(dialogRowData)}
                sx={{
                  backgroundColor: "white",
                  cursor: "pointer",
                  border: "1px solid #006ad1",
                  boxShadow: "none",
                  padding: "2%",
                  width: "60%",
                }}
              >
                <PrintIcon sx={{ color: "#006ad1" }} />
                Print DN{" "}
              </Button>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <BatchWarningDialog
        open={wrongBatchPopup}
        onClose={() => setBatchError("")}
        message={batchError}
      />

      <Dialog
        open={rcoPopUp}
        onClose={rcoHandleClose}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundAttached">
            <DoneIcon className="icon" />
          </Box>
          {rcoDetails.rcoP2FillFlag &&
          CheckPermissions(
            permissions,
            "General Services",
            "Meter Change Order",
            "Workflow Permissions",
            "Meter Installation",
            "RCO Filling",
          ) ? (
            <Typography variant="h6" className="groupTitle">
              RCO Generated
            </Typography>
          ) : (
            <Typography variant="h6" className="groupTitle">
              RCO Generated
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            {rcoDetails.rcoP2FillFlag &&
            CheckPermissions(
              permissions,
              "General Services",
              "Meter Change Order",
              "Workflow Permissions",
              "Meter Installation",
              "RCO Filling",
            ) ? (
              <p className="applicationSubmit">
                Your Service Connection has been generated successfully.
              </p>
            ) : (
              <p className="applicationSubmit">
                Your Service Connection has been generated successfully.
              </p>
            )}
            <p className="trackId"> {dialogRowData.applicationId}</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      <Dialog
        open={cpPopUp}
        onClose={cpHandleClose}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundAttached">
            <DoneIcon className="icon" />
          </Box>

          <Typography variant="h6" className="groupTitle">
            Application Completed
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p className="applicationSubmit">
              Your Reconnection Application has been completed successfully.
            </p>
            <p className="trackId"> {dialogRowData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => downloadMasterData(dialogRowData)}
                sx={{
                  backgroundColor: "white",
                  cursor: "pointer",
                  border: "1px solid #006ad1",
                  boxShadow: "none",
                  padding: "2%",
                  width: "60%",
                }}
              >
                <PrintIcon sx={{ color: "#006ad1" }} />
                {dialogRowData.connectionCategory != "Domestic" &&
                dialogRowData.connectionCategory != "Commercial"
                  ? "Print CP-138"
                  : "Print CP-138"}
              </Button>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      {/* DN Expiry pop up*/}
      <Dialog
        open={showDnExpiryPopup}
        onClose={() => {
          setShowDnExpiryPopup(false);
        }}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{
          style: { width: "100%", height: "45%", borderRadius: 20 },
        }}
      >
        <DialogTitle>
          <Box className="backgroundRedAttached">
            <EventBusyIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle">
            Demand Note Expired
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p className="applicationSubmit">
              Demand Note for below Application ID. is expired.
            </p>
            <p className="trackId"> {dialogRowData.applicationId}</p>
            <div
              style={{
                borderRadius: "5px",
                marginLeft: "27%",
                marginTop: "2%",
                cursor: "pointer",
              }}
            >
              {CheckPermissions(
                permissions,
                "General Services",
                "Meter Change Order",
                "Workflow Permissions",
                "Renew DN",
              ) && (
                <Button
                  variant="outlined"
                  onClick={async () => {
                    await callDemandNoteRenewalAPI(dialogRowData.applicationId);
                    setShowDnExpiryPopup(false);
                  }}
                  sx={{
                    backgroundColor: "white",
                    cursor: "pointer",
                    border: "1px solid #006ad1",
                    boxShadow: "none",
                    padding: "2%",
                    width: "60%",
                  }}
                >
                  Renew DN
                </Button>
              )}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      {/* Success / error response modal */}
      <Dialog
        open={openResponseModal}
        onClose={handleCloseResponseModal}
        className={`dde-result-dialog${
          responseModalMeta.isReject ? " dde-result-dialog--reject" : ""
        }`}
        fullWidth
        maxWidth="sm"
        PaperProps={{ className: "dde-result-dialog__paper" }}
      >
        <DialogTitle className="dde-result-dialog__title">
          <Box className="dde-result-dialog__icon-wrap">
            {responseModalMeta.isReject ? (
              <HighlightOffIcon className="dde-result-dialog__icon dde-result-dialog__icon--reject" />
            ) : (
              <CheckCircleIcon className="dde-result-dialog__icon dde-result-dialog__icon--approve" />
              )}
            </Box>
          <Typography variant="h6" className="dde-result-dialog__heading">
            {responseModalMeta.title}
          </Typography>
        </DialogTitle>

        <DialogContent className="dde-result-dialog__content">
          <DialogContentText component="div">
            <p className="dde-result-dialog__message">
            {responseMessageError || responseMessage}
            </p>

          {dialogRowData.applicationProgressId === 2 &&
            responseMessageError ? (
              <Box className="dde-result-dialog__actions">
              <Button
                  type="button"
                variant="outlined"
                  className="dde-result-dialog__bill-btn"
                  onClick={() => downloadBill(dialogRowData.referenceNo)}
              >
                Open Your Bill
              </Button>
              </Box>
            ) : null}
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {/* RCO Fee Voucher Rejection Modal */}
      <Dialog
        open={openRejectModal}
        onClose={() => setOpenRejectModal(false)}
        fullWidth
        maxWidth="md" // options: xs, sm, md, lg, xl
        PaperProps={{
          style: { width: "600px", maxWidth: "90%" }, // you can customize exact width
        }}
      >
        <DialogTitle>Reject RCO Fee Voucher</DialogTitle>
        <Formik
          initialValues={{ remarksDetail: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.remarksDetail) {
              errors.remarksDetail = "Remarks are required.";
            } else if (values.remarksDetail.length < 10) {
              errors.remarksDetail = "Remarks must be at least 10 characters.";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            processRCOFeeVoucher("reject", values.remarksDetail).then(() => {
              setSubmitting(false);
              setOpenRejectModal(false);
            });
          }}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <DialogContent>
                <Field
                  as={TextField}
                  name="remarksDetail"
                  label="Remarks"
                  fullWidth
                  multiline
                  rows={4}
                  error={touched.remarksDetail && Boolean(errors.remarksDetail)}
                  helperText={touched.remarksDetail && errors.remarksDetail}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setOpenRejectModal(false)}
                  variant="contained"
                  color="secondary"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  variant="contained"
                  color="primary"
                >
                  Submit
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>

      {/* RCO Fee Paid Voucher Rejection/Approval Modal */}
      {/* <Dialog
        open={openVoucherActionModal}
        onClose={() => setOpenVoucherActionModal(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ style: { width: "600px", maxWidth: "90%" } }}
      >
        <DialogTitle>
          {voucherActionType === "approve"
            ? "Approve Paid RCO Fee Voucher"
            : "Reject Paid RCO Fee Voucher"}
        </DialogTitle>

        <Formik
          initialValues={{ remarksDetail: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.remarksDetail) {
              errors.remarksDetail = "Remarks are required.";
            } else if (values.remarksDetail.length < 10) {
              errors.remarksDetail = "Remarks must be at least 10 characters.";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            RCOFeeVoucherVerification(
              voucherActionType,
              values.remarksDetail,
            ).then(() => {
              setSubmitting(false);
              setOpenVoucherActionModal(false);
            });
          }}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <DialogContent>
                <Field
                  as={TextField}
                  name="remarksDetail"
                  fullWidth
                  multiline
                  rows={4}
                  error={touched.remarksDetail && Boolean(errors.remarksDetail)}
                  helperText={touched.remarksDetail && errors.remarksDetail}
                  InputProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      fontSize: "1rem", // optional
                    },
                  }}
                />
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => setOpenVoucherActionModal(false)}
                  variant="contained"
                  sx={{ backgroundColor: "#e11b3c" }}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  disabled={isSubmitting}
                  variant="contained"
                  sx={{ backgroundColor: "#003971" }}
                >
                  {voucherActionType === "approve" ? "Approve" : "Reject"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog> */}
      <Dialog
        open={openVoucherActionModal}
        onClose={() => setOpenVoucherActionModal(false)}
        className={`rco-remarks-dialog${
          voucherActionType === "reject" ? " rco-remarks-dialog--reject" : ""
        }`}
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "rco-remarks-dialog__paper" }}
      >
        <Formik
          initialValues={{ remarksDetail: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.remarksDetail) {
              errors.remarksDetail = "Remarks are required.";
            } else if (values.remarksDetail.length < 10) {
              errors.remarksDetail = "Remarks must be at least 10 characters.";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            RCOFeeVoucherVerification(
              voucherActionType,
              values.remarksDetail,
            ).then(() => {
              setSubmitting(false);
              setOpenVoucherActionModal(false);
            });
          }}
        >
          {({
            isSubmitting,
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
          }) => (
            <Form>
              <DialogTitle className="rco-remarks-dialog__title">
                <div className="rco-remarks-dialog__header">
                  <Typography className="rco-remarks-dialog__heading">
                    {voucherActionType === "approve"
                      ? "Approve Paid RCO Fee Voucher"
                      : "Reject Paid RCO Fee Voucher"}
                  </Typography>
                  <button
                    type="button"
                    className="rco-remarks-dialog__close"
                    onClick={() => setOpenVoucherActionModal(false)}
                    aria-label="Close dialog"
                  >
                    <CloseIcon id="clearPopup" />
                  </button>
                </div>
              </DialogTitle>
              <DialogContent className="rco-remarks-dialog__content">
                <TextField
                  autoFocus
                  name="remarksDetail"
                  placeholder="Enter your remarks here..."
                  value={values.remarksDetail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  multiline
                  minRows={5}
                  maxRows={8}
                  variant="outlined"
                  className="rco-remarks-dialog__textarea"
                  error={
                    touched.remarksDetail && Boolean(errors.remarksDetail)
                  }
                />
                {touched.remarksDetail && errors.remarksDetail ? (
                  <p className="rco-remarks-dialog__error">
                    {errors.remarksDetail}
                  </p>
                ) : null}
              </DialogContent>
              <DialogActions className="rco-remarks-dialog__actions">
                <Button
                  type="button"
                  onClick={() => setOpenVoucherActionModal(false)}
                  className="rco-remarks-dialog__btn rco-remarks-dialog__btn--cancel"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  className="rco-remarks-dialog__btn rco-remarks-dialog__btn--confirm"
                >
                  {voucherActionType === "approve" ? "Approve" : "Reject"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>

      {/* DN Rejection/Approval Modal */}
      {/* <Dialog
        open={openVoucherActionModalForDN}
        onClose={() => setOpenVoucherActionModalForDN(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{ style: { width: "600px", maxWidth: "90%" } }}
      >
        <DialogTitle>
          {voucherActionTypeForDN === "approve" ? "Approve DN" : "Reject DN"}
        </DialogTitle>

        <Formik
          initialValues={{ remarksDetail: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.remarksDetail) {
              errors.remarksDetail = "Remarks are required.";
            } else if (values.remarksDetail.length < 10) {
              errors.remarksDetail = "Remarks must be at least 10 characters.";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            DNFeeVoucherVerification(
              voucherActionTypeForDN, // Fix: use correct state variable
              values.remarksDetail,
            ).then(() => {
              setSubmitting(false);
              setOpenVoucherActionModalForDN(false);
            });
          }}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <DialogContent>
                <Field
                  as={TextField}
                  name="remarksDetail"
                  fullWidth
                  multiline
                  rows={4}
                  error={touched.remarksDetail && Boolean(errors.remarksDetail)}
                  helperText={touched.remarksDetail && errors.remarksDetail}
                  InputProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                  FormHelperTextProps={{
                    sx: {
                      fontSize: "1rem",
                    },
                  }}
                />
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => setOpenVoucherActionModalForDN(false)} // Fix: use correct setter
                  variant="contained"
                  sx={{ backgroundColor: "#e11b3c" }}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  disabled={isSubmitting}
                  variant="contained"
                  sx={{ backgroundColor: "#003971" }}
                >
                  {voucherActionTypeForDN === "approve" ? "Approve" : "Reject"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog> */}
      <Dialog
        open={openVoucherActionModalForDN}
        onClose={() => setOpenVoucherActionModalForDN(false)}
        className={`rco-remarks-dialog rco-remarks-dialog--dn${
          voucherActionTypeForDN === "reject" ? " rco-remarks-dialog--reject" : ""
        }`}
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "rco-remarks-dialog__paper" }}
      >
        <Formik
          initialValues={{ remarksDetail: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.remarksDetail) {
              errors.remarksDetail = "Remarks are required.";
            } else if (values.remarksDetail.length < 10) {
              errors.remarksDetail = "Remarks must be at least 10 characters.";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            DNFeeVoucherVerification(
              voucherActionTypeForDN,
              values.remarksDetail,
            ).then(() => {
              setSubmitting(false);
              setOpenVoucherActionModalForDN(false);
            });
          }}
        >
          {({
            isSubmitting,
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
          }) => (
            <Form>
              <DialogTitle className="rco-remarks-dialog__title">
                <div className="rco-remarks-dialog__header">
                  <Typography className="rco-remarks-dialog__heading">
                    {voucherActionTypeForDN === "approve"
                      ? "Approve DN"
                      : "Reject DN"}
                  </Typography>
                  <button
                    type="button"
                    className="rco-remarks-dialog__close"
                    onClick={() => setOpenVoucherActionModalForDN(false)}
                    aria-label="Close dialog"
                  >
                    <CloseIcon id="clearPopup" />
                  </button>
                </div>
              </DialogTitle>
              <DialogContent className="rco-remarks-dialog__content">
                <TextField
                  autoFocus
                  name="remarksDetail"
                  placeholder="Enter your remarks here..."
                  value={values.remarksDetail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  fullWidth
                  multiline
                  minRows={5}
                  maxRows={8}
                  variant="outlined"
                  className="rco-remarks-dialog__textarea"
                  error={
                    touched.remarksDetail && Boolean(errors.remarksDetail)
                  }
                />
                {touched.remarksDetail && errors.remarksDetail ? (
                  <p className="rco-remarks-dialog__error">
                    {errors.remarksDetail}
                  </p>
                ) : null}
              </DialogContent>
              <DialogActions className="rco-remarks-dialog__actions">
                <Button
                  type="button"
                  onClick={() => setOpenVoucherActionModalForDN(false)}
                  className="rco-remarks-dialog__btn rco-remarks-dialog__btn--cancel"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  className="rco-remarks-dialog__btn rco-remarks-dialog__btn--confirm"
                >
                  {voucherActionTypeForDN === "approve" ? "Approve" : "Reject"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>

      {/* Assign to field Staff Modal */}
      <Dialog
        open={linemanAllocationSubPopUp}
        onClose={() => {
          setLinemanAllocationSubPopUp(false);
        }}
        fullWidth={true}
        maxWidth={"sm"}
        className="objectionDialog"
      >
        <DialogTitle className="objection-dialog-title">
          <Grid container className="objectionheadercontainer">
            <Grid item className="applicationTitleGrid">
              <p className="applicationTitleText">Assign To Field Staff </p>
            </Grid>
            <Grid item className="closeIcon">
              <CloseIcon
                id="clearPopup"
                onClick={() => {
                  setLinemanAllocationSubPopUp(false);
                }}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className="objection-dialog-content">
          <DialogContentText component="div" className="objection-dialog-content-text">
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                backgroundColor: "white",
              }}
            >
              <thead>
                <tr
                  style={{
                    fontFamily: "Roboto-Medium",
                    backgroundColor: "#f5f5f5",
                    backgroundColor: "white",
                    boxShadow: "3px 3px 6px lightgray",
                  }}
                >
                  <th
                    style={{
                      width: "50px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  ></th>
                  <th
                    style={{
                      width: "20px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Sr.
                  </th>
                  <th
                    style={{
                      width: "200px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Name
                  </th>
                  <th
                    style={{
                      width: "50px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Designation
                  </th>
                  <th
                    style={{
                      width: "50px",
                      textAlign: "left",
                      padding: "10px",
                    }}
                  >
                    Mobile No.
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    colSpan="5"
                    style={{ height: "10px", backgroundColor: "transparent" }}
                  ></td>
                </tr>
                {workForceData.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #ddd",
                      backgroundColor: index % 2 ? "white" : "#d5e5ff",
                    }}
                  >
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      <input
                        type="radio"
                        name="fieldStaff"
                        value={item.userId}
                        checked={selectedStaffId === item.userId}
                        onChange={() => setSelectedStaffId(item.userId)}
                      />
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {index + 1}
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {item.name}
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {fieldStaffDesignations.find(
                        (itm) => itm.employeeDesignationId == item.designation,
                      )?.employeeDesignationName || "N/A"}
                    </td>
                    <td style={{ padding: "5px", textAlign: "left" }}>
                      {item.phoneNo}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="objection-dialog-action">
          <button
            onClick={() => {
              if (selectedStaffId) {
                callAssignmentAPI(dialogRowData.applicationId, selectedStaffId);
              } else {
                alert("Please select a field staff member before assigning.");
              }
            }}
            type="submit"
            className="submit-button"
          >
            Assign
          </button>
        </DialogActions>
      </Dialog>
      {/* Prepare Estimate Modal */}
      <Dialog
        open={showBoq}
        onClose={() => setShowBoq(false)}
        fullWidth
        maxWidth="md"
        className="rco-prepare-estimate-dialog"
        PaperProps={{ className: "rco-prepare-estimate-dialog__paper" }}
      >
        <DialogTitle className="rco-prepare-estimate-dialog__title">
          <Box className="rco-prepare-estimate-dialog__header">
            <Typography className="rco-prepare-estimate-dialog__heading">
          Prepare Estimate
            </Typography>
            <CloseIcon
              id="clearPopup"
              className="rco-prepare-estimate-dialog__close"
              onClick={() => {
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
                setShowBoq(false);
              }}
            />
          </Box>
        </DialogTitle>

        <DialogContent
          className="rco-prepare-estimate-dialog__content"
          onKeyDownCapture={restrictPrepareEstimateFractionKeys}
          onPasteCapture={restrictPrepareEstimateFractionPaste}
        >
          <Box className="rco-prepare-estimate-dialog__item-panel">
            <Box className="rco-prepare-estimate-dialog__item-row">
              <Box>
                    <Typography className="fieldLabel">Item</Typography>
                    <Autocomplete
                      options={allMaterialList || []}
                      getOptionLabel={(option) => {
                        if (!option) return "";
                        const code = option.Item_Code || option.item_Code || "";
                        const name = option.Item_Name || option.item_Name || "";
                        return name ? `${code} - ${name}` : code;
                      }}
                      value={
                        (allMaterialList || []).find(
                          (item) =>
                            String(item.Item_Code || item.item_Code)
                              .trim()
                              .toLowerCase() ===
                            String(fieldItemFormik.values.iv_fieldItemId)
                              .trim()
                              .toLowerCase(),
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        if (newValue) {
                          const rate = getBoqItemRate(
                            newValue.item_Amount || newValue.Item_Amount,
                          );
                          const unit = newValue.item_Unit || newValue.Item_Unit;
                          fieldItemFormik.setFieldValue(
                            "iv_fieldItemId",
                            newValue.Item_Code || newValue.item_Code,
                          );
                          fieldItemFormik.setFieldValue(
                            "iv_fieldItemRate",
                            rate,
                          );
                          fieldItemFormik.setFieldValue(
                            "iv_fieldItemUnit",
                            unit,
                          );
                        } else {
                          fieldItemFormik.setFieldValue("iv_fieldItemId", "");
                          fieldItemFormik.setFieldValue("iv_fieldItemRate", "");
                          fieldItemFormik.setFieldValue("iv_fieldItemUnit", "");
                        }
                      }}
                      filterOptions={(options, state) =>
                        options.filter((option) => {
                          const input = state.inputValue.toLowerCase();
                          return (
                            String(option.Item_Code || option.item_Code || "")
                              .toLowerCase()
                              .includes(input) ||
                            String(option.Item_Name || option.item_Name || "")
                              .toLowerCase()
                              .includes(input)
                          );
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Item"
                          size="small"
                          error={
                            fieldItemFormik.touched.iv_fieldItemId &&
                            Boolean(fieldItemFormik.errors.iv_fieldItemId)
                          }
                          helperText={
                            fieldItemFormik.touched.iv_fieldItemId &&
                            fieldItemFormik.errors.iv_fieldItemId
                          }
                          sx={{
                            "& .MuiInputBase-root": {
                              height: 35,
                              minHeight: 35,
                            },
                            "& .MuiInputBase-input": {
                              padding: "0 8px",
                            },
                          }}
                        />
                      )}
                      disableClearable
                      fullWidth
                      disabled={dnDetails && dnDetails.filledFlag === 1}
                    />
              </Box>

              <Box>
                    <Typography className="fieldLabel">Unit</Typography>
                    <TextField
                      name="iv_fieldItemUnit"
                      value={fieldItemFormik.values.iv_fieldItemUnit}
                      fullWidth
                      disabled
                  size="small"
                      InputProps={{
                        sx: {
                      height: 36,
                      background: "#fff",
                      "& input": { textAlign: "right" },
                        },
                      }}
                    />
              </Box>

              <Box>
                    <Typography className="fieldLabel">Qty</Typography>
                    <TextField
                      name="iv_fieldItemQty"
                      disabled={dnDetails && dnDetails.filledFlag === 1}
                      value={fieldItemFormik.values.iv_fieldItemQty}
                      fullWidth
                  className="rco-prepare-estimate-dialog__qty-field"
                      onChange={(e) => {
                    const digitsOnly = e.target.value.replace(/\D/g, "");
                    fieldItemFormik.setFieldValue(
                      "iv_fieldItemQty",
                      digitsOnly,
                    );
                  }}
                      size="small"
                  inputProps={{ inputMode: "numeric", pattern: "\\d*", min: 1 }}
                      InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          disabled={dnDetails && dnDetails.filledFlag === 1}
                          onClick={() => {
                            const curr = parseInt(
                              fieldItemFormik.values.iv_fieldItemQty,
                              10,
                            );
                            const current = isNaN(curr) ? 1 : curr;
                            const next = current - 1 >= 1 ? current - 1 : 1;
                            fieldItemFormik.setFieldValue(
                              "iv_fieldItemQty",
                              String(next),
                            );
                          }}
                        >
                          <RemoveIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          disabled={dnDetails && dnDetails.filledFlag === 1}
                          onClick={() => {
                            const curr = parseInt(
                              fieldItemFormik.values.iv_fieldItemQty,
                              10,
                            );
                            const current = isNaN(curr) || curr < 1 ? 0 : curr;
                            fieldItemFormik.setFieldValue(
                              "iv_fieldItemQty",
                              String(current + 1),
                            );
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Box>
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      fullWidth
                  className="rco-prepare-estimate-dialog__add-btn"
                      onClick={fieldItemFormik.handleSubmit}
                      disabled={dnDetails && dnDetails.filledFlag === 1}
                    >
                      Add
                    </Button>
              </Box>
            </Box>
          </Box>

            {/* Items Table */}
            {itemsArray?.length > 0 && (
                <TableContainer
                  component={Paper}
              className="rco-prepare-estimate-dialog__items-table"
              sx={{ maxHeight: 250, overflowY: "auto" }}
                >
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Sr.</TableCell>
                        <TableCell>Item Name</TableCell>
                    <TableCell align="left">Unit</TableCell>
                    <TableCell align="center" sx={{ minWidth: 78 }}>
                          Qty
                        </TableCell>
                        <TableCell align="right">Rate</TableCell>
                        <TableCell align="right">Amount</TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {itemsArray.map((row, index) => (
                        <TableRow key={`${row.item_Code || row.Id || "item"}-${index}`}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.item_Name}</TableCell>
                      <TableCell align="left">{row.unit}</TableCell>
                      <TableCell align="center" sx={{ minWidth: 78 }}>
                        <Box className="rco-prepare-estimate-qty-control">
                              <IconButton
                                size="small"
                                onClick={() => updateItemQtyByDelta(index, -1)}
                                disabled={dnDetails && dnDetails.filledFlag === 1}
                              >
                                <RemoveIcon fontSize="small" />
                              </IconButton>
                          <Typography component="span">{row.qty}</Typography>
                              <IconButton
                                size="small"
                                onClick={() => updateItemQtyByDelta(index, 1)}
                                disabled={dnDetails && dnDetails.filledFlag === 1}
                              >
                                <AddIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell align="right">
                            {numberFormatting(row.rate)}
                          </TableCell>
                          <TableCell align="right">
                            {numberFormattingForRCO(row.amount)}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton onClick={() => deleteItem(index)}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
          )}

          <Box className="rco-prepare-estimate-dialog__charges-grid">
            <Box className="rco-prepare-estimate-charge rco-prepare-estimate-charge--readonly">
              <Typography className="fieldLabel">Items' Total Amount</Typography>
              <TextField
                size="small"
                fullWidth
                disabled
                className="rco-prepare-estimate-charge__readonly-input"
                value={
                  itemsAmount
                    ? numberFormatting(itemsAmount)
                    : "-"
                }
              />
                        </Box>

            <Box className="rco-prepare-estimate-charge rco-prepare-estimate-charge--readonly">
              <Typography className="fieldLabel">
                Store Charges (
                {String(
                  historyData?.applicationId ||
                    dialogRowData?.applicationId ||
                    "",
                ).startsWith("MC-13")
                  ? "0%"
                  : "12%"}
                )
                          </Typography>
              <TextField
                size="small"
                fullWidth
                disabled
                className="rco-prepare-estimate-charge__readonly-input"
                value={
                  storeCharges
                    ? formatBoqChargeAmount(storeCharges)
                    : "-"
                }
              />
                        </Box>

            <Box className="rco-prepare-estimate-charge rco-prepare-estimate-charge--readonly">
              <Typography className="fieldLabel">
                Installation Charges (8%)
                          </Typography>
              <TextField
                size="small"
                fullWidth
                disabled
                className="rco-prepare-estimate-charge__readonly-input"
                value={
                  installationCharges
                    ? formatBoqChargeAmount(installationCharges)
                    : "-"
                }
              />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Misc. Charges</Typography>
                          <TextField
                name="iv_miscellaneous_charges"
                value={fieldFormik.values.iv_miscellaneous_charges}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                  fieldFormik.setFieldValue("iv_miscellaneous_charges", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                  fieldFormik.setFieldValue("iv_miscellaneous_charges", val);
                  setMiscellaneousCharges(val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Civil Work Charges</Typography>
                          <TextField
                name="iv_civil_work_charges"
                value={fieldFormik.values.iv_civil_work_charges}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                  fieldFormik.setFieldValue("iv_civil_work_charges", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                  fieldFormik.setFieldValue("iv_civil_work_charges", val);
                  setCivilWorkCharges(val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Fixed Charges</Typography>
                          <TextField
                            name="iv_fixed_charges_of_metering"
                value={fieldFormik.values.iv_fixed_charges_of_metering}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_fixed_charges_of_metering", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                  fieldFormik.setFieldValue(
                    "iv_fixed_charges_of_metering",
                    val,
                  );
                  setFixedChargesOfMetering(val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Grid Sharing Amount</Typography>
                          <TextField
                            name="iv_grid_sharing_cost"
                            value={fieldFormik.values.iv_grid_sharing_cost || 0}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_grid_sharing_cost", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_grid_sharing_cost", val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Feeder Rehab Amount</Typography>
                          <TextField
                            name="iv_feeder_rehab_charges"
                            value={fieldFormik.values.iv_feeder_rehab_charges || 0}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_feeder_rehab_charges", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_feeder_rehab_charges", val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">M&T Charges</Typography>
                          <TextField
                            name="iv_mt_charges"
                            value={fieldFormik.values.iv_mt_charges || 0}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_mt_charges", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_mt_charges", val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Labour Charges</Typography>
                          <TextField
                            name="iv_labour_charges"
                            value={fieldFormik.values.iv_labour_charges || 0}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_labour_charges", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_labour_charges", val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Design Wetting Fee</Typography>
                          <TextField
                            name="iv_design_wetting_fee"
                            value={fieldFormik.values.iv_design_wetting_fee || 0}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_design_wetting_fee", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_design_wetting_fee", val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Consultancy Charges</Typography>
                          <TextField
                            name="iv_consultancy_charges"
                            value={fieldFormik.values.iv_consultancy_charges || 0}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_consultancy_charges", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_consultancy_charges", val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Variation Charges</Typography>
                          <TextField
                            name="iv_variation_charges"
                            value={fieldFormik.values.iv_variation_charges || 0}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_variation_charges", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_variation_charges", val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Dismantlement Charges</Typography>
                          <TextField
                            name="iv_dismantlement_charges"
                            value={fieldFormik.values.iv_dismantlement_charges || 0}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_dismantlement_charges", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_dismantlement_charges", val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Earthing Charges</Typography>
                          <TextField
                            name="iv_earthing_charges"
                            value={fieldFormik.values.iv_earthing_charges || 0}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_earthing_charges", val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Number(e.target.value) || 0);
                              fieldFormik.setFieldValue("iv_earthing_charges", val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-charge">
              <Typography className="fieldLabel">Less the Cost</Typography>
                          <TextField
                            name="iv_less_the_cost"
                value={-Math.abs(Number(fieldFormik.values.iv_less_the_cost) || 0)}
                            type="number"
                            size="small"
                fullWidth
                            onChange={(e) => {
                              const val = Math.trunc(Math.abs(Number(e.target.value) || 0));
                  fieldFormik.setFieldValue("iv_less_the_cost", val);
                  setLessTheCost(val);
                            }}
                            onBlur={(e) => {
                              const val = Math.trunc(Math.abs(Number(e.target.value) || 0));
                  fieldFormik.setFieldValue("iv_less_the_cost", val);
                  setLessTheCost(val);
                            }}
                            inputProps={{ step: "1", min: "0", inputMode: "numeric" }}
                          />
                        </Box>

            <Box className="rco-prepare-estimate-dialog__total">
              <span>Total</span>
              <span>
                {grandTotalCharges ? numberFormatting(grandTotalCharges) : "-"}
              </span>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions className="rco-prepare-estimate-dialog__actions">
          <Button
            variant="contained"
            className="rco-prepare-estimate-dialog__save-btn"
            onClick={onSaveCostEstimationConfirm}
          >
            Save Estimate
          </Button>
        </DialogActions>
      </Dialog>

      {/* Show Cost Estimation */}
      <Dialog
        open={showCostEstimation}
        onClose={handleCostEstimationClose}
        fullWidth
        maxWidth="sm"
        className="rco-workflow-subdialog rco-workflow-subdialog--wide"
        PaperProps={{ className: "rco-workflow-subdialog__paper" }}
      >
        <DialogTitle className="rco-workflow-subdialog__title">
          <Box className="rco-workflow-subdialog__header">
            <Typography className="rco-workflow-subdialog__heading">
          Cost Estimation
            </Typography>
            <CloseIcon
              id="clearPopup"
              className="rco-workflow-subdialog__close"
              onClick={() => {
                arearBillDocumentFormik.resetForm();
                arearBillDocumentFormik.values.iv_arear_paid_bill_document = "";
                handleCostEstimationClose();
              }}
            />
          </Box>
        </DialogTitle>

        <DialogContent className="rco-workflow-subdialog__content">
          {costEstimationForNC ? (
            <Box className="rco-workflow-subdialog__summary-card">
              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Items&apos; Total Amount:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {itemsAmount
                      ? Number(itemsAmount.toFixed(0)).toLocaleString()
                      : 0}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>
                  Store Charges (
                  {String(dialogRowData?.applicationId || "").startsWith("MC-13")
                    ? "0%"
                    : "12%"}
                  ):
                </strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {storeCharges
                      ? Number(storeCharges.toFixed(0)).toLocaleString()
                      : 0}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>Installation Charges (8%):</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {installationCharges
                      ? Number(installationCharges.toFixed(0)).toLocaleString()
                      : 0}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Civil Work Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {civilWorkCharges
                      ? Number(civilWorkCharges.toFixed(0)).toLocaleString()
                      : 0}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Fixed Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {fixedChargesOfMetering
                      ? Number(
                          fixedChargesOfMetering.toFixed(0),
                        ).toLocaleString()
                      : 0}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Miscellaneous Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {miscellaneousCharges
                      ? Number(miscellaneousCharges.toFixed(0)).toLocaleString()
                      : 0}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Grid Sharing Amount:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {Number(
                      Number(fieldFormik.values.iv_grid_sharing_cost) || 0,
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Feeder Rehab Amount:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {Number(
                      Number(fieldFormik.values.iv_feeder_rehab_charges) || 0,
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                <strong>M&amp;T Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {Number(
                      Number(fieldFormik.values.iv_mt_charges) || 0,
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Labour Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {Number(
                      Number(fieldFormik.values.iv_labour_charges) || 0,
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Design Wetting Fee:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {Number(
                      Number(fieldFormik.values.iv_design_wetting_fee) || 0,
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Consultancy Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {Number(
                      Number(fieldFormik.values.iv_consultancy_charges) || 0,
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Variation Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {Number(
                      Number(fieldFormik.values.iv_variation_charges) || 0,
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Dismantlement Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {Number(
                      Number(fieldFormik.values.iv_dismantlement_charges) || 0,
                    ).toLocaleString()}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Earthing Charges:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                    {Number(
                      Number(fieldFormik.values.iv_earthing_charges) || 0,
                    ).toLocaleString()}
                </span>
              </Box>

              {hasLessTheCostValue(
                fieldFormik.values.iv_less_the_cost || lessTheCost,
              ) && (
              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Less the Cost:</strong>
                <span className="rco-workflow-subdialog__summary-value">
                    Rs.{" "}
                  {(-Math.round(
                    Number(
                      fieldFormik.values.iv_less_the_cost || lessTheCost || 0,
                    ),
                  )).toLocaleString()}
                </span>
              </Box>
              )}

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Service Connection:</strong>
                <span className="rco-workflow-subdialog__summary-value rco-workflow-subdialog__summary-value--highlight">
                    Rs.{" "}
                    {itemsAmount
                      ? Number(
                          [
                            Math.round(Number(itemsAmount) || 0),
                          Math.round(
                            Number(fieldFormik.values.iv_grid_sharing_cost) ||
                              0,
                          ),
                            Math.round(Number(storeCharges) || 0),
                            Math.round(Number(installationCharges) || 0),
                          Math.round(
                            Number(fieldFormik.values.iv_feeder_rehab_charges) ||
                              0,
                          ),
                          Math.round(
                            Number(fieldFormik.values.iv_civil_work_charges) ||
                              0,
                          ),
                          Math.round(
                            Number(
                              fieldFormik.values.iv_fixed_charges_of_metering,
                            ) || 0,
                          ),
                          Math.round(
                            Number(
                              fieldFormik.values.iv_miscellaneous_charges,
                            ) || 0,
                          ),
                            Math.round(Number(fieldFormik.values.iv_mt_charges) || 0),
                          Math.round(
                            Number(fieldFormik.values.iv_labour_charges) || 0,
                          ),
                          Math.round(
                            Number(fieldFormik.values.iv_design_wetting_fee) ||
                              0,
                          ),
                          Math.round(
                            Number(
                              fieldFormik.values.iv_consultancy_charges,
                            ) || 0,
                          ),
                          Math.round(
                            Number(fieldFormik.values.iv_variation_charges) ||
                              0,
                          ),
                          Math.round(
                            Number(
                              fieldFormik.values.iv_dismantlement_charges,
                            ) || 0,
                          ),
                          Math.round(
                            Number(fieldFormik.values.iv_earthing_charges) || 0,
                          ),
                          -Math.round(
                            Number(fieldFormik.values.iv_less_the_cost) || 0,
                          ),
                          ]
                            .map(Number)
                            .reduce((acc, val) => acc + val, 0),
                        ).toLocaleString()
                      : 0}
                </span>
              </Box>

              <Box className="rco-workflow-subdialog__summary-row">
                    <strong>Total Cost Estimation Deposit:</strong>
                <span className="rco-workflow-subdialog__summary-value rco-workflow-subdialog__summary-value--highlight">
                    Rs.{" "}
                    {itemsAmount
                      ? Number(
                          [
                            Math.round(Number(itemsAmount) || 0),
                          Math.round(
                            Number(fieldFormik.values.iv_grid_sharing_cost) ||
                              0,
                          ),
                            Math.round(Number(storeCharges) || 0),
                            Math.round(Number(installationCharges) || 0),
                          Math.round(
                            Number(fieldFormik.values.iv_feeder_rehab_charges) ||
                              0,
                          ),
                          Math.round(
                            Number(fieldFormik.values.iv_civil_work_charges) ||
                              0,
                          ),
                          Math.round(
                            Number(
                              fieldFormik.values.iv_fixed_charges_of_metering,
                            ) || 0,
                          ),
                          Math.round(
                            Number(
                              fieldFormik.values.iv_miscellaneous_charges,
                            ) || 0,
                          ),
                            Math.round(Number(fieldFormik.values.iv_mt_charges) || 0),
                          Math.round(
                            Number(fieldFormik.values.iv_labour_charges) || 0,
                          ),
                          Math.round(
                            Number(fieldFormik.values.iv_design_wetting_fee) ||
                              0,
                          ),
                          Math.round(
                            Number(
                              fieldFormik.values.iv_consultancy_charges,
                            ) || 0,
                          ),
                          Math.round(
                            Number(fieldFormik.values.iv_variation_charges) ||
                              0,
                          ),
                          Math.round(
                            Number(
                              fieldFormik.values.iv_dismantlement_charges,
                            ) || 0,
                          ),
                          Math.round(
                            Number(fieldFormik.values.iv_earthing_charges) || 0,
                          ),
                          -Math.round(
                            Number(fieldFormik.values.iv_less_the_cost) || 0,
                          ),
                          Math.round(
                            Number(
                              costEstimationForNC?.estimatedSecurityAmount,
                            ) || 0,
                          ),
                          ]
                            .map((val) => Number(val) || 0)
                            .reduce((acc, val) => acc + val, 0),
                        ).toLocaleString("en-PK")
                      : 0}
                </span>
              </Box>
            </Box>
          ) : (
            <Typography variant="body2">Loading cost details...</Typography>
          )}
        {errormessageCostEstimation ? (
            <Typography className="rco-workflow-subdialog__error">
            {errormessageCostEstimation}
          </Typography>
        ) : null}
        </DialogContent>

        <DialogActions className="rco-workflow-subdialog__actions">
          <Button
            variant="contained"
            className="rco-workflow-subdialog__btn"
            onClick={onPressCostEstimationConfirm}
          >
            Save Cost Estimation
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={snackbar.open}
        onClose={handleCloseSnackbarDialog}
        className={`dde-result-dialog${
          snackbarDialogMeta.isReject ? " dde-result-dialog--reject" : ""
        }`}
        fullWidth
        maxWidth="sm"
        PaperProps={{ className: "dde-result-dialog__paper" }}
      >
        <DialogTitle className="dde-result-dialog__title">
          <Box className="dde-result-dialog__icon-wrap">
            {snackbarDialogMeta.isReject ? (
              <HighlightOffIcon className="dde-result-dialog__icon dde-result-dialog__icon--reject" />
            ) : (
              <CheckCircleIcon className="dde-result-dialog__icon dde-result-dialog__icon--approve" />
            )}
          </Box>
          <Typography variant="h6" className="dde-result-dialog__heading">
            {snackbarDialogMeta.title}
            </Typography>
        </DialogTitle>
        <DialogContent className="dde-result-dialog__content">
          <DialogContentText component="div">
            <p className="dde-result-dialog__message">{snackbar.message}</p>
            {snackbar.message ===
            "Application completed. Print CP-138 for further processing." ? (
              <Box className="dde-result-dialog__actions">
              <Button
                  type="button"
                variant="outlined"
                  className="dde-result-dialog__bill-btn"
                onClick={() => downloadCP138PDF(dialogRowData, scoDetails)}
                >
                  <PrintIcon className="dde-result-dialog__bill-icon" />
                  CP-138
              </Button>
          </Box>
            ) : null}
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* PAID RCO Fee Voucher Image Dialog */}
      <Dialog
        open={openImgDialog}
        onClose={handleCloseImg}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Paid RCO Fee Voucher
          <IconButton
            aria-label="close"
            onClick={handleCloseImg}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <img
            src={paidRCOFeeVoucherImg}
            alt="Paid RCO Fee Voucher"
            style={{
              maxWidth: "100%",
              maxHeight: "85vh",
              objectFit: "contain",
            }}
          />
        </DialogContent>
      </Dialog>

      {/* DN Image Dialog */}
      <Dialog
        open={openImgDialogDN}
        onClose={handleCloseImgDN}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Paid DN Image
          <IconButton
            aria-label="close"
            onClick={handleCloseImgDN}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <img
            src={paidDNVoucherImg}
            alt="Paid DN voucher"
            style={{
              maxWidth: "100%",
              maxHeight: "85vh",
              objectFit: "contain",
            }}
          />
        </DialogContent>
      </Dialog>

      {/* DN Rejection Modal FOR REMARLS */}
      <Dialog
        open={dnRejectModalOpen}
        onClose={() => {
          setDnRejectModalOpen(false);
          dnRejectFormik.resetForm();
        }}
        className="dn-reject-dialog"
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "dn-reject-dialog__paper" }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            dnRejectFormik.handleSubmit();
          }}
        >
          <DialogTitle className="dn-reject-dialog__title">
            <div className="dn-reject-dialog__header">
              <Typography className="dn-reject-dialog__heading">
            Reject Demand Notice
          </Typography>
              <button
                type="button"
                className="dn-reject-dialog__close"
            onClick={() => {
              setDnRejectModalOpen(false);
              dnRejectFormik.resetForm();
            }}
                aria-label="Close dialog"
          >
            <CloseIcon />
              </button>
            </div>
        </DialogTitle>

          <DialogContent className="dn-reject-dialog__content">
            <div className="dn-reject-dialog__field">
              <label className="dn-reject-dialog__label" htmlFor="reasonType">
                Select Reason:
              </label>
              <TextField
                select
                id="reasonType"
                name="reasonType"
                fullWidth
                size="small"
                variant="outlined"
                className="dn-reject-dialog__select"
                value={dnRejectFormik.values.reasonType}
                onChange={dnRejectFormik.handleChange}
                onBlur={dnRejectFormik.handleBlur}
                error={
                  dnRejectFormik.touched.reasonType &&
                  Boolean(dnRejectFormik.errors.reasonType)
                }
              >
                <MenuItem value="">Select reason</MenuItem>
                <MenuItem value="4">Field Survey & Cost Estimation</MenuItem>
                {/* <MenuItem value="2">Arrear Verification</MenuItem>
                      <MenuItem value="1">Documents Verification</MenuItem> */}
              </TextField>
              {dnRejectFormik.touched.reasonType &&
              dnRejectFormik.errors.reasonType ? (
                <p className="dn-reject-dialog__error">
                  {dnRejectFormik.errors.reasonType}
                </p>
              ) : null}
            </div>

            <div className="dn-reject-dialog__field">
              <label className="dn-reject-dialog__label" htmlFor="remarks">
                Please provide a reason for rejection:
              </label>
              <TextField
                id="remarks"
                name="remarks"
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                placeholder="Enter your remarks here..."
                className="dn-reject-dialog__textarea"
                value={dnRejectFormik.values.remarks}
                onChange={dnRejectFormik.handleChange}
                onBlur={dnRejectFormik.handleBlur}
                error={
                  dnRejectFormik.touched.remarks &&
                  Boolean(dnRejectFormik.errors.remarks)
                }
              />
              {dnRejectFormik.touched.remarks &&
              dnRejectFormik.errors.remarks ? (
                <p className="dn-reject-dialog__error">
                  {dnRejectFormik.errors.remarks}
                </p>
              ) : null}
            </div>
          </DialogContent>

          <DialogActions className="dn-reject-dialog__actions">
            <button
              type="button"
              onClick={() => {
                setDnRejectModalOpen(false);
                dnRejectFormik.resetForm();
              }}
              className="view-button"
            >
              Cancel
            </button>
            <button type="submit" className="reject-button">
              Reject
            </button>
          </DialogActions>
        </form>
      </Dialog>

      <RcoActivityLogDetailDialog
        open={activityLogDetailOpen}
        onClose={() => setActivityLogDetailOpen(false)}
        historyItems={eFileData}
        currentStatus={eFileCurrentStatus || {}}
        currentProgressId={dialogRowData?.applicationProgressId}
        buildDetailRows={buildMcoActivityLogDetailRows}
        applicationDetails={{
          applicationId: dialogRowData?.applicationId || "",
          name: dialogRowData?.consumerName || "",
          sanctionedLoad: dialogRowData?.sanctionedLoad ?? "",
          tariff: dialogRowData?.tariffDesc || "",
        }}
        formatDateFn={convertDatewithTime}
        onStepClick={openDetailsPopUp}
        timelineType={ACTIVITY_LOG_TIMELINE_TYPES.MCO}
      />
    </>
  );
});

export default MeterChangeRequestTable;


